import { totemPresenceEnUS } from "./totem-presence-messages";
import { giftPreflightEnUS } from "./gift-preflight-messages";
import { trailChatV3EnUS } from "./trail-chat-v3-messages";
import { giftRefundEnUS } from "./gift-refund-messages";
import { roomToolsEnUS } from "./room-tools-messages";
import { reportsDashboardEnUS } from "./reports-dashboard-messages";

export const enUSMessages = {
  totemPresence: totemPresenceEnUS,
  quizReview: {
  "title": "Review with Jev",
  "scope": "Check clarity, overlapping alternatives, and clues that reveal the answer before publishing.",
  "disclaimer": "Review is optional and analyzes text only. Signals can be wrong; check the content and answer key before publishing.",
  "button": "Review quiz",
  "loading": "Reviewing quiz…",
  "retry": "Try again",
  "again": "Review again",
  "summary": "Questions: {{attention}} with signals · {{uncertain}} inconclusive · {{clear}} with no signals detected",
  "question": "Question {{number}}",
  "media": "Images, videos, and other attachments were not evaluated. Check the question together with its media.",
  "criteria": {
    "clarity": "Question clarity",
    "answerOverlap": "Overlapping alternatives",
    "answerLeak": "Answer clues"
  },
  "status": {
    "attention": "Needs attention",
    "uncertain": "Inconclusive",
    "clear": "No signal detected",
    "not_applicable": "Not applicable"
  },
  "suggestions": {
    "clarity": "Check that the question says exactly what students should answer and provides the context they need.",
    "answerOverlap": "Check that only one alternative can be defended as correct. Distinguish options with similar meanings.",
    "answerLeak": "Check whether the question or the wording of the alternatives reveals the correct answer."
  },
  "errors": {
    "incomplete": "Fill in the title, questions, and alternatives and select the correct answers to review.",
    "limits": "Review supports up to 30 questions and 10 alternatives per question. Text limits: title 200, description and question 4,000, alternative 1,000, and total 60,000 characters.",
    "unavailable": "The review is unavailable right now. Try again shortly.",
    "invalidResponse": "The review returned incomplete data. Try again."
  }
},
  trailChatV3: trailChatV3EnUS,
  giftRefund: giftRefundEnUS,
  giftPreflight: giftPreflightEnUS,
  debugMenu: {
    trigger: "Debug",
    subscriptionGroup: "Subscription",
    trialEnded: "Trial ended",
    onboardingGroup: "Onboarding",
    onboardingTitle: "Debug: onboarding",
    school: "School onboarding",
    professor: "Teacher onboarding",
    firstSteps: "First steps",
    emailGroup: "Transactional emails",
    emailTitle: "Debug: transactional emails",
    welcomeTrial: "Welcome with trial (14 days)",
    welcomePaid: "Welcome without trial",
    sending: "Sending...",
    emailSent: 'Email "{{label}}" sent to your email address.',
    emailFailed: 'Failed to send the email "{{label}}".',
    environmentGroup: "Environment",
    geo: "Geography and currency",
  },
  app: {
    defaultTitle: "Gamefik Schools at max level.",
    loadingCachedData: "Refreshing data",
  },
  accessInstructions: {
    title: "Access instructions for {{name}}",
    pageSubtitle: "Sign in using one of the options below",
    step1Title: "Download the Gamefik app",
    step1Stores: "Available on the App Store and Google Play",
    appStore: "App Store",
    googlePlay: "Google Play",
    step2Title: "Choose how to sign in",
    scanQrTitle: "Scan QR code",
    scanQrHint: "Best on a device with a camera",
    scanQrHintPage: "Best on a device with a camera",
    scanQrStep1: "1. Open your phone camera",
    scanQrStep2: "2. Scan the QR code",
    scanQrStep3: "3. The link will open automatically",
    scanQrStep1Long: "Open your phone camera or a QR code reader",
    scanQrStep2Long: "Scan the QR code above",
    scanQrStep3Long: "The login link will open automatically in the browser",
    loginLinkTitle: "Login link",
    linkHintStart: "Best on a device ",
    linkHintEmphasis: "without",
    linkHintEnd: " a camera",
    linkHintLongStart: "Best on a device",
    linkHintLongMid: "without",
    linkHintLongEnd: "a camera",
    pasteInBrowser: "Paste the link below in a browser",
    generatingLink: "Generating link...",
    copyLink: "Copy link",
    copied: "Copied!",
    privacyNote:
      "Students will not be able to access or see other students' work with these instructions",
    helpTitle: "Need help?",
    helpSubtitle: "Visit the help center for more information",
    generatingAccessLink: "Generating access link...",
    modalTrigger: "Access instructions for {{name}}",
    resetLink: "Reset link",
    resetConfirmTitle: "Warning: this action cannot be undone!",
    resetConfirmQuestion: "Are you sure you want to reset the link for {{name}}?",
    resetWarnInvalidate:
      "The current link will be permanently invalidated and a new one will be generated.",
    resetWarnQrCard:
      "If the player has a printed QR code card, it will also be invalidated — you will need to generate and print a new card.",
    resetting: "Resetting...",
  },
  navigation: {
    dashboard: "Dashboard",
    launches: "Feedback",
    players: "Players",
    classes: "Classes",
    attitudes: "Attitudes",
    quizzes: "Quizzes",
    manage: "Manage",
    createWithAi: "Create with AI✨",
    createFromScratch: "Create from scratch",
    newMissions: "New quests",
    missions: "Quests",
    approve: "Approve",
    mural: "Feed",
    studentApp: "Student app",
    reports: "Reports",
    shopping: "Store",
    overview: "Overview",
    orders: "Orders",
    rewards: "Rewards",
    giftCards: "Gift cards",
    statement: "Statement",
    invoices: "Invoices",
    settings: "Settings",
    history: "History",
    games: "Segments",
    userManagement: "User management",
    automations: "Automations",
    advanced: "Advanced",
    home: "Home",
    chatIa: "Home",
    activities: "Activities",
    trails: "Learning Paths",
  },
  pageTitles: {
    dashboard: "Dashboard",
    players: "Players",
    missions: "Quests",
    approveMissions: "Approve quests",
    quizzes: "Quizzes",
    shop: "My Store",
    shoppingOrders: "Store - Orders",
    history: "History",
    attitudes: "Attitudes",
    newAttitude: "New attitude",
    editAttitude: "Edit attitude",
    createQuiz: "Create quiz",
    shopping: "Store",
    reviewOpenQuestions: "Review open-ended answers",
    purchases: "Orders",
    rewards: "My Store",
    requests: "Store - Orders",
  },
  missions: {
    allGames: "All segments",
    allClasses: "All classes",
    allTeachers: "All teachers",
    tips: {
      clearObjectivesTitle: "Set clear goals",
      clearObjectivesDescription: "Clearly define what the student needs to do to complete the quest.",
      clearObjectivesPlaceholder: "Video showing how to set clear goals for quests",
      adjustComplexityTitle: "Adjust complexity",
      adjustComplexityDescription: "Adapt the quest complexity to the students' level and ability.",
      adjustComplexityPlaceholder: "Video demonstrating how to adjust quest complexity",
      quickFeedbackTitle: "Provide quick feedback",
      quickFeedbackDescription: "Validate quests as quickly as possible to keep students engaged.",
      quickFeedbackPlaceholder: "Video about the importance of quick feedback in quests",
      aiVariationsTitle: "Use AI to create variations",
      aiVariationsDescription: "Use AI to create different versions of similar quests.",
      aiVariationsPlaceholder: "Tutorial video on how to use AI to create quest variations",
      curriculumConnectionTitle: "Connect with the curriculum",
      curriculumConnectionDescription: "Relate quests to the curriculum content to reinforce learning.",
      curriculumConnectionPlaceholder: "Video explaining how to connect quests to the school curriculum",
    },
    searchByName: "Search by name",
    tabs: {
      all: "All",
      active: "Active",
      inactive: "Inactive",
    },
    missionUpdatedSuccess: "Quest updated successfully!",
    missionUpdatedError: "There was an error updating the quest. Please try again.",
    missionDeletedSuccess: "Quest deleted successfully!",
    viewProofs: "View submissions",
    manualValidation: "Manual validation",
    edit: "Edit",
    deleteMission: "Delete quest",
    confirmDeletion: "Confirm deletion",
    editMission: "Edit quest",
    viewFullBank: "View full bank",
    createdBy: "Created by",
    creatorUnavailable: "Deleted or unavailable user",
    games: "Segments",
    status: "Status",
    inactive: "Inactive",
    active: "Active",
    proofUncollectedAndRemoved: "Submission revoked and removed",
    errorUncollectingProof: "Failed to revoke the submission, contact support",
    createWithAi: "Create quest with AI",
    createFromScratch: "Create from scratch",
    searchPlaceholder: "Search by name",
    selectGame: "Select a segment",
    selectClass: "Select a class",
    selectTeacher: "Select a teacher",
    itemsPerPage: "Items per page",
    perPage: "{{count}} per page",
    previous: "Previous",
    next: "Next",
    openAll: "Open all",
    closeAll: "Close all",
    emptyTitle: "No quests found",
    emptySubtitle: "Try changing the filters or create more quests",
  },
  activities: {
    title: "Activities",
    creatorUnavailable: "Deleted or unavailable user",
    subtitle: "{{count}} activities · {{active}} active",
    subtitleLoading: "Loading...",
    createManual: "Create manually",
    createManualShort: "Manual",
    createShort: "Create",
    createWithAi: "Create with AI",
    createWithAiShort: "AI",
    createManualModal: {
      title: "What do you want to create?",
      hint: "Choose the activity type to create from scratch, without AI.",
      quiz: "Quiz",
      quizDesc: "Questions with alternatives or open-ended answers.",
      quizFormatTitle: "Which quiz format do you want to create?",
      quizFormatHint: "Choose the answer type. You can edit every question afterward.",
      quizMultiple: "Multiple choice",
      quizMultipleDesc: "Students select an option and receive automatic grading.",
      quizDiscursive: "Open-ended",
      quizDiscursiveDesc: "Students write an open response for evaluation.",
      mission: "Quest",
      missionDesc: "Task where the student submits proof of completion.",
      flashcards: "Flashcards",
      flashcardsVf: "True/False flashcards",
    },
    createWithAiDialog: {
      title: "Create activity with AI",
      hint: "Describe what you want (topic, grade, activity type). The AI will start generating from your request right away.",
      placeholder:
        "E.g.: Quiz about fractions for 5th grade, with 10 multiple-choice questions…",
      submit: "Create activity",
      cancel: "Cancel",
      promptRequired: "Describe what you want to create",
      typeAuto: "Type: automatic",
    },
    tabs: {
      all: "All",
      quizzes: "Quizzes",
      missions: "Quests",
      flashcards: "Flashcards",
    },
    searchPlaceholder: "Search...",
    filterClasses: "Classes",
    filterClassesSearch: "Search class...",
    filterStatus: "Status",
    filterCreatorsSearch: "Search teacher...",
    deletedTeacher: "Deleted teacher {{index}}",
    filterClassesNoResults: "No results",
    filterClassesClear: "Clear selection",
    filterPending: "With pending items",
    createdBy: "Created by",
    filters: "Filters",
    filtersAriaLabel: "Open filters",
    clearFilters: "Clear filters",
    showResults: "Show {{count}} activities",
    createAriaLabel: "Create activity",
    editAriaLabel: "Edit activity",
    toggleAriaLabel: "Change status of {{title}}",
    moreActionsAriaLabel: "More actions",
    status: {
      active: "Active",
      ended: "Ended",
      scheduled: "Scheduled",
      draft: "Draft",
    },
    actions: {
      edit: "Edit",
      duplicate: "Duplicate",
      duplicating: "Duplicating...",
      delete: "Delete",
      report: "Report",
      reviewProofs: "Review submissions",
      reviewAnswers: "Grade answers",
      fullResults: "Results",
      reviewProofsCount: "Review {{count}} submissions",
      apply: "Apply",
      playLiveTooltip: "Play live with the class",
      presentTooltip: "Present on TV or projector",
      copyLinkTooltip: "Copy activity link",
      copyLinkSuccess: "Link copied!",
    },
    typeSelection: {
      title: "New activity type",
      subtitle: "Choose an option below",
      quiz: "Quiz",
      quizDescription: "Multiple choice questions",
      mission: "Quest",
      missionDescription: "Homework with submission",
    },
    emptyState: {
      title: "No activities found",
      withSearch: "Try searching for another term",
      withoutSearch: "Create your first activity",
    },
    duplicateSuccess: "\"{{title}}\" duplicated successfully",
    deleteDialog: {
      title: "Delete activity",
      description: "Are you sure you want to delete {{title}}? This action cannot be undone.",
      cancel: "Cancel",
      confirm: "Delete",
      deleting: "Deleting...",
    },
    toast: {
      duplicateError: "Error duplicating the activity. Please try again.",
      editError: "Could not identify the activity to edit.",
      loadQuizError: "Could not load the original quiz for editing.",
      loadMissionError: "Could not load the original quest for editing.",
      prepareEditError: "Could not prepare editing now. Please try again.",
      deleteError: "Error deleting the activity. Please try again.",
      deleteSuccess: "Activity deleted successfully!",
      statusUpdateSuccess: "Activity status updated successfully!",
    },
  },
  history: {
    loadingStarting: "Starting...",
    loadingHistory: "Loading history...",
    loadedPeriods: "{{loaded}} of {{total}} periods loaded",
    loadedRecordsHint: "{{count}} records loaded so far — you can already use the filters while the rest loads.",
    filtersAndSearch: "Filters and search",
    search: "Search",
    searchActivities: "Search activities...",
    startDate: "Start date",
    endDate: "End date",
    category: "Category",
    allCategories: "All categories",
    type: "Type",
    noTypesAvailable: "No type available",
    allTypes: "All types",
    khanBonus: "Khan Academy bonus",
    otherTypes: "Other types",
    playerHistory: {
      title: "Student history",
      description: "Records of attitudes, missions and transactions for this student.",
      searchPlaceholder: "Search history",
      filterByGame: "Filter by segment",
      allGames: "All segments",
      gameLabel: "Segment",
      appliedBy: "Applied by",
      collectDate: "Collect date",
      createdAt: "Date",
      activities: "Activities",
      collected: "Collected",
      pendingCollect: "Pending collect",
      noGame: "No segment",
      empty: "No attitude records found for this student.",
      sectionToday: "Today",
      sectionYesterday: "Yesterday",
      sectionThisWeek: "This week",
      sectionMoreTimeAgo: "In a not-so-distant past",
      print: "Print history",
      close: "Close",
      details: {
        title: "Record details",
        tabDetails: "Details",
        tabTechnical: "Technical JSON",
        registerId: "Record ID",
        type: "Type",
        typeManual: "Manual activity",
        typeGame: "Game activity",
        titleLabel: "Title/Description",
        gameName: "Segment name",
        appliedBy: "Applied by",
        points: "Points earned",
        noPoints: "No point type specified",
        createdAt: "Created at",
        collectDate: "Collect date",
        stackedIds: "Stacked IDs ({{count}})",
        technicalData: "Technical data (JSON)",
        technicalHint: "Copy this JSON for technical analysis or debugging.",
        close: "Close",
      },
      remove: {
        title: "Confirm removal",
        body: "Are you sure you want to remove this record?",
        confirm: "Remove",
        cancel: "Cancel",
      },
      normalizeGames: {
        button: "Normalize segments",
        buttonTitle: "Set all transactions' game_id to the student's current segment",
        viewJson: "View JSON",
        hideJson: "Hide JSON",
        viewJsonTitle: "Show full history JSON",
        title: "Normalize segments",
        description:
          "Reassigns all transactions (hot and cold) to the student's current segment. Balance per point type stays the same — only the per-segment partition changes.",
        loadingDryRun: "Computing preview…",
        errorTitle: "Could not load preview",
        errorGeneric: "Failed to normalize segments",
        retry: "Try again",
        targetGame: "Target segment",
        targetBadge: "target",
        otherGames: "Other segments",
        before: "Before (by segment)",
        after: "After (consolidated)",
        alreadyNormalized: "All transactions are already on the target segment. Nothing to change.",
        saldNoteTitle: "Consolidated balance (unchanged)",
        saldNoteBody:
          "The sum per point type is the same before and after. This operation only fixes game_id on transactions.",
        confirmApply: "Confirm normalization",
        applying: "Applying…",
        successTitle: "Segments normalized successfully",
        filtersTitle: "Include transactions",
        includeCollected: "Collected points",
        includeUncollected: "Uncollected points",
        noFilterSelected: "Select at least one point type to continue.",
        journeyConflictTitle: "Duplicate journey bonuses",
        journeyConflictBody:
          "{{count}} journey bonus transaction(s) will be removed to avoid a unique index conflict (same cycleKey on the target segment).",
      },
    },
  },
  languages: {
    ptBR: "Português",
    enUS: "English",
    esES: "Español",
  },
  languageSelector: {
    label: "Language",
    description: "Choose the platform language",
  },
  common: {
    close: "Close",
    cancel: "Cancel",
    save: "Save",
    help: "Help",
    logout: "Sign out",
    settings: "Settings",
    helpAndSupport: "Help & Support",
    language: "Language",
    login: "Login",
    email: "Email",
    password: "Password",
    selectUnit: "Select unit",
    selectGender: "Select a gender",
    requiredField: "Required field",
    ok: "Ok",
    send: "Send",
    loading: "Loading",
    fetchErrorTitle: "Could not load",
    fetchErrorDescription:
      "Something went wrong while fetching data. Check your connection and try again.",
    tryAgain: "Try again",
    back: "Back",
    create: "Create",
    edit: "Edit",
    change: "Change",
    success: "Success",
    error: "Error",
    add: "Add",
    remove: "Remove",
    confirm: "Confirm",
    selectGame: "Choose your segment",
    previous: "Previous",
    next: "Next",
    testEnvironmentOnly: "HMG only",
    testEnvironmentBadge: "HMG",
    testEnvironmentDescription: "This element is intentionally visible only in the test environment for now.",
    testEnvironmentTemporary: "Temporary in HMG",
  },
  login: {
    pageTitle: "Login | Gamefik Schools at max level.",
    title: "Sign in",
    description: "Enter your information to sign in to Gamefik",
    emailPlaceholder: "Enter your email",
    passwordPlaceholder: "Enter your password",
    submit: "Sign in",
    forgotPassword: "Forgot your password?",
    needHelp: "Need help?",
    clickHere: "Click here",
    invalidCredentials: "Invalid email or password!",
    footerLabel: "Platform language",
  },
  forgotPassword: {
    heading: "Forgot your password?",
    subtitle: "Enter your account email to receive a password reset link",
    emailLabel: "Email",
    invalidEmail: "Invalid email",
    submit: "Get reset link",
    back: "Back",
    successMessage: "We sent a password reset link to your email!",
    userNotFound: "Sorry, we could not find any account registered with this email.",
    userNotVerified: "Your account has not been verified yet. We sent a new invitation to your email.",
    genericError: "Sorry, an error occurred while sending the link to your email. Please contact support.",
  },
  loginCode: {
    continueSubmit: "Continue",
    invalidEmail: "Invalid email",
    verifyHeading: "Check your email",
    verifySubtitle: "We sent a login code to {{email}}",
    codeLabel: "Login code",
    codePlaceholder: "Enter the 6-digit code",
    helper: "We sent a code to {{email}}. Check your inbox and spam folder.",
    sentToast: "Code sent! Check your email.",
    userNotFound: "We couldn't find an account with this email. Double-check the address or create an account.",
    sendError: "We couldn't send the code. Please try again in a moment.",
    invalidCode: "Incorrect or expired code. Check your email or resend the code.",
    changeEmail: "Change email",
    usePassword: "Sign in with password",
    useCode: "Sign in with email code",
  },
  signup: {
    tabLogin: "Sign in",
    tabSignup: "Create account",
    loginHeading: "Welcome back",
    loginSubheading: "Sign in to continue your epic journey",
    profileHeading: "Select your profile",
    profileSubheading: "Start your epic journey now",
    formHeading: "Create your account",
    formSubheading: "Choose how you'd like to continue: Google, Apple, or your email",
    verifyHeading: "Verify your email",
    verifySubheading: "Enter the code sent to {{email}}",
    profileSchools: "Schools",
    profileTeachers: "Teachers",
    profileNext: "Next",
    toastResendSuccess: "We sent a new code to your email.",
    toastResendError: "Could not resend the code.",
    firstName: "First name",
    firstNamePlaceholder: "Enter your first name",
    lastName: "Last name",
    lastNamePlaceholder: "Enter your last name",
    email: "Email",
    emailPlaceholder: "your@email.com",
    emailInvalid: "Invalid email",
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    password: "Password",
    passwordPlaceholder: "••••••••",
    passwordMin: "Minimum 6 characters",
    confirmPassword: "Confirm password",
    passwordMismatch: "Passwords do not match",
    rememberMe: "Remember me",
    forgotPassword: "Forgot my password",
    termsText: "By creating your account, you declare that you have read and agree to the",
    termsAnd: "and the",
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    loginSubmit: "Sign in to Gamefik",
    signupSubmit: "Create account",
    appleLogin: "Sign in with Apple",
    appleSignup: "Sign up with Apple",
    dividerLogin: "OR SIGN IN WITH",
    dividerSignup: "OR SIGN UP WITH",
    noAccount: "Don't have an account yet?",
    startFree: "Start for free",
    hasAccount: "Already have an account?",
    loginLink: "Sign in",
    verificationCode: "Verification code",
    verificationPlaceholder: "Enter the code you received",
    verificationHelper: "We sent a code to {{email}}. Check your inbox.",
    verifySubmit: "Verify and continue",
    resendCode: "Resend code",
    resendCountdown: "Resend code in {{countdown}}s",
    toastFillAllFields: "Please fill in email, password and confirmation correctly.",
    toastAccountCreated: "Account created. We sent a code to your email.",
    toastEnterCode: "Please enter the code received by email.",
    toastInvalidCode: "Invalid code. Please try again.",
    toastVerified: "Account verified successfully.",
    toastLoginError: "Invalid email or password",
    toastGoogleError: "Error authenticating with Google",
    toastGoogleNotFound: "No account found for this Google email",
    toastAppleSoon: "Apple login coming soon",
    toastAppleError: "Error authenticating with Apple",
    toastAppleNotFound: "No account found for this Apple ID",
    toastAppleNotConfigured: "Apple Sign In not configured in this environment",
    toastSignupError: "Could not create your account right now.",
  },
  schoolOnboarding: {
    pageTitle: "School setup — Gamefik",
    step1Title: "Tell us a little about yourself!",
    step2Title: "Tell us about your school",
    step3Title: "What do you want to achieve with Gamefik?",
    step4Title: "Personalize your school's environment",
    panel1Title: "Where classrooms become adventures",
    panel2Title: "+1,000 schools have turned engagement into a routine",
    panel3Title: "Gamified schools have up to 40% more engagement",
    panel4Title: "Your students will access an environment that reflects your school",
    roleLabel: "What is your role at the school?",
    rolePlaceholder: "Select your role",
    roleDirector: "Principal",
    roleCoordinator: "Pedagogical Coordinator",
    roleMaintainer: "Maintainer",
    roleOther: "Other",
    countryLabel: "In which country is your school located?",
    countryPlaceholder: "Select country",
    countrySearch: "Search country...",
    countryEmpty: "No country found",
    schoolNameLabel: "School name",
    schoolNamePlaceholder: "Enter the school name",
    studentCountLabel: "Number of students",
    studentCountPlaceholder: "Select the number",
    studentUpTo100: "Up to 100",
    student100to200: "100 to 200",
    student200to500: "200 to 500",
    student500to1000: "500 to 1,000",
    studentAbove1000: "Above 1,000",
    teacherCountLabel: "Number of teachers",
    teacherUpTo5: "Up to 5",
    teacher5to20: "5 to 20",
    teacher20to50: "20 to 50",
    teacherAbove50: "Above 50",
    goalEngagement: "Increase student engagement",
    goalPerformance: "Improve academic performance",
    goalPedagogy: "Facilitate pedagogical monitoring",
    goalMotivate: "Motivate teachers to use technology",
    goalRetention: "Reduce dropout rates",
    goalOther: "Other",
    goalOtherPlaceholder: "Describe your goal...",
    uploadHelp: "Drag a photo here or choose from your device",
    uploadLater: "You can do this later in settings",
    back: "Back",
    next: "Next",
    finish: "Finish",
    phoneLabel: "Contact phone number",
    phonePlaceholder: "(555) 000-0000",
    errorRole: "Please select your role at the school.",
    errorCountry: "Please select the school's country.",
    errorPhone: "Please enter a phone number.",
    errorPhoneInvalid: "Invalid phone number.",
    errorSchoolName: "Please enter the school name.",
    errorStudentCount: "Please select the number of students.",
    errorTeacherCount: "Please select the number of teachers.",
    errorGoals: "Please select at least one goal.",
    errorSave: "Could not save the information. Please try again.",
  },
  teacherOnboarding: {
    welcomeTitleNoName: "Your next class starts here.",
    welcomeSubtitle: "Let's make your first class shine.",
    welcomeMicro: "One question and the AI creates your first activity.",
    nameQuestion: "What's your name?",
    namePlaceholder: "Your name",
    countryQuestion: "In which country do you teach?",
    countryPlaceholder: "Select your country",
    countrySearch: "Search country",
    countryEmpty: "No country found",
    phoneLabel: "WhatsApp (optional)",
    phonePlaceholder: "Your number",
    phoneInvalid: "Invalid number. Include the area code, digits only.",
    phoneWhy: "Only to let you know when your activity is ready. No spam.",
    ctaContinue: "Continue",
    subjectTitle: "Which subject do you teach?",
    subjectSubtitle: "The AI builds the right activity for your class.",
    topicLabel: "What will you teach this week?",
    topicPlaceholder: "E.g.: fractions, the French Revolution",
    ctaCreate: "Create my first activity",
    welcomeCta: "Get started",
    activitySubtitle: "Write the topic. We'll take care of the rest.",
    suggestionsLabel: "Or start with a {subjects} idea",
    suggestionsLabelGeneric: "Or start with one of these ideas",
    topic: {
      matematica_fractions: "Fractions",
      matematica_linear_equations: "Linear equations",
      matematica_plane_geometry: "Plane geometry",
      matematica_percentages: "Percentages",
      portugues_text_interpretation: "Reading comprehension",
      portugues_figures_of_speech: "Figures of speech",
      portugues_verb_agreement: "Subject-verb agreement",
      portugues_spelling: "Spelling",
      ingles_verb_tenses: "Verb tenses",
      ingles_phrasal_verbs: "Phrasal verbs",
      ingles_daily_vocabulary: "Everyday vocabulary",
      ingles_reading_comprehension: "Reading comprehension",
      espanhol_present_tense: "Present tense verbs",
      espanhol_basic_vocabulary: "Basic vocabulary",
      espanhol_false_friends: "False cognates",
      espanhol_pronunciation: "Pronunciation",
      ciencias_solar_system: "The solar system",
      ciencias_ecosystems: "Ecosystems",
      ciencias_human_body: "The human body",
      ciencias_states_of_matter: "States of matter",
      fisica_kinematics: "Kinematics",
      fisica_newtons_laws: "Newton's laws",
      fisica_electricity: "Electricity",
      fisica_thermodynamics: "Thermodynamics",
      quimica_periodic_table: "The periodic table",
      quimica_chemical_reactions: "Chemical reactions",
      quimica_stoichiometry: "Stoichiometry",
      quimica_organic_chemistry: "Organic chemistry",
      biologia_genetics: "Genetics",
      biologia_evolution: "Evolution",
      biologia_digestive_system: "Digestive system",
      biologia_cell_biology: "Cell biology",
      historia_french_revolution: "French Revolution",
      historia_world_war_2: "World War II",
      historia_middle_ages: "The Middle Ages",
      historia_ancient_civilizations: "Ancient civilizations",
      geografia_world_climates: "World climates",
      geografia_landforms: "Landforms",
      geografia_globalization: "Globalization",
      geografia_cartography: "Cartography",
      filosofia_socrates_plato: "Socrates and Plato",
      filosofia_ethics: "Ethics",
      filosofia_enlightenment: "The Enlightenment",
      filosofia_modern_philosophy: "Modern philosophy",
      sociologia_culture_identity: "Culture and identity",
      sociologia_work: "The world of work",
      sociologia_social_movements: "Social movements",
      sociologia_citizenship: "Citizenship",
      ed_fisica_team_sports: "Team sports",
      ed_fisica_olympic_history: "Olympic history",
      ed_fisica_athletics: "Track and field",
      ed_fisica_game_rules: "Game rules",
      arte_renaissance: "The Renaissance",
      arte_impressionism: "Impressionism",
      arte_modern_art: "Modern art",
      arte_color_composition: "Color and composition",
      musica_notes_rhythm: "Notes and rhythm",
      musica_great_composers: "Great composers",
      musica_instruments: "Musical instruments",
      musica_world_music: "World music",
      computacao_algorithms: "Basic algorithms",
      computacao_how_internet_works: "How the internet works",
      computacao_programming_logic: "Programming logic",
      computacao_digital_safety: "Digital safety",
      financas_interest_rates: "Simple and compound interest",
      financas_personal_budget: "Personal budgeting",
      financas_investments: "Investments",
      financas_financial_literacy: "Financial literacy",
      redacao_argumentation: "Argumentation",
      redacao_essay_structure: "Essay structure",
      redacao_cohesion: "Cohesion and coherence",
      redacao_writing_techniques: "Writing techniques",
      religiao_world_religions: "World religions",
      religiao_ethics_values: "Ethics and values",
      religiao_religious_tolerance: "Religious tolerance",
      religiao_mythology: "Mythology",
      outra_citizenship: "Citizenship",
      outra_sustainability: "Sustainability",
      outra_critical_thinking: "Critical thinking",
      outra_current_affairs: "Current affairs",
    },
    stepProgress: "Step {current} of {total}",
    ctaToEditor: "Open in editor",
    submitError: "I couldn't open the editor right now. Please try again.",
    creating: "Creating…",
    nextStepsLabel: "Your next steps",
    loadingPulse1: "Analyzing your topic…",
    loadingPulse2: "Building the questions…",
    loadingPulse3: "Making it all gamified…",
    loadingPulse4: "Polishing the details…",
    loadingTitle: "Almost there, {name}…",
    loadingTitleNoName: "Almost there…",
    loadingSubtitle: "While the AI builds your activity, see how to transform your school.",
    card1Title: "Create your class",
    card1Desc: "Organize your students in seconds and share activities with everyone.",
    card2Title: "Invite your students",
    card2Desc: "One link or code and your students are in. They play, you track.",
    card3Title: "Track the results",
    card3Desc: "See who participated, scores and engagement, in real time.",
    celebrationTitle: "Done, {name}. Your class is now a game.",
    celebrationTitleNoName: "Done. Your class is now a game.",
    celebrationSubtitle: "Open the editor to make it yours before publishing.",
    ctaPublish: "Publish to my students",
    ctaAdjust: "Adjust first",
    previewUnavailable: "I couldn't load the student preview right now, but your activity is ready.",
    back: "Back",
    handoffPrompt: "Create a gamified activity for {subjects}{topic}.",
    handoffPromptTopic: " about {topic}",
    subject: {
      matematica: "Mathematics",
      portugues: "Native lang.",
      ingles: "English",
      espanhol: "Spanish",
      ciencias: "Science",
      fisica: "Physics",
      quimica: "Chemistry",
      biologia: "Biology",
      historia: "History",
      geografia: "Geography",
      filosofia: "Philosophy",
      sociologia: "Sociology",
      ed_fisica: "PE",
      arte: "Art",
      musica: "Music",
      computacao: "Technology",
      financas: "Finance",
      redacao: "Writing",
      religiao: "Religion",
      outra: "Other",
    },
  },
  profile: {
    referAndEarn: "Refer and earn",
    accountNameFallback: "My account",
    editUser: "Edit user",
    emailLabel: "Email",
    finalizeTitle: "Complete your profile",
    editTitle: "Edit your user",
    missingFieldsFinalize: "To complete your profile, fill in these fields: {{fields}}",
    missingFieldsEdit: "Please fill in all required fields: {{fields}}",
    fullName: "Full name",
    fullNamePlaceholder: "Name",
    birthDate: "Birth date",
    gender: "Gender",
    whatsappNumber: "WhatsApp number",
    finishing: "Finishing...",
    saving: "Saving...",
    finishRegistration: "Complete profile",
    saveChanges: "Save",
    missingFieldNames: {
      fullName: "Full name",
      email: "Email",
      whatsappNumber: "WhatsApp number",
      gender: "Gender",
      birthDate: "Birth date",
    },
    genderOptions: {
      female: "Female",
      male: "Male",
      preferNot: "Prefer not to say",
    },
    modal: {
      title: "My Profile",
      changePhoto: "Change photo",
      firstName: "First name",
      firstNamePlaceholder: "Your first name",
      firstNameRequired: "First name is required",
      firstNameMinLength: "First name must be at least 2 characters",
      lastName: "Last name",
      lastNamePlaceholder: "Your last name",
      lastNameRequired: "Last name is required",
      lastNameMinLength: "Last name must be at least 2 characters",
      email: "Email",
      userType: "User type",
      accountType: "Account type",
      userTypes: {
        manager: "Manager",
        teacher: "Teacher",
        secretary: "Secretary",
        financial_admin: "Financial administrator",
      },
      accountTypes: {
        individual_teacher: "Individual teacher",
        new_manager_school: "New Manager school",
        legacy_school: "Legacy school",
      },
      phone: "Phone",
      phonePlaceholder: "Your phone number",
      school: "School where you teach",
      schoolPlaceholder: "School name",
      schoolRequired: "School is required",
      subjects: "Subjects you teach",
      subjectsPlaceholder: "Select subjects",
      subjectsSelected: "{{count}} subject selected",
      subjectsSelectedPlural: "{{count}} subjects selected",
      subjectsRequired: "Select at least one subject",
      subjectLabels: {
        Matematica: "Mathematics",
        Portugues: "Portuguese",
        Historia: "History",
        Geografia: "Geography",
        Ciencias: "Science",
        Fisica: "Physics",
        Quimica: "Chemistry",
        Biologia: "Biology",
        Ingles: "English",
        Espanhol: "Spanish",
        "Educacao Fisica": "Physical Education",
        Artes: "Arts",
        Filosofia: "Philosophy",
        Sociologia: "Sociology",
        Outros: "Other",
      },
      cancel: "Cancel",
      save: "Save",
      saved: "Saved",
    },
  },
  sidebar: {
    unitDialogTitle: "Select unit",
    unitLabel: "Unit",
    accountCodeLabel: "Account code:",
    accountCodeCopyTitle: "Copy school code",
    accountCodeCopied: "Copied!",
    help: "Help",
    helpAriaLabel: "Open help center",
    supportSectionLabel: "Support",
    menuAriaLabel: "Open navigation menu",
    logout: "Sign out",
    launchMenu: "Feedback menu",
    changeUnitError: "We couldn't switch units right now.",
    newBadge: "New",
    comingSoonBadge: "Coming soon",
    activities: "Activities",
    trails: "Learning Paths",
    firstSteps: "First steps",
    collapseSidebar: "Collapse sidebar",
    expandSidebar: "Expand sidebar",
  },
  premiumModal: {
    exclusiveBadge: "Exclusive feature",
    title: "{{funcionalidade}} is a {{planName}} feature",
    features: {
      rewards: "Rewards",
    },
    description: "This feature is part of the {{planName}} plan. Upgrade to unlock all exclusive benefits.",
    planName: "Teacher Shiny",
    planNameSchool: "School Pro",
    includesLabel: "Includes:",
    highlight1: "Custom currency",
    highlight2: "Unlimited AI",
    highlight3: "Exclusive rewards",
    highlight4: "Rewards store",
    includedBadge: "Included",
    ctaButton: "Unlock with {{planName}}",
    viewPlans: "View plans",
    dismiss: "Not now",
  },
  novaRecompensa: {
    notifyStudents: "Notify students",
    notifyStudentsDescription: "Send a new reward notification to students in the selected segments.",
    title: "New Reward",
    back: "Back",
    close: "Close",
    step: "Step {{current}} of {{total}}",
    next: "Next",
    creating: "Creating...",
    createReward: "Create Reward",
    payAndCreate: "Pay and Create",
    stepType: "Type",
    stepDetails: "Details",
    stepValues: "Values",
    stepClasses: "Classes",
    stepGiftCards: "Gift Cards",
    stepCheckout: "Checkout",
    typeTitle: "Reward Type",
    typeDescription: "Choose the type of reward you want to create.",
    normalTitle: "Normal Reward",
    normalDescription: "Stickers, prizes, privileges and other rewards",
    giftcardTitle: "Gift Card",
    giftcardDescription: "Buy gift cards for your students to redeem",
    comingSoon: "Coming soon",
    detailsTitle: "Reward Details",
    detailsDescription: "Add image, name and description.",
    imageLabel: "Image",
    imageOptional: "Optional",
    uploadLabel: "Upload",
    nameLabel: "Reward name",
    namePlaceholder: "E.g.: Special Sticker",
    nameMinError: "Name must be at least 3 characters",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Describe the reward for students...",
    descriptionRequiredError: "Description is required",
    advanced: "Advanced",
    availabilityDateLabel: "Availability date",
    availabilityDateDescription: "The reward will be available for redemption from this date.",
    valuesTitle: "Values and Quantities",
    valuesDescription: "Set the coin value and availability of the reward.",
    coinValueLabel: "Coin value",
    stockLabel: "Available stock",
    limitLabel: "Limit per student",
    previewSentence: "{{stock}} units available. Each student can redeem up to {{limit}} {{times}} for {{price}} coins each.",
    timesOne: "time",
    timesMany: "times",
    classesTitle: "Select Classes",
    classesDescription: "Choose which classes will have access to this reward.",
    allClasses: "All classes",
    noClasses: "No classes found",
    selectedCount: "{{selected}} of {{total}} selected",
    giftcardsTitle: "Build your Gift Cards",
    giftcardsDescription: "Select the brand, value and quantity of each gift card.",
    brandColumn: "Brand",
    valueColumn: "Value",
    qtyColumn: "Qty",
    addGiftcard: "Add another gift card",
    giftcardTotal: "Total ({{count}} gift cards)",
    checkoutTitle: "Confirm Purchase",
    checkoutDescription: "Review your order before proceeding to payment.",
    orderSummary: "Order Summary",
    totalToPay: "Total to pay",
    howItWorks: "How it works:",
    checkoutInfo: "After payment, the gift cards will be added as drafts in your rewards list. You can set coin value and stock before making them available to students.",
    brandInfoWhere: "Where it can be used",
    brandInfoInstructions: "Redemption instructions",
    brandInfoValues: "Available values",
    brandInfoTerms: "View terms and conditions",
    successToast: "Reward created successfully!",
    errorToast: "Error creating reward. Please try again.",
  },
  editarRecompensa: {
    title: "Edit Reward",
    subtitle: "Modify the reward details",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Optional description...",
    coinValueLabel: "Coin value",
    stockLabel: "Stock",
    stockGiftCardLocked: "Stock is set by the purchased gift cards — not editable",
    limitLabel: "Limit per student",
    classesLabel: "Classes",
    selectAll: "Select all",
    noClasses: "No classes found",
    selectedCount: "{{selected}} of {{total}} selected",
    nameMinError: "Minimum 3 characters",
    uploadImage: "Change image",
    uploadingImage: "Uploading...",
    removeImage: "Remove image",
    changeImage: "Change image",
    imageUploadError: "Error uploading image. Please try again.",
    cancel: "Cancel",
    save: "Save Changes",
    saving: "Saving...",
    successToast: "Reward updated successfully!",
    errorToast: "Error saving changes.",
  },
  calculadoraCoins: {
    trigger: "Calculator",
    title: "Coins calculator",
    description: "Enter how much the reward is worth in real money to see the suggested coin value.",
    reaisLabel: "Value in currency",
    reaisPlaceholder: "e.g. 10.00",
    suggestedLabel: "Suggested value",
    rarityLabel: "Rarity:",
    useValue: "Use this value",
  },
  rewardCard: {
    giftBadge: "Gift",
    autoDeliveryBadge: "Automatic delivery",
    autoDeliveryBadgeShort: "Auto",
    enableAutoDelivery: "Enable automatic delivery",
    disableAutoDelivery: "Disable automatic delivery",
    inactiveBadge: "Inactive",
    edit: "Edit",
    delete: "Delete",
    coinsUnit: "coins",
    stockPrefix: "Stock",
    stockCount: "{{count}} in stock",
    moreActions: "More actions",
  },
  excluirRecompensa: {
    title: "Delete Reward",
    description: "Are you sure you want to delete {{name}}? This action cannot be undone.",
    stockInfo: "{{coins}} coins — {{stock}} in stock",
    cancel: "Cancel",
    confirm: "Delete",
    deleting: "Deleting...",
  },
  orderStatus: {
    todos: "All",
    pendentes: "Pending",
    created: "Pending",
    accepted: "Accepted",
    delivered: "Delivered",
    cancelled: "Cancelled",
    acceptTitle: "Accept",
    rejectTitle: "Reject",
    cancelTitle: "Cancel",
    markDelivered: "Deliver",
  },
  helpChat: {
    title: "Help Center",
    subtitle: "How can we help?",
    closeAriaLabel: "Close help center",
    successTitle: "Message sent!",
    successThanks: "Thank you for getting in touch.",
    successReply: "Our team will reply within {{hours}} hours.",
    nameLabel: "Name",
    namePlaceholder: "Your name",
    emailLabel: "Email",
    emailPlaceholder: "your@email.com",
    typeLabel: "Request type",
    typePlaceholder: "Select a type",
    typeFeedback: "Feedback",
    typeDuvidas: "Questions",
    typeSugestoes: "Suggestions",
    typeBugs: "Bugs",
    typeOutros: "Other",
    messageLabel: "Message",
    messagePlaceholder: "Describe your request in detail...",
    attachmentsLabel: "Attachments (optional)",
    attachButton: "Attach images or videos",
    removeAttachmentAriaLabel: "Remove attachment {{name}}",
    submitButton: "Send message",
    submitting: "Sending...",
  },
  unitSelector: {
    title: "Select Unit",
    subtitle: "Choose the unit you want to manage",
    searchPlaceholder: "Search unit...",
    emptyTitle: "No units found",
    emptySubtitle: "Try searching with a different term",
    addUnit: "Add new unit",
  },
  clearTheme: {
    loadingAria: "Loading content",
  },
  account: {
    createPageTitle: "Create account | Gamefik Schools at max level.",
  },
  notFound: {
    pageTitle: "404 - Page not found | Gamefik Schools at max level.",
    title: "Page not found...",
    goBack: "Go back",
  },
  suspendedAccount: {
    permanentlySuspendedTitle: "Your account is suspended.",
    suspendedForPaymentTitle: "Your account has been suspended due to unpaid invoices!",
    payOverdueInvoices: "Pay overdue invoices",
    payInvoice: "Pay invoice",
    permanentlySuspendedDescription:
      "Your account has been permanently suspended because payment is overdue by more than {{days}} days after the invoice due date. Complete the payment and the account will be unlocked within 30 minutes, or contact support.",
    suspendedForPaymentDescription:
      'To unlock your account, pay the overdue invoices by clicking the "Pay invoice" button. After payment, your account will be unlocked automatically.',
  },
  publicPost: {
    defaultTitle: "Announcement",
    notFoundTitle: "Announcement not found",
    notFoundDescription: "This link may have expired or the announcement was removed.",
    eventBadge: "EVENT",
    noReactions: "No reactions yet",
    reactionsCount: {
      one: "{{count}} reaction",
      other: "{{count}} reactions",
    },
    viewsCount: {
      one: "{{count}} view",
      other: "{{count}} views",
    },
    footerBrand: "Gamefik - Schools at max level",
  },
  acceptInvite: {
    pageTitle: "Registration | Gamefik Schools at max level.",
    title: "Create your access password",
    description: "Set a password to accept the invitation and automatically enter Gamefik.",
    passwordLabel: "New password",
    confirmPasswordLabel: "Confirm password",
    invalidPassword: "Invalid password",
    passwordTooShort: "Your password must be at least 6 characters.",
    passwordsDoNotMatch: "Passwords do not match",
    passwordHint: "Use at least 6 characters. You can change your password later in your profile.",
    showPassword: "Show password",
    hidePassword: "Hide password",
    submit: "Create password and sign in",
    submitting: "Creating password...",
    loginCta: "Login",
    successMessage: "Your password has been saved. You can now log in.",
    errorMessage: "We could not process your request. Your token may have expired. Please request a new invitation or contact support.",
    invalidOrExpired: "This invitation is invalid, expired, or has already been used. Request a new invitation.",
  },
  changePassword: {
    pageTitle: "Registration | Gamefik Schools at max level.",
    title: "Change password",
    description: "Your password must be at least 6 characters.\nYour password must not contain symbols (@,#,%,ˆ,& )",
    newPasswordLabel: "New password",
    confirmNewPasswordLabel: "Confirm new password",
    invalidPassword: "Invalid password",
    passwordsDoNotMatch: "Passwords do not match",
    submit: "Change",
    successMessage: "Password changed!",
    tokenExpiredError: 'Your password reset token has expired. Request another one by clicking "Forgot your password?" on the login screen.',
    genericError: "Sorry, something went wrong while changing your password. Please contact support.",
  },
  rewards: {
    bannerTitle: "Smart rewards system",
    bannerDescription: "Create custom rewards and use AI for automatic suggestions.",
    watchTutorial: "Watch tutorial",
    deleteSelected: "Delete selected",
    newReward: "New reward",
    rewardSuggestion: "Store suggestion",
    searchPlaceholder: "Search rewards by name",
    rewardsCount: {
      one: "{{count}} reward",
      other: "{{count}} rewards",
    },
    selectedCount: {
      one: "{{count}} selected",
      other: "{{count}} selected",
    },
    deselectAll: "Deselect all",
    selectAll: "Select all",
    outOfStock: "Out of stock",
    viewMode: "View:",
    grid: "Grid",
    list: "List",
    table: "Table",
    rewardDetails: "Reward details",
    noGamesAssigned: "No segments",
    sendToStore: "Send to store",
    details: "Details",
    noRewardFound: "No reward found",
    editTitle: "Edit reward",
    editPageTitle: "Edit reward | Gamefik Schools at max level.",
    newRewardPageTitle: "New reward | Gamefik Schools at max level.",
    newRewardTitle: "New Reward",
    rewardSavedSuccess: "Reward saved successfully.",
    redeemError: "An error occurred while processing your request",
    requestError: "An error occurred while processing your request. Please try again later.",
    rewardRemovedSuccess: "Reward removed successfully.",
    rewardsPageTitle: "Rewards | Gamefik Schools at max level.",
    myStore: "My Store",
    smartRewardsSystem: "Smart rewards system",
    smartRewardsDescription: "Create custom rewards and use AI for automatic suggestions.",
    shinyOnlyTitle: "Rewards are available on the Shiny plan",
    shinyOnlyDescription: "Subscribe to unlock custom rewards, gift cards, and the full store for your class.",
    shinyOnlyCta: "Subscribe to Shiny",
    shinyOnlySecondary: "Back",
    deleteSelectedButton: "Delete Selected",
    newRewardButton: "New Reward",
    storeSuggestionButton: "Store Suggestion",
    searchRewardsPlaceholder: "Search rewards...",
    confirmDeletion: "Confirm deletion",
    confirmDeletionMessage: "Are you sure you want to delete the following rewards?",
    cancel: "Cancel",
    deleteAction: "Delete",
    editRewardDialog: "Edit Reward",
    newRewardDialog: "New Reward",
    rewardsDeletedSuccess: "Rewards deleted successfully",
    processingError: "An error occurred while processing your request",
    closeButton: "Close",
    uploadImage: "Upload an image",
    productName: "Product Name*",
    productNameLabel: "Name that will appear to students",
    descriptionLabel: "Description*",
    descriptionPlaceholder: "Brief description of the item",
    categoryLabel: "Category*",
    createCategory: "Create Category",
    availableQuantity: "Available quantity*",
    stockQuantity: "Stock quantity",
    playerLimitLabel: "Limit per player",
    noLimits: "No limits",
    coinsCalculator: "Coins calculator",
    rarityIs: "The rarity is",
    useThisValue: "🪙 Use this value 🪙",
    defineCoinsValue: "Set the value in coins",
    rarityLabel: "Rarity",
    coinsCalculatorButton: "Coins calculator 🤑",
    rarityImportantInfo: "Important information about reward rarity",
    applicableGames: "Which segments is this reward applicable to?",
    advancedSettings: "Advanced settings",
    scheduleLabel: "Schedule",
    notifyStudents: "Notify Students",
    automaticDeliveryLabel: "Automatic delivery",
    automaticDeliveryHint: "Students receive the reward without manual validation.",
    automaticDeliveryBadge: "Automatic delivery",
    automaticDeliveryYes: "Yes",
    automaticDeliveryNo: "No",
    activateAutomaticDelivery: "Activate automatic delivery",
    activateAutomaticDeliveryConfirm: "Activate automatic delivery for the selected rewards?",
    activateAutomaticDeliveryDescription: "{{count}} reward(s) will be delivered automatically to students without manual validation.",
    activateAutomaticDeliverySuccess: "Automatic delivery activated successfully.",
    activateAutomaticDeliveryPartialError: "{{count}} reward(s) could not be updated.",
    savingReward: "Please wait, saving reward...",
    fillRewardName: "Enter a reward name",
    fillRewardDescription: "Enter a reward description",
    fillAvailableQuantity: "Enter the available quantity",
    selectAtLeastOneGame: "Select at least one segment",
    addToStore: "Add to store",
    browseButton: "Browse",
    removeButton: "Remove",
    defineValueIn: "Set the value in {{point}}",
    rarityCommon: "common",
    rarityUncommon: "uncommon",
    rarityRare: "rare",
    rarityEpic: "epic",
    rarityLegendary: "legendary",
    rarityCommonTime: "Time to redeem: 1 to 2 weeks",
    rarityUncommonTime: "Time to redeem: 2 to 4 weeks",
    rarityRareTime: "Time to redeem: 1 to 3 months",
    rarityEpicTime: "Time to redeem: 3 to 6 months",
    rarityLegendaryTime: "Time to redeem: 6 to 10 months",
    rewardsDialogTitle: "Rewards",
    chooseRewardsToRedeem: "Choose the rewards you want to redeem from the account of",
    totalLabel: "Total",
    redeemButton: "Redeem",
    rewardsRedeemedSuccess: "Rewards redeemed successfully.",
    insufficientScore: "The student does not have enough points for this purchase.",
    duplicatedTransaction: "Duplicate transaction.",
    insufficientBalanceReward: "Insufficient balance for this reward.",
    rewardNotFoundError: "Reward not found or unavailable.",
    playerNotFoundError: "Player not found.",
    gameNotFoundError: "Segment not found.",
    rewardAlreadyRedeemed: "Reward has already been redeemed.",
    purchaseFinishError: "An error occurred while completing this purchase. Check your connection and try again.",
    playerNotLinkedToGame: "The selected player is not linked to a segment.",
    cannotAssignMultipleGames: "Cannot assign rewards to students linked to different segments.",
    noGames: "No segments!",
    noRewardsFound: "No rewards found",
    startCreatingRewards: "Start by creating your first reward to motivate your students.",
    imageColumn: "Image",
    descriptionColumn: "Description",
    gamesColumn: "Segments",
    statusColumn: "Status",
    dateColumn: "Date",
    actionsColumn: "Actions",
    outOfStore: "Not in store",
    noStockBadge: "Out of stock",
    createdAtLabel: "Created on",
    sendToStoreButton: "Send to store",
    editAction: "Edit",
    tipCreateTitle: "Create attractive rewards",
    tipCreateDesc: "Offer varied rewards that motivate different types of students.",
    tipPriceTitle: "Set strategic prices",
    tipPriceDesc: "Balance the coin value to maintain engagement without making rewards too easy.",
    tipAITitle: "Use AI for suggestions",
    tipAIDesc: "Take advantage of automatic reward generation to save time.",
    tipStockTitle: "Monitor stock",
    tipStockDesc: "Keep track of available rewards and restock when needed.",
    tipPopTitle: "Analyze popularity",
    tipPopDesc: "See which rewards are most sought after and adjust your strategy.",
    xpRecommendation: "We recommend assigning only coin value to rewards, so that the player does not lose experience. Do you want to continue?",
    noButton: "No",
    yesButton: "Yes",
    inStock: "In stock",
    createdOn: "Created on",
    atTime: "at",
    quantityLabel: "Quantity",
    reaisLabel: "BRL",
  },
  purchases: {
    pageTitle: "[Store] - Orders | Gamefik Schools at max level.",
    walletBalance: "My wallet balance",
    addBalance: "Add balance",
    rewardSuggestion: "Store suggestion",
    giftCardStock: "Gift card stock",
    giftCardDescription: "Select a gift card to make it available in the store",
    buyGiftCard: "Buy gift card",
    cartWizardEntry: "Buy gift cards (cart)",
    rewardsSectionTitle: "Rewards",
    ordersSectionTitle: "Orders",
    manageStore: "Manage Store",
    itemMadeAvailableInStore: "Item made available in the store.",
    addGiftCard: "Add Gift Card",
    selectedGiftCard: "Gift Card {{name}}",
    quantityToMakeAvailable: "How many gift cards do you want to make available?",
    availableCount: "{{count}} available",
    gameLabel: "Segment",
    costInCoins: "How much will it cost (in coins)",
    costInCoinsPlaceholder: "Value in coins",
    playerLimit: "Limit per player",
    unlimited: "Unlimited",
    limitPerPlayerSummary: "Limit of {{count}} per player",
    optional: "Optional",
    schedule: "Schedule",
    scheduleHint: "Set a date if you want the reward to be available only on the selected date. Leave this field blank to make it available immediately.",
    errorMakingAvailable: "Error making available in store",
    makeAvailableInStore: "Make available in store",
    currentScores: "Current Scores",
    coins: "Coins",
    noOrderToApprove: "No orders to approve!",
    toDeliver: "To deliver",
    waiting: "Waiting",
    approved: "Approved",
    cancelledStatus: "Cancelled",
    nameColumn: "Name",
    priceColumn: "Price",
    totalColumn: "Total",
    nothingFound: "Nothing found",
    quantityLabel: "Quantity",
    giftCardUnavailable: "Gift Card Unavailable",
    giftCardUnavailableDesc: "The gift card from brand {{brand}} with value R$ {{value}} is no longer available.",
    selected: "Selected",
    bulkProcessingTitle: "Processing Items in Bulk",
    bulkProcessingProgress: "Processing {{current}} of {{total}}...",
    successLabel: "Success",
    processingLabel: "Processing...",
    closeAndUpdate: "Close and Update",
    importantInfo: "Important Information",
    acceptButton: "Accept",
    deliverButton: "Deliver",
    cancelButton: "Cancel",
    itemsPerPage: "Items per page",
    noRewardRequest: "No reward requests so far. Check if your store is available in",
    advancedSettingsLink: "Advanced Settings",
    pendingStatus: "Pending",
    acceptedStatus: "Accepted",
    acceptAll: "Accept All",
    deliverAll: "Deliver All",
    cancelAll: "Cancel All",
    orderDate: "Order date",
    deliveredBy: "Delivered by",
    deliveryDate: "Delivery date",
    createdBy: "Created by",
    acceptedBy: "Accepted by",
    acceptanceDate: "Acceptance date",
    cancelledBy: "Cancelled by",
    statusChangedSuccess: "Order status changed successfully.",
    internalError: "An internal problem occurred.",
    invalidProductCode: "Invalid product code. Check if the product is still available.",
    insufficientBalance: "Insufficient balance to make the purchase.",
    playerNotFound: "Player not found. Check if the player is still active.",
    gameNotFound: "Segment not found. Check if the segment is still active.",
    purchaseAlreadyProcessed: "This order has already been processed.",
    processingError: "An error occurred while processing the order. Contact support.",
    connectionError: "Connection problem. Check your internet and try again.",
    timeoutError: "The operation took too long to respond. Try again.",
    serverError: "Server communication error.",
    giftCardInstructions: "Gift card usage instructions",
    redemptionUrl: "Redemption URL",
    openRedemptionPage: "Open redemption page",
    giftCode: "Gift code",
    complementaryCode: "Complementary code",
    printGiftVoucher: "Print gift voucher",
    viewGiftCardResult: "View gift card result",
    selectItem: "select item",
    deliveredStatus: "Delivered",
    filtersTitle: "Filters",
    selectStatus: "Select a status",
    pendingCount: "Pending",
    cancelledCount: "Cancelled",
    acceptedCount: "Accepted",
    deliveredCount: "Delivered",
    updateError: "Error updating",
    confirmBulkAction: "Confirm changing the status of {{count}} items to {{status}}?",
    unknown: "Unknown",
    failedToLoadOrders: "Failed to load orders",
    failedToLoadOrdersDesc: "Could not fetch orders. Please try again.",
    retryButton: "Try again",
    loadingOrders: "Loading orders...",
    loadingOrdersProgress: "Loading orders... {{loaded}} of {{total}}",
    selectGiftToReplace: "Select a gift to replace the unavailable gift card",
    contactSupportRefund: "Contact support to process the refund for this gift card",
    giftCardUnavailableTitle: "Gift Card Unavailable",
    giftCardUnavailableText: "The gift card from the brand {{brand}} with the value R$ {{value}} is no longer available.",
    newValuesAvailable: "New values available for this brand:",
    selectedButton: "Selected",
    selectButton: "Select",
    closeButton: "Close",
    confirmButton: "Confirm",
    processingBulkTitle: "Processing Items in Bulk",
    processingProgress: "Processing {{current}} of {{total}}...",
    successResult: "Success",
    unknownError: "Unknown error",
    processingButton: "Processing...",
    closeAndUpdateButton: "Close and Update",
    selectAllPending: "Select All Pending",
    selectAllAccepted: "Select All Accepted",
    clearSelection: "Clear Selection ({{count}})",
    itemsPerPagePlaceholder: "Items per page",
    perPage: "{{count}} per page",
    previousPage: "Previous",
    nextPage: "Next",
    searchOrders: "Search orders",
    csvPlayerName: "Player Name",
    csvItemName: "Item Name",
    csvQuantity: "Quantity",
    csvStatus: "Status",
    csvCreatedAt: "Created Date",
    downloadSummary: "Download summary",
    importantInfoTitle: "Important Information",
    importantInfoAccept: "Check if the reward the student selected is actually available. If so, click",
    importantInfoAcceptAction: "Accept",
    importantInfoCancel: "The requested reward is no longer available? Click",
    importantInfoCancelAction: "Cancel",
    importantInfoCancelResult: "and the student will receive a refund.",
    importantInfoDeliver: "Important! After delivering the reward, always click",
    importantInfoDeliverAction: "Deliver",
    noRequestsMessage: "No reward requests so far. Check if your store is available at",
    advancedSettings: "Advanced Settings",
    oneItemSelected: "1 item selected",
    selectedItemsCount: "{{count}} items selected",
    itemsSelectedCount: "{{count}} item(s) selected",
    pendingLabel: "Pending",
    acceptedLabel: "Accepted",
    acceptAllButton: "Accept All",
    deliverAllButton: "Deliver All",
    cancelAllButton: "Cancel All",
    confirmBulkStatusChange: "Confirm changing the status of {{count}} items to {{status}}?",
    confirmSingleStatusChange: "Confirm changing this order's status to {{status}}?",
    cancelAcceptedTitle: "Cancel accepted order",
    confirmCancelOrder: "Cancel this order? The student's points will be refunded.",
    confirmBulkCancellation: "Cancel {{count}} orders? The students' points will be refunded.",
    confirmCancellationButton: "Confirm cancellation",
    selectedOrdersTitle: "Process selected orders",
    refreshBeforeRetry: "The change could not be confirmed. Refresh the page before trying again.",
    errorUpdating: "Error updating",
    unknownName: "Unknown",
    cancelOrderTooltip: "Cancel order and return points to student",
    makeAvailablePostPaid: "Make available (post-paid)",
    postPaidHint: "The R$ amount is only charged when you deliver the gift to the student.",
    postPaidCatalogTitle: "Make a gift card available (post-paid)",
    postPaidCatalogDescription: "Pick a gift card from the catalog to add to the store. The R$ amount is only charged at delivery to the student.",
    makingAvailable: "Making available...",
    noBalanceToDeliverTitle: "Not enough balance to deliver this gift",
    noBalanceToDeliverBody: "Current balance: R$ {{balance}} — required: R$ {{required}}. Add balance and try delivering again.",
    addBalanceCta: "Add balance",
    cartWizardTitle: "Buy gift cards",
    cartStepBuild: "Build your gift cards",
    cartStepCheckout: "Checkout",
    cartTotal: "Total to pay",
    cartPayNow: "Pay now",
    cartAwaitingPayment: "Awaiting payment. Once it is confirmed, you'll set coins and classes right here.",
    cartStepConfirm: "Confirmation",
    cartStepPublish: "Add to store",
    cartConfirmWaiting: "Waiting for confirmation — this window moves on automatically once the payment clears.",
    cartPublishIntro: "Payment confirmed!",
    cartPublishHint: "Now set how many coins students pay and which classes can redeem the gift card.",
    cartPublishLater: "Do it later",
    cartPublishStockMissing: "Stock not found for",
    cartAddRow: "Add another gift card",
    cartSelectBrand: "Brand",
    cartSearchBrand: "Search brand...",
    cartBrandNotFound: "No brand found.",
    cartSelectValue: "Value",
    cartQuantity: "Qty",
    cartPaymentMethod: "Payment method",
    cartPaymentPix: "Pix",
    cartPaymentBoleto: "Boleto",
    cartPaymentCreditCard: "Credit Card",
    cartOrderSummary: "Order summary",
    cartFieldName: "Full name",
    cartFieldEmail: "Email",
    cartFieldCpf: "CPF / CNPJ",
    cartFieldCardNumber: "Card number",
    cartFieldCardHolder: "Name on card",
    cartFieldExpiryMonth: "Expiry month",
    cartFieldExpiryYear: "Expiry year",
    cartFieldCcv: "CVV",
    cartFieldPostalCode: "Postal code",
    cartFieldAddressNumber: "Address number",
    cartLoadingCatalog: "Loading catalog...",
    cartSuccess: "Purchase completed! Gift cards will appear in your stock shortly.",
    cartError: "Error processing payment. Please try again.",
    cartErrorCatalog: "Could not load the gift card catalog.",
    cartNext: "Next",
    cartBack: "Back",
    cartProcessing: "Processing...",
    cartPixCopyPaste: "Pix Copy and Paste",
    cartBoletoOpen: "Open boleto",
    cartUseBalance: "Use balance (R$ {{balance}} available)",
    cartBalanceApplied: "Balance applied",
    cartToPay: "To pay",
    cartPayWithBalance: "Pay with balance",
    addGiftCards: "Add gift cards",
    addGiftCardsTitle: "Add gift cards",
    addGiftCardsDesc: "Choose how to add gift cards to the store.",
    modeCartTitle: "Buy (cart)",
    modeCartDesc: "Build a cart and pay now (pix, boleto, credit card, or balance).",
    modePostPaidTitle: "Make available (post-paid)",
    modePostPaidDesc: "Make available now and pay only when delivering to the student.",
    modePrePaidTitle: "Buy with balance",
    modePrePaidDesc: "Buy gift cards using the account balance.",
    tabRewards: "Rewards",
    tabOrders: "Orders",
    rewardsEmpty: "No rewards in the store yet.",
    ordersEmpty: "No pending orders.",
    rewardStock: "Stock",
  },
  attitudes: {
    pageTitle: "Attitudes | Gamefik Schools at max level.",
    positiveAttitudes: "Positive attitudes",
    negativeAttitudes: "Negative attitudes",
    recommendation: "Recommendation",
    recommendationDescription: "We recommend keeping at most 5 positive attitudes and 3 negative ones to make them easier for students to understand.",
    searchPlaceholder: "Search by name...",
    filterByGame: "Filter by segment",
    newAttitude: "New attitude",
    showingAttitudes: "Showing {{count}} attitudes",
    collapseAll: "Collapse all",
    expandAll: "Expand all",
    emptyTitle: "No attitudes found",
    emptySubtitle: "Try adjusting your filters or create a new attitude",
    deletedSuccess: "Attitudes deleted successfully",
    savedSuccess: "Attitude saved successfully.",
    removedSuccess: "Attitude removed successfully.",
    duplicatedSuccess: "Attitude duplicated successfully",
    appliedSuccess: "Attitude applied successfully",
    attitudesAppliedSuccess: "Attitudes awarded successfully!",
    attitudesLaunched: "Attitudes awarded!",
    playersUpdated: "Players updated",
    requestError: "An error occurred while processing your request. Please try again later.",
    processingError: "An error occurred while processing your request",
    applyingAttitudes: "Applying attitudes/quests...",
    errorApplyingAttitudes: "Error applying attitudes",
    contactSupport: "Something went wrong, please contact support.",
    duplicatedTransaction: "Duplicate transaction.",
    confirmDeleteTitle: "Are you sure you want to delete the attitudes below?",
    confirmDuplicateTitle: "Are you sure you want to duplicate this attitude?",
    newAttitudePageTitle: "New attitude | Gamefik Schools at max level.",
    editAttitudePageTitle: "Edit attitude | Gamefik Schools at max level.",
    newMission: "New quest",
    deleteMissions: "Delete quests",
    deleteAttitudesButton: "Delete attitudes",
    createNewAttitude: "Create a new attitude",
    chooseSuggestion: "Choose a suggestion",
    selectButton: "Select",
    applyButton: "Apply",
    editButton: "Edit",
    deleteButton: "Delete",
    showMore: "Show more",
    proceedAnyway: "Proceed anyway",
    cancelCreation: "Cancel creation",
    finalizeAndCreate: "Finalize and Create",
    finalizeAndSave: "Finalize and Save",
    continueButton: "Continue",
    nextRecurrence: "Next: Recurrence",
    selectAll: "Select all",
    applyEmoji: "🌟 Apply 🌟",
    or: "or",
    ideal: "ideal",
    tooMuch: "too much",
    attitudeNameHeader: "Attitude Name",
    descriptionHeader: "Description",
    valueHeader: "Value",
    activeHeader: "Active",
    nameHeader: "Name",
    activeGamesHeader: "Active segments",
    classesHeader: "Classes",
    editHeader: "Edit",
    descriptionPrefix: "Description:",
    createdBy: "Created by:",
    deletedLabel: "deleted",
    allLabel: "All",
    noRewards: "No rewards",
    editMission: "Edit quest",
    editAttitudeLabel: "Edit attitude",
    noPlayerFound: "No players found",
    noPlayerFoundSubtitle: "Change the filters or register more players in the attitude's segments",
    searchByNamePlaceholder: "Search by name...",
    allClasses: "All Classes",
    studentCount: "{{count}} student(s)",
    playersSelected: "{{count}} player(s) selected",
    selectAtLeastOneStudent: "Select at least one student",
    applyAttitudeForStudents: "Apply attitude for {{count}} student(s)",
    applyAttitudeDialogTitle: "Apply Attitude: {{name}}",
    receivedTimes: "Received {{count}} times",
    receivedOnce: "Received 1 time",
    notReceivedToday: "Not received today",
    noClass: "No class",
    levelImage: "level image",
    configureRecurrence: "Configure Recurrence",
    defineAutoApply: "Define when this attitude will be applied automatically",
    applicationFrequency: "Application frequency",
    howItWorks: "How it works:",
    autoApplyOnSelectedDays: "Automatic application on selected days",
    validForAllStudents: "Valid for all students in classes",
    canBePausedAnytime: "Can be paused at any time",
    newAttitudeDialogTitle: "New Attitude",
    howToCreateQuestion: "How would you like to create this new attitude?",
    suggestionBank: "Suggestion Bank",
    suggestionBankDesc: "Explore our library with ready-to-use attitudes.",
    createFromScratch: "Create from Scratch",
    createFromScratchDesc: "Fully customize the name, rules, and rewards.",
    attitudeLibrary: "Attitude Library",
    searchByNameOrDesc: "Search by name or description...",
    positiveTab: "Positive",
    negativeTab: "Negative",
    tryAnotherSearch: "Try searching for another term",
    showingOptions: "Showing {{count}} options",
    notFoundCreateFromScratch: "Didn't find it? Create from scratch",
    attitudeDetailsTitle: "Attitude Details",
    customizeDescription: "Customize how this attitude will be displayed and scored.",
    recurrenceMode: "Recurrence Mode",
    recurrenceModeDesc: "This attitude will be applied automatically. Only positive attitudes are allowed in this mode.",
    impactType: "Impact Type",
    positiveLabel: "Positive",
    recognizeGoodBehavior: "Recognize good behaviors",
    negativeLabel: "Negative",
    correctBehavior: "Correct behaviors",
    attitudeNameLabel: "Attitude Name",
    attitudeNamePlaceholder: "E.g.: Class participation",
    attitudeNameRequired: "Please give the attitude a name.",
    descriptionLabel: "Description",
    optionalLabel: "(Optional)",
    descriptionPlaceholder: "Briefly describe the reason for this attitude...",
    rewardPenalty: "Reward / Penalty",
    impactOnXpAndCoins: "Impact on XP and Coins",
    impactOnCoins: "Impact on Coins",
    selectRewardValue: "Select a reward value.",
    customRewardValue: "Custom value",
    whereToApply: "Where to apply?",
    selectGamesDesc: "Select the segments that will have access to this attitude.",
    availableGames: "Available Segments ({{count}})",
    noGameFound: "No segments found.",
    limitExceededTitle: "Attitude limit exceeded",
    limitExceededDesc: "You have already reached the recommended limit of 5 positive or 3 negative attitudes. Adding more attitudes may make the system confusing for students and make it harder to understand the rules.",
    recommendationsTitle: "Recommendations:",
    recommendationKeepMax: "Keep a maximum of 5 attitudes of each type for easier understanding",
    recommendationConsolidate: "Consider reviewing and consolidating similar attitudes",
    recommendationSimple: "Simpler and clearer attitudes are more effective",
    confirmExceedLimit: "I understand that I am exceeding the recommended limit and that this may negatively affect the student experience. I wish to proceed anyway and use Gamefik in non-recommended mode.",
    continueAnyway: "Proceed anyway",
    missionsType: "Quests",
    missionsTooltip: "Quests are occasional events that happen once or a few times.",
    yesOption: "Yes",
    noOption: "No",
    nameLabel: "Name",
    positiveRecurrenceInfo: "This is a positive recurrence. Recurrences are always positive and are automatically applied on selected days.",
    selectType: "Select the type",
    gamesApplicableRecurrence: "In which segments is this recurrence applicable?",
    gamesApplicableMission: "In which segments is this quest applicable?",
    gamesApplicableAttitude: "In which segments is this attitude applicable?",
    pointsToGainMission: "How many points should the player earn for completing this quest?",
    pointsToGainAttitude: "How many points should the player earn for completing this attitude?",
    recurrencePriorityNegative: "What is the priority of this negative recurrence?",
    recurrencePriorityPositive: "What is the priority of this positive recurrence?",
    recurrenceTitle: "Recurrence",
    visibleOnlyInHmg: "Visible only in staging",
    recurrenceSelectTooltip: "If you select yes, you will be able to set a frequency for this attitude to be applied automatically.",
    mandatoryCollection: "Expire uncollected points",
    mandatoryCollectionTooltip: "When enabled, students must open the app and collect the points before the period ends. Daily automations must be collected on the same day; weekly automations by the end of the week. Uncollected points expire.",
    classesTitle: "Classes",
    issuesFound: "Issues found:",
    operationInProgress: "Operation in progress...",
    selectAtLeastOneGame: "Select at least one segment",
    fillName: "Enter a name",
    fillDescription: "Enter a description",
    selectTypeReason: "Select the type",
    selectAtLeastOneClass: "Select at least one class",
    saveButton: "Save",
    continuousMission: "Continuous quest",
    continuousMissionInfo1: "A continuous quest remains available to the player even after being completed.",
    continuousMissionInfo2: "If the quest can be completed multiple times, check this option.",
    recurrenceAutoApplyInfo: "This recurrence will be automatically applied based on the selected frequency",
    priorityVeryLow: "Very Low",
    priorityLow: "Low",
    priorityModerate: "Moderate",
    priorityHigh: "High",
    priorityVeryHigh: "Very high",
    difficultyQuick: "Quick",
    difficultyVeryEasy: "Very Easy",
    difficultyEasy: "Easy",
    difficultyHard: "Hard",
    difficultyVeryHard: "Very hard",
    difficultyLasting: "Lasting",
    difficultyMedium: "Medium",
    difficultyHardTeacher: "Hard",
    applyAttitudesTitle: "Apply attitudes",
    studentsWhoWillReceive: "Students who will receive:",
    errorApplyingAttitudeToPlayer: "Error applying attitude {{attitude}} to {{player}}.",
    otherAttitudesAppliedCorrectly: "All other attitudes were applied correctly.",
    playerNotLinkedToGame: "One or more selected players are not linked to a segment ({{name}}).",
    selectOneOrMorePlayers: "Select one or more players",
    positiveAttitudesHeader: "Positive attitudes",
    negativeAttitudesHeader: "Negative attitudes",
    missionsHeader: "Quests",
    closeButton: "close",
    applyWithStars: "🌟 Apply 🌟",
    studentsLabel: "students",
    attitudesLabel: "attitudes",
    allStudentsWillReceive: "All students will receive all selected attitudes!",
    noAttitudesSelected: "No attitudes selected",
    manualLaunchTitle: "Manually launching: {{name}}",
    selectAClass: "Select a class",
    search: "Search",
    clearButton: "Clear",
    launchAttitude: "Apply attitude!",
    launchMission: "Apply quest!",
    selectAtLeastOnePlayer: "Select at least one player",
    applyAttitudeButton: "Apply attitude",
    applyMissionButton: "Apply quest",
    general: "General",
    selectAType: "Select a type",
    multipliable: "Stackable",
    nothingAvailable: "Nothing available here",
    selectAPlayer: "Select a player!",
    deletedClass: "deleted",
    allClassesChip: "All",
    editAttitudeTitle: "Edit Attitude",
    closeButtonLabel: "Close",
    createdSuccess: "Attitude created successfully",
    headTitle: "Attitudes | Gamefik Schools at max level.",
    positiveTitle: "Positive attitudes",
    negativeTitle: "Negative attitudes",
    recommendationTitle: "Recommendation",
    statusChangedSuccess: "Attitude status changed successfully",
    updatedSuccess: "Attitude updated successfully",
    showingCount: "Showing {{count}} attitudes",
    deleteAttitude: "Delete attitude",
    editLabel: "Edit",
    apply: "Apply",
    linkedGames: "Linked segments",
    deleteLabel: "Delete",
    objectiveLabel: "Goal",
    allGames: "All segments",
    statusTabs: {
      all: "All",
      active: "Active",
      inactive: "Inactive",
    },
    typeTabs: {
      all: "All",
      positive: "Positive",
      negative: "Negative",
    },
    filterLabel: "Filter",
    filterWithType: "Filter: {{type}}",
    confirmDeleteDescription:
      "Are you sure you want to delete this attitude? This action cannot be undone.",
    editAttitudeTooltip: "Edit attitude",
    inactiveBadge: "Inactive",
    statusLabel: "Status:",
    detailsSectionTitle: "Details",
    systemUser: "System",
    debugJson: "Debug JSON",
    xpAndCoinAlt: "XP and coins",
    coinsAlt: "Coins",
    tips: {
      clearObjective: {
        title: "Define clear, objective attitudes",
        description:
          "Create attitudes with clear descriptions so students understand what is expected of them.",
        placeholder: "Video showing how to create an attitude with a clear, objective description",
      },
      balance: {
        title: "Balance positive and negative attitudes",
        description:
          "Keep a balance between recognizing positive behaviors and correcting negative ones.",
        placeholder: "Video demonstrating the balance between positive and negative attitudes",
      },
      consistency: {
        title: "Be consistent when applying",
        description: "Apply attitudes consistently and fairly for all students.",
        placeholder: "Video showing how to apply attitudes consistently",
      },
      revisit: {
        title: "Review regularly",
        description: "Review attitudes periodically to ensure they stay relevant.",
        placeholder: "Video on how to review and update attitudes periodically",
      },
      fairValues: {
        title: "Use appropriate values",
        description: "Assign coin and point values according to how important the attitude is.",
        placeholder: "Video explaining how to set appropriate values for attitudes",
      },
    },
    suggestions: {
      positive: {
        presence: { name: "Attendance", desc: "Attend classes regularly." },
        punctuality: { name: "Punctuality", desc: "Arrive on time for activities." },
        homework: { name: "Homework", desc: "Complete homework on time." },
        classwork: { name: "In-class work", desc: "Complete assigned tasks with dedication." },
        teamwork: {
          name: "Collaboration and teamwork",
          desc: "Help classmates and work well in groups.",
        },
        respect: {
          name: "Respected teachers and peers",
          desc: "Treat everyone with courtesy and consideration.",
        },
        materials: {
          name: "Complete materials",
          desc: "Bring all materials and be properly uniformed.",
        },
        participation: {
          name: "Active participation",
          desc: "Contribute in activities and engage in class.",
        },
      },
      negative: {
        excessTalk: { name: "Excessive talking", desc: "Talking out of turn and disrupting class." },
        phoneMisuse: {
          name: "Inappropriate phone use",
          desc: "Using the phone without permission during class.",
        },
        unexcusedAbsences: {
          name: "Unexcused absences",
          desc: "Arriving late or missing class without reason.",
        },
        carelessMaterial: {
          name: "Careless with personal or school property",
          desc: "Damaging books, desks, equipment, or leaving trash around.",
        },
      },
    },
  },
  quizzes: {
    editQuiz: "Edit quiz",
    alternative: "Option {{index}}",
    removeAlternative: "Remove option",
    save: "Save",
    cancel: "Cancel",
    exportToExcel: "Export to Excel",
    tipsQuestionTypesTitle: "Vary question types",
    tipsQuestionTypesDescription: "Mix multiple choice, true/false, and short-answer questions.",
    tipsQuestionTypesPlaceholder: "Video showing different question types for quizzes",
    tipsDifficultyTitle: "Balance difficulty",
    tipsDifficultyDescription: "Include questions of different difficulty levels to challenge all students.",
    tipsDifficultyPlaceholder: "Video on how to balance question difficulty",
    tipsResultsTitle: "Analyze results",
    tipsResultsDescription: "Use reports to identify areas where learning can improve.",
    tipsResultsPlaceholder: "Tutorial video on analyzing quiz results",
    tipsExplanationsTitle: "Provide explanations",
    tipsExplanationsDescription: "Include explanations for wrong answers to support learning.",
    tipsExplanationsPlaceholder: "Video demonstrating how to provide useful explanations",
    tipsAiQuestionsTitle: "Use AI to create questions",
    tipsAiQuestionsDescription: "Take advantage of AI-generated questions to save time.",
    tipsAiQuestionsPlaceholder: "Video on using AI to create quiz questions",
    createQuiz: "Create Quiz",
    quizzes: "Quizzes",
    loading: "Loading...",
    checkingIaCredits: "Checking AI credits/plan...",
    iaCheckError: "Could not verify your AI credits right now. Please try again later.",
    basicInfo: "Basic information",
    selectGames: "Select segments",
    enableCoins: "Enable coins",
    deadlinesAndSettings: "Deadlines and settings",
    questionIndex: "Question {{index}}",
    discursiveEvaluation: "Open-ended answer evaluation",
    byAi: "🤖 By AI",
    manually: "👨‍🏫 Manually",
    titleRequired: "Quiz title is required.",
    descriptionRequired: "Quiz description is required.",
    atLeastOneQuestion: "The quiz must have at least one question.",
    questionStatementRequired: "Fill in the statement for every question.",
    alternativesRequired: "Fill in every alternative; each multiple-choice question needs at least two.",
    correctAlternativeRequired: "Select a valid correct answer for every multiple-choice question.",
    createError: "The quiz could not be created. Review the data and try again.",
    rewardsRequired: "Quiz rewards are required.",
    selectEvaluationMethod: "Select how open-ended answers will be evaluated (AI or manual).",
    classesRequired: "Quiz classes are required.",
    cannotExpireNow: "The quest cannot expire now! Give your students more time.",
    back: "back",
    waiting: "Please wait...",
    create: "Create",
    previewTitle: "Quiz preview",
    questionsGenerated: "{{count}} questions generated",
    moreQuestions: "+{{count}} questions...",
    difficultyEasy: "Easy",
    difficultyMedium: "Medium",
    difficultyAdvanced: "Advanced",
    rename: {
      questions: "question",
      rewards: "rewards",
      classes: "classes",
      alternatives: "alternatives",
      startDate: "start date",
      expirationDate: "expiration date",
      title: "Title",
      description: "Description",
      statement: "Statement",
      teacherCanValidate: "Teacher can validate",
      notifyStudents: "Notify students",
      startsAt: "📅 Starts at",
      endsAt: " 📅 Ends at",
    },
    selectImage: "Select an Image",
    searchImages: "Search images...",
    imageSearchHint:
      "Search the web and pick an image. Results appear below — scroll the list to see more.",
    imageSearchEmptyTitle: "Search for an image",
    imageSearchEmptyHint:
      'Enter a term (e.g. "food culture") and tap Search.',
    imageSearchNoResults: "No images found",
    imageSearchNoResultsHint: "Try another term or broader keywords.",
    imageSearchBack: "Back to search",
    imageSearchOpenSource: "Open source page",
    confidenceHigh: "high",
    confidenceMedium: "medium",
    confidenceLow: "low",
    search: "Search",
    searchFailed: "Failed to search images. Try again.",
    noTitle: "No title",
    image: "Image",
    from: "From:",
    unknown: "Unknown",
    confidence: "Confidence:",
    confidenceUnknown: "unknown",
    confirmSelection: "Confirm Selection",
    editImage: "Edit Image",
    confirm: "Confirm",
    reviewDiscursive: "Review Open-ended Answers",
    exportToExcelButton: "📊 Export to Excel",
    correctAnswers: "Correct",
    partialAnswers: "Partial",
    errors: "Errors",
    averageCorrect: "Avg correct",
    uniqueStudents: "Unique students",
    resubmissions: "Resubmissions",
    review: "Review",
    questionsLabel: "Questions",
    answerDistribution: "Answer distribution",
    totalAnswers: "{{count}} total answers",
    submitted: "Submitted",
    pending: "Pending",
    correct: "Correct",
    partialOrWrong: "Partial/Wrong",
    all: "All",
    pendingTab: "Pending",
    reviewed: "Reviewed",
    searchAnswerContent: "Search by answer content",
    submissions: "Submissions",
    clickToEvaluate: "Click to open and evaluate",
    repeated: "REPEATED",
    answersCount: "{{count}} answers",
    players: "Players",
    clickPlayerRow: "Click on the player row to open the review",
    name: "Name",
    classLabel: "Class",
    reviewedCount: "Reviewed",
    pendingCount: "Pending",
    actions: "Actions",
    reviewPending: "Review pending",
    allReviewed: "All reviewed",
    noSubmissions: "No submissions found",
    classRanking: "Class Ranking",
    orderedByReviewRate: "Ordered by review rate",
    reviewedOfSubmissions: "{{reviewed}} reviewed of {{total}} submissions",
    noClassData: "No class data",
    reviewSubmission: "Review submission",
    close: "Close",
    statusReviewed: "Reviewed",
    statusPending: "Pending",
    statusAi: "AI",
    statusCorrect: "CORRECT",
    statusPartial: "PARTIAL",
    statusWrong: "WRONG",
    toggleCorrect: "Correct",
    togglePartial: "Partial",
    toggleWrong: "Wrong",
    student: "Student",
    sentAt: "Sent at",
    evaluation: "Evaluation",
    evaluationManual: "Manual",
    evaluationAi: "AI",
    status: "Status",
    totalResponses: "Total responses",
    statementLabel: "Statement",
    studentAnswer: "Student answer",
    teacherFeedback: "Teacher feedback",
    feedbackPlaceholder: "Write feedback/justification for the student",
    aiReasoning: "AI reasoning",
    coins: "coins",
    totalEstimated: "Total estimated: {{total}} coins",
    saving: "Saving...",
    saveEvaluation: "Save evaluation",
    noDataToExport: "No data to export",
    studentName: "Student name",
    game: "Segment",
    noClass: "No class",
    totalCorrect: "Total correct",
    totalErrors: "Total errors",
    totalPartial: "Total partial",
    coinsReceived: "Coins received",
    quizAnswers: "Quiz Answers",
    questions: "Questions",
    totalQuestions: "Total: {{count}} questions",
    addQuestion: "Add question",
    newQuestion: "New question",
    removeQuestion: "Remove question",
    addAlternative: "Add alternative",
    multipleChoice: "Multiple choice",
    discursive: "Open-ended",
    quizTopic: "Quiz Topic",
    topicPlaceholder: "E.g.: Quiz about the Solar System, Brazilian History, Basic Math...",
    topicHint: "Be specific for better results. E.g.: \"Quiz about the capitals of South American countries\"",
    detailedDescription: "Detailed description (optional)",
    descriptionPlaceholder: "Describe in more detail the content you want to cover in the quiz, specific topics, approach, etc.",
    numberOfQuestions: "Number of questions",
    nQuestions: "{{count}} questions",
    age6to10: "6 to 10 years",
    age6to10Desc: "Kindergarten, elementary school or children in general",
    simpleLanguage: "Simple language",
    age10to15: "10 to 15 years",
    age10to15Desc: "Middle school or teenagers",
    deepLanguage: "In-depth language",
    age15to18: "15 to 18 years",
    age15to18Desc: "High school or technical",
    technicalLanguage: "Technical language",
    age18plus: "Above 18 years",
    age18plusDesc: "Higher education or professional",
    academicLanguage: "Academic language",
    teacherTip: "Tip for teachers",
    educationLevelTip: "The education level automatically adjusts the vocabulary and complexity of questions to suit the target audience.",
    easyDesc: "Common and everyday questions about the topic, without specific prior knowledge",
    mediumDesc: "More complex questions that require prior knowledge about the topic",
    advancedDesc: "Highly uncommon questions that require specific training in the area",
    difficultyTip: "Choose a difficulty level that is appropriate for your quiz's target audience and scoring.",
    goBack: "Back",
    nextStep: "Next Step",
    generateQuiz: "GENERATE QUIZ",
    createWithAi: "Create Quiz with AI",
    createFromScratch: "Create from Scratch",
    searchQuizByName: "Search quiz by name",
    selectAGame: "Select a segment",
    selectAClass: "Select a class",
    selectATeacher: "Select a teacher",
    allGames: "All segments",
    allClasses: "All classes",
    allTeachers: "All teachers",
    allDifficulties: "All difficulties",
    allTab: "All",
    activeTab: "Active",
    inactiveTab: "Inactive",
    noGameSelected: "No segment selected",
    more: "+{{count}} more",
    noQuizFound: "No quiz found",
    noQuizFoundSub: "Change the filters or create more quizzes",
    quizActivated: "Quiz activated successfully.",
    quizDeactivated: "Quiz deactivated successfully.",
    quizRemoved: "The quiz has been removed successfully.",
    quizUpdated: "The quiz has been updated successfully.",
    noIaCreditsTitle: "No AI credit available",
    noIaCreditsDesc: "Your school's account has no AI credits. Create your quiz manually or contact the account manager.",
    createManualQuiz: "Create manual quiz",
    discursiveLabel: "Open-ended",
    multipleChoiceLabel: "Multiple choice",
    autoApproval: "Automatic approval",
    aiApproval: "AI approval",
    manualApproval: "Manual approval",
    disabled: "Disabled",
    createdBy: "Created by:",
    userFallback: "User",
    difficulty: "Difficulty:",
    creationDate: "Creation date:",
    expirationDate: "Expiration date:",
    noExpiration: "No expiration date",
    statusLabel: "Status:",
    gamesLabel: "Segments:",
    classesLabel: "Classes:",
    performance: "Performance:",
    hitRate: "Accuracy: {{rate}}%",
    results: "Results",
    bncc: "BNCC",
    delete: "Delete",
    debugJson: "Debug JSON",
    confirmDelete: "Confirm deletion",
    confirmDeleteMessage: "Are you sure you want to delete this quiz?",
    confirmDeleteAction: "Confirm deletion",
    discursiveSummary: "Open-ended answers summary",
    studentsSent: "Students who submitted: {{count}}",
    awaitingEvaluation: "Awaiting evaluation: {{count}}",
    approvedCorrect: "Approved (correct): {{count}}",
    incomplete: "Incomplete: {{count}}",
    wrong: "Wrong: {{count}}",
    awaitingTeacherReview: "{{count}} awaiting teacher review",
    reviewAction: "Review",
    requiredField: "Required field",
    requiredFieldDesc: "Please enter the quiz topic.",
    requiredSelection: "Required selection",
    requiredSelectionDesc: "Please select the target audience age range.",
    questionType: "Question type",
    multipleChoiceOption: "Multiple choice",
    discursiveOption: "Open-ended",
    questionTypeHint: "Choose whether you want only multiple choice or only open-ended questions.",
    cancelButton: "CANCEL",
    backButton: "BACK",
    nextStepButton: "NEXT STEP",
    generatingQuiz: "GENERATING QUIZ...",
    generateQuizButton: "GENERATE QUIZ",
    preparingQuiz: "Preparing the quiz...",
    generatingQuestion: "Generating question #{{number}}",
    finishingDetails: "Finishing final details",
    createWithFiles: "Create Quiz with files",
    createWithFilesTitle: "Create Quiz with Files",
    createWithFilesDesc: "Upload to create a quiz based on visual content",
    upload: "Upload",
    processing: "Processing",
    completed: "Completed",
    quizTitle: "Quiz Title",
    quizTitlePlaceholder: "E.g.: Quiz about Marine Biology",
    uploadImages: "Upload Images",
    clickToUpload: "Click to upload",
    supportedFormats: "Supported formats: JPG, PNG, WEBP, PDF",
    imagesSelected: "{{count}} images selected",
    imageSelected: "{{count}} image selected",
    clearAll: "Clear all",
    processFiles: "Process Files",
    limitExceeded: "Limit exceeded",
    limitExceededDesc: "You can upload up to 50 images.",
    noImages: "No images",
    noImagesDesc: "Please upload at least one image.",
    titleRequiredToast: "Title required",
    titleRequiredDesc: "Please enter a title for the quiz.",
    processingImages: "Processing images...",
    processingComplete: "Processing complete!",
    processingDesc: "Our AI is analyzing your images and generating relevant questions for the quiz. This may take a few minutes.",
    processingDoneDesc: "All images have been processed successfully. Your quiz is ready for review.",
    percentComplete: "{{percent}}% complete",
    hundredComplete: "100% complete",
    quizGeneratedSuccess: "Quiz generated successfully!",
    quizGeneratedDesc: "Our AI analyzed your images and created a personalized quiz. Now you can review and adjust the questions before publishing.",
    quizSummary: "Quiz Summary",
    titleLabel: "Title:",
    processedImages: "Processed images:",
    generatedQuestions: "Generated questions:",
    estimatedDifficulty: "Estimated difficulty:",
    reviewQuiz: "Review Quiz",
    quizGeneratedToast: "Quiz generated successfully!",
    quizGeneratedToastDesc: "Now you can review and configure the quiz before publishing.",
    undo: "Undo",
    redo: "Redo",
    heading1: "Heading 1",
    heading2: "Heading 2",
    bold: "Bold",
    italic: "Italic",
    strikethrough: "Strikethrough",
    superscript: "Superscript",
    subscript: "Subscript",
    bulletList: "Bullet List",
    orderedList: "Numbered List",
    blockquote: "Blockquote",
    code: "Code",
    textColor: "Text Color",
    colorLabel: "Color {{color}}",
    insertLink: "Insert Link",
    link: "Link",
    insertImage: "Insert Image",
    insertVideo: "Insert video",
    insertVideoPrompt: "Paste a YouTube link or video URL",
    videoDialogHint: "Choose how you want to add the video.",
    videoSourceChoose: "How do you want to add it?",
    videoSourceYoutube: "YouTube video",
    videoSourceYoutubeDesc: "Paste a YouTube link — we embed the player in the content.",
    videoSourceUpload: "Upload file",
    videoSourceUploadDesc: "MP4, WebM, and other formats hosted on Gamefik.",
    videoSourceLink: "Video link",
    videoSourceLinkDesc: "Direct URL to an .mp4 file or similar.",
    videoBack: "Back to options",
    videoYoutubePanelHint: "Follow the steps to embed a YouTube video.",
    videoUploadPanelHint: "Upload a video file from your computer.",
    videoLinkPanelHint: "Paste the public URL of the video file.",
    videoYoutubeStep1: "Open the video on YouTube.",
    videoYoutubeStep2: "Click Share → Copy link.",
    videoYoutubeStep3: "Paste the link below and check the embed preview.",
    videoYoutubeFieldLabel: "YouTube link",
    videoYoutubePlaceholder: "https://www.youtube.com/watch?v=…",
    videoYoutubeInvalid: "We could not recognize this link. Use the full YouTube video URL.",
    videoYoutubeValid: "Valid link — check the player below.",
    videoYoutubeConfirm: "Use this embed",
    videoYoutubeReady: "YouTube embed is ready. Click Insert to add it to the text.",
    videoEmptyTitle: "No video selected",
    videoPreviewLabel: "Preview",
    videoLinkLabel: "Video URL",
    videoLinkPlaceholder: "https://example.com/video.mp4",
    videoLinkApply: "Use link",
    videoUpload: "Upload video",
    imageLabel: "Image",
    imageDialogHint:
      "Upload an image, search the web, or pick from the educational image bank.",
    imageEmptyTitle: "No image selected",
    imagePreviewLabel: "Preview",
    insertAttachment: "Insert Attachment",
    attachmentDialogHint:
      "Upload a file, search the web, or pick from the educational image bank.",
    attachmentUpload: "Upload file",
    attachmentSearch: "Search the web",
    attachmentBank: "Image bank",
    attachmentReady: "File ready to insert",
    attachment: "Attachment",
    mobilePreview: "Mobile Preview",
    viewOnMobile: "View on mobile",
    formattingToolbar: "Text formatting",
    mediaToolbar: "Insert media and preview",
    insert: "Insert",
    closeModal: "Close modal",
    iphonePreview: "iPhone 12/13 (375 × 812 px)",
    imageBank: "Educational Image Bank",
    coverDefaultsTitle: "School cover default",
    coverDefaultsDescription: "Choose the source and, below, the subject used for new activities.",
    coverSourceLabel: "Cover source",
    coverDefaultCategoryLabel: "Default subject",
    coverSourceSubject: "Selected subject",
    coverSourceCharacters: "Gamefik characters",
    coverSourceMixed: "Subject and characters",
    saveCoverDefault: "Save default",
    coverDefaultSaved: "Default saved for this school.",
    coverDefaultSaveError: "The default could not be saved. Check your permission and try again.",
    selectCategoryForCoverDefault: "Select a subject or category below to save this default.",
    categoriesLabel: "Categories",
    allCategories: "All",
    searchCategories: "Search categories...",
    noResults: "No results found.",
    loadingCategories: "Loading categories...",
    noImagesCategory: "No images in this category",
    tryAnotherCategory: "Try selecting another category or subcategory.",
    exploreImageBank: "Explore the Image Bank",
    selectCategoryToStart: "Select a category above to get started.",
    clearSelection: "Clear selection",
    useImage: "Use image",
    previousImage: "Previous image",
    nextImage: "Next image",
    addToFavorites: "Add to favorites",
    removeFromFavorites: "Remove from favorites",
    closePreview: "Close preview",
    resultsTitle: "Results:",
    participation: "Participation",
    completionRate: "{{rate}}% completion",
    hitRateTitle: "Accuracy Rate",
    information: "Information",
    difficultyLabel: "Difficulty:",
    valueLabel: "Value:",
    createdByLabel: "Created by:",
    dateLabel: "Date:",
    questionsByHitRate: "Questions by Accuracy Rate",
    questionsByHitRateDesc: "Ordered from highest to lowest accuracy",
    hitsCount: "{{count}} correct ({{rate}}%)",
    errorsCount: "{{count}} errors ({{rate}}%)",
    noQuestionsFound: "No questions found for this quiz",
    playersTitle: "Players",
    playersDesc: "List of students who completed the quiz",
    allClassesFilter: "All classes",
    searchByName: "Search by name",
    nameNotAvailable: "Name not available",
    classNotAvailable: "Class not available",
    noPlayersFound: "No players found with the selected filters",
    showingPlayers: "Showing {{filtered}} of {{total}} players",
    classRankingTitle: "Class Ranking",
    classRankingDesc: "Performance by class ordered by accuracy",
    hitPercentage: "{{rate}}% correct",
    studentsCount: "{{completed}}/{{total}} students ({{rate}}%)",
    hitsOfResponses: "{{hits}} correct of {{total}} responses",
    questionDetails: "Question Details",
    correctAnswer: "Correct Answer: {{answer}}",
    hitsTab: "Correct ({{count}})",
    errorsTab: "Errors ({{count}})",
    noStudentsCorrect: "No student got this question right",
    allStudentsCorrect: "All students got this question right",
    nameErrorNotAvailable: "Error: Student name not available",
    classStudents: "Class Students",
    completedCount: "{{completed}}/{{total}} completed",
    hitRateLabel: "Accuracy",
    studentsTookQuiz: "Students who took it",
    participationRate: "Participation rate",
    studentList: "Student List",
    position: "Pos.",
    date: "Date",
    noStudentsTookQuiz: "No student from this class took the quiz yet",
    showingStudents: "Showing {{count}} students who took the quiz",
    studentPerformance: "Student Performance",
    questionsCorrect: "Questions correct",
    allQuestions: "All ({{count}})",
    hitsTabPlayer: "Correct ({{count}})",
    errorsTabPlayer: "Errors ({{count}})",
    correctLabel: "CORRECT",
    wrongLabel: "WRONG",
    studentAnswerLabel: "Student answer:",
    correctAnswerLabel: "Correct answer:",
    answerLabel: "Answer:",
    noQuestionsAnswered: "The student didn't answer any questions",
    noCorrectAnswers: "The student didn't get any questions right",
    allQuestionsCorrect: "The student got all questions right!",
    noAnswersYet: "No answers yet",
    noStudentsCompleted: "No student has completed this quiz yet.",
    refresh: "Refresh",
    errorOccurred: "An error occurred",
    errorLoadingData: "Failed to load quiz data or players. Check your connection and try again.",
    dataNotAvailable: "Quiz data not available.",
    tryAgain: "Try again",
    undoQuiz: "Undo quiz (Staging)",
    itemsRemoved: "Items removed",
    undoQuizDesc: "The quiz \"{{title}}\" was undone for this student. The transactions and receipt below were removed and the record was sent to history.",
    undoQuizGeneric: "The quiz was undone for this student. The removals were sent to history.",
    receipt: "Receipt",
    receiptRemoved: "Receipt marked as removed",
    noReceiptReturned: "No receipt returned.",
    transactionsRemoved: "Transactions removed",
    transactionsCount: "{{count}} transactions removed",
    transactionsSummary: "Summary of removed transactions",
    noTransactionsFound: "No transactions found for removal.",
    historyNote: "Note: A record detailing the removals was sent to this account's history.",
    undoConfirm: "Are you sure you want to undo this quiz? This action removes the associated transactions.",
    receiptNotFound: "Receipt not found for this student",
    quizUndone: "Quiz undone successfully",
    undoFailed: "Failed to undo the quiz, contact support",
    nameHeader: "Name",
    classHeader: "Class",
    hitsHeader: "Correct",
    rateHeader: "Rate",
    descriptionHeader: "Description",
    pointHeader: "Point",
    valueHeader: "Value",
    createdAtHeader: "Created at",
    idLabel: "ID:",
    descriptionFieldLabel: "Description:",
    correctFieldLabel: "Correct:",
    wrongFieldLabel: "Wrong:",
    totalFieldLabel: "Total:",
    createdAtFieldLabel: "Created at:",
    classesResult: "Classes",
    studentLabel: "Student",
    studentHitRate: "Accuracy",
    viewBtn: "View",
    downloadBtn: "Download",
    imageFallback: "Image {{index}}",
    descriptionPlaceholderModal: "📝 Describe additional details about the content...",
    addNewQuestionTooltip: "Add new question",
    multipleSubmissionsTooltip: "This player has multiple submissions",
    allClassesShort: "All",
  },
  historyCategory: {
    players: "Players",
    game: "Segment",
    launch: "Feedback",
    class: "Class",
    shop: "Store",
    attitude: "Attitude",
    block: "Block",
    missions: "Quests",
    transactions: "Transactions",
    system: "System",
    khan: "Khan Academy",
    recurrence: "Recurrence",
    ai: "AI",
    missionProofs: "Submissions",
    quizzes: "Quizzes",
    nullifiedTransactions: "Nullified Transactions",
    security: "Security",
    aiCredits: "AI Credits",
    letrus: "Letrus",
  },
  historyType: {
    create: "Creation",
    update: "Update",
    remove: "Removal",
    delete: "Deletion",
    accepted: "Accepted",
    delivered: "Delivered",
    canceled: "Canceled",
    changeClass: "Class Change",
    changeGame: "Segment Change",
    generateQrCode: "QR Code Generation",
    resetGame: "Segment Reset",
    apply: "Apply",
    edit: "Edit",
    freeze: "Freeze",
    prove: "Submission",
    tempUnlock: "Temporary Unlock",
    khanDailyBonus: "Khan Daily Bonus",
    khanWeeklyBonus: "Khan Weekly Bonus",
    khanMonthlyBonus: "Khan Monthly Bonus",
    khanWeeklyMasteryBonus: "Khan Mastery Bonus (Weekly)",
    khanMonthlyMasteryBonus: "Khan Mastery Bonus (Monthly)",
    khanOccasionalPercentBonus: "Khan Percentage Bonus",
    nullify: "Nullification",
    applyRecurrence: "Apply Recurrence",
    startApplyRecurrence: "Start Recurrence",
    aiActivate: "Enable AI",
    aiDeactivate: "Disable AI",
    aiScheduleCancel: "Cancel AI Schedule",
    aiChangePlan: "Change AI Plan",
    aiApplyDiscount: "Apply AI Discount",
    aiToggle: "Toggle AI",
    aiSelectStudents: "AI Student Selection",
    aiSelectStudentsV2: "AI 2.0 student selection",
    aiGenerateAttempt: "AI generation started",
    aiGenerateSuccess: "AI generation completed",
    aiGenerateFailure: "AI generation failed",
    generateQrCodeVoleimania: "Voleimania QR Code generation",
    khanMarcosBonus: "Khan milestone bonus",
    xpDisable: "XP disabled",
    xpEnable: "XP enabled",
    spent: "Spent",
    adjust: "Adjustment",
    dailyAlert: "Daily Alert",
    impersonationTokenGenerated: "Access Token Generated",
    impersonationLoginSuccess: "Impersonation Login",
    letrusMonthly: "Letrus Monthly Report",
  },
  historyDialog: {
    noData: "No data available",
    activityDetails: "Activity details",
    overview: "Overview",
    details: "Details",
    technicalData: "Technical data",
    dateAndTime: "Date and time",
    categoryAndType: "Category and type",
    affectedPlayers: "Affected players ({{count}})",
    identifiers: "Identifiers",
    account: "Account",
    completeDataJson: "Complete data (JSON)",
    showJson: "Show JSON",
    hideJson: "Hide JSON",
    downloadQrCode: "Download QR code",
    submissions: "Submissions",
    pending: "Pending",
    reviewed: "Reviewed",
    searchAnswerContent: "Search by answer content",
    answerDistribution: "Answer distribution",
    totalAnswers: "{{count}} total answers",
    submitted: "Submitted",
    correct: "Correct",
    partialOrWrong: "Partial/Wrong",
    repeat: "Repeat",
    reviewRate: "Review",
    uniqueStudents: "Unique students",
    averageCorrect: "Average correct",
    questions: "Questions",
    responses: "Responses",
    partial: "Partial",
    errors: "Errors",
    repeated: "REPEATED",
    submittedAt: "Submitted on {{date}}",
    unknownDate: "Unknown date",
    missionNotFound: "Quest not found",
    backToSelection: "Back to selection",
    selectMission: "Select a quest",
    pendingOne: "{{count}} pending",
    pendingOther: "{{count}} pending",
    noMissionAvailable: "No quest available",
    exportCsv: "Export CSV",
    loadErrorTitle: "There was an error loading the data.",
    loadErrorDescription: "Check your connection and try again.",
    retry: "Try again",
    loadingData: "Loading data...",
    updating: "Updating...",
    approvedOne: "{{count}} awarded",
    approvedOther: "{{count}} awarded",
    activities: "{{count}} activities",
    students: "{{count}} students",
    periodSummary: "Period summary",
    processedMonthReport: "Processed monthly report",
    generatedAt: "Generated on {{date}}",
    writes: "Writes",
    rewrites: "Rewrites",
    totalDistributed: "Total distributed",
    operationPerformed: "Operation performed:",
    monthlyLetrusReport: "Letrus monthly report",
    pageSummary: "Page {{page}} of {{totalPages}} • {{count}} activities",
    noActivityFound: "No activity found",
    noActivityDescription: "Try adjusting the filters or performing some actions in the system",
    applyingFilters: "Applying filters...",
    processingData: "Processing data",
    clearFilters: "Clear filters",
    allUsers: "All users",
    processed: "Processed",
    awarded: "Awarded",
    allGames: "All segments",
    allClasses: "All classes",
    noStudentFound: "No student found",
    adjustFilters: "Try adjusting the filters",
    noClass: "No class",
    searchingTransactions: "Searching for transactions with",
    noTransactionFound: "No transaction found",
    transactionsRemovedOrNotSaved: "Transactions may have been removed or not saved",
    attitudeRemovedNoDetails: "Attitude removed without detailed data",
    removalRecordKeptInHistory: "Only the removal record was kept in history",
    noPlayersAffected: "No players affected",
    noScoringSystemConfigured: "No scoring system configured",
    noPointTypeSpecified: "No point type specified",
    progressZeroed: "Progress reset",
    missionsReset: "Quests reset",
    productImage: "Product image",
    removedProductImage: "Removed product image",
    noGameLinked: "No segment linked",
    showingTransactions: "Showing transactions with",
    user: "User",
    actions: "Actions",
  },
  historyPage: {
    startLoading: "Starting...",
    loadingHistory: "Loading history...",
    loadedPeriods: "{{loaded}} of {{total}} periods loaded",
    progressText: "{{count}}%",
    loadedRecords: "{{count}} records loaded so far — you can already use the filters while the rest loads.",
    filtersAndSearch: "Filters and search",
    search: "Search",
    searchPlaceholder: "Search activities...",
    startDate: "Start date",
    endDate: "End date",
    category: "Category",
    allCategories: "All categories",
    type: "Type",
    noTypeAvailable: "No type available",
    allTypes: "All types",
    khanBonus: "Khan Academy bonus",
    otherTypes: "Other types",
    previousPage: "Previous",
    nextPage: "Next",
  },
  gift: {
    pageTitle: "[GiftCard] - GiftCard | Gamefik Schools at max level.",
    overview: "Overview",
    buyGifts: "Buy gifts",
    giftCardDetails: "Gift card details",
    giftCardDescriptionTitle: "Description",
    copyIssuedCode: "Copy {{name}} code",
    issuedTitle: "Issued gift cards",
    issuedStudent: "Student",
    issuedStudentUnavailable: "Not provided",
    receiptDetails: "Receipt details",
    receiptMessageTitle: "Receipt message",
    howToUse: "How to use",
    termsAndConditions: "Terms and conditions",
    termsAndConditionsLink: "Terms and conditions",
    redeemInstructionsFallback: "Check the redemption instructions below.",
    readAndAcceptTerms: "I have read and accept the terms of use",
    usageTermsAccept: "I have read and accept the terms of use",
    cancel: "Cancel",
    confirmAndAdd: "Confirm and add",
    details: "Details",
    viewSpecifications: "View specifications",
    specificationsDescription: "Read the rules, scroll to the end, and accept the terms to continue your purchase.",
    termsPending: "Terms pending. Review and accept",
    termsAccepted: "Terms read and accepted",
    reviewAndAcceptTerms: "Review and accept terms",
    scrollTermsToEnd: "Scroll to the end to enable acceptance of the terms.",
    termsEndReached: "You reached the end. Now check the confirmation below.",
    acceptTermsExplicitly: "I have read all specifications and accept the terms for this gift card.",
    acceptTermsAction: "Accept terms for this gift card",
    usageLocations: "Where it can be used",
    description: "Description",
    receiptMessage: "Receipt message",
    search: "Search",
    loadError: "Unable to load gift cards.",
    tryAgain: "Try again",
    balance: "Balance",
    stock: "Balance",
    addBalance: "Add balance",
    selectValue: "Select amount",
    available: "{{count}} available",
    gameLabel: "Segment *",
    costInCoins: "How much will it cost (in coins) *",
    coinsPlaceholder: "Value in coins",
    playerLimit: "Limit per student",
    unlimited: "Unlimited",
    advancedSettings: "Advanced settings",
    optional: "Optional",
    schedule: "Schedule",
    noLimits: "No limits",
    limitPerStudent: "{{count}} per student",
    clearCart: "Clear cart",
    finishWithBalance: "Finish with balance",
    emptyCart: "Empty",
    finalizeWithBalance: "Finish with Balance",
    purchaseSummary: "Purchase summary",
    items: "Items",
    subtotal: "Subtotal",
    minimumValueDescription: "You can add a balance equal to or greater than R$50.00.",
    confirm: "Confirm",
    close: "Close",
    viewTerms: "view terms",
    filtersTitle: "Filters",
    valueLabel: "Value",
    myBalance: "My Balance",
    availableValues: "Available values",
    continueButton: "Continue",
    congratsPurchase: "Congratulations on your purchase!",
    makeCardsAvailable: "Make the cards available to students!",
    finishButton: "Finish",
    startingFrom: "Starting from R$ {{value}}",
    viewProduct: "View Product",
    makeAvailableInStore: "Make available in Store",
    howToUseLabel: "How to Use",
    continueShopping: "Continue Shopping",
    sendToStore: "Send to store",
    buyGift: "Buy Gift",
    refundButton: "Refund",
    selectGiftForDelivery: "Select a gift to deliver",
    giftCardDiscontinued: "Unfortunately, this gift card has been discontinued",
    requestRefund: "Request refund",
    deliverGiftToStudent: "Deliver gift to student",
  },
  balance: {
    walletBalanceTitle: "My wallet balance",
    updated: "Updated",
    totalDeposits: "Total deposits",
    totalPurchases: "Total purchases",
    totalTransactions: "Total transactions",
    back: "Back",
    overviewExtractTitle: "Overview - Statement",
    overviewExtractDescription: "Track all of your financial transactions",
    refresh: "Refresh",
    tutorial: "Tutorial",
    addBalanceTitle: "Add balance and delight your students with our gift cards",
    addBalanceDescription: "You can add a balance equal to or greater than R$50.00.",
    minimumValueDescription: "You can add a balance equal to or greater than R$50.00.",
    enterValue: "Enter amount",
    addBalanceAction: "Add balance",
    fullName: "Full name",
    cpfOrCnpj: "Tax ID",
    acceptTerms: "I accept the terms and conditions",
    continue: "Continue",
    pay: "Pay",
    overview: "Overview",
    addBalancePage: "Add Balance",
    namePlaceholder: "Name",
    emailLabel: "Email",
    emailPlaceholder: "Email",
    termsTitle: "TERMS OF USE FOR GAMEFIK BALANCE AND GIFT CARDS",
    cancelButton: "Cancel",
    acceptButton: "Accept",
    invalidName: "Invalid name",
    invalidCpfCnpj: "Invalid Tax ID",
    invalidEmail: "Invalid email",
    acceptTermsError: "Accept the terms of use",
    payValue: "Pay R${{value}}.00",
    backButton: "Back",
    refundNotice: "Balance refundable only for requests made within 7 days after payment",
    cardData: "Card Details",
    cardNumber: "Card Number",
    month: "Month",
    year: "Year",
    holderData: "Holder Details",
    holderName: "Holder Name",
    cardHolder: "Card Holder",
    cellphoneLabel: "Mobile",
    zipCode: "Zip Code",
    creditCard: "Credit card",
    paymentSuccess: "Payment completed successfully",
    pixKey: "Pix Key:",
    pixInstruction: "Use the pix key above, or the QR code in your banking app to make the payment.",
    finalize: "Finalize",
    pixPayment: "Payment via PIX!",
    boletoGenerated: "Your boleto has been generated!",
    boletoInstruction: "Pay your boleto now or by the due date. To pay, copy the barcode, open your bank's app or website and make the payment.",
    orderDetails: "Order Details",
    taxesAndFees: "Taxes and Fees",
    includingTaxes: "Including taxes",
    extractDetailedTitle: "Detailed Statement",
    extractType: "Type",
    extractDetails: "Details",
    extractValue: "Amount",
    extractPurchaseValue: "Purchase amount",
    extractMethod: "Method",
    extractQuantity: "Quantity",
    extractDate: "Date",
    accumulatedBalance: "Accumulated Balance",
    receipt: "Receipt",
    noTransactions: "No transactions found",
    transactionsWillAppear: "Your transactions will appear here when available.",
    giftPurchase: "Gift Purchase",
    refund: "Refund",
    userOrigin: "User",
    adminAddBalance: "Admin - Add balance",
    adminRemoveBalance: "Admin - Remove balance",
    boletoPix: "Boleto/Pix",
    boletoMethod: "Boleto",
    creditCardMethod: "Credit card",
    adminMethod: "Admin",
    pixMethod: "PIX",
    notInformed: "Not informed",
    balanceMethod: "Balance",
    paymentTitle: "Payment",
    payWith: "Pay with",
    pixLabel: "Pix",
    cardDataTitle: "Card Details",
    cardNumberLabel: "Card Number",
    monthLabel: "Month",
    yearLabel: "Year",
    cvvLabel: "CVV",
    holderDataTitle: "Cardholder Details",
    holderNameLabel: "Cardholder Name",
    holderNamePlaceholder: "Cardholder",
    cpfCnpjLabel: "CPF/CNPJ",
    cpfCnpjPlaceholder: "Enter the cardholder's CPF/CNPJ!",
    phoneLabel: "Phone",
    mobilePhoneLabel: "Mobile",
    postalCodeLabel: "Zip Code",
    numberLabel: "Number",
    complementLabel: "Complement",
    complementPlaceholder: "House/Apt",
    saveCardData: "Save my card data",
    payAmount: "Pay R${{value}}.00",
    creditCardTitle: "Credit card",
    paymentSuccessTitle: "Payment completed successfully",
    thankYouPurchase: "Thank you for your purchase",
    returnToHome: "Return to home",
    privacyNotice: "Your personal data will be used to process your order, support your experience throughout this website and for other purposes described in our privacy policy.",
    pixKeyLabel: "Pix Key:",
    pixInstructions: "Use the Pix key above, or the QR code in your banking app to make the payment.",
    finalizeButton: "Finalize",
    pixPaymentTitle: "Payment via PIX!",
    emailCopySent: "We sent a copy to your email",
    valueLabel: "Value: R${{value}}.00",
    extractButton: "Statement",
    boletoGeneratedTitle: "Your boleto has been generated!",
    boletoPayInstructions: "Pay your boleto now or by the due date.",
    boletoPayDetails: "To pay, copy the barcode, open your banking app or website and complete the payment.",
    viewBoleto: "View Boleto",
    orderDetailsTitle: "Order Details",
    balanceRecharge: "Balance recharge",
    subtotalLabel: "Subtotal",
    feesLabel: "Fees and Charges",
    totalLabel: "Total",
    includingFees: "Including fees",
    refundNoticePayment: "Balance refundable only for requests made up to 7 days after payment",
    januaryMonth: "January",
    februaryMonth: "February",
    marchMonth: "March",
    aprilMonth: "April",
    mayMonth: "May",
    juneMonth: "June",
    julyMonth: "July",
    augustMonth: "August",
    septemberMonth: "September",
    octoberMonth: "October",
    novemberMonth: "November",
    decemberMonth: "December",
  },
  sharedInfoModal: {
    trigger: "Best practices",
    title: "Best practices: {{pageName}}",
    videosTab: "Videos",
    textTab: "Text",
    understood: "Got it",
  },
  legacyAlertDialog: {
    cancel: "Cancel",
    accept: "Accept",
  },
  communication: {
    pageTitle: "Feed",
    pageSubtitle: "Manage announcements, events and school deadlines",
    viewing: "Viewing:",
    selectClass: "Select class",
    feed: "Feed",
    shinyOnlyTitle: "The Feed is available on the Shiny plan",
    shinyOnlyDescription: "The Feed is part of the Shiny plan. Subscribe to Shiny to unlock announcements, events, and the full class feed.",
    shinyOnlySecondary: "Back",
    calendar: "Calendar",
    metrics: "Metrics",
    announcements: "Announcements",
    views: "Views",
    events: "Events",
    upcomingDeadlines: "Upcoming Deadlines",
    viewAll: "View all",
    noScheduledDeadline: "No scheduled deadlines",
    mostViewed: "Most Viewed",
    noAnnouncementForClass: "No announcements for this class",
    allDeadlines: "All Deadlines",
    noActivityThisDay: "No activity on this day",
    createActivityThisDay: "Create activity on this day",
    details: "Details",
    description: "Description",
    studentCompletion: "Student completion",
    studentsCompleted: "{{percent}}% of students completed",
    noStudentAssigned: "No students assigned yet",
    edit: "Edit",
    delete: "Delete",
    whatToCreate: "What would you like to create?",
    eventLabel: "Event",
    eventDesc: "Meetings, parties, presentations",
    quizLabel: "Quiz",
    quizDesc: "Quick questions and assessments",
    missionLabel: "Quest",
    missionDesc: "Challenges and timed activities",
    newEvent: "New Event",
    newQuiz: "New Quiz",
    newMission: "New Quest",
    eventTitleLabel: "Event title",
    quizTitleLabel: "Quiz title",
    missionTitleLabel: "Quest title",
    eventTitlePlaceholder: "E.g.: Parent meeting",
    quizTitlePlaceholder: "E.g.: Math Quiz",
    missionTitlePlaceholder: "E.g.: Monthly Reading",
    schedule: "Time",
    deadlineTime: "Deadline (time)",
    location: "Location",
    locationPlaceholder: "E.g.: Auditorium",
    coins: "Coins",
    numberOfQuestions: "Number of questions",
    descriptionOptional: "Description (optional)",
    describeEvent: "Describe the event...",
    describeQuiz: "Describe the quiz...",
    describeMission: "Describe the quest...",
    cancel: "Cancel",
    createEvent: "Create Event",
    createQuiz: "Create Quiz",
    createMission: "Create Quest",
    deleteEvent: "Delete event",
    deleteQuiz: "Delete quiz",
    deleteMission: "Delete quest",
    deleteConfirm: "Are you sure you want to delete",
    actionCannotBeUndone: "This action cannot be undone.",
    viewAnnouncementTitle: "View announcement",
    duplicatedSuccess: "Announcement duplicated successfully",
    duplicateError: "Error duplicating announcement",
    createPostError: "Failed to create post. Try again.",
    createEventError: "Failed to create event. Try again.",
    deleteSuccess: "Deleted successfully",
    deleteError: "Error deleting. Try again.",
    editSuccess: "Changes saved successfully",
    editError: "Error saving changes. Try again.",
    createEventSuccess: "Event created successfully",
    questions: "questions",
    completed: "completed",
    participants: "participants",
    monthNames: "January,February,March,April,May,June,July,August,September,October,November,December",
    weekDays: "Sun,Mon,Tue,Wed,Thu,Fri,Sat",
    now: "Now",
    minAgo: "{{count}} min ago",
    hoursAgo: "{{count}} hour{{suffix}} ago",
    daysAgo: "{{count}} day{{suffix}} ago",
    roleTeacher: "Teacher",
    roleSecretary: "Secretary",
    roleFinancial: "Financial",
    roleManager: "Manager",
    more: "+{{count}} more",
    wholeSchool: "Whole school",
    allClasses: "All classes",
    teachers: "Teachers",
    students: "Students",
    teachingStaff: "Teaching staff",
    editAction: "Edit",
    duplicateAction: "Duplicate",
    shareLink: "Share link",
    deleteAction: "Delete",
    inspectJson: "Inspect JSON",
    reactions: "reactions",
    noReactionsYet: "No reactions yet",
    viewsCount: "views",
    viewsTitle: "Views ({{count}})",
    reactionsTitle: "Reactions ({{count}})",
    seeMore: "See more ({{count}})",
    deleteAnnouncement: "Delete announcement",
    deleteAnnouncementConfirm: "Are you sure you want to delete this announcement? This action cannot be undone.",
    linkCopied: "Link copied",
    noReactionYet: "No reactions yet",
    whatToCommunicate: "What would you like to communicate?",
    postTitleRequired: "Title *",
    eventName: "Event name *",
    eventDescOptional: "Event description (optional)",
    date: "Date",
    time: "Time",
    bold: "Bold",
    italic: "Italic",
    underline: "Underline",
    list: "List",
    numberedList: "Numbered list",
    insertLink: "Insert link",
    enterLinkUrl: "Enter the link URL:",
    photo: "Photo",
    video: "Video",
    attachment: "Attachment",
    addImage: "Add image",
    addVideo: "Add video",
    attachFile: "Attach file",
    embedQuiz: "Embed quiz",
    embedMission: "Embed quest",
    createEventAction: "Create event",
    backToAnnouncement: "Back to announcement",
    publishAction: "Publish",
    published: "Published!",
    sendingProgress: "Sending {{done}}/{{total}}...",
    publishing: "Publishing...",
    publishError: "Error publishing. Try again.",
    publishWhen: "When to publish",
    publishNow: "Publish now",
    schedulePost: "Schedule",
    muralAiButton: "Create with AI",
    muralAiOpen: "Create Mural text with AI",
    muralAiTitle: "Create text with AI",
    muralAiDescription: "Describe the announcement. AI will suggest a title and text you can edit before publishing.",
    muralAiPromptLabel: "What would you like to communicate?",
    muralAiPromptPlaceholder: "E.g. Write a welcoming announcement about Friday's cultural fair.",
    muralAiCost: "This suggestion costs {{cost}} AI credits.",
    muralAiGenerate: "Generate suggestion",
    muralAiGenerating: "Generating...",
    muralAiPromptRequired: "Describe the announcement you want to create.",
    muralAiError: "We could not generate the text right now. Your content was preserved; try again.",
    scheduleDateTime: "Date and time",
    scheduleHint: "Push notifications and other effects will be sent at the selected time.",
    scheduleFutureError: "Choose a future date and time.",
    scheduleAction: "Schedule",
    scheduling: "Scheduling...",
    scheduledSuccess: "Scheduled!",
    scheduledPosts: "Scheduled",
    scheduledPostsHint: "Edit content, reschedule, or cancel pending posts.",
    backToFeed: "Back to feed",
    noScheduledPosts: "No scheduled posts.",
    scheduledBadge: "Scheduled",
    untitledPost: "Untitled post",
    rescheduleAction: "Reschedule",
    cancelScheduledAction: "Cancel schedule",
    rescheduledSuccess: "Post rescheduled successfully.",
    scheduledCancelledSuccess: "Schedule canceled successfully.",
    scheduledConflictError: "This post has already been published or changed. Refresh the Feed to see its current state.",
    scheduledActionError: "The schedule could not be changed. Try again.",
    scheduledEditorHint: "Change the time in the Scheduled area.",
    schedulingCapabilityError: "We could not check whether scheduling is available.",
    retryAction: "Try again",
    emptyContentError: "Write some text or attach an image/file before saving.",
    notifyPushLabel: "Notify students via push",
    notifyPushHint: "Students get a notification on their phone with the beginning of the announcement.",
    where: "Where:",
    classes: "Classes:",
    all: "All",
    classesCount: "{{count}} classes",
    embeddedQuiz: "Embedded quiz",
    embeddedMission: "Embedded quest",
    quizAvailable: "Quiz available",
    missionAvailable: "Quest available",
    selectQuiz: "Select Quiz",
    selectMission: "Select Quest",
    searchQuiz: "Search quiz...",
    searchMission: "Search quest...",
    noQuizFound: "No quiz found",
    noMissionFound: "No quest found",
    editAnnouncement: "Edit Announcement",
    duplicateAnnouncement: "Duplicate Announcement",
    saveChanges: "Save changes",
    publishCopy: "Publish copy",
    sending: "Sending...",
    uploadError: "Error uploading files:",
    current: "Current",
    future: "Future",
    until: "Until",
    legendEvents: "Events",
    legendQuizzes: "Quizzes",
    legendMissions: "Quests",
    linkUrlPrompt: "Link URL:",
    schoolBadge: "School",
    quizBadge: "QUIZ",
    missionBadge: "MISSION",
    eventBadgeLabel: "EVENT",
    moreStudentsCount: "+{{count}} students",
    coinsUnit: "coins",
    freeLimitBannerTitle: "Free plan limit reached",
    freeLimitBannerDescription: "The Free plan allows up to {{limit}} announcements on the wall. Upgrade to Shiny to post without limits.",
    freeUnavailableBannerTitle: "Wall unavailable on the Free plan",
    freeUnavailableBannerDescription: "The Free plan doesn't include wall announcements. Upgrade to Shiny to post.",
    freeLimitBannerCta: "See plans",
    freeLimitUsageLabel: "Announcements published",
    freeLimitModalTitle: "You reached the Free plan limit",
    freeLimitModalDescription: "You have already published {{count}} of {{limit}} announcements available on the Free plan. Subscribe to Shiny to post without limits.",
    freeLimitModalCta: "Subscribe to Shiny",
    freeLimitModalDismiss: "Got it",
  },
  recurrence: {
    pageTitle: "Automations & Recurrences",
    eyebrow: "Automation",
    pageDescription: "Schedule recurring attitudes, track what is active, and decide when uncollected points should expire.",
    summaryTitle: "Automation summary",
    summaryActive: "Active automations",
    summaryPaused: "Paused automations",
    summaryExpiring: "With point expiration",
    listTitle: "Your automations",
    listDescription: "Manage frequency, segments, collection, and status in one place.",
    totalCount: "{{count}} automations",
    rewardsLabel: "Reward",
    createDialogDescription: "Configure the attitude, frequency, and collection rules for this automation.",
    creating: "Creating...",
    createNew: "Create New Recurrence",
    coinDistributionAnalysis: "Coin Distribution Analysis by Recurrence",
    analyzedRecurrences: "Analyzed Recurrences",
    totalCoins: "Total Coins",
    totalTransactions: "Total Transactions",
    monthlyDistributionHistory: "Monthly Coin Distribution History",
    detailByRecurrence: "Detail by Recurrence",
    attitudeNotFound: "Attitude not found",
    active: "Active",
    inactive: "Inactive",
    createdAt: "Created at:",
    transactions: "transactions",
    monthlyDistribution: "Monthly distribution of this recurrence:",
    aboutAnalysis: "About this analysis:",
    analysisInfo1: "This analysis shows the actual history of coin distribution by recurrences",
    analysisInfo2: "Data is based on transactions actually performed",
    analysisInfo3: "Each recurrence may have different monthly distribution patterns",
    analysisInfo4: "Use this information to optimize your gamification strategies",
    progressAnalysis: "Progress Analysis: Distributed vs Predicted",
    alreadyDistributed: "Already Distributed",
    predictedRemaining: "Predicted (Remaining)",
    yearTotal: "Year Total",
    progress: "Progress",
    annualDistributionProgress: "Annual Distribution Progress",
    yearStart: "Start of year",
    yearEnd: "End of year",
    distributed: "Distributed:",
    remaining: "Remaining:",
    timelineHistoryVsPrediction: "Timeline: History vs Prediction",
    historicalData: "Historical Data (coins already distributed)",
    predictionForPeriod: "Prediction for the period",
    greenBarExplanation: "The green bar appears over the blue to compare actual vs predicted performance",
    progressInsights: "Progress Insights:",
    distributionRhythm: "Distribution Rhythm:",
    coinsPerMonth: "Average of {{count}} coins/month",
    annualGoal: "Annual Goal:",
    completedOfTotal: "{{percent}}% completed of total projected",
    projection: "Projection:",
    coinsUntilDecember: "{{count}} coins remaining until December",
    efficiency: "Efficiency:",
    transactionsCompleted: "{{count}} transactions completed",
    detailedCoinPredictions: "Detailed Coin Prediction Calculations",
    activeRecurrences: "Active Recurrences",
    daysUntilYearEnd: "Days until year end",
    totalPredicted: "Total Predicted",
    detailedCalcByRecurrence: "Detailed Calculation by Recurrence",
    totalOfThisRecurrence: "Total of this recurrence",
    stepByStepCalc: "Step-by-step calculation:",
    applicationFrequency: "Application frequency",
    applications: "applications",
    coinsPerApplication: "Coins per application",
    configuredInAttitude: "Value configured in the attitude",
    eachTimeApplied: "Each time the attitude is applied to a student",
    coinsLabel: "coins",
    affectedStudents: "Affected students",
    totalStudentsReceiving: "Total students who will receive the attitude",
    studentsLabel: "students",
    finalCalc: "Final calculation",
    applicationsTimesCoinsTimesStudents: "{{apps}} applications × {{coins}} coins × {{students}} students",
    distributionByGame: "Distribution by segment:",
    unknownGame: "Unknown segment",
    calcFormula: "Calculation Formula:",
    formulaTotalCoins: "Total Coins",
    formulaApplications: "Applications",
    formulaCoinsPerApp: "Coins per Application",
    formulaStudentCount: "Number of Students",
    formulaApplicationsDesc: "Calculated based on frequency (daily, weekly, monthly) and remaining days in the year",
    formulaCoinsPerAppDesc: "Value configured in the attitude",
    formulaStudentCountDesc: "Active students in segments associated with the recurrence",
    individualPrediction: "Individual Prediction: Coins per Student",
    averagePerStudent: "Average per Student",
    averageCalc: "Average Calculation:",
    totalCoinsLabel: "Total coins:",
    numberOfStudents: "Number of students:",
    average: "Average:",
    yearlyPreviewByGame: "Total Coin Forecast Until Year End by Segment",
    generalTotal: "Grand Total",
    coinsDistributedTo: "Coins to be distributed to {{count}} students",
    untilDate: "until 12/31/{{year}}",
    detailByGame: "Breakdown by Segment",
    studentsCount: "{{count}} students",
    perStudent: "{{count}} per student",
    gameTotal: "Segment total",
    activeRecurrencesInGame: "Active recurrences in this segment:",
    totalOfThisRecurrenceShort: "Total of this recurrence",
    applicationsLabel: "Applications:",
    perApplication: "Per application:",
    days: "Days:",
    daysOfMonth: "Days of the month:",
    importantInfo: "Important information:",
    info1: "This forecast considers only active recurrences",
    info2: "Each recurrence is applied once per day per student according to the configured schedule",
    info3: "Values show the total coins to be distributed per segment",
    info4: "The calculation considers all active students in each segment",
    info5: "The forecast is calculated from today until 12/31/{{year}}",
    noRecurrenceFound: "No recurrences found",
    createFirstRecurrence: "Create your first recurrence to automate attitudes",
    createFirstButton: "Create First Recurrence",
    mandatoryCollection: "Mandatory collection:",
    yes: "Yes",
    no: "No",
    everyDay: "Every day",
    everyWeekdays: "Every {{days}}",
    monthDays: "Day(s) {{days}} of the month",
    createdOn: "Created on",
    gamesLabel: "Segments:",
    deleteButton: "Delete",
    invalidateUncollectedPoints: "Expire uncollected points",
    invalidateUncollectedPointsDescription: "Students must collect in the app during the automation period. Otherwise, the points expire.",
    pauseButton: "Pause",
    reactivateButton: "Reactivate",
    createNewRecurrence: "Create New Recurrence",
    confirmDeletion: "Confirm Deletion",
    confirmDeleteMessage: "Are you sure you want to delete this recurrence? This action cannot be undone.",
    recurrenceLabel: "Recurrence:",
    frequencyLabel: "Frequency:",
    cancelButton: "Cancel",
    deleting: "Deleting...",
    deleteAction: "Delete",
    loadError: "Error loading recurrences",
    createSuccess: "Recurrence created successfully! 🎉",
    createError: "Error creating recurrence",
    activatedSuccess: "Recurrence activated successfully!",
    deactivatedSuccess: "Recurrence deactivated successfully!",
    mandatoryCollectionActivatedSuccess: "Uncollected points will now expire.",
    mandatoryCollectionDeactivatedSuccess: "Future points will not expire when they are not collected.",
    toggleError: "Error updating recurrence",
    deleteSuccess: "Recurrence deleted successfully!",
    deleteError: "Error deleting recurrence",
    recurrenceNotFound: "Recurrence not found",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    dailyApplication: "Daily application",
    weeklyApplication: "Weekly application: {{days}}",
    monthlyApplication: "Monthly application: days {{days}}",
    daysRemainingCalc: "{{days}} remaining days × 1 application per day",
    daysPerWeekCalc: "{{daysPerWeek}} days per week × {{weeks}} weeks",
    daysPerMonthCalc: "{{daysPerMonth}} days per month × {{months}} months",
    dayNameSun: "Sun",
    dayNameMon: "Mon",
    dayNameTue: "Tue",
    dayNameWed: "Wed",
    dayNameThu: "Thu",
    dayNameFri: "Fri",
    dayNameSat: "Sat",
    monthNameShort: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
    current: "Current",
    future: "Future",
  },
  bncc: {
    pageTitle: "BNCC Selection",
    pageSubtitle: "Select a competency from the National Common Curricular Base through the interactive modal",
    openSelection: "Open BNCC Selection",
    selectedCompetency: "Selected Competency",
    id: "ID: ",
    title: "Title: ",
    descriptionLabel: "Description: ",
    area: "Area: ",
    levels: "Levels: ",
  },
  details: {
    pageTitle: "Players | Gamefik Schools at max level.",
    playersTitle: "Players",
    playersSubtitle: "Manage students, apply attitudes, and adjust coins without leaving the list.",
    filteredPlayersCount: "{{filtered}} of {{total}}",
    loadingPlayers: "Loading players...",
    filtersLabel: "Filters",
    historyButton: "History",
    aiSelectionButton: "Select with AI",
    actionsPanelTitle: "Bulk actions",
    selectedPlayersCount: "{{count}} selected",
    selectPlayersHint: "Select students in the grid to unlock bulk actions, attitudes, and coin adjustments.",
    quickCoinsTitle: "Quick coin adjustment",
    quickCoinsEmptyHint: "Select students to apply",
    searchByName: "Search by name",
    appliedAttitudesHistory: "Applied attitudes history",
    selectStudentsWithAi: "Select students with AI",
    loadingHistory: "Loading history...",
    playersUpdated: "Players updated",
    updatingPlayers: "Updating {{count}} players",
    attitudesAppliedSuccess: "Attitudes awarded successfully!",
    inStudents: "to {{count}} student{{suffix}}",
    andMore: "... and {{count}} more",
    clickToSeeAttitudes: "Click here to see attitudes",
    addAction: "Add",
    removeAction: "Remove",
    coinsAndXp: "coins and xp",
    confirmAddRemoveTitle: "{{action}} {{amount}} coins {{xpText}}",
    confirmAddRemoveMessage: "Are you sure you want to {{action}} {{amount}} coins {{xpText}} from students:",
    confirmButton: "Confirm",
    cancelButton: "Cancel",
    quickCoinApplication: "Quick coin application",
    selectYourClasses: "Select your classes",
    classesPlaceholder: "Classes",
    saveButton: "Save",
    appliedAttitudesTitle: "Applied Attitudes History",
  },
  requestAttitude: {
    attitudeValidatedSuccess: "Attitude validated successfully.",
    requestError: "An error occurred while processing your request. Please try again later.",
    points: "Points:",
    creationDate: "Creation date:",
    reject: "Reject",
    accept: "Accept",
  },
  news: {
    systemUpdates: "What's new 🎉",
    newUpdates: "What's new",
    alreadySeen: "Already seen",
    allUpToDate: "All caught up!",
    allUpdatesViewed: "You've seen all updates.",
    noUpdateSeen: "No updates seen",
    seenUpdatesAppearHere: "Your viewed updates will appear here.",
    newLabel: "New",
    accessPage: "Go to page",
    close: "Close",
    dashboardTitle: "Dashboard page",
    dashboardDetails: "Now you have access to real-time data on engagement, store data, teacher usage and much more...",
    recurrencesTitle: "Recurrences page",
    recurrencesDetails: "Automate coin delivery to students, an excellent practice to always guarantee collection for all enrolled students.",
    quizzesTitle: "Quizzes page",
    quizzesDetails: "Create and apply gamified quizzes with automatic grading. A revolution in assessment!",
    attitudesTitle: "Attitudes page update",
    attitudesDetails: "New design, and now it's possible to apply attitudes from this screen, and check all players who received the entry.",
  },
  acessoAluno: {
    pageTitle: "Student Access",
    pageDescription: "See how the app appears to each student and copy their access details",
    browserTitle: "Student Access | Gamefik",
    bannerTitle: "Tip",
    bannerBody: 'Click "Copy access" next to a student\'s name to copy their link, or use "Print class access" to generate a PDF/spreadsheet with all links.',
    bannerDismissAria: "Dismiss tip",
    printButton: "Print class access",
    printButtonAllClassesTooltip: "Select a class to print access details",
    copyAccess: "Copy access",
    accessCopied: "Copied!",
    copyAccessUnavailable: "Unavailable for this student",
    credentialsCardAccessLinkLabel: "Access link",
    credentialsCardCopyButton: "Copy access details",
    credentialsCardCopiedButton: "Details copied!",
    openInNewTab: "Open in new tab",
  },
  classes: {
    general: "General",
    pageTitle: "Classes | Gamefik Schools",
    pageDescription: "Manage your school's classes and students on Gamefik.",
    editPageTitle: "Edit class | Gamefik Schools at max level.",
    newPageTitle: "New class | Gamefik Schools at max level.",
    newPageDescription: "Create a new class to organize your students and apply gamification to learning.",
    errorLoadingClasses: "Error loading classes",
    errorLoadingClassesTitle: "Error loading classes",
    errorLoadingClassesDescription: "We couldn't load your classes right now. Please try again — your classes haven't been deleted.",
    retryLoadingClasses: "Try again",
    deleteSelected: "Delete Selected ({{count}})",
    newClass: "New Class",
    classList: "Class List",
    classesFound: "{{count}} class(es) found",
    searchPlaceholder: "Search classes...",
    sortBy: "Sort by:",
    alphabetical: "Alphabetical",
    studentsLabel: "Students",
    clear: "Clear",
    noClassFound: "No class found",
    noClassCreated: "No class created",
    adjustSearchTerms: "Try adjusting the search terms",
    startCreatingClass: "Start creating your first class to organize students",
    createFirstClass: "Create first class",
    clickToSortByName: "Click to sort by name",
    clickToSortByStudents: "Click to sort by number of students",
    classColumn: "Class",
    gameColumn: "Segment",
    actionsColumn: "Actions",
    confirmDeletion: "Confirm Deletion",
    confirmDeletionDescription: "Are you sure you want to delete the selected classes? This action cannot be undone.",
    classesToBeDeleted: "Classes to be deleted:",
    deleting: "Deleting...",
    deleteClasses: "Delete Classes",
    classStudents: "Class Students",
    noStudentFound: "No student found",
    noStudentsRegistered: "This class has no registered students yet.",
    studentsFound: "{{count}} student(s) found",
    gamesLabel: "Segments:",
    moreGames: "+{{count}} more...",
    noGame: "No segment",
    gamesNotFound: "Segments not found",
    classDeletedSuccess: "Class deleted successfully",
    classesDeletedSuccess: "Classes deleted successfully",
    processingError: "An error occurred while processing your request",
    classSavedSuccess: "Class saved successfully.",
    classRemovedSuccess: "Class removed successfully.",
    requestError: "An error occurred while processing your request. Please try again later.",
    creatingClass: "Creating class...",
    classCreatedSuccess: "Class created successfully!",
    readyForStudents: "The class has been created and is ready to receive students!",
    configuring: "Configuring...",
    settings: "Settings",
    classLabel: "Class",
    finalization: "Finalization",
    guidedSetup: "Guided Setup",
    preselectedGameHint: "The segment was pre-selected to simplify the process",
    newClassTitle: "New Class",
    configureNewClass: "Set up a new class for your students",
    editClass: "Edit Class",
    classFormDescription: "Configure the class details and select the corresponding segment",
    className: "Class Name",
    classNameHint: "(Enter a descriptive name)",
    classNamePlaceholder: "E.g.: 6th Grade A, Morning Class...",
    classNameRequired: "Class name is required",
    classNameMinLength: "Name must be at least 2 characters",
    classNameMaxLength: "Name must be at most 50 characters",
    characters: "{{count}}/50 characters",
    nearLimit: "Near limit",
    classGame: "Class Segment",
    classGameHint: "(Select the class segment)",
    classGameRequired: "Select a segment for the class",
    preselectedGame: "Pre-selected Segment",
    preselectedGameDescription: "The segment was automatically set",
    updateClass: "Update Class",
    createClass: "Create Class",
    completeRequiredFields: "Complete all required fields to continue",
    confirmDeleteTitle: "Confirm Deletion",
    confirmDeleteDescription: "Are you sure you want to delete this class? This action is <strong>irreversible</strong> and all data related to the class will be permanently lost.",
    deleteWhatWillBeDeleted: "What will be deleted:",
    deleteClassData: "Class data",
    deleteActivityHistory: "Activity history",
    deleteStudentLinks: "Student links",
    deleteReportsAndStats: "Reports and statistics",
    deletePermanently: "Delete Permanently",
    errorDuplicateName: "A class with this name already exists. Choose another name.",
    errorInvalidGame: "Selected segment is not valid. Check if the segment is still active.",
    errorTeacherNotFound: "Teacher not found. Check if the teacher is still active.",
    errorInsufficientPermissions: "You do not have permission to create classes.",
    errorMaxClassesReached: "Maximum number of classes reached.",
    errorGeneric: "Error creating class. Check the data and try again.",
    errorConnection: "Connection problem. Check your internet and try again.",
    errorTimeout: "The operation took too long to respond. Try again.",
    errorServerCommunication: "Server communication error.",
    editClassTitle: "Edit class",
    nameColumn: "Name",
    createdColumn: "Created",
    editColumn: "Edit",
    nothingFound: "Nothing found",
    allClasses: "ALL CLASSES",
    all: "ALL",
    some: "SOME",
    allYourClasses: "All your classes",
    allClassesLabel: "All classes",
    allYourClassesCanSee: "All your classes will be able to see this quest",
    allClassesCanSee: "All classes of the selected segments will be able to see this quest",
    selectClasses: "Select classes",
    selectAClass: "Select a class",
    selectGameFirst: "Select a segment to see classes",
    noOptionFound: "No option found",
    selected: "{{count}} selected",
    studentsCount: "{{count}} students",
    turmasHeading: "Classes",
    turmasToolbarSearchPlaceholder: "Search...",
    turmasSortNameAsc: "Name A-Z",
    turmasSortNameDesc: "Name Z-A",
    turmasSortRecent: "Most recent",
    turmasSortOldest: "Oldest",
    turmasSortPerformance: "Best performance",
    turmasSortMostStudents: "Most students",
    turmasSortFewestStudents: "Fewest students",
    turmasSortMostXp: "Most XP",
    turmasSortMostCoins: "Most coins",
    importTemplateColClass: "Class",
    importTemplateColStudent: "Student name",
    importTemplateFileName: "class_import_template.csv",
    turmasSelectMultiple: "Select multiple",
    turmasExitSelectionMode: "Exit selection",
    turmasSelectAll: "Select all",
    turmasCancelSelection: "Cancel selection",
    turmasSortByLabel: "Sort by",
    turmasMoreOptionsAria: "More options",
    turmasImportLong: "Import classes",
    turmasImportShort: "Import",
    turmasPedagogicalReport: "Generate pedagogical report",
    turmasPedagogicalReportShort: "Report",
    turmasLaunch: "Feedback ({{count}})",
    turmasMoreActionsAria: "More actions",
    turmasAccessStudents: "Student access ({{count}})",
    turmasEditClassAction: "Edit class",
    turmasDeleteWithCount: "Delete ({{count}})",
    noStudentsInSelection: "No students in the selected classes.",
    accessInstructionsDownloadStarted: "Access instructions download started.",
    turmasPaginationSelection: "{{selected}} of {{total}} {{label}} selected",
    turmasPaginationPage: "Page {{current}} of {{total}}",
    turmasLabelShort: "class(es)",
    turmasPrevPageAria: "Previous page",
    turmasNextPageAria: "Next page",
    turmasAllStudentsCard: "All students",
    turmasUnlinkedStudentsCard: "Unlinked students",
    turmasUnlinkedStudentsCount: "{{count}} without class or segment",
    turmasLimitReached: "Limit reached",
    turmasAtLimitToast: "You have reached your plan limit of {{limit}} class(es).",
    turmasGameRequired: "Add or select a segment before creating classes.",
    turmasImportSuccess: "Import completed.",
    turmasImportError: "Error importing classes or students.",
    importTurmasProgressToast: "Importing {{current}} of {{total}} students...",
    turmasModalNewTitle: "New class",
    turmasModalEditTitle: "Edit class",
    turmasModalClassNameLabel: "Class name",
    turmasModalClassNamePlaceholder: "E.g. Class 3A",
    turmasModalSegmentLabel: "Segment",
    turmasModalSegmentPlaceholder: "Select segment",
    turmasModalCancel: "Cancel",
    turmasModalCreate: "Create class",
    turmasModalSave: "Save changes",
    turmasModalCloseAria: "Close",
    turmasAccessModalTitle: "Student access",
    turmasAccessModalSubtitle: "Download student access data",
    turmasAccessFormatLabel: "File format",
    turmasAccessPdfHint: "Printable document",
    turmasAccessSpreadsheetLabel: "Spreadsheet",
    turmasAccessSpreadsheetHint: "Excel / Google Sheets",
    turmasAccessInfoBox:
      "The file will include each student's access details: name, username, password, and QR code for quick app access.",
    turmasAccessDownloaded: "Downloaded!",
    turmasAccessGenerating: "Generating...",
    turmasAccessDownloadButton: "Download {{format}}",
    accessMissingWarning: "{{count}} student(s) still have no access code — they would appear without a link in the file. When downloading, we'll ask to generate them automatically.",
    accessMissingConfirmTitle: "Generate access codes?",
    accessMissingConfirmDesc: "{{count}} student(s) don't have an access code yet.",
    accessMissingConfirmHint: "We'll automatically generate access codes for {{count}} student(s) and continue the download. Other students' codes won't change.",
    accessMissingGenerate: "Generate and download",
    accessMissingGenerating: "Generating codes...",
    accessGenerateError: "Error generating access codes. Please try again.",
    accessGeneratePartial: "{{count}} student(s) still have no code — the file was generated without those links.",
    accessZipOptionTitle: "QR Codes",
    accessZipOptionHint: "ZIP with printable cards",
    accessZipModeLabel: "Student codes",
    accessZipKeepTitle: "Keep current codes",
    accessZipKeepHint: "Uses the QR codes already linked — printed cards keep working.",
    accessZipOverwriteTitle: "Generate new codes",
    accessZipOverwriteHint: "Overwrites the codes of every selected student — old QR codes and printed cards stop working.",
    accessZipMissingWarning: "{{count}} student(s) still have no access code — they would come out in the ZIP with an unlinked QR. Choose \"Generate new codes\" to link them.",
    accessZipInfoBox: "The ZIP will contain one QR Code card per student, organized in folders by class — ready to send to print.",
    accessZipGeneratingInfo: "Generating the ZIP on the server — this may take a few minutes. The file will also be available on the History page.",
    accessZipReadyInfo: "ZIP ready! Click \"Download ZIP\" to save the file.",
    accessZipTimeout: "Generation is taking longer than expected. It keeps running on the server — check the History page in a few minutes to download the file.",
    accessZipRequestError: "Could not start the ZIP generation (error {{status}}). Please try again.",
    accessZipOverwriteConfirmTitle: "Generate new codes?",
    accessZipOverwriteConfirmDesc:
      "The current QR codes of {{count}} student(s) will be overwritten — old codes and printed cards stop working immediately. This action is irreversible.",
    accessZipGenerateButton: "Generate ZIP",
    accessZipGeneratingButton: "Generating ZIP...",
    accessZipDownloadButton: "Download .zip",
    accessZipPrintOptionButton: "Print-ready",
    accessZipPrintTitle: "Card printing",
    accessZipPrintDesc: "Choose how the cards are laid out on the A4 sheet",
    accessZipPrintPresetLabel: "Page layout",
    accessZipPrintPresetOption: "{{count}} per page ({{grid}})",
    accessZipPrintPageIndicator: "Page {{page}} of {{total}}",
    accessZipPrintLoading: "Preparing the cards...",
    accessZipPrintLoadError: "Could not load the images from the ZIP. Download the .zip directly or try again.",
    accessZipPrintDownloadButton: "Download PDF",
    accessZipPrintGeneratingPdf: "Building PDF...",
    accessZipPrintPdfError: "Could not generate the PDF. Please try again.",
    searchEllipsis: "Search...",
    classesForCreation: "Classes for Creation",
    classCount: "{{count}} class",
    classesCountLabel: "{{count}} classes",
    viewJsonClasses: "View JSON - Classes for Creation ({{count}})",
    viewJsonPlayersAndClasses: "View JSON - Players and Classes ({{playersCount}} players, {{classesCount}} classes)",
    playersForCreation: "Players for Creation ({{count}}):",
    existingClasses: "Existing Classes in the System ({{count}}):",
    createNClasses: "Create {{count}} Class",
    createNClassesPlural: "Create {{count}} Classes",
    classesCreatedSuccess: "Classes created successfully!",
    errorCreatingClasses: "Error creating classes",
    creatingClasses: "Creating classes...",
    classCreatedToast: "Class created successfully!",
    errorCreatingClass: "Error creating class.",
    configureNewClassForStudents: "Set up a new class to organize your students",
    detailPageTitle: "Class management | Gamefik",
    detailPageDescription: "Class management — view and manage students.",
    classNotFoundHeadTitle: "Class not found | Gamefik",
    classNotFoundPageMessage: "Class not found.",
    detailLoadErrorTitle: "Could not load the class",
    detailLoadErrorHint: "Check your connection and try again.",
    tryAgain: "Try again",
    detailClassMissingTitle: "Class not found",
    detailClassMissingDescription: "The requested class was not found.",
    backToClasses: "Back to classes",
    staleDataBanner: "Failed to refresh — showing previous data.",
    editClassButtonAria: "Edit class",
    refreshingDataAria: "Refreshing data",
    refreshingTitle: "Refreshing...",
    refreshingInline: "Refreshing…",
    balanceLoading: "Refreshing student balance",
    balanceUnavailable: "Balance unavailable. Refresh the page.",
    updatedAt: "Updated at {{time}}",
    lastUpdatedTooltip: "Last updated at {{time}}",
    toastSelectStudentForLaunch: "Select at least one student to give feedback",
    toastSelectStudentForBulk: "Select at least one student to use bulk actions",
    detailLaunchWithCount: "Feedback ({{count}})",
    moveClassWithCount: "Move class ({{count}})",
    noStudentMatchSearchTitle: "No students found",
    noStudentMatchSearchHint: "Try adjusting your search terms",
    turmasStudentsLabelShort: "student(s)",
    playersDeletedSuccess: "Student(s) deleted successfully",
    playersDeleteError: "Error deleting student(s)",
    playersDeletePartialError: "Failed to delete {{count}} student(s).",
    alunoCardViewMenu: "View student",
    alunoCardEditMenu: "Edit",
    novoAlunoCardLabel: "New student",
    studentsMovedClassSuccess: "Students moved to another class successfully!",
    studentsMoveClassError: "Error moving students to another class.",
    playerUpdatedSuccess: "Student updated successfully",
    playerUpdateError: "Error updating student",
    deleteStudentsTitleOne: "Delete student",
    deleteStudentsTitleMany: "Delete students",
    deleteStudentConfirmIntro: "Are you sure you want to delete",
    deleteStudentConfirmOutro: "? This action cannot be undone.",
    thisStudentFallback: "this student",
    nStudentsCount: "{{count}} students",
    deletingStudentsAria: "Deleting students...",
    editStudentModalTitle: "Edit student",
    editStudentSegmentLabel: "Segment (segment)",
    editStudentSegmentHint: "The segment is determined by the classes and cannot be changed here.",
    newStudentTitle: "New student",
    importManyStudentsLink: "Import many students at once",
    importStudentsShort: "Import students",
    studentFirstNameLabel: "First name",
    studentFirstNamePlaceholder: "E.g.: John",
    studentLastNameLabel: "Last name",
    studentLastNamePlaceholder: "E.g.: Smith",
    studentEmailLabel: "Student email",
    studentEmailPlaceholder: "student@school.com",
    studentEmailHint: "Optional. Clear the field to unlink the email.",
    studentEmailInvalid: "Enter a valid email address.",
    studentClassesFieldLabel: "Classes",
    selectClassesPrompt: "Select classes",
    oneClassSelectedSummary: "1 class",
    nClassesSelectedSummary: "{{count}} classes selected",
    searchClassPlaceholder: "Search class...",
    noClassInFilter: "No class found.",
    clearClassesSelection: "Clear selection",
    studentMultipleClassesHint: "The student can belong to multiple classes",
    addingStudent: "Adding...",
    addStudentCta: "Add student",
    studentAddedToast: "Student {{name}} added successfully",
    createStudentError: "Error creating student",
    lancarSidebarLabel: "Feedback",
    lancarExpandAria: "Expand",
    lancarBackAria: "Back",
    lancarSubmitting: "Launching...",
    lancarTabAttitudes: "Attitudes",
    lancarTabFeedback: "Feedback",
    lancarAttitudesTitle: "Attitudes",
    lancarAttitudesSubtitle: "Select attitudes to give as feedback",
    lancarDefaultAttitudesBalanceDescription: "Default attitudes (not in catalog): {{summary}}",
    lancarPositive: "Positive",
    lancarNegative: "Negative",
    lancarAttitudeOrderSaving: "Saving order...",
    lancarAttitudeReorderHandle: "Reorder {{name}}",
    lancarAttitudeOrderSaveError: "Could not save the attitude order.",
    lancarAddAttitudeType: "Add {{type}}",
    lancarAddTypePositive: "positive",
    lancarAddTypeNegative: "negative",
    lancarFeedbackTitle: "Custom feedback",
    lancarFeedbackSubtitle: "Send custom feedback with coins to the selected students.",
    lancarReasonLabel: "Reason",
    lancarReasonPlaceholder: "Enter the reason the balance is being changed...",
    lancarAddCoins: "Add",
    lancarRemoveCoins: "Remove",
    lancarCoinsLabel: "Coins",
    lancarSetCoins: "Set balance",
    lancarManualBalanceDescription: "Manual coin adjustment",
    lancarTabChests: "Chests",
    lancarChestsHmgBadge: "HMG",
    lancarChestsHmgNotice: "Staging-only feature (localhost/hmg) — not visible in production.",
    lancarChestsTitle: "Give chests",
    lancarChestsSubtitle: "Grant surprise chests for the selected students to open in the app",
    lancarChestsQuantityLabel: "Number of chests",
    lancarStudentsListHeading: "Students ({{count}})",
    lancarHeaderManyStudents: "{{count}} students",
    lancarCoverageWarningSingle:
      "\"{{attitude}}\" won't be applied to {{count}} of {{total}} selected students because the attitude isn't configured for their segment.",
    lancarCoverageWarningMulti:
      "{{count}} of {{total}} selected students won't receive every attitude ({{attitudes}}) because they aren't configured for their segment.",
    lancarSearchAttitudePlaceholder: "Search attitude...",
    lancarNoAttitudeFound: "No attitude found",
    quickLaunchBarLabel: "Quick launch",
    quickLaunchValueAria: "Launch {{value}} coins",
    quickLaunchOpenFullPanel: "Full launch",
    quickLaunchTitleAdd: "Add {{count}} coins",
    quickLaunchTitleRemove: "Remove {{count}} coins",
    quickLaunchSubtitleOne: "to the selected student",
    quickLaunchSubtitleMany: "to {{count}} selected students",
    quickLaunchReasonOptional: "(optional)",
    quickLaunchReasonPlaceholder: "e.g. participation in class",
    quickLaunchConfirm: "Launch now",
    quickLaunchDefaultDescription: "Quick launch",
    quickLaunchApplying: "Launching coins...",
    quickLaunchSuccess: "{{value}} coins launched",
    quickLaunchError: "Could not launch the coins.",
    viewStudentModalTitle: "Student",
    studentProfileTab: "Profile",
    studentHistoryTab: "History",
    studentCollectionTab: "Collection",
    studentRowCreatedAt: "Created on",
    collectionLoading: "Loading collection...",
    collectionError: "Could not load the collection. Please try again.",
    collectionEmptyTitle: "No collectibles yet",
    collectionEmptyHint: "Collectibles the student earns or buys will show up here.",
    collectionObtainedAt: "Obtained on {{date}}",
    historicoTypeOther: "Other",
    historySearchPlaceholder: "Search history...",
    historyFilterAll: "All",
    historyTypeFilterLabel: "Record type",
    historyViewModeLabel: "View",
    historyViewSimple: "Simple",
    historyViewComplete: "Complete",
    historyFilterEmpty: "Nothing found with these filters.",
    historyProgressLoading: "Loading full history... ({{loaded}} of {{total}})",
    historyLoadError: "Could not load the history. Please try again.",
    studentRowClass: "Class",
    studentRowEmail: "Email",
    studentRowCoins: "Coins",
    studentRowGems: "Gems",
    studentRowXp: "XP",
    studentRowCollectibles: "Collectibles",
    studentQrCode: "QR code",
    studentCopied: "Copied!",
    studentAccessLink: "Access link",
    studentAppButton: "Access student app",
    studentNoHistoryTitle: "No records",
    studentNoHistoryHint: "The student's history will appear here",
    historicoTypeAttitude: "Attitude",
    historicoTypeMission: "Mission",
    historicoTypeQuiz: "Quiz",
    studentHistoryAt: "{{date}} at {{time}}",
    studentHistoryLaunchedBy: "Launched by {{author}}",
    studentHistoryUnknownAuthor: "Responsible user not identified",
    studentHistoryCollectedAt: "Collected on {{date}} at {{time}}",
    studentHistoryApplicationDate: "Application date",
    studentHistoryCollectionDate: "Collection date",
    studentHistoryResponsible: "Responsible user",
    studentHistoryCollectionStatus: "Collection status",
    studentHistoryCollected: "Collected",
    studentHistoryPending: "Pending",
    studentHistoryDateUnavailable: "Date not provided",
    studentHistoryNotCollected: "Not collected",
    studentHistoryRewards: "Rewards",
    studentHistoryNoRewards: "No reward recorded",
    historyPartialLoadError: "Part of the older history could not be loaded. Available records remain visible.",
    undoLaunchAria: "Undo feedback",
    deleteStudentButton: "Delete student",
    editStudentButton: "Edit student",
    studentNoClass: "No class",
    importTurmasTitleUpload: "Import classes and students",
    importTurmasTitleValidating: "Validating spreadsheet...",
    importTurmasTitlePreview: "Review import",
    importTurmasTitleImporting: "Importing...",
    importTurmasTitleResult: "Import completed",
    importTurmasHowTitle: "How it works",
    importTurmasHowBody:
      "Download the template and repeat the same full name in every class the student attends. The system will create one student associated with all of them.",
    importTurmasTemplateTitle: "Spreadsheet template",
    importTurmasTemplateHint: "Use the template to ensure the format is correct",
    importTurmasDownloadCsv: "Download template (.csv)",
    importTurmasOr: "or",
    importTurmasDropHere: "Drop the file here",
    importTurmasDragOrClick: "Drag the file or click to select",
    importTurmasFormats: "Accepted formats: .csv, .xlsx, .xls",
    importTurmasErrorUnsupportedFile: "Use a .csv, .xlsx, or .xls file.",
    importTurmasErrorEmptyFile: "The file does not contain classes and students to import.",
    importTurmasErrorInvalidColumns: "The spreadsheet must have exactly two columns: class and student name.",
    importTurmasErrorMalformedCsv: "The CSV has an unclosed quote. Fix the file and try again.",
    importTurmasErrorReadFile: "The file could not be read. Check that it is not corrupted or password-protected.",
    importTurmasStructureTitle: "Spreadsheet structure",
    importTurmasColClass: "Class",
    importTurmasColStudent: "Student name",
    importTurmasValidatingTitle: "Validating spreadsheet",
    importTurmasValidatingHint: "Checking structure and data...",
    importTurmasClassesFoundLabel: "classes found",
    importTurmasStudentsTotalLabel: "students in total",
    importTurmasProblemsFound: "Attention: {{count}} issue(s) found",
    importTurmasProblemsHint:
      "Items with errors will be skipped. You can fix the spreadsheet and import again.",
    importTurmasValidatedTitle: "Spreadsheet validated successfully",
    importTurmasValidatedHint: "All data is correct and ready to import.",
    importTurmasListToCreate: "Classes to be created",
    importTurmasClassNamed: "Class {{name}}",
    importTurmasNStudentsInClass: "{{count}} student(s)",
    importTurmasNWithErrors: "- {{count}} with errors",
    importTurmasImportingTitle: "Importing classes and students",
    importTurmasImportingCounts: "{{classes}} — {{students}}",
    importTurmasCountTurmasOne: "{{count}} class",
    importTurmasCountTurmasMany: "{{count}} classes",
    importTurmasCountAlunosOne: "{{count}} student",
    importTurmasCountAlunosMany: "{{count}} students",
    importTurmasResultTitle: "Import completed!",
    importTurmasResultSubtitle: "All classes and student associations were processed successfully.",
    importTurmasCreatedClassesLabel: "classes created",
    importTurmasAddedStudentsLabel: "students processed",
    importTurmasSkippedRecords: "{{count}} record(s) skipped due to errors",
    importTurmasLocalOnly: "All data is processed locally",
    importTurmasNewSheet: "New spreadsheet",
    importTurmasImportNClasses: "Import {{count}} class(es)",
    importTurmasImportingBtn: "Importing...",
    importTurmasImportMore: "Import more",
    importTurmasDone: "Done",
    importTurmasErrStudentName: "Name required",
    importTurmasErrClassName: "Class name required",
    importTurmasUnnamedClass: "Unnamed",
    importAlunosTitleInput: "Import students",
    importAlunosTitlePreview: "Review students",
    importAlunosModeCopyPaste: "Copy/paste",
    importAlunosModeExcel: "Import Excel",
    importAlunosPasteListTitle: "Paste your student list",
    importAlunosExcelImportTitle: "Import from Excel",
    importAlunosPasteHint: "We will parse your list automatically and remove duplicates.",
    importAlunosExcelHint: "Select an Excel (.xlsx, .xls) or .csv file with the student list.",
    importAlunosTargetClass: "Target class:",
    importAlunosDownloadTemplate: "Download spreadsheet template",
    importAlunosClickSelectFile: "Click to select a file",
    importAlunosFileTypesShort: ".xlsx, .xls or .csv",
    importAlunosFileContentPlaceholder: "File contents...",
    importAlunosPastePlaceholder:
      "Paste student names here. Put each name on a new line.\n\nExamples:\n\nJohn Smith\nJane Doe\nPeter Brown",
    importAlunosFoundLine: "{{count}} student(s) found",
    importAlunosReviewHeading: "Review students before importing",
    importAlunosReviewHint: "You can edit or remove students from the list before confirming.",
    importAlunosToImportLine: "{{count}} student(s) to import",
    importAlunosErrorReadFile: "Error reading file",
    importAlunosErrorImport: "Error importing students",
    importAlunosNoSegment: "This class has no segment defined. Set a segment for the class before importing students — otherwise students receive no reward and do not appear in the ranking.",
    importAlunosNothingToImport: "No valid students to import. Fill in at least one name.",
    importAlunosReviewList: "Review list",
    importAlunosImporting: "Importing...",
    importAlunosImportN: "Import {{count}} student(s)",
    importAlunosSuccessToast: "{{count}} student(s) imported successfully",
    importAlunosFailToast: "Failed to import {{count}} student(s)",
    importAlunosSuccessCount: "{{count}} success(es)",
    importAlunosErrorCount: "{{count}} error(s)",
    moveClassDialogTitle: "Move to class",
    moveClassSelectedLine: "{{count}} student(s) selected",
    moveClassHowApply: "How should classes be applied?",
    moveClassReplace: "Replace",
    moveClassReplaceHint: "Remove from current classes and move to the new ones",
    moveClassAdd: "Add",
    moveClassAddHint: "Keep current classes and add the new ones",
    moveClassSelectTarget: "Select target classes",
    moveClassSearchPlaceholder: "Search class...",
    moveClassNoResults: "No class found",
    moveClassNClassesSelected: "{{count}} class(es) selected",
    moveClassTabClasses: "Classes",
    moveClassTabStudents: "Students ({{count}})",
    moveClassSegmentHint:
      "Each student stays in a single segment — the chosen class's.",
    moveClassAddSegmentHint:
      "In Add mode the student keeps their current classes, so only classes from the {{segment}} segment can be selected. To change segments, use Replace.",
    moveClassSegmentBlocked: "Class from another segment",
    segmentChangeWarningTitle: "Students also change segment",
    segmentChangeWarning:
      "Every student in class \"{{turma}}\" moves to the new segment.",
    segmentChangeWarningWithCount:
      "The {{count}} student(s) in class \"{{turma}}\" move to the new segment.",
    segmentChangeConfirmCta: "Confirm segment change",
    segmentConflictTitle: "{{count}} student(s) also belong to other classes",
    segmentConflictDesc:
      "They have other classes in the current segment. Choose what to do:",
    segmentConflictMore: "and {{count}} more",
    segmentConflictOptionMove: "Take them to the new segment",
    segmentConflictOptionMoveDesc:
      "They leave the other classes and stay only in this one.",
    segmentConflictOptionKeep: "Keep them in the current segment",
    segmentConflictOptionKeepDesc:
      "They leave this class and stay in the others.",
    segmentFixAlertTitle: "Students outside the class segment",
    segmentFixAlertDescription:
      "{{students}} student(s) in {{turmas}} class(es) need fixing.",
    segmentFixAlertCta: "Fix now",
    segmentFixModalTitle: "Fix segments",
    segmentFixModalCount: "{{count}} student(s) to fix",
    segmentFixModalDescription:
      "For each student, choose: move to the class segment or remove from this class.",
    segmentFixTurmaSegment: "Class segment: {{segment}}",
    segmentFixStudentSegment: "Student's current segment: {{segment}}",
    segmentFixOptionMove: "Move to {{segment}}",
    segmentFixOptionRemove: "Remove from class",
    segmentFixCancel: "Not now",
    segmentFixApply: "Fix {{count}} student(s)",
    segmentFixApplying: "Fixing...",
    segmentFixSuccess: "Segments fixed.",
    segmentFixError: "Could not fix: {{names}}. Please try again.",
    multipleGamesAlertTitle: "Classes with more than one segment",
    multipleGamesAlertDescription: "{{count}} class(es) need a single segment selected.",
    multipleGamesAlertCta: "Fix now",
    multipleGamesModalTitle: "Fix class segments",
    multipleGamesModalCount: "{{count}} class(es) to fix",
    multipleGamesModalDescription:
      "Choose which segment should remain in each class. Students will not be moved in this step.",
    multipleGamesChooseSegment: "Choose the segment to keep",
    multipleGamesCancel: "Not now",
    multipleGamesApply: "Fix {{count}} class(es)",
    multipleGamesApplying: "Fixing...",
    multipleGamesSuccess: "Class segments fixed.",
    multipleGamesError: "Could not fix: {{names}}. Please try again.",
    settingsTurmasColName: "Class",
    settingsTurmasColSegment: "Segment",
    settingsTurmasColStudents: "Students",
    settingsTurmasEmpty: "No classes found.",
    settingsTurmasDeleteCta: "Delete class",
    settingsTurmasDeleteTitle: "Delete class \"{{turma}}\"?",
    settingsTurmasDeleteDesc:
      "This action cannot be undone. {{count}} student(s) are in this class and will no longer belong to it.",
    settingsTurmasDeleteDescStudents:
      "This action cannot be undone. {{count}} student(s) in this class will be permanently deleted, along with their points and history.",
    settingsTurmasDeleteDescEmpty: "This action cannot be undone.",
    settingsTurmasDeleteDescShared:
      "{{count}} student(s) also belong to other classes and will not be deleted — they will only be removed from the deleted class(es).",
    deleteClassStudentsCheckbox:
      "I understand that {{count}} student(s) will be permanently deleted, with all their points and history.",
    deleteClassStudentsError:
      "Could not delete {{count}} student(s). The class(es) were not deleted — please try again.",
    settingsTurmasDeleted: "Class deleted.",
    moveClassStudentsListTitle: "Students to be moved",
    moveClassMoving: "Moving...",
    moveClassConfirm: "Move students",
    lancarAtitude: {
      ajudar: "Helping others",
      participacao: "Participation",
      criatividade: "Creativity",
      persistencia: "Persistence",
      "trabalho-equipe": "Teamwork",
      esforco: "Effort",
      respeito: "Respect",
      dedicacao: "Dedication to studies",
      lideranca: "Leadership",
      superacao: "Overcoming",
      indisciplina: "Indiscipline",
      conversa: "Excessive talking",
      atraso: "Lateness",
      desrespeito: "Disrespect",
      desatencao: "Inattention",
      "nao-participacao": "Non-participation",
    },
    editarAtitudeTitulo: "Edit attitude",
    editarAtitudeTipoLabel: "Type",
    editarAtitudePositiva: "Positive",
    editarAtitudeNegativa: "Needs improvement",
    editarAtitudeNomeLabel: "Name",
    editarAtitudeNomePlaceholder: 'E.g. "Participation"',
    editarAtitudeNomeRequired: "Please enter a name for the attitude.",
    editarAtitudeMoedasLabel: "Coins",
    editarAtitudeMoedasCustomPlaceholder: "Custom value",
    atitudeMoedasCustomOption: "Custom",
    atitudeMoedasCustomInvalid: "Enter a whole number between 1 and {{max}}.",
    editarAtitudeGamesLabel: "Segments",
    editarAtitudeGamesPlaceholder: "Select the segments",
    editarAtitudeGamesAll: "All segments",
    editarAtitudeGamesRequired: "Select at least one segment.",
    editarAtitudeGamesSearchPlaceholder: "Search segment...",
    editarAtitudeGamesNoResults: "No segments found",
    editarAtitudeSalvar: "Save changes",
    excluirAtitudeTitulo: "Delete attitude",
    excluirAtitudeDescricao: "Are you sure you want to delete the attitude \"{{name}}\"?",
    excluirAtitudeAviso: "This action cannot be undone.",
    excluirAtitudeConfirmar: "Delete attitude",
    printAccessAllStudents: "Print access for the whole class",
    printAccessSelectedStudents: "Print access for {{count}} selected students",
    printAccessButton: "Print access",
    alunoCardAccessMenu: "Access details",
    alunoCardAccessCopied: "Copied!",
    classAccessLinkModalTitle: "Access Link",
    classAccessLinkModalScanHint: "Scan the QR code or copy the link below",
    classAccessLinkModalShareHint:
      "Share this link with your students. When they open it, they create an account and join the class automatically.",
    classAccessLinkModalPrintPdf: "Print PDF",
    classAccessLinkModalPrintTitle: "Access - {{name}}",
    classAccessLinkModalPrintSubtitle: "Educational Gamification Platform",
    classAccessLinkModalPrintCardLabel: "Class Access Link",
    classAccessLinkModalPrintInstructions:
      "Scan the QR code above or open the link below to join the class",
    classAccessLinkModalQrAlt: "QR Code",
    classAccessLinkCopy: "Copy",
    classAccessLinkCopied: "Copied",
    classAccessLinkButtonAria: "Class access link",
    classAccessLinkButtonLabel: "Access link",
  },
  players: {
    pageTitle: "Players | Gamefik Schools at max level.",
    total: "Total",
    playersUpdated: "Players updated",
    errorUpdatingPlayers: "Error updating players",
    qrCodesBeingGenerated: "QR Codes are being generated! Wait 5 minutes and check the history!",
    qrCodesGenerationError: "Error generating QR Codes. Try again.",
    qrCodesDownloadError: "Error downloading QR Codes. Try again.",
    errorDeleting: "Error deleting",
    errorChangingClass: "Error changing class",
    errorChangingGame: "Error changing segment",
    editPageTitle: "Edit player | Gamefik Schools at max level.",
    editPlayerTitle: "Edit player",
    requestError: "An error occurred while processing your request. Please try again later.",
    playerRemovedSuccess: "User removed successfully.",
    createPageTitle: "Create Student | Gamefik - Schools at max level",
    createPageDescription: "Register new students quickly and intuitively",
    createNewPlayer: "Create New Student",
    registrationForm: "Registration Form",
    completeSteps: "Complete all steps to finish registration",
    createGameClassTooltip: "The Segment and Class creation buttons are available inside the form",
    playerCreatedSuccess: "Student registered successfully!",
    playerCreatedMessage: "Student created successfully!",
    createPlayerError: "Error registering student.",
    personalData: "Personal Data",
    basicStudentInfo: "Basic student information",
    complete: "Complete",
    firstName: "First name",
    surname: "Surname",
    email: "Student email",
    emailHint: "Optional. This email can be used for student access when the unit enables email login.",
    emailInvalid: "Enter a valid email address.",
    firstNameRequired: "First name is required",
    surnameRequired: "Surname is required",
    personalDataComplete: "Personal data complete",
    selectGameAndClasses: "Select Segment and Classes",
    gameAndClassesEnvironment: "Segment and class environment for the student",
    selectGame: "Select Segment",
    createNewGame: "Create new segment",
    selectGameToContinue: "Select a segment to continue",
    gameSelectedSuccess: "Segment selected successfully",
    chooseClasses: "Choose Classes",
    createNewClass: "Create new class",
    selectAtLeastOneClass: "Select at least one class",
    classesSelected: "{{count}} class(es) selected",
    selectGameFirstForClasses: "Select a segment first to create classes",
    saving: "Saving...",
    saveChanges: "Save Changes",
    registerPlayer: "Register Student",
    removePlayer: "Remove player",
    confirmDeletePlayer: "Are you sure you want to delete this player?",
    deletePlayerWarning: "This action is irreversible, all points and history will be completely lost.",
    createNewClassTitle: "Create New Class",
    createNewGameTitle: "Create New Segment",
    configureNewGameEnvironment: "Set up a new segment environment for your students",
    gameName: "Segment Name",
    gameNameRequired: "Segment name is required",
    setCoinsLimit: "Set coins limit for the segment",
    coinsLimit: "Coins Limit",
    creating: "Creating...",
    createGame: "Create Segment",
    gameCreatedSuccess: "Segment created successfully!",
    createGameError: "Error creating segment.",
    changeClassTitle: "Change class — {{name}}",
    howToChangeClasses: "How would you like to change the classes?",
    replaceClasses: "Replace classes",
    replaceClassesDescription: "Removes from current classes and places only in the selected ones",
    addClasses: "Add classes",
    addClassesDescription: "Keeps current classes and adds the selected ones",
    modeAdd: "Mode: Add",
    modeReplace: "Mode: Replace",
    addModeDescription: "The student will remain in their current classes and will be added to the classes selected above.",
    replaceModeDescription: "The student will be removed from all current classes and will only be in the classes selected above.",
    classUpdatedSuccess: "Class updated successfully.",
    classUpdateError: "Error updating class.",
    changeGameTitle: "Change segment — {{name}}",
    changeGameWarning: "This action will remove the student from their current classes, as classes are linked to the previous segment.",
    gameUpdatedSuccess: "Segment updated successfully.",
    gameUpdateError: "Error updating segment.",
    profileTitle: "Student Profile",
    viewProfile: "View student profile",
    basicInfo: "Basic Information",
    fullName: "Full Name",
    accessHash: "Access Hash",
    accessHashCopied: "Hash copied to clipboard.",
    accessHashCopyError: "Could not copy the hash.",
    copyLabel: "Copy",
    accessLink: "Access Link",
    classesTitle: "Classes",
    classesEnrolled: "Classes in which the student is enrolled",
    noClassAssigned: "No class assigned",
    classSummary: "Classes Summary",
    generalScore: "General Score",
    scoreDescription: "Student points and experience",
    coins: "Coins",
    experience: "Experience",
    pendingRewards: "Pending Rewards",
    pendingRewardsDescription: "Rewards to be collected",
    toCollect: "To Collect",
    totalMissions: "Total Quests",
    gamesAndProgress: "Segments and Progress",
    gamesAndProgressDescription: "Details of segments the student participates in",
    coinsToCollect: "Coins to Collect",
    xpToCollect: "XP to Collect",
    levelLabel: "Level {{order}}",
    progress: "Progress: {{percent}}%",
    runningQuests: "Running Quests",
    activeQuests: "{{count}} active quest(s)",
    accessAccount: "Access account",
    access: "ACCESS",
    editPlayer: "Edit player",
    level: "Level",
    name: "Name",
    noPlayerFound: "No player found for your search.",
    noPlayerFoundAlt: "No player found.",
    selectAll: "Select all",
    selectInBulk: "Bulk select",
    selectDuplicates: "Select duplicates",
    selectWithoutQrCode: "Select without QR code",
    selectWithoutClass: "Select without class",
    selectWithoutGame: "Select without segment",
    extractData: "Extract data",
    generateQrCodesBlank: "Generate QR Codes without name",
    blankQrCodesDescription: "Enter how many unnamed QR Codes should be generated for printing (maximum: {{max}}).",
    blankQrCodesAmountLabel: "Number of QR Codes",
    blankQrCodesProcessing: "We are preparing the QR Codes",
    blankQrCodesProcessingDescription: "Keep this window open while the file is being prepared.",
    blankQrCodesPollingHint: "The status updates automatically every 5 seconds.",
    blankQrCodesReady: "Your QR Codes are ready",
    blankQrCodesReadyDescription: "The file has been generated and is ready to download.",
    blankQrCodesDownload: "Download QR Codes",
    blankQrCodesFailed: "The QR Codes could not be generated",
    blankQrCodesFailedDescription: "Try generating the file again. If the problem persists, contact support.",
    blankQrCodesRetry: "Try again",
    putStudentDataHere: "Put your students' data here",
    confirm: "Confirm",
    studentsSelectedSuccess: "Students selected successfully!",
    couldNotFindStudents: "Could not find the selected students!",
    download: "Download",
    qrCodesWillBeGenerated: "QR Codes will be generated in at most 10 minutes, check the history",
    generate: "Generate",
    tableLevel: "Level",
    tableStudent: "Name",
    tableBalance: "Balance",
    tableClass: "Class",
    tableGame: "Segment",
    noStudentFound: "No student found.",
    generatingQrCodes: "Generating QR Codes... This process may take up to 5 minutes.",
    selectClassesToMove: "Select which classes to move the students to:",
    selectGamesToMove: "Select which segments to move the students to:",
    removeFromCurrentClasses: "This action will remove the selected students from their current classes, keeping them only in the selected classes.",
    removeFromCurrentClassesForGames: "This action will remove the selected students from their current classes, keeping them only in the selected classes.",
    confirmDeletePlayers: "Are you sure you want to delete these players?",
    deletePlayersWarning: "This action is irreversible, all points and history of the selected students below will be completely lost.",
    playersRemovedSuccess: "Players removed successfully.",
    deletionError: "Error during deletion",
    playersMovedClassSuccess: "Players moved to class successfully.",
    classChangeError: "Error changing class",
    playersMovedGameSuccess: "Players moved to segment successfully.",
    gameChangeError: "Error changing segment",
    selectAtLeastOnePlayer: "Select at least one player!",
    confirmGenerateQrCodes: "Do you really want to generate QR Codes for {{count}} students?",
    failedToGenerateQrCodes: "Failed to generate QR Codes",
    newPlayer: "new player",
    newPlayerTooltip: "If you want to add only one student to the segment, select this option!",
    importPlayers: "import students",
    importPlayersTooltip: "Need to add multiple students at once? This is the best option! Download the spreadsheet and follow the step-by-step.",
    bulkMarkWithAi: "bulk mark with AI",
    bulkMarkWithAiTooltip:
      "Use AI to select multiple students at once based on a prompt or file.",
    aiAgentV2: "AI 2.0 (Agent)",
    aiAgentV2Tooltip:
      "Agentic AI with tools (JS, bash, vision) for intelligent student selection.",
    applyAttitudes: "Apply attitudes/quests",
    deselectAll: "deselect all",
    adjustBalance: "adjust balance",
    setBalance: "set balance",
    giveChests: "give chests",
    chestQuantity: "Number of chests",
    chestsGrantedSuccess: "Chests granted successfully!",
    studentsLabel: "Students",
    changeClass: "change class",
    changeGame: "change segment",
    deleteLabel: "delete",
    generateNewQrCodes: "Generate NEW QR Codes",
    downloadExistingQrCodes: "Download EXISTING QR Codes",
    studentsSelectedOf: "students selected of",
    studentsSelected: "students selected",
    adjustPlayerCoins: "adjust player coins",
    filtersTitle: "Filters",
    clearFilters: "Clear Filters",
    onlyPlayersWithoutQrCode: "Only players without QR code",
    sortByLabel: "Sort by",
    deselectPlayers: "Deselect {{count}} players",
    selectAllPlayers: "Select all {{count}} players",
    noGames: "NO SEGMENTS",
    noClasses: "NO CLASSES",
    createdAt: "Created at:",
    notAvailable: "N/A",
    balanceLabel: "Balance",
    missionsToCollect: "Quests to collect:",
    attitudesToCollect: "Attitudes to collect:",
    chestsToCollect: "Chests to collect:",
    chestsPendingHint: "waiting to open",
    detailsLabel: "Details",
    changeClassLabel: "Change class",
    changeGameLabel: "Change segment",
    historyLabel: "History",
    accessAccountLabel: "Access account",
    generalInfo: "General Information",
    noGameLabel: "No segment",
    noClassLabel: "No class",
    optionsLabel: "Options",
    playerUpdatedSuccess: "Player updated successfully!",
    errorSavingChanges: "Error saving changes.",
    playerRemovedSuccessAlt: "Player removed successfully.",
    errorRemovingPlayer: "Error removing player.",
    errorLoadingPlayerData: "Error loading player data.",
    editPlayerDialogTitle: "Edit player — {{name}}",
    didNotReceiveToday: "did not receive today",
    receivedTimes: "received {{count}} time",
    receivedTimesPlural: "received {{count}} times",
    classesLabel: "Classes:",
    noClassText: "No Class",
    gameLabel: "Segment:",
    noGameText: "No Segment",
    qrCodeTitle: "Link QR Code",
    virtualCard: "Virtual Card",
    approachQrCode: "Bring the QR Code close to the camera to link it to the player.",
    generateCard: "Generate card",
    generateNewCard: "Generate new card",
    downloadCard: "Download card",
    downloadCardError: "Could not generate the card image. Please try again.",
    viewCard: "View card",
    confirmNewQrCode: "Are you sure you want to link another QR Code for this player?",
    qrCodeWarning: "This action is irreversible and the old QR Code will instantly lose access to all Gamefik platforms.",
    playerSavedSuccess: "Player saved successfully.",
    searchPlayersPlaceholder: "Search players...",
    filtersSubtitle: "Refine the player list",
    filterGameLabel: "Segment",
    filterClassesLabel: "Classes",
    filterSortLabel: "Sort",
    filterOtherLabel: "Other",
    levelShort: "Lv {{order}}",
    chestAlt: "Chest",
    exportAccessInstructions: "Export access instructions",
    exportAccessInstructionsTooltip: "Exports a spreadsheet with the name and access instruction link of the selected students.",
    playerCountSingular: "{{count}} player",
    playerCountPlural: "{{count}} players",
    cancel: "Cancel",
    save: "Save",
    back: "Back",
    completeRequiredFields: "Complete all required fields to continue",
    search: "Search",
    selectClasses: "Select classes",
    selectOneClass: "Select a class",
    allClassesUpper: "ALL",
    someClassesUpper: "SOME",
    searchEllipsis: "Search...",
    clearSearch: "Clear search",
    noOptionFound: "No option found",
    allYourClasses: "All your classes",
    allClasses: "All classes",
    allYourClassesCanSee: "All your classes will be able to see this quest",
    allClassesCanSee: "All classes from selected segments will be able to see this quest",
    selectGameToSeeClasses: "Select a segment to see classes",
    allClassesOption: "ALL CLASSES",
    studentsCount: "students",
    editClassTitle: "Edit class",
    nothingFound: "Nothing found",
    nameColumn: "Name",
    gamesColumn: "Segments",
    createdColumn: "Created",
    playersColumn: "Players",
    editColumn: "Edit",
    rowActionView: "View student",
    rowActionEdit: "Edit student",
    rowActionQrCode: "QR Code",
    rowActionOpenApp: "Open App",
    accessUnavailableGenerateQr: "Generate or link this student's QR Code before opening the app.",
    rowActionCopyAccess: "Copy access",
    rowActionAccessCopied: "Copied!",
    importButton: "Import",
    allPlayersTitle: "All",
    allPlayersSubtitle: "Consolidated view of all students",
    allPlayersPageTitle: "All Students | Gamefik",
    refreshingData: "Refreshing…",
    refreshingDataLabel: "Refreshing data",
    updatedAt: "Updated at {{time}}",
    lastUpdatedAtTitle: "Last updated at {{time}}",
    exportButton: "Export",
    exportAll: "All students ({{count}})",
    exportSelected: "Selected ({{count}})",
    totalStudents: "Total students",
    totalClasses: "Total classes",
    filterAllClasses: "All classes",
    filterClassMobile: "Class",
    filterSearchClass: "Search class...",
    filterNoClass: "No class found.",
    filterSingleClass: "1 class",
    filterClassCount: "{{count}} classes",
    filterClearClasses: "Clear selection ({{count}})",
    aiSelectionLabel: "Select students with AI",
    aiSelectionButton: "Select with AI",
    filterAllEngagement: "All engagement",
    colEngagement: "Engagement",
    colCollectiblesShort: "Collect.",
    colCoins: "Coins",
    colActions: "Actions",
    selectedCount: "{{count}} selected",
    selectedCountPlural: "{{count}} selected",
    clearSelectionButton: "Clear",
    bulkActionsLabel: "More actions",
    bulkAccessStudents: "Student access ({{count}})",
    bulkMoveClass: "Move class ({{count}})",
    bulkSetBalance: "Set balance ({{count}})",
    bulkDelete: "Delete ({{count}})",
    filterWithoutAccess: "No access code ({{count}})",
    filterWithoutAccessMobile: "No access",
    filterUnlinked: "Unlinked ({{count}})",
    filterUnlinkedMobile: "Unlinked",
    noClassMoveAction: "Student without a class — click to move them into a class",
    selectScopeTitle: "Select students",
    selectScopeDesc: "The list has {{pages}} pages ({{total}} students with the current filters). What do you want to select?",
    selectScopePage: "This page ({{count}})",
    selectScopeAll: "All pages ({{count}})",
    allHaveAccess: "Everyone has an access code",
    allHaveAccessMobile: "Access OK",
    addCta: "Add",
    applyCta: "Apply",
    exportModalTitle: "Export students",
    exportModalSubtitle: "Download a CSV with name, class, XP and coins.",
    exportDownloadCsv: "Download CSV",
    setBalanceTitle: "Set balance",
    setBalanceSubtitle:
      "Sets the target balance for the {{count}} selected students. The adjustment (add or remove) is calculated automatically for each student.",
    setBalanceCoinLabel: "Coins",
    setBalanceToggleAria: "Change {{currency}} balance",
    setBalanceTargetLabel: "Target balance",
    setBalanceHint:
      "Currencies that are off are not changed. The calculation considers the current balance plus rewards to collect.",
    setBalanceProgress: "Applying: {{current}} of {{total}} students...",
    setBalanceApplying: "Applying...",
    setBalanceApply: "Set balance",
    setBalanceDescription: "[Set balance] Automatic adjustment to reach the target balance",
    setBalanceSuccess: "Balance set for {{count}} student(s).",
    setBalancePartialError: "Failed to adjust {{count}} student(s). Try again.",
    emptyStateTitle: "No students found",
    emptyStateSubtitle: "Try adjusting the search filters",
    loadError: "Could not load students",
    loadErrorSubtitle: "Check your connection and try again.",
    retryButton: "Try again",
    staleDataWarning: "Failed to update — showing previous data.",
    deleteStudentsTitleOne: "Delete student",
    deleteStudentsTitleMany: "Delete students",
    deleteStudentConfirmIntro: "Are you sure you want to delete",
    deleteStudentConfirmOutro: "? This action cannot be undone.",
    thisStudentFallback: "this student",
    nStudentsCount: "{{count}} students",
    deleting: "Deleting...",
    removedSuccess: "Students removed successfully!",
    removeError: "Error removing students.",
    updatedSuccess: "Student updated successfully!",
    updateError: "Error updating student.",
    movedClassSuccess: "Students moved to class successfully!",
    movedClassSuccessWithWarning: "Students were moved, but some auxiliary records were not completed. You do not need to try again.",
    movedClassPartial: "{{success}} student(s) moved; {{errors}} could not be moved.",
    movedClassPartialWithWarning: "{{success}} student(s) moved; {{errors}} could not be moved. Some auxiliary records for completed moves also failed.",
    moveClassFailed: "Could not move {{errors}} student(s).",
    moveClassError: "Error moving students to class.",
    paginationInfo: "Showing {{from}} to {{to}} of {{total}} students",
    moreOptionsLabel: "More options",
    selectAllMobileCta: "Select all",
    loadMoreButton: "Load more ({{count}})",
    normalizeGamesBulk: {
      button: "Normalize segments",
      buttonTooltip: "Unify game_id of every selected student to each one's current segment",
      title: "Normalize segments in bulk",
      description:
        "Reassigns all transactions (hot and cold) of each selected student to their current segment. The balance per point type stays the same — only the partition by segment changes. Each student is processed independently with its own transaction.",
      filtersTitle: "Include transactions",
      includeCollected: "Collected points",
      includeUncollected: "Uncollected points",
      noFilterSelected: "Select at least one point type to continue.",
      progressLabel: "{{current}} of {{total}} students",
      processingPlayer: "Processing {{name}}",
      statusQueued: "Queued",
      statusPreviewing: "Calculating preview",
      statusApplying: "Applying",
      statusSuccess: "Normalized",
      statusFailure: "Failed",
      statusSkipped: "Already normalized",
      alreadyNormalized: "No changes needed.",
      targetGame: "Target segment",
      otherGames: "Other segments",
      affectedTxs: "{{count}} txs affected",
      modifiedLabel: "{{hot}} hot · {{cold}} cold",
      summaryLabel: "{{success}} success · {{failures}} failure(s) · {{skipped}} already normalized",
      noPlayersSelected: "Select at least one student to normalize.",
      cancel: "Cancel",
      canceling: "Canceling…",
      close: "Close",
      retry: "Retry failures",
      runningHint: "Processing in parallel (3 at a time). You can cancel anytime — students in progress will finish their current operation.",
      completedHint: "Operation completed. Each student was processed independently and idempotently.",
    },
  },
  importPlayers: {
    pageTitle: "Import Players | Gamefik Schools at max level.",
    back: "Back",
    title: "Import Player List",
    subtitle: "Follow the steps below to import your players simply and quickly",
    stepSelectGame: "Select Segment",
    stepDownload: "Download",
    stepSend: "Upload",
    stepCreateClasses: "Create Classes",
    stepCreatePlayers: "Create Players",
    selectGameTitle: "Select the Segment",
    selectGameDescription: "Link players to the corresponding segment",
    selectGameWarning: "Every player must be linked to a segment. This step is <strong>mandatory</strong> and fundamental to the process.",
    downloadTemplateTitle: "Download Template Spreadsheet",
    downloadTemplateDescription: "Use our spreadsheet to standardize the data",
    downloadTemplateInstructions: "You need to complete this spreadsheet correctly, as it will help our system understand your students' information.",
    important: "IMPORTANT",
    downloadTemplateWarning: "Put in this spreadsheet <strong>only the students of this segment</strong>. To add students from other segments, you will need to repeat the process selecting the correct segment.",
    downloadTemplateButton: "Download Template Spreadsheet",
    alreadyHaveTemplate: "I already have the filled spreadsheet",
    uploadTitle: "Spreadsheet Upload",
    uploadDescription: "Upload the CSV file with player data",
    manualUpload: "Manual Upload (CSV/TXT)",
    processingFile: "Processing file...",
    dragOrClick: "Drag the file here or click to select",
    acceptedFormats: "Accepted formats: CSV, TXT",
    confirmUpload: "Confirm Upload",
    fileSelected: "File selected",
    incompatibleFormat: "Format Not Compatible with Manual Upload",
    fileNeedExactColumns: "The file must have <strong>exactly</strong> the columns:",
    expectedFormat: "Expected Format",
    yourFile: "Your File",
    columnsDetected: "{{count}} column detected",
    columnsDetectedPlural: "{{count}} columns detected",
    noColumnDetected: "No column detected",
    recommendedSolution: "Recommended Solution",
    useAiUpload: "Use the <strong>AI Upload</strong> below. The AI will automatically process any spreadsheet format!",
    acceptsAnyStructure: "Accepts any structure",
    identifiesColumnsAutomatically: "Identifies columns automatically",
    worksWithFormats: "Works with CSV, XLSX, PDF and more",
    errorProcessingFile: "Error Processing File",
    suggestion: "Suggestion",
    useAiSuggestion: "Use the <strong>AI Upload</strong> below to automatically process files in any format.",
    validatingFile: "Validating file format...",
    fileReadyToProcess: "File ready to be processed",
    sendFile: "Upload File",
    processing: "Processing...",
    or: "OR",
    aiUploadLabel: "AI Upload (FOR TESTING ONLY)",
    aiUploadDescription: "Use AI to automatically process files in any format. The AI will standardize to \"name\" and \"class\" columns.",
    codegenMode: "Codegen Mode (Experimental)",
    codegenDescription: "AI generates transformation code instead of direct JSON",
    codegenActive: "Codegen Mode Active",
    codegenInfo: "The AI will generate JavaScript code to transform the data. Faster, more economical, and more reliable. Supports CSV/XLSX only.",
    processingWithAi: "Processing with AI...",
    selectFileForAi: "Select File for AI",
    aiAcceptedFormats: "Accepted formats: CSV, XLSX, XLS, PDF, TXT",
    studentProcessed: "{{count}} student processed",
    studentsProcessed: "{{count}} students processed",
    realTime: "Real time",
    downloadBatch: "Download Batch {{current}}",
    lastFound: "Last Found:",
    previewJson: "Preview JSON",
    batchDownloaded: "Batch {{current}}/{{total}} downloaded!",
    batchCompleted: "Batch {{current}}/{{total}} completed",
    studentsInBatch: "{{count}} students in this batch. Total: {{total}}",
    aiNotFoundValid: "AI did not find valid data. Try another file.",
    fileProcessedSuccess: "File processed successfully! {{count}} player found.",
    fileProcessedSuccessPlural: "File processed successfully! {{count}} players found.",
    aiProcessingFailed: "Failed to process file with AI",
    errorSendingToAi: "Error sending the file to AI.",
    csvError: "Please send a CSV or TXT file",
    invalidFormat: "Invalid format",
    emptyFile: "Empty file or no valid data",
    validationError: "Error validating file. Format not recognized.",
    spreadsheetProcessed: "Spreadsheet processed successfully!",
    spreadsheetReadError: "Error reading the spreadsheet. Check the format (CSV) and encoding.",
    classValidation: "Class Validation",
    classValidationDescription: "Confirm the classes that will be created in the system",
    reviewClassInfo: "Review and confirm the information about the classes that will be created:",
    playerValidation: "Player Validation",
    playerValidationDescription: "Confirm the players that will be created in the system",
    reviewPlayerInfo: "Review and confirm the information about the players that will be created:",
    duplicateNamesFound: "{{count}} duplicate name found",
    duplicateNamesFoundPlural: "{{count}} duplicate names found",
    duplicatesWillBeMerged: "Duplicate players will be automatically merged with their classes combined",
    unknown: "Unknown",
    linesWillBeCombined: "Lines {{line1}} and {{line2}} - Classes will be combined",
    playersForCreation: "Players for Creation",
    playerCount: "{{count}} player",
    playersCount: "{{count}} players",
    viewJson: "View JSON (Players and Classes)",
    playersLabel: "Players ({{count}}):",
    availableClasses: "Available Classes ({{count}}):",
    createNPlayers: "Create {{count}} Player",
    createNPlayersPlural: "Create {{count}} Players",
    completed: "Completed!",
    progressLabel: "Progress:",
    of: "of",
    processingComplete: "Processing complete",
    processingLabel: "Processing...",
    pleaseWait: "Please wait while we process your request",
    creatingPlayers: "Creating players...",
    creatingPlayersProgress: "Creating players... ({{success}} created{{errors}})",
    errorsLabel: ", {{count}} errors",
    playersCreatedWithWarning: "{{count}} players created successfully",
    failedDescription: "{{count}} failed. Check the console for details.",
    playersCreatedSuccess: "{{count}} players created successfully!",
    errorCreatingPlayers: "Error creating players",
    invalidServerResponse: "Invalid server response",
    startingProcessing: "Starting processing...",
    aiProcessingFail: "Failed to process file",
    batchLabel: "Batch {{current}}/{{total}}",
  },
  homePage: {
    metaTitle: "Home · Gamefik",
    greetingMorning: "Good morning",
    greetingAfternoon: "Good afternoon",
    greetingEvening: "Good evening",
    hello: "Hello",
    helloName: "Hello, {{name}}",
    tagline: "Let's turn your class into your students' favorite moment!",
    createWithAi: "Create with AI",
    onboarding: {
      welcomeBadge: "Welcome mission",
      progress: "Progress",
      reward: "Reward",
      setupTitle: "Set up your account in ",
      setupHighlight: "4 steps",
      setupSubtitle: "In under 10 minutes you'll be ready to go.",
      startHere: "Start here!",
      startNow: "Start now",
      completed: "Done",
      stepsCompleted: "steps completed",
      recommended: "Recommended",
      tutorialTitle: "Full platform tutorial",
      tutorialDescription:
        "Learn how to set up classes, create gamified activities, and track your students' progress in real time.",
      watchNow: "Watch tutorial",
      viewTutorial: "How to do it",
      missionComplete: "Mission complete!",
      schoolReady: "Your school is ready. Now create amazing activities for your students.",
    },
    steps: {
      alunos: {
        title: "Add your students",
        description: "Create classes and add your first students",
      },
      atividade: {
        title: "Create your first activity",
        description: "Quiz or mission with AI in seconds",
      },
      professores: {
        title: "Invite your teachers",
        description: "Bring your team to Gamefik",
      },
      app: {
        title: "Open the student app",
        description: "See how your students will use it",
      },
    },
    activities: {
      sectionTitle: "Create activity",
      sectionSubtitle: "Pick a format or let AI do it for you.",
      seeAllFormats: "See all formats",
      createNow: "Create now",
      comingSoon: "Coming soon",
      comingSoonColon: "Coming soon:",
      footer: "Gamefik — Max level",
      quiz: {
        title: "Quiz",
        description: "Multiple choice to check understanding",
        fullDescription:
          "A Quiz is an interactive activity where students answer multiple-choice questions. Each question can have 2–5 options with instant feedback when they pick an answer. Great for review, checks for understanding, and exam prep. Teachers can set time limits, random order, and number of attempts.",
      },
      missao: {
        title: "Mission",
        description: "Hands-on tasks with evidence submission",
        fullDescription:
          "A Mission is a hands-on task where the student does something in the real world and submits proof (photo, text, or file). The teacher or Gamefik's AI validates the submission. Perfect for hands-on work, creative projects, physical exercises, and homework that needs verification.",
      },
      flashcard: {
        title: "Flashcard",
        description: "Memorize content",
        fullDescription:
          "Front-and-back cards for spaced repetition. Ideal for vocabulary, dates, and concepts. Can be term/definition or true/false style.",
      },
      trilha: {
        title: "Path",
        description: "Learning journeys with achievements",
        fullDescription:
          "A Path is a multi-step learning journey. Students move through sequential phases, unlocking new content and achievements. It combines quizzes, missions, and other content into one gamified, visual progression.",
      },
      comingCompletePhrase: "Complete the phrase",
      comingAssociacao: "Matching",
      comingRedacao: "Essay",
      comingDesembaralhe: "Unscramble",
      moreAboutAria: "More information about {{type}}",
    },
    dialog: {
      createWithType: "Create {{type}}",
      describeTheme: "Describe the topic and AI builds it for you",
      assistantAlt: "AI assistant",
      aiBadge: "AI",
      assistantIntro: "Hi! Tell me what topic you want for your",
      assistantOutroQuiz: "quiz",
      assistantOutroMissao: "mission",
      assistantOutroFlashcard: "flashcard",
      assistantSuffix: ". It can be a subject, a specific topic, or even pasted text!",
      placeholderQuiz: "E.g. French Revolution for 8th grade...",
      placeholderMissao: "E.g. Research on recycling in your neighborhood...",
      placeholderFlashcard: "E.g. Basic English vocabulary...",
      submitHint: "Press Enter or tap the button to create with AI",
      aboutActivity: "About this activity",
      createType: "Create {{type}}",
      comingSoonButton: "Coming soon",
    },
  },
  dashboard: {
    exportData: "Export data",
    close: "Close",
    coinsGoal: {
      title: "Contrast: Time Progress vs. Coins Reality",
      descriptionPart1: "Comparative analysis between the",
      descriptionIdealProgress: "ideal time progress",
      descriptionPart2: "(based on elapsed time) and the",
      descriptionRealProgress: "real coins progress",
      descriptionPart3: "(based on actual usage)",
      temporal: "Time",
      real: "Real",
      analysisPeriod: "Analysis Period",
      selectPeriod: "Select the desired period for time-based coin analysis",
      startDate: "Start Date",
      endDate: "End Date",
      predefinedPeriods: "Predefined periods",
      schoolYear: "School Year",
      schoolYearTooltip: "School year: from February to December of the current year",
      lastThreeMonths: "Last 3 months",
      lastThreeMonthsTooltip: "Last 3 months: from the 1st of the month 3 months ago until today",
      semester: "Semester",
      semesterTooltip: "Current semester: from the beginning of the semester until today",
      timeVsReality: "Contrast: Time vs. Reality",
      idealTimeProgress: "Ideal Time Progress",
      realCoinsProgress: "Real Coins Progress",
      basedOnTimePeriod: "Based on elapsed time in the period",
      basedOnCoinsUsed: "Based on coins effectively used",
      inSync: "✅ In sync",
      aboveIdeal: "⚠️ Above ideal",
      belowIdeal: "⚠️ Below ideal",
      difference: "Difference:",
      totalDays: "Total days",
      daysPassed: "Days passed",
      daysRemaining: "Days remaining",
      tabTemporal: "Time",
      tabAverage: "Average per Student",
      tabTop10: "Top 10%",
      temporalContrast: "Time Contrast: Ideal vs. Real",
      idealVsRealAnalysis: "Ideal Time Progress vs. Real Coins Progress - Comparative analysis of expected pace vs. reality",
      temporalProgress: "Time progress",
      temporalProgressIcon: "📊 Time Progress:",
      ofPeriodElapsed: "of period elapsed",
      realProgressIcon: "💰 Real Progress:",
      ofCoinsUsed: "of coins used",
      resolution: "Resolution:",
      weeklyPoints: "Weekly points",
      biweeklyPoints: "Biweekly points",
      monthlyPoints: "Monthly points",
      timeVsRealityComparison: "Comparison: Time vs. Reality",
      basedOnTimeElapsed: "Based on elapsed time",
      upToCurrentMoment: "Up to the current moment",
      futureProjection: "Future Projection",
      basedOnCurrentRate: "Based on current rate",
      currentPointToday: "Current point (today)",
      timeVsCoins: "{{time}}% time vs {{coins}}% coins",
      averageVsMaxPrize: "Contrast: Average per Student vs. Max Prize",
      goalMaxPrizeVsAvg: "Goal to reach maximum prize vs. Real average coins per student - Purchasing power analysis",
      temporalGoalIcon: "🎯 Time Goal:",
      expectedCoins: "expected coins",
      realAverageIcon: "💰 Real Average:",
      coinsPerStudent: "coins per student",
      maxPrize: "Maximum prize:",
      coins: "coins",
      purchasingPowerGoalVsReality: "Purchasing Power: Goal vs. Reality",
      temporalGoalLabel: "Time Goal",
      towardsMaxPrize: "Towards maximum prize",
      realAvgPerStudent: "Real Average per Student",
      currentCoins: "Current coins",
      projection: "Projection",
      currentPoint: "Current point",
      ofMaxPrize: "of maximum prize",
      top10VsMaxPrize: "Contrast: Top 10% vs. Max Prize",
      goalMaxPrizeVsTop10: "Goal to reach maximum prize vs. Top 10% student average - Elite vs. Goal",
      eliteGoalIcon: "🏆 Elite Goal:",
      top10RealIcon: "⭐ Top 10% Real:",
      eliteVsGoal: "Elite vs. Goal: Top 10% of Students",
      eliteGoalLabel: "Elite Goal",
      top10RealLabel: "Top 10% Real",
      currentElite: "Current elite",
      eliteProjection: "Elite Projection",
      temporalContrastAnalysis: "Time Contrast Analysis",
      syncEvaluation: "Evaluation of sync between time and real progress, with ±10% margin to determine if in sync",
      behind: "Behind",
      ahead: "Ahead",
      onTrack: "On Track",
      scheduleStatus: "Schedule status",
      margin: "Margin: ±10%",
      timeDiffProgress: "Time/progress difference",
      needToAccelerate: "Needs to accelerate pace",
      spendingTooFast: "Spending too fast",
      adequateRhythm: "Adequate rhythm",
      withinMargin: "Within ±10% margin",
      outsideMargin: "Outside margin",
      requiredPacePerDay: "Required pace/day",
      toRecoverDelay: "To recover the delay",
      toNotAccelerate: "To not accelerate further",
      toMaintainPace: "To maintain the pace",
      consideredProblematic: "⚠️ Considered problematic",
      needsAttention: "⚠️ Needs attention",
      idealSituation: "✅ Ideal situation",
      totalCoinsVolume: "Total Coins Volume",
      totalCoinsVolumeDesc: "Comparison between student coins and store availability",
      totalFromStudents: "Student total",
      excludingStoreSpending: "(Excluding store spending)",
      totalAvailableInStore: "Total available in store",
      avgCoinsVsMaxPrize: "Average Coins per Student vs Max Prize",
      avgCoinsVsMaxPrizeDesc: "Relationship between average coins per student and the most expensive store item",
      averagePerStudent: "Average per student",
      maxPrizeInStore: "Max store prize",
      top10AvgVsMaxPrize: "Top 10% Student Average Coins vs Max Prize",
      top10AvgVsMaxPrizeDesc: "Relationship between top 10% student coin average and the most expensive store item",
      top10Average: "Top 10% average",
      utilizationRate: "Utilization rate",
      purchasingPower: "Purchasing power",
      remainingCoins: "Remaining coins:",
      currentVsRequiredPace: "Current vs required pace:",
      coinsPerDay: "{{value}} coins/day",
      goalReached: "Goal reached",
      chartIdealProgress: "Ideal Time Progress",
      chartRealProgress: "Real Coins Progress",
      chartProjection: "Projection Based on Current Rate",
      timeElapsed: "Time Elapsed",
      coinsUsedLabel: "Coins Used",
      remaining: "Remaining",
      temporalProgressTooltip: "Time progress: {{value}}%",
    },
    coinsPerClass: {
      title: "Coins per class",
      totalClasses: "Total number of classes: {{count}}",
      allGames: "All segments",
      selectGame: "Select a segment",
      searchClass: "Search by class...",
      nameCol: "Name",
      coinsCol: "Coins",
      playersCol: "Players",
      averageCol: "Average",
    },
    generalInfo: {
      activeGames: "Active Segments",
      viewDetails: "View details",
      participants: "Participants",
      classes: "Classes",
      averagePerClass: "Average per class",
      studentsCount: "{{count}} students",
      students: "Students",
      activeMissions: "Active Quests",
      pendingCount: "{{count}} pending",
      totalStock: "Total Stock",
      averagePerStudent: "Average/student",
      dataNotLoaded: "The data for this card could not be loaded right now.",
      useRetryGlobal: "Use the dashboard global retry to try again.",
      gameCreatedSuccess: "Segment created successfully! 🎉",
      gameCreatedError: "Error creating segment",
      needGameName: "You need to set a name for the Segment",
      whatIsGame: "What is a Segment?",
      whatIsGameDesc: "All players will be under the same rules and store, playing together. It is very common for schools to separate elementary and high school segments, for example.",
      studentsLabel: "{{count}} students",
      active: "Active",
      inactive: "Inactive",
      creating: "Creating...",
      newGame: "New Segment",
      studentsInGame: "Students",
      language: "Language",
      activePoints: "Active points",
      coinsLimit: "Coins limit",
      searchStudent: "Search student",
      editGame: "Edit Segment",
      studentsOfGame: "Segment students",
      studentsBadge: "{{count}} students",
      studentFallback: "Student",
      noClass: "No class",
      noStudentFound: "No students found.",
      rewardsStore: "Rewards Store",
      remainingStock: "Remaining Stock",
      averagePerStudentDialog: "Average per Student",
      pendingOrders: "Pending Orders",
      ordersBadge: "{{count}} orders",
      pendingBadge: "Pending",
      storeManager: "Store manager",
      viewPendingOrders: "View pending orders",
      gameDetailsUnavailable: "Segment details unavailable",
      gameDetailsUnavailableDesc: "Could not load the complete modal data right now. Use the dashboard global retry to try again.",
      loadingGameDetails: "Loading segment details",
      loadingGameDetailsDesc: "We are preparing the complete list of segments and players for this modal.",
      missionDetailsUnavailable: "Quest details unavailable",
      missionDetailsUnavailableDesc: "Could not load auxiliary data for this modal. Try again from the dashboard.",
      loadingMissionDetails: "Loading quest details",
      loadingMissionDetailsDesc: "We are gathering players, classes and segments related to each quest.",
      unknown: "Unknown",
      expired: "Expired",
      startsOn: "Starts on {{date}}",
      createdBy: "Created by:",
      period: "Period:",
      classesLabel: "Classes:",
      allLabel: "all",
      gamesLabel: "Segments:",
      teachersCanValidate: "Teachers can validate",
      teachersCantValidate: "Teachers cannot validate",
      completions: "Completions",
      evaluateProofs: "Review {{count}} pending submissions",
    },
    links: {
      manuals: "Manuals",
      marketingFolder: "Marketing folder",
      storeSuggestion: "Store suggestion",
      gamefikInsta: "Gamefik Instagram",
    },
    loadingStatus: {
      reloadingDashboard: "Reloading dashboard",
      clearingAndReloading: "Clearing loaded data and fetching everything again.",
      tryingAgain: "Trying again",
      loadingDashboard: "Loading dashboard",
      retryingFailed: "Retrying failed sections.",
      loadingSections: "Fetching data for each dashboard section.",
      couldNotLoad: "Could not load the dashboard",
      mainNotResponding: "Main sections did not respond. Try again or reload the page.",
      partialNotLoaded: "Some data did not load",
      someNotLoaded: "The page opened, but some sections could not be loaded.",
      dashboardReady: "Dashboard ready",
      allDataLoaded: "All data was loaded successfully.",
      sectionLoaded: "{{count}} section loaded",
      sectionsLoaded: "{{count}} sections loaded",
      of: "of",
      restarting: "RESTARTING",
      loading: "LOADING",
      progress: "Progress",
      loadingDashboardData: "Loading dashboard data",
      sectionInLoading: "{{count}} section loading",
      sectionsInLoading: "{{count}} sections loading",
      errorLoading: "Something went wrong while loading",
      someNotResponded: "Some sections have not responded yet. The final result will appear when finished.",
      failure: "FAILURE",
      whatFailed: "What failed",
      noEssentialLoaded: "No essential parts could be loaded in this attempt.",
      tryAgain: "Try again",
      restartLoading: "Restart loading",
      restart: "Restart",
      didNotLoad: "Did not load:",
    },
    missions: {
      title: "Quests",
      totalMissions: "Total number of quests: {{count}}",
      nameCol: "Name",
      participantsCol: "Participants",
      approvalsCol: "Approvals",
      rejectionsCol: "Rejections",
      valueCol: "Value",
      valueAcquiredCol: "Value acquired",
      descriptionLabel: "Description:",
      participantsLabel: "Participants:",
      approvalsLabel: "Approvals:",
      rejectionsLabel: "Rejections:",
      valueLabel: "Value:",
      valueAcquiredLabel: "Value Acquired:",
    },
    recentActions: {
      title: "Recent Actions",
      viewFullHistory: "View full history",
    },
    engagement: {
      title: "Quest engagement this year",
      subtitle: "Percentage of players who completed at least one quest.",
      players: "Players",
    },
    monthlyAccess: {
      title: "Monthly access",
      chartLabel: "access",
    },
    mostRedeemedItems: {
      title: "Most redeemed products",
      totalRedeemed: "Total products redeemed: {{count}}",
      totalSpentInStore: "Total spent in store:",
      product: "Product",
      quantitySold: "Quantity sold",
      currentValue: "Current value",
      averageValue: "Average Value",
      totalSpent: "Total Spent",
      stock: "Stock",
      productInfo: "Product information: {{name}}",
      productDetails: "Product Details",
      priceLabel: "Price:",
      stockLabel: "Stock:",
      playerLimit: "Limit per player:",
      unlimited: "Unlimited",
      categories: "Categories:",
      startDateLabel: "Start date:",
      giftCardLabel: "Gift Card:",
      yes: "Yes",
      no: "No",
      giftCardInfo: "Gift Card Information",
      provider: "Provider:",
      brand: "Brand:",
      valueLabel: "Value:",
      messageLabel: "Message:",
      instructionsLabel: "Instructions:",
      purchaseHistory: "Purchase History",
      purchaseId: "Purchase ID",
      playerName: "Player Name",
      purchaseDate: "Purchase Date",
      statusCol: "Status",
      quantityCol: "Quantity",
      totalValue: "Total Value",
      delivered: "Delivered",
      pendingStatus: "Pending",
      canceled: "Canceled",
      noPurchases: "This product has not been purchased by any player yet.",
    },
    rewardsSection: {
      title: "Rewards Dashboard",
      subtitle: "Complete analysis of the rewards system.",
      spendingRanking: "Spending Ranking",
      totalOf: "Total",
      playersLabel: "Players",
      rewardsLabel: "Rewards",
      inStore: "In store",
      stockPer: "Stock per",
      playerLabel: "Player",
      deliveredLabel: "Delivered",
      deliveredPer: "Delivered per",
      deliveryRate: "Delivery Rate",
      purchased: "Purchased",
      percentPurchased: "{{percentage}}% of students made",
      atLeastOnePurchase: "at least one purchase in the store",
      notPurchased: "Did not purchase",
      studentSpendingRanking: "Student Spending Ranking",
      exportXlsx: "📊 Export XLSX",
      position: "Position",
      studentName: "Student Name",
      totalSpentCol: "Total Spent",
      currentBalance: "Current Balance",
      totalBalance: "Total Balance",
      purchases: "Purchases",
      items: "Items",
      deliveredCol: "Delivered",
      actions: "Actions",
      viewDetails: "View Details",
      purchaseDetails: "Purchase Details: {{name}}",
      purchaseId: "Purchase ID",
      date: "Date",
      itemsCol: "Items",
      statusCol: "Status",
      totalValueCol: "Total Value",
      deliveredStatus: "Delivered",
      pendingStatus: "Pending",
      canceledStatus: "Canceled",
      includingToCollect: "Including coins to collect",
    },
    pagination: {
      paginationMode: "Pagination",
      scrollMode: "Scroll",
      perPage: "{{count}} / page",
      of: "of",
      firstPage: "First page",
      previousPage: "Previous page",
      nextPage: "Next page",
      lastPage: "Last page",
    },
    platformUsage: {
      title: "Platform usage",
      totalRecords: "Total number of records: {{count}}",
      searchTeacher: "Search by teacher...",
      teacher: "Teacher",
      accesses: "Accesses",
    },
    playersAccess: {
      neverCollected: "Never collected",
      activationList: "Activation list ({{count}})",
      activationSubtitle: "Activation, balance and last redemption of players.",
      exportCsv: "Export CSV",
      allGames: "All segments",
      allClasses: "All classes",
      selectGame: "Select a segment",
      selectClass: "Select a class",
      orderBy: "Order by",
      lastCollection: "Last collection",
      missionsSent: "Quests sent",
      quizzesSent: "Quizzes sent",
      direction: "Direction",
      descending: "Descending",
      ascending: "Ascending",
      total: "Total",
      activeLabel: "Active",
      inactiveLabel: "Inactive",
      nameCol: "Name",
      classesCol: "Classes",
      gamesCol: "Segments",
      missionsCol: "Quests",
      statusCol: "Status",
      lastRedemption: "Last Redemption",
      active: "Active",
      inactive: "Inactive",
      lastRedemptionPerPlayer: "Last redemption per player",
      periodLabel: "Period",
      periodDays: "{{count}} days",
    },
    playersRanking: {
      title: "Players ranking",
      totalPlayers: "Total number of players: {{count}}",
      searchPlayer: "Search by player...",
      exportData: "📊 Export data",
      student: "Student",
    },
    teacherUse: {
      title: "Teacher usage",
      totalTeachers: "Total number of teachers: {{count}}",
      searchTeacher: "Search by teacher...",
      nameCol: "Name",
      lastPlatformUse: "Last use",
      ofPlatform: "of platform",
      missionsCreated: "Quests",
      missionsCreatedSub: "Created",
      quizzesCreated: "Quizzes",
      quizzesCreatedSub: "Created",
      distributedCoins: "Coins",
      distributedCoinsSub: "distributed",
      playersCol: "Players",
      avgCoinsPerPlayer: "Average coins per player",
      activeTag: "Active",
      absentTag: "Inactive",
    },
  },
  modal: {
    shopTitle: "Gamefik Shop",
    coins: "coins",
    purchased: "Purchased",
    buy: "Buy",
    purchaseSuccess: "Purchase completed successfully! The item has been added to your inventory.",
    insufficientBalance: "Insufficient balance. Complete more tasks to earn coins.",
    availableItems: "Available Items",
    myInventory: "My Inventory",
    emptyInventory: "Your inventory is empty",
    buyItemsToSee: "Buy items from the shop to see them here.",
    viewAvailableItems: "View Available Items",
    purchasedAt: "Purchased on",
    code: "Code:",
    copy: "Copy",
    rankingTitle: "School Ranking",
    place: "place",
    weekly: "Weekly",
    monthly: "Monthly",
    yearly: "Yearly",
    yourSchool: "Your School",
    completedPercent: "{{percent}}% completed",
    points: "points",
    generalRanking: "General Ranking",
    yourSchoolLabel: "Your school",
    students: "students",
    days: "days",
    howPointsCalculated: "How points are calculated",
    pointsDescription: "The score is based on three main factors:",
    completionProgress: "Completion progress:",
    completionProgressDesc: "Up to 100 points based on the percentage of completed tasks.",
    accumulatedCoins: "Accumulated coins:",
    accumulatedCoinsDesc: "Every 10 coins equals 1 point in the ranking.",
    completionSpeed: "Completion speed:",
    completionSpeedDesc: "Up to 100 bonus points for schools that complete onboarding faster.",
    ranking: "Ranking",
    shop: "Shop",
    earlyBonus: "Early bonus!",
    estimatedTime: "Estimated time:",
    deadlineForCompletion: "Deadline for completion",
    start: "Start:",
    end: "End:",
    tip: "Tip:",
    completeBefore: "Complete this task before the deadline to earn +{{bonus}} bonus coins!",
    takesOnly: "Takes only {{time}}",
    concludeBeforeDeadline: "Complete before the deadline to earn +{{bonus}} bonus coins!",
    completedEarly: "Completed early! +{{bonus}} bonus coins",
    dayUnit: "day",
    daysUnit: "days",
    deadlineExpired: "Deadline expired",
    oneDayRemaining: "1 day remaining",
    daysRemaining: "{{count}} days remaining",
    zeroDays: "0 days",
    oneMinute: "1 minute",
    minutes: "{{count}} minutes",
    oneHour: "1 hour",
    hours: "{{count}} hours",
    easy: "Easy",
    medium: "Medium",
    advanced: "Advanced",
    confirmPurchase: "Confirm Purchase",
    aboutToBuy: "You are about to buy",
    for: "for",
    insufficientMissing: "Insufficient balance. Missing {{count}} coins.",
    currentBalance: "Your current balance:",
    cancel: "Cancel",
    section1Title: "Welcome to Gamefik!",
    section1Desc: "🎯 Step 1: Welcome to Gamefik! Get to know our educational gamification platform.",
    section1Content: "Welcome to Gamefik! Our educational gamification platform allows you to transform learning into a fun and engaging experience.",
    section2Title: "Create your first Segment",
    section2Desc: "🎮 Step 2: Create your first Segment! Learn to create and configure your first segment on the platform.",
    section2Content: "Creating your first segment is simple! Set an attractive name, choose a visual theme and establish learning objectives. You can customize the experience with different levels, challenges and scoring systems to keep your students engaged.",
    section3Title: "Create your classes and players!",
    section3Desc: "🧑‍🏫 Step 3: Create your classes and players! Learn to create classes and add students to your segment.",
    section3Content: "Organize your students into classes for easier management. Add players individually or import a list. Each player will have their own profile where they can track their progress, achievements and rewards obtained.",
    section4Title: "Adding my quests (2 quests)!",
    section4Desc: "🎯 Step 4: Adding my quests! Learn to create quests to engage your students.",
    section4Content: "Quests are tasks that students must complete to advance in the segment. Create at least two initial quests with clear objectives, deadlines and scores. You can add detailed descriptions, support resources and evaluation criteria for each quest.",
    section5Title: "Adding my first attitudes (2 Attitudes)!",
    section5Desc: "🧠 Step 5: Learning about attitudes! Discover how to create and use attitudes to recognize positive behaviors.",
    section5Content: "Attitudes are positive behaviors you want to encourage, such as collaboration, punctuality or creativity. Define at least two initial attitudes and establish how they will be recognized and rewarded within the gamification system.",
    section6Title: "Creating my first reward in the Gamefik Shop!",
    section6Desc: "🛍️ Step 6: Creating my first reward! Learn to create rewards to motivate your students.",
    section6Content: "Rewards motivate students to actively participate. In the Gamefik Shop, you can create virtual or physical rewards that students can 'buy' with accumulated points. Set the name, description, image and point value for each reward.",
    section7Title: "Participate in Gamefik training!",
    section7Desc: "Training content",
    section7Content: "Make the most of the platform by participating in our complete training. Learn advanced gamification strategies, tips to increase engagement and how to analyze performance data to continuously improve the learning experience.",
    section8Title: "Train your teachers!",
    section8Desc: "Content on how to train teachers",
    section8Content: "Share knowledge with your team! Organize training sessions so all teachers can use Gamefik effectively. Show how to create content, track student progress and use platform resources to enhance learning.",
    section9Title: "Segment Launch!",
    section9Desc: "Content teaching best launch practices",
    section9Content: "Everything is ready for launch! Present the segment to students in an exciting way, explaining the objectives, rules and benefits. Consider creating a special launch event to generate enthusiasm and ensure everyone understands how to participate.",
    shopItem1Name: "Gift Card $25",
    shopItem1Desc: "Digital gift card worth $25 to use at any partner store.",
    shopItem2Name: "Premium Certificate",
    shopItem2Desc: "Premium digital course completion certificate with exclusive design.",
    shopItem3Name: "Exclusive Theme",
    shopItem3Desc: "Unlock an exclusive visual theme to customize your Gamefik experience.",
    shopItem4Name: "AI Plan Access",
    shopItem4Desc: "Free access to the Artificial Intelligence plan for 2 months to create personalized content.",
    completionCode: "Completion code:",
    enterCodeHere: "Enter the code here",
    verify: "Verify",
    coin: "Coin",
    ob1Heading: "🎯 Step 1: Welcome to Gamefik!",
    ob1WelcomeTitle: "👋 Welcome to Gamefik! 🎉",
    ob1WelcomeP1: "You are about to transform your students' experience with engagement, fun, and real learning.",
    ob1WelcomeP2: "This onboarding was designed to guide you step by step, in a light, practical, and gamified way.",
    ob1HowTitle: "🕹️ How the Gamified Onboarding works:",
    ob1HowItem1: "9 simple steps:",
    ob1HowItem1Desc: "you will be guided through everything you need to know to use Gamefik in practice.",
    ob1HowItem2: "Ideal timeline:",
    ob1HowItem2Desc: "finish everything within 7 days and have your school ready for launch!",
    ob1HowItem3: "Points system:",
    ob1HowItem3Desc: "with each completed task, you earn coins and points. Besides learning, you start building your reputation on the platform!",
    ob1VideoTitle: "Complete Gamefik implementation tutorial",
    ob1VideoLabel: "👉 Complete Gamefik implementation tutorial!",
    ob1TourTitle: "🗺️ Start with a guided tour:",
    ob1TourButton: "👉 TAKE A SYSTEM TOUR",
    ob1TourDesc: "This tour will show you the first steps directly on the platform. It's quick and super useful!",
    ob1DeepTitle: "📚 Want to understand Gamefik more deeply?",
    ob1DeepDesc: "Check out our article with the complete step-by-step implementation guide:",
    ob1DeepLink: "📖 Gamefik Simplified Guide",
    ob1NextTitle: "✅ What comes next?",
    ob1NextDesc: "You will see a checklist with the next steps. With each completed task, you earn points and unlock the next one.",
    ob1CheckWelcome: "Welcome to Gamefik! ✅",
    ob1CheckGame: "Create your first Segment",
    ob1CheckClasses: "Create your classes and players",
    ob1CheckMissions: "Add 2 quests",
    ob1CheckAttitudes: "Learn about attitudes",
    ob1CheckRewards: "Create 2 rewards in the Shop",
    ob1CheckTraining: "Participate in Gamefik training",
    ob1CheckTeachers: "Train your teachers",
    ob1CheckLaunch: "Official Gamefik launch! 🚀",
    ob2Heading: "🎮 Step 2: Create your first Segment!",
    ob2Intro1: "Now it's time to start the real game! 🕹️",
    ob2Intro2: "In Gamefik, everything revolves around Segments — they are the foundation of your school's entire gamified experience.",
    ob2WhatTitle: "🤔 What is a Segment?",
    ob2WhatDesc: "A Segment is like the \"game universe\" for your classes. It's where you configure:",
    ob2WhatItem1: "Which classes will participate;",
    ob2WhatItem2: "How students earn points;",
    ob2WhatItem3: "Quests, attitudes, and rewards.",
    ob2TipTitle: "💡 Tip: Create different segments for different audiences, such as:",
    ob2TipItem1: "Elementary I",
    ob2TipItem2: "Elementary II",
    ob2TipItem3: "High School",
    ob2TipExtra: "For extracurricular schools, we recommend dividing by age:",
    ob2TipAge1: "Young children: 4 to 6 years",
    ob2TipAge2: "Pre-teens: 7 to 12 years",
    ob2TipAge3: "Teenagers: 13 to 17 years",
    ob2TipAge4: "Adults: 18 years or older",
    ob2TipFreedom: "This gives you the freedom to customize the experience and adapt gamification to each age group.",
    ob2HowTitle: "⚙️ How to create your Segment:",
    ob2HowStep1: "To create a segment, just go to Settings > Advanced in the left sidebar",
    ob2HowStep2: "Click the \"+ New Segment\" button.",
    ob2HowScreenAlt: "New segment creation screen",
    ob2HowStep4: "Give the Segment a name!",
    ob2HowStep5: "Finish configuring the remaining fields.",
    ob2HowStep6: "Click save. Done! 🚀",
    ob2MoreTitle: "📚 Want to know more?",
    ob2MoreDesc: "If you want to go deeper, check out our complete article:",
    ob2MoreLink: "📖 What is a segment? How to create a segment",
    ob2CoinTitle: "🪙 Earn your first coins!",
    ob2CoinDesc: "As soon as you create your first Segment, you automatically earn coins and unlock the next step! 🎉",
    ob3Heading: "🧑‍🏫 Step 3: Create your classes and players!",
    ob3Intro1: "It's time to create your classes and add the students who will participate in the segments. 🚀",
    ob3Intro2: "In Gamefik, players are the students. And classes are groups where you organize participants by grade, room, subject, or however you want.",
    ob3ClassTitle: "🧩 How to create a class:",
    ob3ClassStep1: "Go to the menu and click on Settings > Classes.",
    ob3ClassStep2: "Click \"New class\".",
    ob3ClassStep3: "Enter the class information.",
    ob3ClassStep4: "Save. Done, your class is created!",
    ob3ClassLink: "📖 Tutorial on how to create a class",
    ob3PlayerTitle: "🧍‍♂️ How to add players (students):",
    ob3PlayerDesc: "You can add them manually or import multiple students at once!",
    ob3ManualTitle: "✅ Add manually:",
    ob3ManualStep1: "Access your created class.",
    ob3ManualStep2: "Go to Players > Add student.",
    ob3ManualStep3: "Enter a name, class, and other info.",
    ob3ManualLink: "📖 How to add a new student",
    ob3ImportTitle: "🗂️ Bulk import (via spreadsheet):",
    ob3ImportDesc: "Ideal for schools with many students!",
    ob3ImportWarning: "Create all classes before importing students! 💡",
    ob3ImportGuide: "Follow the tutorial in the article below to import your students:",
    ob3ImportLink: "📖 How to import student list to the segment",
    ob3DoneTitle: "🎯 When is the step completed?",
    ob3DoneDesc: "✅ After creating 2 classes and adding students (manually or via spreadsheet), the task is automatically completed — and you earn more coins!",
    ob4Heading: "🎯 Adding my quests (2 quests)",
    ob4VideoTitle: "🎥 Watch first: How to create a quest",
    ob4VideoLink: "Click here to watch the video on YouTube",
    ob4VideoDesc: "In less than 2 minutes you'll learn the step-by-step to create a quest in practice!",
    ob4NowTitle: "✍️ Now that you've seen how it works…",
    ob4NowDesc1: "Let's transform your students' learning into a journey full of purpose! 🎮",
    ob4NowDesc2: "Quests are gamified activities that connect school events, learning, and engagement.",
    ob4NowDesc3: "They are simple to create — and powerful in results.",
    ob4WhyTitle: "🔥 Why use Quests?",
    ob4WhyDesc: "Quests help you:",
    ob4WhyItem1: "Stimulate task completion.",
    ob4WhyItem2: "Motivate students with clear goals.",
    ob4WhyItem3: "Improve commercial performance →",
    ob4WhyItem3Bold: "+Enrollments +Retention",
    ob4WhyItem4: "Improve academic and pedagogical performance.",
    ob4WhyInsight: "💡 Schools that use quests well report more engagement, better grades, and reduced dropout!",
    ob4WhyIdeasLink: "Quest ideas to start your Segment",
    ob4HowTitle: "🛠️ How to create a quest (video summary):",
    ob4HowStep1: "Go to the Quests menu.",
    ob4HowStep2: "Click \"Manage\".",
    ob4HowStep3a: "Create with AI",
    ob4HowStep3b: "Create from scratch",
    ob4HowStep3Pre: "Click the button for",
    ob4HowStep3Mid: "or",
    ob4HowStep4: "Enter the necessary information to finish configuring the quest.",
    ob4HowStep5: "Define how many coins, points, and XP students will earn (Use the indicated difficulty scale).",
    ob4HowStep6: "Save. Quest created! 🚀",
    ob4MoreTitle: "📚 Want to go deeper?",
    ob4MoreLink1: "Complete Quests 2.0 Guide",
    ob4MoreLink2: "How to create a new quest (article section)",
    ob4MoreLink3: "Quest ideas for your teachers",
    ob4DoneTitle: "✅ When is the step completed?",
    ob4DoneDesc1: "After creating 2 quests in practice, the task will be automatically completed.",
    ob4DoneDesc2: "And of course… you'll earn extra coins for your segment! 💰",
    ob5Heading: "🧠 Learning about attitudes!",
    ob5Intro1: "Attitudes are quick actions worth points that help build a positive culture at school! ✨",
    ob5Intro2: "While quests are more structured, with rules and deadlines, attitudes work as instant recognitions — you can award points with a few clicks whenever a student demonstrates a positive behavior or desired attitude.",
    ob5ExamplesTitle: "🌟 Examples of attitudes:",
    ob5Example1: "Helping a classmate",
    ob5Example2: "Being kind to staff",
    ob5Example3: "Organizing the space after class",
    ob5Example4: "Arriving on time for 5 consecutive days",
    ob5Example5: "Putting effort during physical education class",
    ob5ExampleInsight: "💡 The secret is in frequency and consistency: well-used attitudes create positive reinforcement in daily school life.",
    ob5DiffTitle: "🤔 What's the difference between attitudes and quests?",
    ob5DiffMissionsHeader: "Quests",
    ob5DiffAttitudesHeader: "Attitudes",
    ob5DiffRow1Col1: "They are challenges",
    ob5DiffRow1Col2: "They are behavioral feedback",
    ob5DiffRow2Col1: "Have defined deadlines and rules",
    ob5DiffRow2Col2: "Are quick and punctual actions",
    ob5DiffRow3Col1: "Are planned in advance",
    ob5DiffRow3Col2: "Are launched on the spot",
    ob5DiffRow4Col1: "May include documents or evidence",
    ob5DiffRow4Col2: "Are based on direct observation",
    ob5DiffLink: "Learn more about this difference here",
    ob5HowTitle: "⚙️ How to create an attitude:",
    ob5HowStep1: "Access the Attitudes menu in the sidebar.",
    ob5HowStep2: "Click \"New Attitude\".",
    ob5HowStep3: "Give the attitude a name (e.g.: \"Helped a classmate\").",
    ob5HowStep4: "Choose the value in coins, XP, and points.",
    ob5HowStep5: "Save. Now you can launch it whenever you want with 1 click!",
    ob5HowLink1: "How to create an attitude",
    ob5HowLink2: "What is an attitude",
    ob5LaunchTitle: "🖱️ How to launch an attitude? Learn from the materials below:",
    ob5LaunchLink1: "How to launch an attitude?",
    ob5LaunchLink2: "How to do a quick launch?",
    ob5DoneTitle: "✅ When is the step completed?",
    ob5DoneDesc1: "You need to create an attitude to unlock the next step.",
    ob5DoneDesc2: "After that, attitudes will be available to use with your students!",
    ob6Heading: "Creating my first reward in the Gamefik Shop!",
    ob6VideoTitle: "🎥 Start by watching:",
    ob6VideoLink: "How to create a reward",
    ob6VideoDesc: "In less than 2 minutes, you'll learn the step-by-step to create a reward and activate your shop!",
    ob6NowTitle: "✍️ Now it's your turn!",
    ob6NowDesc1: "The Gamefik Shop is where students can exchange the coins they earn for real or symbolic rewards. This is what makes the gamified experience even more concrete and motivating!",
    ob6NowDesc2: "You can include simple prizes (like leaving class 5 minutes early) to physical items (like a gaming mouse, gift cards, and more).",
    ob6WhyTitle: "🧠 Why does this matter?",
    ob6WhyDesc: "The reward system activates the so-called Student Reward Cycle — a mechanism that:",
    ob6WhyItem1: "Reinforces positive behaviors",
    ob6WhyItem2: "Creates constant motivation",
    ob6WhyItem3: "Helps maintain engagement over time",
    ob6WhyItem4: "Clearly connects effort with results",
    ob6WhyLink: "Read more about the student reward cycle",
    ob6HowTitle: "🛠️ How to create a reward:",
    ob6HowStep1: "Go to the menu, click on Shopping > Rewards.",
    ob6HowStep2: "Click \"New reward\".",
    ob6HowStep3: "Give it a creative name.",
    ob6HowStep4: "Enter all fields correctly.",
    ob6HowStep5: "Don't forget to set the Stock and the number each student can redeem. 🚨",
    ob6HowStep6: "Save. Done! Your shop has come to life! 🛍️",
    ob6HowLink: "Complete guide on how to add a reward",
    ob6DoneTitle: "🪙 When is the step completed?",
    ob6DoneDesc1: "After you create 2 different rewards, the task will be automatically completed.",
    ob6DoneDesc2: "And of course: you also earn coins 🎉",
    ob7Heading: "🎓 Participate in Gamefik training!",
    ob7VideoTitle: "🎥 Watch the complete training:",
    ob7VideoLink: "Official Gamefik Training (Video)",
    ob7VideoDesc: "This video is essential to understand all the pedagogical, technical, and strategic logic of Gamefik.",
    ob7LiveDesc: "Or participate in our live online training, just schedule at the link below:",
    ob7LiveButton: "Schedule your online training for managers ✅",
    ob7LearnTitle: "✍️ What you will learn:",
    ob7LearnItem1: "How to use gamification as a pedagogical tool",
    ob7LearnItem2: "Best practices to engage students, parents, and teachers",
    ob7LearnItem3: "Real examples of use in schools",
    ob7LearnItem4: "How to get the most out of the platform daily",
    ob7LearnInsight: "💡 This content was lovingly crafted by our team of experts — it's your map to success with Gamefik!",
    ob7CodeTitle: "🔐 How to complete the step:",
    ob7CodeDesc1: "At the end of the video, an exclusive code will be revealed.",
    ob7CodeDesc2: "Enter this code in the field below to complete this step and unlock the next one!",
    ob7MissionTitle: "🎯 This is your quest:",
    ob7MissionDesc: "Watch until the end + enter the code = task completed + coins guaranteed!",
    ob8Heading: "👩‍🏫 Train your teachers!",
    ob8WhyTitle: "✍️ Why is this step essential?",
    ob8WhyDesc: "Your teachers are the protagonists of gamification. When they understand how to apply Gamefik daily, everything flows better:",
    ob8WhyBold1: "engagement increases",
    ob8WhyBold2: "students get more involved",
    ob8WhyBold3: "results appear!",
    ob8HowTitle: "👥 How to train your teachers",
    ob8HowDesc: "You can choose between two ways to empower your team:",
    ob8LiveTitle: "✅ 1. Live training with the Gamefik team (MOST RECOMMENDED)",
    ob8LiveLink: "Schedule teacher training",
    ob8LiveDesc: "A dynamic, practical meeting with room for questions, held weekly.",
    ob8LiveCode: "🛡️ At the end, teachers receive an exclusive code to validate participation.",
    ob8AsyncTitle: "▶️ 2. Recorded training (asynchronous)",
    ob8AsyncLink: "Watch the recorded training",
    ob8AsyncDesc: "Ideal for teachers who prefer to watch at their own pace.",
    ob8AsyncCode: "📝 At the end of the video, an exclusive code will be displayed to validate completion.",
    ob8BonusTitle: "📥 Bonus: Quick guide for teachers",
    ob8BonusDesc: "Want to support teachers from day one? Share this direct and practical material:",
    ob8BonusLink: "📖 Practical guide for teachers who want to excel",
    ob8CodeTitle: "🔐 How to complete this step:",
    ob8CodeDesc1: "After training (live or recorded), teachers must send you the code displayed at the end.",
    ob8CodeDesc2: "Enter this code in the field below to complete the step and unlock the final quest!",
    ob9Heading: "🚀 Official Gamefik launch!",
    ob9TimeTitle: "🎉 The most awaited moment has arrived!",
    ob9TimeDesc1: "Congratulations on making it this far! Now that everything is configured, it's time to officially launch Gamefik at your school.",
    ob9TimeDesc2: "This moment is special: it marks the beginning of the gamified experience for your students — and can be the turning point for school engagement.",
    ob9PrereqTitle: "✅ Before launching, review the prerequisites:",
    ob9PrereqDesc: "Make sure everything is ready for an unforgettable launch:",
    ob9PrereqItem1Title: "Are student cards ready?",
    ob9PrereqItem1Desc: "They are the access key to the gamified experience.",
    ob9PrereqItem2Title: "Totem or tablet positioned?",
    ob9PrereqItem2Desc: "Ideally, students should be able to check and collect coins easily.",
    ob9PrereqItem3Title: "Segment configuration finished?",
    ob9PrereqItem3Desc: "Verify that all previous steps are completed, with classes, players, quests, and rewards active.",
    ob9PrereqItem4Title: "Shop visible to students?",
    ob9PrereqItem4Desc: "Display prizes in a showcase or print posters with available rewards — this generates curiosity and anticipation!",
    ob9LaunchTitle: "📣 How to perform the launch:",
    ob9LaunchDesc: "Now let's get the show on the road! Here is the step-by-step:",
    ob9LaunchStep1Title: "📢 Notify students and parents - ",
    ob9LaunchStep1Link: "Materials we prepared for you to use in promotion",
    ob9LaunchStep1Desc: "Send a notice with the official Gamefik start date. Use channels like planner, WhatsApp, or email.",
    ob9LaunchStep2Title: "🗣️ Present Gamefik to students",
    ob9LaunchStep2Desc1: "Go room by room explaining how it works and hand out cards individually.",
    ob9LaunchStep2Desc2: "OR hold a special event with all students to announce the segment's start! 🎊",
    ob9LaunchStep3Title: "👀 Monitor the first collection",
    ob9LaunchStep3Desc: "Assign someone from your team to stay near the totem on launch day. This ensures students learn to use it and feel welcomed into the experience.",
    ob9BestTitle: "🔍 Best practices from other schools",
    ob9BestDesc: "Nothing like being inspired by those who have already made it happen. Watch this series of videos with real examples of successful launches:",
    ob9BestVideo: "🎥 [Launch best practices (coming soon)]",
    ob9DoneTitle: "🪙 When is this step completed?",
    ob9DoneDesc1: "The step will be automatically completed after 10% of students make their first collection in the system.",
    ob9DoneDesc2: "In other words: just launch officially, and the students do the rest! 😉",
  },
  settingsAdvanced: {
    pageTitle: "Advanced Settings | Gamefik Schools",
    pageDescription: "Manage advanced settings, segments, invoices and users for your school on Gamefik.",
    heading: "Advanced Settings",
    subheading: "Manage all settings for your school",
    loadingConfig: "Loading settings...",
    loadError: "Unable to load settings.",
    tabSettings: "Settings",
    tabFinancial: "Financial",
    tabGames: "Segments",
    tabClasses: "Classes",
    tabUsers: "Users",
    tabAutomations: "Automations",
    tabHistory: "History",
    systemSettingsTitle: "System Settings",
    systemSettingsDescription: "Configure general system preferences",
    globalTestFlagTitle: "Global test enabled",
    globalTestFlagDescription: "This block only appears for Manager users in New Manager Global accounts when the feature flag feature-flag-global-test is active.",
    globalTestFlagEnabled: "Flag active",
    languageTitle: "Platform language",
    languageDescription: "Choose which language the admin panel should use.",
    languagePreferenceTitle: "Panel language",
    languagePreferenceDescription: "On the first visit, the system automatically uses the device language and falls back to English when it is not supported.",
    xpManagementTitle: "XP Management",
    xpActive: "Active",
    xpDisabled: "Disabled",
    xpManagementDescription: "Enable or disable XP for all attitudes, quests and quizzes",
    xpIsActive: "XP is active",
    xpIsDisabled: "XP is disabled",
    xpActiveDescription: "All attitudes, quests and quizzes are granting XP normally.",
    xpDisabledDescription: "Disabled on {date}{user}. {count} records affected.",
    xpDisabledByUser: " by {user}",
    xpDisabledUnknownDate: "unknown date",
    xpToggleLabel: "Enable/Disable XP",
    xpHowItWorks: "How it works:",
    xpDisableExplanation: "Removes XP from all attitudes, quests and quizzes, saving values for restoration",
    xpEnableExplanation: "Restores previously saved original XP values",
    xpCoinsUnaffected: "Coin values are not affected",
    xpDisableTitle: "Disable XP",
    xpDisableWarning: "This action will remove XP from all attitudes, quests and quizzes. Values will be saved and can be restored later.",
    xpWhatWillBeAffected: "What will be affected:",
    xpAttitudesZeroed: "All attitudes will have XP zeroed",
    xpMissionsZeroed: "All quests will have XP zeroed",
    xpQuizzesZeroed: "All quizzes will have XP zeroed",
    xpCoinsUnchanged: "Coin values will remain unchanged",
    xpConfirmDisable: "Confirm Disable",
    xpSuccessDisabled: "XP disabled successfully! {count} records affected.",
    xpSuccessEnabled: "XP restored successfully! {count} records restored.",
    xpErrorDisable: "Error disabling XP",
    xpErrorEnable: "Error enabling XP",
    iaEnhancementTitle: "AI Enhancement",
    iaOptionalAddon: "Optional Add-on",
    iaEnhancementDescription: "Add AI features to any plan. AI pricing is based on the number of students.",
    iaResourcesTitle: "✨ Gamefik AI Resources",
    iaActive: "Active",
    iaMonthlyPlan: "Monthly Plan",
    iaInactiveDescription: "Enhance your Gamefik experience with AI-powered insights",
    iaProcessing: "Processing...",
    iaCancelScheduled: "Cancellation scheduled for {date}. Access remains active until then.",
    iaCancelEndOfMonth: "end of month",
    iaReactivationBlocked: "Reactivation will only be available after end of month.",
    iaToggleLabel: "Enable AI Resources",
    iaActivatedSuccess: "AI activated successfully!",
    iaActivateError: "Error activating AI",
    iaDeactivatedSuccess: "AI deactivated successfully!",
    iaDeactivateError: "Error deactivating AI",
    iaPricingError: "Unable to calculate AI pricing.",
    invoicesTitle: "Invoices",
    invoicesDescription: "View and manage your invoices",
    noInvoicesFound: "No invoices found",
    invoiceStatusPaid: "Paid",
    invoiceStatusOpen: "Pending",
    invoiceStatusDraft: "Draft",
    invoiceHeaderStatus: "Status",
    invoiceHeaderAmount: "Amount",
    invoiceHeaderSentDate: "Sent Date",
    invoiceHeaderDueDate: "Due Date",
    invoiceHeaderActions: "Actions",
    invoicePayWithPix: "Pay with Pix",
    invoicePay: "Pay",
    invoiceView: "View",
    gamesTitle: "Segments",
    gamesDescription: "Create and manage your school's segments",
    newGame: "New Segment",
    noGamesYet: "No segments created yet",
    createFirstGame: "Create your first segment",
    coinIconTitle: "Coin Icon",
    coinIconDescription: "Customize the coin icon shown across all segments",
    coinIconGlobalHint: "This setting applies to every segment in your school — admin panel, student app, and store.",
    coinIconCurrent: "Preview",
    coinIconUpload: "Upload icon",
    coinIconUploading: "Uploading...",
    coinIconSaving: "Saving...",
    coinIconSaveSuccess: "Coin icon updated for all segments.",
    coinIconSaveError: "Failed to save coin icon.",
    coinIconUploadError: "Failed to upload image.",
    resetGamesTitle: "Reset Segments",
    resetGamesDescription: "Irreversible action: removes all student points",
    resetGamesWarning: "It is common and recommended to reset points at the end of the semester or school year. This action cannot be undone.",
    classesTitle: "Classes",
    classesDescription: "Manage your school's classes",
    usersTitle: "User Management",
    usersDescription: "Manage teachers and administrators",
    automationsTitle: "Automations",
    automationsDescription: "Configure automatic recurrences for attitudes",
    historyTitle: "Activity History",
    historyDescription: "View all activities performed in the system",
    gameSavedSuccess: "Segment saved successfully.",
    gameSaveError: "Error saving segment",
    gameDeleteConfirm: "Are you sure you want to delete this segment?",
    gameNameRequired: "You need to set a name for the Segment",
    cancel: "Cancel",
    close: "Close",
    save: "Save",
    checkoutCancelled: "Checkout cancelled. You can choose another plan or try again.",
    planActivatedSuccess: "Plan activated successfully.",
    checkoutPaymentPending: "We couldn't confirm your payment. Your account stays on the Free plan — you can try to complete the payment again.",
    checkoutConfirmError: "Unable to confirm checkout.",
    iaPricingTier0To100: "AI for schools with 0 to 100 students",
    iaPricingTier100To200: "AI for schools with 100 to 200 students",
    iaPricingTier200To400: "AI for schools with 200 to 400 students",
    iaPricingTier400To600: "AI for schools with 400 to 600 students",
    iaPricingTier600To1000: "AI for schools with 600 to 1000 students",
    iaPricingTierAbove1000: "AI for schools above 1000 students",
  },
  contractModal: {
    title: "Unlimited AI Package",
    closeLabel: "Close",
    createMissionsWithAI: "Create quests with AI",
    createQuizzesWithAI: "Create quizzes with AI",
    missionApprovalWithAI: "Quest approval with AI",
    andMoreComing: "And much more coming soon 👀",
    calculatingPricing: "Calculating pricing based on number of students...",
    endsIn: "Ends in:",
    lifetimeOff: "20% OFF Lifetime",
    detectedStudents: "We detected <strong>{count}</strong> students. Plan: <strong>{tier}</strong>.",
    lifetimeDiscountUntil: "20% lifetime discount for subscriptions made until {date}.",
    lifetimeDiscountEnded: "Lifetime 20% offer ended. Current price is {price} per month.",
    perMonth: "/month",
    agreeWithTerms: "I agree with the",
    termsOfService: "terms of service",
    mustAgreeToTerms: "You must agree to the terms of service to continue.",
    addToSubscription: "Add to my subscription",
    expired: "Ended",
  },
  cancelModal: {
    title: "Cancel Unlimited AI Plan",
    reviewConditions: "Review the cancellation conditions before proceeding.",
    cancellationRules: "Cancellation Rules:",
    ruleEndOfPeriod: "Cancellation takes effect at the end of the current period (last day of the month)",
    ruleUseUntilEnd: "AI features can be used until the end of the current period",
    ruleNoRefund: "No refund as stated in the terms of service",
    cancellationReasonLabel: "Reason for cancellation:",
    cancellationReasonPlaceholder: "Please tell us why you're cancelling...",
    keepPlan: "Keep Plan",
    confirmCancellation: "Confirm Cancellation",
  },
  termsModal: {
    title: "Terms of Use",
    readAndAccept: "I've Read and Accept",
    documentTitle: "Terms of Use – Gamefik Unlimited AI Package",
    lastUpdated: "Last updated: 08/15/2025",
    intro: "These Terms of Use (\"Terms\") govern the contracting and use of the Unlimited AI Package offered by Gamefik (\"Platform\") by the contracting educational institution (\"School\"). By joining this package, the School declares awareness and agreement with the conditions described herein.",
    section1Title: "1. Subject",
    section1Content: "The Unlimited AI Package provides unrestricted access to the artificial intelligence features made available by Gamefik during the contracted period, as described in the company's communications and marketing materials.",
    section2Title: "2. Commercial Conditions",
    section21Title: "2.1. Prorated Charge in the First Month",
    section21Item1: "Subscription can be made at any time.",
    section21Item2: "On the 1st of the month following the subscription, a prorated charge will be issued for the number of days of use in the subscription month, included in the School's current invoice as an additional item.",
    section22Title: "2.2. Full Charge from the Second Month",
    section22Content: "From the second month onwards, the full current amount of the Unlimited AI Package will be charged monthly, on a recurring basis, as an addition to the School's invoice, regardless of usage frequency.",
    section23Title: "2.3. Cancellation and Prorated Charge",
    section23Item1: "The School may cancel the package at any time using Gamefik's own system.",
    section23Item2: "Upon cancellation, the full amount for the cancellation month will be charged and access to AI features will be available until the end of the current period.",
    section23Item3: "If the platform is contracted and cancelled in the same month, the prorated amount from the subscription date to the end of the current period will be charged.",
    section3Title: "3. Payment Method",
    section3Content: "The Unlimited AI Package amount will be charged together with the School's monthly invoice from the existing Gamefik subscription, as a separately itemized addition. In case of default, the rules provided in the main contract will apply, including potential fines and service suspension.",
    section4Title: "4. Price Changes",
    section4Content: "Gamefik may update the Unlimited AI Package price upon notification to the School with a minimum of 30 (thirty) days advance notice.",
    section5Title: "5. Term",
    section5Content: "These Terms take effect on the subscription date and remain valid while the School maintains the Unlimited AI Package subscription.",
    section6Title: "6. Cancellation by Gamefik",
    section6Intro: "Gamefik reserves the right to suspend or cancel access to the Unlimited AI Package, at no cost to the School, in the following cases:",
    section6Item1: "Improper use or use inconsistent with the Platform's educational purpose.",
    section6Item2: "Violation of Gamefik's general Terms of Use.",
    section7Title: "7. General Provisions",
    section7Item1: "These Terms supplement and integrate the Main Contract and Gamefik's Terms of Use already accepted by the School.",
    section7Item2: "In case of conflict between these Terms and the Main Contract, the specific conditions of this document shall prevail regarding the Unlimited AI Package.",
    section7Item3: "The jurisdiction of Gamefik's headquarters is elected to resolve any disputes arising from these Terms.",
    agreementNote: "By clicking \"I've Read and Accept\" or equivalent, the School declares having read, understood and agreed to all conditions established in these Terms.",
  },
  pixModal: {
    title: "Pay with Pix",
    invoiceAmount: "Invoice amount",
    dueDate: "Due date: {date}",
    qrCodeExpiresIn: "QR Code expires in:",
    expired: "Expired",
    paymentConfirmed: "✓ Payment confirmed!",
    generatingQrCode: "Generating QR Code...",
    paymentConfirmedLabel: "Payment confirmed",
    qrCodeUnavailable: "QR Code temporarily unavailable",
    qrCodeError: "Error generating QR Code",
    qrCodePix: "Pix QR Code",
    scanWithBank: "Scan with your bank app",
    paymentConfirmedSuccess: "Payment confirmed successfully!",
    orCopyCode: "Or copy the code:",
    copy: "Copy",
    codeCopied: "Code copied!",
    howToPay: "How to pay:",
    step1: "1. Open your bank app",
    step2: "2. Choose pay with Pix QR Code or Pix Copy and Paste",
    step3: "3. Scan the code or paste the code above",
    step4: "4. Confirm the payment",
    pixPaymentError: "Error creating PIX payment",
    paymentConfirmedToast: "Payment confirmed successfully!",
  },
  settingsForm: {
    loginWithoutQrCode: "Login without QR Code",
    loginWithoutQrCodeDesc: "Allows simplified login for testing",
    studentEmailLogin: "Student email login",
    studentEmailLoginDesc: "Allows students in this unit to sign in with their registered email and a temporary code",
    controlledGame: "Controlled Segment",
    controlledGameDesc: "Special control mode for segments",
    missions2WithAI: "Quests 2.0 with AI",
    missions2WithAIDesc: "Submissions validated automatically by AI",
    classSelection: "Class Selection",
    classSelectionDesc: "Teacher can choose their own classes",
    teacherMissions: "Teacher Quests",
    teacherMissionsDesc: "Allows teachers to create quests",
    appSounds: "App Sounds",
    appSoundsDesc: "Sound effects and notifications",
    studentRanking: "Student Ranking",
    studentRankingDesc: "Ranking visible to students",
    rankingDisableTooltip: "When disabled, ranking is hidden from players",
    studentShop: "Student Store",
    studentShopDesc: "Access to the rewards store",
    shopDisableTooltip: "When disabled, the store is hidden from players",
    authSection: "Authentication",
    authSectionDesc: "Login and access settings",
    gamesSection: "Segments",
    gamesSectionDesc: "Segment-specific settings",
    featuresSection: "Features",
    featuresSectionDesc: "System resources and capabilities",
    studentExperienceSection: "Student Experience",
    studentExperienceSectionDesc: "Interface and resources for students",
    testEnvironment: "Test Environment",
    loadError: "Error loading settings",
    updateSuccess: "Setting updated successfully!",
    updateError: "Error updating setting",
    loadingConfig: "Loading configuration...",
  },
  teacherCoinLimits: {
    title: "Educator coin limits",
    description: "Choose whether educators can create activities and set the coin limit for each segment.",
    activitiesEnabled: "Educator activities enabled",
    activitiesDisabled: "Educator activities disabled",
    unlimited: "Unlimited",
    controlled: "Controlled",
    limit: "Coin limit",
    segment: "Segment",
    window30Days: "Usage is measured in a rolling 30-day window.",
    save: "Save",
    saving: "Saving...",
    success: "Limit settings saved successfully.",
    failure: "Unable to save limit settings.",
    loading: "Loading educator limits...",
    empty: "No segments are available to configure.",
    explanationIndividual: "The limit applies individually to each educator and class.",
  },
  gameFormDialog: {
    editGame: "Edit Segment",
    createNewGame: "Create New Segment",
    updateGameSettings: "Update segment settings",
    configureNewGame: "Configure a new segment for your school",
    basicInfo: "Basic Information",
    gameName: "Segment Name",
    required: "Required",
    gameNamePlaceholder: "E.g.: Fun Math, English Quest...",
    gameNameRequired: "Segment name is required",
    monthlyCoinsLimit: "Monthly Coins Limit",
    monthlyCoinsLimitTooltip: "Set the maximum coins teachers can give to students per month",
    configureMaxMonthlyCoins: "Configure the maximum monthly coins limit for this segment",
    limitEnabled: "Limit Enabled",
    noLimit: "No Limit",
    controlled: "Controlled",
    unlimited: "Unlimited",
    limitEnabledDescription: "Teachers will have a maximum monthly coin limit for creating quests and quizzes",
    noLimitDescription: "Teachers can give coins unlimitedly (no monthly control)",
    maxMonthlyLimit: "Maximum Monthly Limit",
    unlimitedModeActive: "Unlimited Mode Active",
    unlimitedModeDescription: "Teachers can give as many coins as they want to students without monthly restrictions.",
    gameLanguage: "Segment Language",
    gameLanguageTooltip: "Language is chosen only during segment creation and cannot be changed later",
    selectLanguage: "Select the language for the segment's default texts",
    fillRequiredFields: "Enter all required fields",
    updatingGame: "Updating segment...",
    creatingGame: "Creating segment...",
    waitAMoment: "Please wait...",
    updateGame: "Update Segment",
    createGame: "Create Segment",
    processError: "Error processing request",
  },
  gameLevelingConfig: {
    levelsAndRewards: "Levels and Rewards Configuration",
    levelsConfigured: "{count} levels configured",
    level: "Level {order}",
    confirmDelete: "Confirm Deletion",
    confirmDeleteDescription: "Are you sure you want to delete Level {order}? This action cannot be undone.",
    levelImage: "Level Image",
    xpConfig: "XP Configuration",
    xpForNextLevel: "XP needed for next level",
    range: "Range: {min} - {max} XP",
    difference: "Difference: {diff} XP",
    rewards: "Rewards",
    addNewLevel: "Add New Level",
    deleteAction: "Delete",
    cancel: "Cancel",
  },
  levelsConfig: {
    pageTitle: "Edit segment levels",
    gameSavedSuccess: "Segment saved successfully.",
    gameSaveError: "An error occurred while processing your request. Please try again later.",
    saveLevels: "Save levels",
  },
  gamesSelect: {
    allGames: "All segments",
    gamesSelected: "{count} segments selected",
    searchGames: "Search segments...",
    noGamesFound: "No segments found.",
    noGamesAvailable: "No segments available",
    selectGames: "Select segments",
    selectAGame: "Select a segment",
  },
  resetGamesForm: {
    whichGamesReset: "Which segments will be reset",
    whichPointsReset: "Which points will be reset",
    pointsTooltip: "Select which coins you want to reset, it will be applied to all players of the selected segment.",
    missions: "Quests",
    missionsTooltip: "Check only if you want to reset quests and allow students to complete them again.",
    resetMissions: "Reset quests",
    reset: "Reset",
    confirmResetTitle: "Are you sure you want to reset the segments?",
    confirmResetDescription: "Resetting the segment is an irreversible action. All selected fields will be reset and cannot be recovered. Do you really want to continue?",
    yesImSure: "Yes, I'm sure!",
    selectAtLeastOne: "You need to select at least one segment and at least one point to continue.",
    importFinished: "Import process finished!",
  },
  activeSubscriptions: {
    yourPlans: "Your Plans",
    yourPlansDescription: "Your plans and next billing",
    plan: "plan",
    plans: "plans",
    noPlanFound: "No plan found",
    errorLoadingPlans: "Error loading plan information. Please try again later.",
    nextInvoice: "Next invoice",
    errorLoadingBreakdown: "Error loading invoice breakdown.",
    description: "Description",
    qty: "Qty",
    unitPrice: "Unit price",
    amount: "Amount",
    invoiceItem: "Invoice item",
    item: "Item",
    proRata: "pro-rata",
    discount: "discount",
    discounts: "Discounts",
    subtotal: "Subtotal",
    tax: "Tax",
    total: "Total",
    nextCharge: "Next Charge",
    nextChargeOn: "Next charge on {{date}}",
    statusActive: "Active",
    statusPastDue: "Past Due",
    statusCanceled: "Canceled",
    statusIncomplete: "Incomplete",
    statusTrialing: "Trial Period",
    statusUnpaid: "Unpaid",
    statusPaused: "Paused",
    statusExpired: "Expired",
    perDay: "per day",
    perWeek: "per week",
    perMonth: "per month",
    perYear: "per year",
    every: "every {count} {interval}",
  },
  plans: {
    teacherPlanTitle: "Choose your teacher plan",
    schoolPlanTitle: "Choose your school plan",
    teacherPlanSubtitle: "Choose how you want to join Gamefik with the same plan page look, without losing checkout, trial and signup selection.",
    schoolPlanSubtitle: "Last step before you start gamifying your school.",
    loadingPlans: "Loading your plans...",
    previewLocalhost: "Preview localhost",
    month: "month",
    year: "year",
    freeMonths: "{{count}} months free",
    yearlySavings: "Best savings yearly",
    onRequest: "On request",
    free: "Free",
    processing: "Processing...",
    compareFeatures: "Compare all features",
    feature: "Feature",
    noPlansFound: "No plans were found for this profile right now. Try again in a few moments.",
    dayLeft: "1 day left",
    daysLeft: "{{count}} days left",
    trialEndsOn: "Trial ends on {{date}}. After that, the account returns to the Free plan if no subscription is activated.",
    plans: "Plans",
    inTrial: "in trial",
    schoolSelector: {
      socialProof: "Trusted by schools worldwide",
      trialTitle: "Almost there. Start your 14-day trial with no charge.",
      trialDescription: "Card on the next screen · No charge during trial · Email 3 days before it ends · Cancel and nothing is debited.",
      monthly: "Monthly",
      yearly: "Yearly",
      yearlyBadge: "Best savings yearly",
      cta: "Start 14-day trial",
      ctaSubtext: "Charged only after trial · Cancel anytime",
      processing: "Processing...",
      equivalentTo: "Equivalent to {{price}} per month",
      economyOf: "Save {{percent}}%",
      saveWithYearly: "Pay yearly and save {{percent}}%",
      addonHint: "Need more? Additional student packs available",
      proExtrasTitle: "With Pro, beyond everything in Starter, you get:",
      proExtras: "school currency · rewards catalog · guided onboarding · dedicated support with SLA",
      helpQuestion: "Not sure which plan to choose?",
      helpLink: "Talk to our team",
      stripeNotice: "Payment processed by Stripe",
      noCommitment: "No lock-in or cancellation fees",
      starterTag: "Start small",
      starterTagline: "For small schools ready to grow",
      starterBestFor: "Up to 100 students · 15 teachers",
      starterFeat1: "Up to 100 active students",
      starterFeat2: "Up to 15 teachers",
      starterFeat3: "200 AI credits per teacher / month",
      starterFeat4: "Feed, announcements and reports",
      starterFeat5: "Email support",
      proTag: "Most popular",
      proTagline: "Built for growing schools",
      proBestFor: "Up to 300 students · unlimited teachers",
      proFeat1: "Up to 300 active students",
      proFeat2: "Unlimited teachers",
      proFeat3: "500 AI credits per teacher / month",
      proFeat4: "School currency and rewards",
      proFeat5: "Guided onboarding",
      proFeat6: "Dedicated support with SLA",
    },
  },
  plansManagement: {
    tabLabel: "Plans",
    heading: "Manage plan",
    subheading: "Manage your subscription, switch plans and track charges.",
    currentPlan: "Current plan",
    currentPlanDescription: "Details of your active subscription",
    noPlanActive: "No active plan",
    noPlanActiveDescription: "You are on Gamefik Free. Upgrade to unlock more features.",
    planLabel: "Plan",
    statusLabel: "Status",
    cycleLabel: "Cycle",
    currencyLabel: "Currency",
    renewsOn: "Renews on {{date}}",
    trialEndsOn: "Trial ends on {{date}}",
    trialDaysLeft: "{{count}} days left in trial",
    manageBilling: "Manage on Stripe",
    manageBillingDescription: "Open the Stripe portal to manage payment methods, invoices and cancellations.",
    changeOnStripe: "Change on Stripe",
    changePlan: "Change plan",
    changePlanDescription: "Choose a new plan for your account.",
    upgradeCta: "Upgrade",
    monthly: "Monthly",
    yearly: "Yearly",
    proRataTitle: "Plan change rules",
    proRataUpgrade: "Mid-cycle upgrade: immediate proportional charge for the remaining period.",
    proRataDowngrade: "Downgrade: proportional credit automatically applied to the next invoice.",
    proRataCycleChange: "Cycle change (monthly to yearly): yearly amount charged with credit for the remaining monthly period.",
    proRataNote: "All changes are processed by Stripe with automatic pro rata calculation.",
    selectPlan: "Select this plan",
    currentPlanBadge: "Current",
    contactSales: "Contact sales",
    nextInvoice: "Next invoice",
    nextInvoiceDescription: "Forecast of the next charge based on the active subscription.",
    billingProfileSection: "Billing information",
    free: "Free",
    perMonth: "/month",
    perYear: "/year",
    perTeacherShort: "/teacher",
    closePlanSelector: "Close",
    openingStripe: "Opening Stripe...",
    plansTitle: "Gamefik Plans",
    plansSubtitle: "Unlock the full potential of the platform",
    billingPeriodToggle: "Toggle billing period",
    cancelationScheduled: "Cancellation scheduled",
    keepPlan: "Keep plan",
    cancelNow: "Cancel now",
    cancelToFree: "Cancel to Free",
    downgradeCta: "Downgrade",
    switchToYearly: "Switch to yearly",
    switchToMonthly: "Switch to monthly",
    cancellationConfirmed: "Cancellation confirmed",
    nextPlanBadge: "Your next plan",
    consumptionHeading: "Your current usage",
    consumptionDescription: "Track the usage of your plan resources.",
    limit: "Limit",
    almostThere: "Almost there",
    unlimited: "Unlimited",
    noLimit: "no limit",
    ofMax: "of {{max}}",
    dayLeft: "day remaining",
    daysLeft: "days remaining",
    accessUntil: "Access until",
    cancellationInfo: "You still have access to all features of {{plan}} until the end of the period. After that, your account automatically returns to the Gamefik Free plan.",
    cancelNowWarning: "Canceling now ends access immediately, without waiting for the end of the period. We do not automatically generate a proportional refund.",
    compareFeatures: "Compare all features",
    feature: "Feature",
    syncTimedOut: "Sync with Stripe is taking longer than expected. The screen will show the last known state until the update arrives.",
    stripeSyncingChange: "Waiting for Stripe to sync your plan change...",
    stripeSyncingUpdate: "Waiting for Stripe to sync the subscription update...",
    syncingAutomatically: "We are automatically syncing the subscription status. This may take a few seconds.",
    updateStatusNow: "Update status now",
    viewPlanOptions: "View plan options",
    planSaved: "Saved plan",
    stripeSyncing: "Syncing Stripe",
    planSavedDescription: "Your current plan is saved in the account registration.",
    stripeSyncingDescription: "Your plan has already been saved. We are waiting for the subscription to arrive from Stripe.",
    paymentProblem: "Your plan has payment issues ({{status}}). Your consumption is temporarily limited to the {{plan}} plan until regularized.",
    activeUntil: "Active until {{date}}",
    endOfPeriod: "end of period",
    classes: "Classes",
    students: "Students",
    activitiesCreated: "Activities created",
    wallPosts: "Wall posts",
    aiCredits: "AI credits",
    syncSuccess: "Plan synchronized with Stripe.",
    syncTimeoutWarning: "Stripe is still syncing your change. Please refresh again in a few moments.",
    syncError: "Error syncing plans with Stripe:",
    cannotOpenStripe: "Could not open the Stripe portal now. Please try again.",
    cannotStartCheckout: "Could not start checkout now. Please try again.",
    cannotIdentifySubscription: "Could not identify the current subscription to change plans.",
    cannotIdentifySubscriptionItem: "Could not identify the subscription item to change plans.",
    cannotOpenPlanChange: "Could not open the plan change in Stripe now. Please try again.",
    changingPlan: "Changing plan...",
    syncing: "Syncing...",
    planChangedSuccess: "Plan changed successfully keeping the remaining trial days.",
    done: "Done!",
    cannotChangeTrialPlan: "Could not change the trial plan now.",
    noActiveSubscription: "No active subscription to cancel.",
    canceling: "Canceling...",
    updatingData: "Updating data...",
    cancelScheduledSuccess: "Cancellation scheduled. Your current plan remains active until the due date.",
    cannotCancelSubscription: "Could not cancel the subscription now.",
    addonUpdateUnavailable: "Add-on updates are temporarily unavailable. Please wait for the system update and try again.",
    aiCoverageIncomplete: "Incomplete Unlimited AI coverage",
    aiCoverageIncompleteBadge: "Incomplete coverage",
    aiSeatsPurchased: "Purchased seats",
    aiTeachersEligible: "Eligible teachers",
    aiCoverageDeficit: "Deficit",
    aiCoverageSyncCta: "Adjust to {{count}} seats",
    aiCoverageSyncSuccess: "Seat quantity updated successfully.",
    aiCoverageSyncError: "Could not update the Unlimited AI seats.",
    aiCoverageUnknown: "AI coverage has not been confirmed by the server yet. Purchasing stays blocked until it refreshes.",
    aiNoEligibleTeachers: "There are no eligible teachers on this account. No AI charge can be created.",
    aiAddonRedundant: "Unlimited AI is already included in the base plan.",
    aiAddonRedundantDescription: "This add-on is redundant and may keep generating charges. Cancel it without increasing its quantity.",
    aiAddonCancelRedundant: "Cancel redundant add-on",
    cancelingNow: "Canceling now...",
    cancelImmediatelySuccess: "Plan canceled immediately. Your account returned to Gamefik Free.",
    cannotCancelNow: "Could not cancel now.",
    reverting: "Reverting...",
    revertSuccess: "Cancellation reverted! Your plan has been kept.",
    cannotRevertCancellation: "Could not revert the cancellation now.",
  },
  planFeatures: {
    teacher: {
      activeClasses: "Active classes",
      totalStudents: "Total students",
      activitiesPerMonth: "Activities/month",
      trails: "Trails",
      aiCreditsPerMonth: "AI credits/month",
      xpAndBadges: "XP and badges",
      gems: "Gems (default currency)",
      customCurrency: "Custom currency",
      rewards: "Rewards",
      announcementsPerMonth: "Announcements/month",
    },
    school: {
      activeStudentsBase: "Active students (base)",
      teachers: "Teachers",
      addon50Students: "Add-on +50 students",
      activities: "Activities",
      aiCreditsPerTeacher: "AI credits (per teacher)",
      addonUnlimitedAI: "Add-on unlimited AI",
      xpAndBadges: "XP and badges",
      customCurrency: "Custom currency",
      rewardCatalog: "Reward catalog",
      rewardsPerClass: "Rewards per class",
      adminPanel: "Admin panel",
      assistedOnboarding: "Assisted onboarding",
      lmsIntegration: "LMS integration",
      dedicatedSupport: "Dedicated support + SLA",
    },
    unlimited: "Unlimited",
    unlimitedFem: "Unlimited",
    unlimitedMasc: "Unlimited",
    upTo2: "Up to 2",
    upTo30: "Up to 30",
    upTo50: "Up to 50",
    upTo100: "Up to 100",
    upTo15: "Up to 15",
    upTo300: "Up to 300",
    perMonth: "/month",
    included: "Included",
    nA: "N/A",
    consumesCredits: "Consumes credits",
    oneTotal: "1 total",
    threePerMonth: "3 per month",
    yes: "Yes",
    no: "No",
    highlights: {
      upTo2Classes: "Unlimited classes",
      upTo30Students: "Up to 50 students",
      fiveActivitiesMonth: "5 activities/month",
      twoHundredAiCreditsMonth: "200 AI credits/month",
      xpAndBadges: "XP and badges",
      gemsDefaultCurrency: "Gems (default currency)",
      unlimitedClasses: "Unlimited classes",
      unlimitedActivities: "Unlimited activities",
      fiveHundredAiCreditsMonth: "500 AI credits/month",
      unlimitedAnnouncements: "Unlimited announcements",
      customCurrency: "Custom currency",
      unlimitedAI: "Unlimited AI",
      exclusiveRewards: "Exclusive rewards",
      rewardStore: "Reward store",
      prioritySupport: "Priority support",
      upTo100Students: "Up to 100 students",
      upTo15Teachers: "Up to 15 teachers",
      adminPanel: "Admin panel",
      consolidatedReports: "Consolidated reports",
      upTo300Students: "Up to 300 students",
      unlimitedTeachers: "Unlimited teachers",
      rewardCatalog: "Reward catalog",
      unlimitedStudents: "Unlimited students",
      oneTrailTotal: "1 trail total",
      threeAnnouncementsMonth: "3 announcements/month",
      unlimitedTeacherCore: "Unlimited classes, students, and activities",
      unlimitedAIIncluded: "Unlimited AI included",
      rewardsPerClass: "Rewards per class",
      lmsIntegration: "LMS integration",
      multiUnits: "Multi-units",
      customContract: "Custom contract",
    },
    presentation: {
      freeTitle: "Gamefik Free",
      freeCta: "Start for free",
      freePriceLabel: "Free",
      freePriceDetail: "Forever",
      epicSubtitle: "Unlock the full potential",
      epicHighlightIntro: "Everything from Free, plus:",
      epicBadge: "Most popular",
      epicCta: "Subscribe now",
      epicMonthlyFootnote: "Cancel anytime",
      shinySubtitle: "The maximum of gamification",
      shinyHighlightIntro: "Premium resources for your gamification:",
      shinyBadge: "Exclusive",
      shinyCta: "Become Shiny",
      shinyMonthlyFootnote: "Cancel anytime",
      starterCta: "Start 14-day trial",
      starterMonthlyFootnote: "Trial 14 days - card required",
      proSubtitle: "Ideal for growing schools",
      proHighlightIntro: "Everything from Starter, plus:",
      proBadge: "Most popular",
      proCta: "Start 14-day trial",
      proMonthlyFootnote: "Trial 14 days",
      enterpriseSubtitle: "Everything from Pro, plus:",
      enterpriseCta: "Talk to sales",
      enterprisePriceLabel: "On request",
    },
  },
  billingProfile: {
    title: "Billing Information",
    description: "Information used for billing and invoices",
    stripeAccount: "Stripe Account",
    nameLabel: "Name/Company Name",
    emailLabel: "E-mail",
    phoneLabel: "Phone",
    addressLine1: "Address (line 1)",
    addressLine2: "Address line 2",
    city: "City",
    state: "State",
    postalCode: "Postal Code",
    country: "Country",
    taxDocument: "Tax Document",
    number: "Number",
    select: "Select",
    saveSuccess: "Billing information updated",
    saveError: "Error saving billing information",
    addressManagedInStripe: "Billing address is managed directly in Stripe.",
    editAddressOnStripe: "Edit address on Stripe",
    vatEU: "VAT (EU)",
    other: "Other",
  },
  gameList: {
    noGameFound: "No segment found",
    createFirstGame: "Create your first segment to start managing points and rewards for your players.",
    game: "Segment",
    scoring: "Scoring",
    coinsLimit: "Coins Limit",
    limitNotDefined: "Limit not defined",
    noLimitLabel: "No limit",
    openMenu: "Open menu",
    editGame: "Edit Segment",
    configureLevels: "Configure Levels",
    deleteGame: "Delete Segment",
  },
  modalGameLimit: {
    teacherMissions: "Teacher quests",
    attentionTeacherMissions: "Your teachers can now create and approve quests.",
    defineCoinsLimit: "Set the coin limit each teacher will receive per month to apply to each of their classes below.",
    unlimitedLabel: "Unlimited",
    withLimit: "With limit",
    coinsPerMonth: "{count} coins/month",
    schoolsWithTeacherMissions: "Schools where teachers create quests have significantly better results with Gamefik!",
    featureEnabled: "Feature enabled",
    featureDisabled: "Feature disabled",
    featureToggleSuccess: "Feature {status} successfully",
    enabled: "enabled",
    disabled: "disabled",
    featureToggleError: "Error enabling/disabling feature",
    updateCoinsError: "Error updating coins limit",
  },
  coinsLimits: {
    checkCoinsLimitByClass: "Check the coin limit per class below",
    classesCannotCreateMissions: "The following classes cannot create quests:",
    limitReached: "{name}: limit reached ({used} / {total})",
    classColumn: "Class",
    usedLimit: "Used Limit",
    remainingCoins: "Remaining coins",
    available: "Available",
    classMissions: "Class quests",
    viewMissions: "quests",
    createdBy: "Created by:",
    createdAt: "Created on:",
    checkLimit: "Check limit",
    returnButton: "Return",
  },
  userManagement: {
    addUser: "Add User",
    importLabel: "Import",
    importUsersTitle: "Import Users",
    importUsersDescription: "Import multiple users using a CSV file",
    startImport: "Start Import",
    importUsersBatchTitle: "Batch Import Users",
    importUsersBatchDescription: "Import multiple users at once using a CSV file",
    downloadTemplate: "Download the template file",
    downloadTemplateDescription: "First, download the template file, fill it with user emails and upload it here.",
    downloadTemplateButton: "Download Template",
    alreadyHaveFile: "I already have the filled file",
    sendSpreadsheet: "Upload the filled spreadsheet",
    verifyEmails: "Verify all emails are correct before sending invitations.",
    selectCsvFile: "Select the CSV file with teacher emails",
    noValidEmails: "No valid emails found in the file. Check if the column is called 'Email' or 'E-mail'.",
    emailsFound: "{count} email(s) found! Scroll down to see the preview and send invitations.",
    previewUsers: "Users Preview ({count})",
    verifyBeforeSending: "Verify emails before sending invitations",
    email: "Email",
    status: "Status",
    sent: "Sent",
    error: "Error",
    waiting: "Waiting",
    continue: "Continue",
    sendInvites: "Send Invitations ({{count}})",
    inviteSentSuccess: "Invitation sent successfully",
    inviteSendError: "Error sending invitation",
    totalUsers: "Total Users",
    administrators: "Administrators",
    teachers: "Teachers",
    pendingInvites: "Pending Invitations",
    userListTitle: "Users List",
    userListDescription: "View and manage all system users",
    user: "User",
    roles: "Roles",
    classes: "Classes",
    actions: "Actions",
    pending: "Pending",
    active: "Active",
    registered: "Registered",
    resendingInvite: "Resending invitation...",
    inviteResentTitle: "Invitation Resent Successfully",
    inviteResentDescription: "The invitation link has been generated. You can copy it or send it by email.",
    accessLink: "Access link:",
    copyButton: "Copy",
    attentionAutoFail: "If the automatic send fails, you can send the invitation manually.",
    sendEmailManually: "Send email manually",
    inviteResentSuccess: "Invitation resent successfully!",
    resendInviteError: "Error resending invitation",
    linkCopied: "Link copied to clipboard!",
    generatingAccess: "Generating secure access...",
    openingAccess: "Opening access in new tab...",
    generateTokenError: "Error generating access token",
    impersonateNotAllowed: "You can't access as this user: their access level isn't lower than yours.",
    noName: "No name",
    accessAsUser: "Access as User",
    viewEdit: "View/Edit",
    resendInvite: "Resend Invitation",
    manageClasses: "Manage Classes",
    removeUser: "Remove User",
    noUsersFound: "No users found",
    addFirstUser: "Add first user",
    searchUsersPlaceholder: "Search by name or email...",
    searchUsersAriaLabel: "Search users by name or email",
    clearSearch: "Clear search",
    searchResultsCount: "{count} of {total} users",
    noUsersForSearch: "No users found for \"{search}\"",
    noUsersForSearchHint: "Try searching for another name or email.",
    noClasses: "No classes",
    classesNotFound: "Classes not found",
    classesCount: "{count} classes",
    roleAdmin: "Administrator",
    roleManager: "Manager",
    roleSecretary: "Secretary",
    roleTeacher: "Teacher",
    roleSchoolTeacher: "School teacher",
    roleAdminFull: "Administrator",
    roleManagerFull: "Manager",
    roleSecretaryFull: "Secretary",
    roleTeacherFull: "Teacher",
    roleSchoolTeacherFull: "School teacher",
    inviteSubject: "Invitation to access the system",
    inviteBody: "Hello!\n\nYou have been invited to access the system. Use the link below to complete your registration:\n\n{link}\n\nBest regards.",
    importLimitedByPlan: "Your plan allows adding {{remaining}} more teacher(s). {{excess}} email(s) were removed from the import.",
  },
  modalRemoveUser: {
    title: "Remove school access",
    subtitle: "Review the impact before removing {name}.",
    scopeTitle: "The user will not be deleted",
    scopeDescription: "This action only removes access to the current school. Accounts at other schools, created content, and historical authorship will be preserved.",
    loadingImpact: "Checking impact",
    loadingImpactDescription: "We are checking linked classes in the primary data source.",
    previewErrorTitle: "The impact could not be checked",
    previewErrorDescription: "No changes were made. Load the data again before confirming.",
    retry: "Try again",
    ownerBlockTitle: "The owner cannot be removed",
    ownerBlockDescription: "Transfer school ownership to another administrator first, then return to this screen.",
    impactTitle: "What will be affected",
    impactDescription: "When confirmed, the membership with this school will be safely removed.",
    classesAffected: "linked classes",
    preservedTitle: "What will be preserved",
    preserved: {
      other_accounts: "The user's access to other schools",
      historical_authorship: "Authorship and history of completed actions",
      school_content: "The school's classes, activities, and content",
    },
    progressTitle: "Removal in progress",
    progressDescription: "We are revoking the membership with this school. Do not close this window; a safe retry uses the same operation.",
    partialErrorTitle: "The removal was partially completed",
    partialErrorDescription: "Some steps were already applied. Try again to resume the same operation without duplicating changes.",
    removeErrorTitle: "The access could not be removed",
    removeErrorDescription: "No completion confirmation was received. Try again or contact support if the problem continues.",
    successTitle: "Access removed safely",
    successDescription: "The school membership was safely revoked.",
    cancelButton: "Cancel",
    deleteButton: "Remove access",
    finishButton: "Done",
  },
  voiceSearch: {
    start: "Search by voice",
    stop: "Stop voice search",
    error: "Voice search could not be used. Keep typing instead.",
  },
  modalSelectClasses: {
    selectClassesFor: "Select classes for {name}",
    classesPlaceholder: "Classes",
    addButton: "Add",
    addSuccess: "Class(es) added successfully",
    addError: "There was an error adding class",
    searchPlaceholder: "Search class...",
    noClassFound: "No classes found.",
    selectedCount: "{{count}} class(es) selected",
    loadError: "Could not load the user's classes.",
    retry: "Try again",
    segmentLoading: "Loading segment...",
    segmentsLoadError: "Segments unavailable",
    segmentUnavailable: "Unidentified segment",
  },
  sendInvitation: {
    sendInvite: "Send Invitation",
    emailLabel: "E-mail *",
    emailPlaceholder: "Enter e-mail",
    permissionLabel: "Permission *",
    selectPermission: "Select a permission",
    classesLabel: "Classes *",
    searchClasses: "Type to search classes...",
    noClassSelected: "No class selected",
    noClassFound: "No class found",
    clickToSelect: "Click to select/deselect classes",
    selected: "Selected",
    selectAtLeastOneClass: "Select at least one class to send the invitation",
    sending: "Sending...",
    sendButton: "Send Invitation",
    invitesSentSuccess: "Invitations sent successfully",
    invitesSentPartially: "Invitations sent partially!",
    segmentLoading: "Loading segment...",
    segmentsLoadError: "Segments unavailable",
    segmentUnavailable: "Unidentified segment",
  },
  viewUser: {
    editUser: "Edit User",
    editUserDescription: "View and edit user information and permissions",
    noName: "No name",
    verified: "Verified",
    notVerified: "Not verified",
    personalInfo: "Personal Information",
    fullName: "Full Name",
    emailLabel: "E-mail",
    genderLabel: "Gender",
    genderMale: "Male",
    genderFemale: "Female",
    genderOther: "Other",
    genderNotInformed: "Not informed",
    settingsTitle: "Settings",
    groupPermission: "Group/Permission",
    selectGroup: "Select a group",
    birthDate: "Birth Date",
    memberSince: "Member since",
    notInformed: "Not informed",
    invalidDate: "Invalid date",
    permissionChangeWarning: "You are changing this user's permissions from <strong>{from}</strong> to <strong>{to}</strong>. This action will affect user's system access.",
    selectGroupError: "Please select a group for the user",
    updateSuccess: "User permissions updated successfully!",
    updateError: "Error updating user permissions",
    saving: "Saving...",
    saveChanges: "Save Changes",
  },
  userTypeTag: {
    legacyAdmin: "Admin · Legacy",
    legacyManager: "Manager · Legacy",
    legacySecretary: "Secretary · Legacy",
    legacyTeacher: "Teacher · Legacy",
    nmgTeacher: "Teacher · NMG",
    nmgSchool: "School · NMG",
    nmgSchoolTeacher: "School Teacher · NMG",
  },
  rowUser: {
    editPermissions: "Edit permissions",
    editClasses: "Edit classes",
    resendInviteLabel: "Resend invitation",
    remove: "Remove",
    emailVerified: "E-mail verified",
    emailNotVerified: "E-mail not verified",
    loading: "Loading...",
    lastUsedOn: "Last used on {date}",
    neverUsed: "Never used",
    userCreatedOn: "User created on {date}",
    unknown: "Unknown",
  },
  registerUser: {
    next: "NEXT",
    previous: "PREVIOUS",
    stepOf: "Step {step} of {total}",
    wantToKnowMore: "We want to know a little more about you",
    invalidName: "Invalid name",
    fullName: "Full name",
    sex: "Gender",
    male: "Male",
    female: "Female",
    preferNotToSay: "Prefer not to say",
    birthDate: "Birth Date",
    schoolRole: "What is your role at school?",
    teacher: "Teacher",
    coordinator: "Coordinator",
    secretary: "Secretary",
    others: "Others",
    registrationSuccess: "Congratulations, your registration is complete!",
    registrationError: "Sorry, an error occurred while completing your registration, please contact support.",
  },
  dialogRegisterAdmin: {
    newAccountIntro: "Meet the new Gamefik account",
    newAccountDescription: "From now on you can have an account with an exclusive password to access your school's Gamefik account and also create an exclusive account with access to your school's information for each team member.",
    readyToCreate: "So? Did you like it? Let's create your account?",
    areYouManager: "Are you a manager?",
    yes: "Yes",
    no: "No",
    whatIsYourEmail: "What is your e-mail?",
    invalidEmail: "Invalid e-mail",
    chooseNewPassword: "Choose a <strong>new password</strong> for your individual user.",
    passwordRequirements: "Password must be at least 6 characters. Password must not contain symbols (@,#,%,ˆ,&)",
    invalidPassword: "Invalid password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    passwordsDontMatch: "Passwords don't match",
    almostThere: "Almost there!",
    confirmData: "We need you to confirm the data you provided. After clicking continue, this action cannot be undone.",
    name: "Name:",
    emailConfirm: "E-mail:",
    gender: "Gender:",
    birthDateConfirm: "Date of birth:",
    schoolName: "School name:",
    contact: "Contact:",
    createUserError: "An error occurred while creating the user, please try again or contact support!",
    emailVerificationCode: "You received an e-mail at (<strong>{email}</strong>) with a <strong>code</strong> to validate your data. Please enter this code in the field below.",
    code: "Code",
    resend: "Resend",
    accountCreatedSuccess: "Your account has been created successfully.",
    addTeamMembers: "You can now add other team members by clicking",
    here: "here",
    onlyManagerAction: "Only the manager can perform this action!",
    contactManager: "Please contact your school's manager.",
    schoolInfoNeeded: "We need some information about your school to complete the registration.",
    schoolNameLabel: "School name",
    nameTooShort: "Name too short",
    telephone: "Telephone",
    invalidNumber: "Invalid Number",
    next: "NEXT",
    cancelButton: "CANCEL",
  },
  dialogRegisterAccount: {
    welcome: "Welcome to Gamefik!",
    welcomeDescription: "To continue your registration, we'll need some information. Let's go?",
    choosePassword: "Choose a <strong>password</strong> for your individual user.",
    profession: "Profession",
    professionConfirm: "Profession:",
    schoolCode: "Your school code is: {code}",
    explorePlatform: "You can now explore our platform by clicking",
  },
  seletorUnidade: {
    switchUnitError: "Error switching unit",
  },
  iaCreditsExhausted: {
    creditsExhausted: "Credits Exhausted",
    monthlyCreditsExhausted: "Your monthly AI credits have run out",
    missionsQuizzesWithAI: "Quests/Quizzes with AI",
    wantUnlimitedAI: "Want to subscribe to the unlimited AI package?",
    contractUnlimitedAI: "Subscribe to Unlimited AI",
    contactAdminToContract: "Contact your school admin to subscribe to unlimited AI.",
    notNow: "Not now",
    creditsNeeded: "You need {{needed}} credits to create with AI",
    adjustNeeded: "Each chat adjustment costs 10 credits",
    muralAdjustNeeded: "Each Mural text suggestion costs 10 credits",
    creditsAvailable: "Credits available",
    usedThisMonth: "{{count}} committed this month",
    quizContext: "Context: quiz",
    missionContext: "Context: quest",
    trailContext: "Context: trail",
    muralContext: "Context: Mural",
    teacherEpicName: "Teacher Epic",
    teacherShinyName: "Teacher Shiny",
    mostPopular: "Most popular",
    exclusive: "Exclusive",
    unlimitedClasses: "Unlimited classes",
    unlimitedStudents: "Unlimited students",
    unlimitedActivities: "Unlimited activities",
    aiCreditsPerMonth: "{{count}} AI credits/month",
    customCurrency: "Custom currency",
    unlimitedAI: "Unlimited AI",
    exclusiveRewards: "Exclusive rewards",
    onboardingAssisted: "Assisted onboarding",
    rewardStore: "Reward store",
    prioritySupport: "Priority support",
    monthShort: "/mo",
    unlockWithEpic: "Unlock with Epic",
    becomeShiny: "Become Shiny",
  },
  iaUpgrade: {
    upgradeToAI: "Upgrade to AI Resources",
    reachedFreeLimit: "You have reached the monthly free creation limit for {type}",
    activateForUnlimited: "Activate AI for unlimited {type} creation",
    currentPlanFree: "Current Plan - Free",
    aiCreationsThisMonth: "AI {type} creations this month:",
    remainingFreeCreations: "{count} free creations remaining this month",
    monthlyLimitReached: "Monthly limit reached - upgrade needed to continue",
    planWithAI: "AI Plan",
    recommended: "Recommended",
    enhanceExperience: "Enhance your Gamefik experience with AI-powered resources",
    unlimitedCreations: "Unlimited AI {type} creations",
    autoAnalysis: "Automatic submission analysis by AI",
    smartFeedback: "Smart feedback for students",
    autoSuggestions: "Automatic improvement suggestions",
    advancedReports: "Advanced reports with AI insights",
    continueFreePlan: "Continue with Free Plan",
    activateAIResources: "Activate AI Resources",
    freeResetInfo: "The free creation limit resets on the 1st of every month",
  },
  xpResetModal: {
    xpResetDescription: "We want to make sure you understand your choice",
    xpSystemUpdate: "XP System Update",
    configureXpMigration: "Configure how you want to migrate student XP",
    newAppLaunched: "Gamefik has launched the <strong>New Student App</strong> with an incredible journey and important changes. Schools no longer need to manage level progression, our system handles it automatically. Students can reach <strong>level 100</strong>.",
    wantToKnowMore: "Want to know more?",
    clickHere: "Click here",
    suggestResetXp: "We strongly suggest resetting XP so everyone can enjoy 100% of the new app experience.",
    dontReset: "Don't Reset",
    resetXp: "Reset XP",
    areYouSure: "Are you sure?",
    ensureChoice: "We want to make sure you understand your choice",
    recommendReset: "We recommend resetting XP so everyone can enjoy 100% of the new app experience.",
    newSystemDescription: "The new system offers a complete and balanced journey from the start, with levels up to 100 and automatic progression.",
    understoodDontReset: "Understood, but I won't reset",
    understoodWantReset: "Understood, I want to Reset XP",
  },
  xpResetMigrationGate: {
    noGamesToReset: "We couldn't find segments to reset XP. Try again in a few seconds.",
    xpResetSuccess: "XP reset successfully!",
    xpResetSaveError: "XP was reset, but we couldn't save your choice. The notice may appear again.",
    xpResetError: "Unable to reset XP. Please try again.",
    decisionSaveError: "Unable to save your choice. The notice may appear again.",
    decisionRegistered: "Choice registered. No changes were made to student XP.",
    noGamesForReset: "No segments to reset.",
  },
  aiCreditsDisplay: {
    iaCredits: "AI credits",
    iaCreditsTitle: "AI Credits",
    creditsAvailable: "{count} credits available",
    lowCredits: "Low credits! Consider recharging.",
    monthlyMovements: "AI Activity (current month)",
    loadingLabel: "Loading...",
    loadError: "Error loading AI credit activity.",
    noMovements: "No activity recorded this month.",
    creationWithAI: "AI Creation",
    zeroedHere: "Depleted here",
    unlimitedAI: "Unlimited AI",
    unlimitedAIDescription: "Create as many quests, quizzes and content as you want with AI, without worrying about credits.",
    contract: "Subscribe",
    contactAdminToContract: "Contact your school admin to subscribe",
    unlimitedFromPlan: "Unlimited AI according to your current plan",
    currentPlanBudget: "Current plan AI budget",
    planLabel: "Plan",
    limitSourceLabel: "Limit source",
    monthlyLimitLabel: "Monthly limit",
    usedInMonthLabel: "Used this month",
    availableLabel: "Available",
    unlimitedLabel: "Unlimited",
    overrideAppliedBadge: "Account override applied",
    sourceAccountOverride: "Account configured override",
    sourcePlanLimit: "Current plan limit",
    sourcePlanUnlimited: "Plan with unlimited AI",
    sourcePremium: "Premium AI package",
    sourceLegacy: "Legacy account limit",
    modalSubtitle: "Your monthly usage",
    remainingCreditsLabel: "Credits remaining",
    reservedInProgress: "{{count}} credits reserved for generations in progress",
    renewsOnFirstOfMonth: "Renews on the 1st of {{month}}",
    recentActivityTitle: "Recent activity",
    needMoreCreditsCta: "Need more credits?",
    planEpicMonthly: "500 credits/month",
    viewPlanButton: "View {{plan}} plan",
    backButton: "Back",
    detailRowType: "Type",
    detailRowReason: "Reason",
    detailRowWhen: "When",
    detailRowUser: "User",
    detailRowCost: "Cost",
    detailRowId: "ID",
    costCreditsOne: "{{count}} credit",
    costCreditsOther: "{{count}} credits",
    reasonCreateMissionAI: "AI mission creation",
    reasonCreateQuizAI: "AI quiz creation",
    reasonAdjustChatAI: "Adjustment / iteration in AI chat",
    reasonComprovantesOnCreation: "Proof included in activity creation",
    reasonDefault: "Credit usage",
    itemQuiz: "Quiz",
    itemMission: "Mission",
    dateToday: "Today, {{time}}",
    dateYesterday: "Yesterday, {{time}}",
  },
  iaContractCta: {
    unlimitedAIActive: "Unlimited AI active",
    unlimitedAIPackage: "Unlimited AI Package",
    manageDescription: "Your Unlimited AI package is active. You can manage your subscription and billing in settings.",
    upgradeDescription: "Your account has no AI credits. Subscribe to the Unlimited AI package to enable AI creation immediately.",
    managePlan: "Manage plan",
    contractNow: "Subscribe to AI now",
    contactAdminToContract: "Contact your school admin to subscribe or manage the AI plan.",
    timeRemaining: "Remaining",
  },
  iaPlanIndicator: {
    unlimitedAI: "Unlimited AI",
  },
  iaUsageNotice: {
    loadingStatus: "Loading AI status...",
    checkError: "Unable to check your AI credits right now.",
    unlimitedActive: "Unlimited AI active — no credits will be deducted.",
    creditsAvailable: "Your account has {{count}} AI credits available.",
    creditsCost: "{{min}} to {{max}} credit(s) will be deducted when creating with AI.",
    contractUnlimited: "Subscribe to unlimited AI now",
    contactAdminToContract: "Contact your school admin to subscribe to unlimited AI.",
  },
  iaUsageProgress: {
    premiumResources: "Premium AI Resources",
    activeLabel: "Active",
    unlimitedCreations: "Unlimited creations available",
    includedResources: "Included Resources:",
    unlimitedQuizzesMissions: "Unlimited AI Quizzes and Quests",
    autoAnalysis: "Automatic submission analysis",
    smartFeedback: "Personalized smart feedback",
    advancedReports: "Advanced reports with insights",
    freeAICreations: "Free AI Creations",
    remainingCreations: "<strong>{count}</strong> free creations remaining this month",
    monthlyLimitReached: "Monthly limit reached - activate AI to create more",
    nextReset: "Next reset: <strong>{date}</strong>",
    days: "{count} days",
    availableInFreePlan: "Creations available in the free plan:",
    quizzesWithAI: "Quizzes with AI",
    missionsWithAI: "Quests with AI",
    freePlanLimitations: "Free plan limitations:",
    manualAnalysis: "Manual submission analysis",
    basicReports: "Basic reports without AI insights",
    standardFeedback: "Standard feedback for students",
    upgradeToUnlimited: "Upgrade to unlimited AI and much more!",
    lastCreation: "Last creation available - consider upgrading!",
  },
  teacherModal: {
    noAICredits: "No AI credits available",
    noCreditsDescription: "Your school account has no AI credits. Create your quest manually or contact the account manager.",
    createManualMission: "Create manual quest",
  },
  trilhas: {
    pageTitle: "Learning paths | Gamefik",
    pageDescription:
      "Build personalized learning paths with quizzes, flashcards, and content in complete journeys for your students.",
    title: "Learning paths",
    comingSoon: "Coming soon",
    description:
      "We are building an amazing experience for you to create Duolingo-style personalized learning paths. Combine quizzes, flashcards, and content into complete journeys for your students.",
    flashcards: "Flashcards",
    quizzes: "Quizzes",
    quests: "Quests",
    accessLinkButtonAria: "Trail access link",
    accessLinkModalTitle: "Access Link",
    accessLinkModalScanHint: "Scan the QR Code or copy the link below",
    accessLinkModalShareHint:
      "Share this link with your students. When they access it, they create an account and automatically join the trail.",
    accessLinkModalPrintPdf: "Print PDF",
    accessLinkModalPrintTitle: "Access - {{name}}",
    accessLinkModalPrintSubtitle: "Educational Gamification Platform",
    accessLinkModalPrintCardLabel: "Trail Access Link",
    accessLinkModalPrintInstructions:
      "Scan the QR Code above or access the link below to join the trail",
    accessLinkModalQrAlt: "QR Code",
    accessLinkCopy: "Copy",
    accessLinkCopied: "Copied",
    accessLinkDisabledHint: "Available after publishing the trail",
    testEnv: {
      viewAnyway: "View paths (test environment)",
    },
    header: {
      eyebrow: "Library — Global Community",
      title: "Learning paths",
      createFromScratch: "Create path from scratch",
    },
    tabs: {
      community: "Community library",
      myTrails: "My paths",
    },
    my: {
      searchPlaceholder: "Search your paths...",
      filters: {
        turmas: "Classes",
        subject: "Subject",
      },
      clearFilters: "Clear ({{count}})",
      stats: {
        active: "{{count}} active",
        drafts: "{{count}} drafts",
        inactive: "{{count}} inactive",
        expired: "{{count}} expired",
      },
      statusActive: "Active",
      statusInactive: "Inactive",
      statusScheduled: "Scheduled",
      statusExpired: "Expired",
    },
    card: {
      createTitle: "Create new path",
      createSubtitle: "Start from scratch",
      phases: "{{count}} phases",
      activities: "{{count}} activities",
      participants: "{{count}} students",
      studentProgress: "Student progress",
      studentProgressAverage: "Average student progress",
      classes: "{{count}} classes",
      viewDetails: "View details",
      openDetails: "Open details for {{title}}",
      reactivate: "Reactivate path",
      deactivate: "Deactivate path",
    },
    report: {
      title: "Report: {{title}}",
      subtitle: "Student performance on this path",
      noClassesTitle: "No linked classes",
      noClassesDescription:
        "Link classes to this path to see student performance reports.",
      understood: "Got it",
      loadErrorTitle: "Could not load report",
      loadErrorDescription: "Check your connection and try again.",
      completionRate: "Completion rate",
      completionRateHint: "{{completed}} of {{total}} students completed",
      averageProgress: "Average progress",
      averageProgressHint: "Average across all students",
      totalStudents: "Total students",
      totalStudentsHint: "Across {{count}} {{unit}}",
      classUnit: "class",
      classesUnit: "classes",
      phasesTitle: "Performance by phase",
      phasesSubtitle: "See where students struggle most",
      attention: "Attention",
      difficultActivity: "Difficult activity:",
      studentsHere: "{{count}} students here",
      completion: "Completion",
      accuracy: "Accuracy rate",
      averageTime: "Average time: {{minutes}}min",
      classesTitle: "Completion by class",
      classesSubtitle: "Classes ranked by completion percentage",
      completedRatio: "{{completed}}/{{total}} completed",
      classAverage: "Average: {{percent}}%",
      statusIncomplete: "Not completed",
      criteriaAllSteps: "Criterion: complete all steps",
      criteriaMinScore: "Criterion: minimum score of {{score}}%",
      hint: "Hint",
      openAttachment: "Open attachment",
      missionResponseUnavailable: "Completion was recorded. This report does not provide the answer or evidence submitted for this mission.",
      studentsTitle: "Student completion and answers",
      studentsSubtitle: "See each student’s completion and open activities to view answers and details.",
      responses: "Answers",
      viewStudentResponses: "View answers",
      viewStudentResponsesLabel: "View answers from {{name}}",
      noStudentsFound: "No students found. Adjust the filters to continue.",
      filterAllClasses: "All classes",
      filterClassesCount: "{{count}} classes",
      searchClassPlaceholder: "Search class...",
      noClassFound: "No class found.",
      clearSelection: "Clear selection ({{count}})",
      filterAllStatus: "All statuses",
      statusCompleted: "Completed",
      statusInProgress: "In progress",
      statusNotStarted: "Not started",
      statusAtRisk: "At risk",
      searchStudentPlaceholder: "Search by name",
      colStudent: "Student",
      colClass: "Class",
      colCurrentPhase: "Current phase",
      colProgress: "Progress",
      colActivities: "Activities",
      colAccuracy: "Accuracy rate",
      showingStudents: "Showing {{shown}} of {{total}} participants",
    },
    detailModal: {
      phasesLabel: "Phases",
      activitiesLabel: "Activities",
      participantsLabel: "Students",
      classesLabel: "Classes",
      linkedClasses: "Classes",
      linkedClassesHint: "{{count}} linked classes · manage",
      linkedClassesHintAll: "All school classes · manage",
      classesAllShort: "All",
      editTrail: "Edit path",
      structureTitle: "Path structure",
      structureSubtitle: "{{phases}} phases with {{activities}} activities",
      phaseActivities: "{{count}} activities",
      noPhases: "This path has no phases yet.",
      structureLoadError: "Could not load path structure.",
      backToStructure: "Back to structure",
      exploreHint: "Click any item to see more details",
      overviewTitle: "Path overview",
      descriptionLabel: "Description",
      themeLabel: "Theme",
      gradeLabel: "Grade level",
      localeLabel: "Locale",
      creatorLabel: "Created by",
      creatorUnavailable: "Deleted or unavailable user",
      statusTitle: "Path status",
      phasesOverviewTitle: "All phases",
      activitiesOverviewTitle: "All activities",
      classesOverviewTitle: "Classes",
      classesPanel: {
        search: "Search class…",
        filterAll: "All",
        filterLinked: "Linked",
        filterUnlinked: "Not linked",
        addVisible: "Link visible",
        removeVisible: "Unlink visible",
        openToAll: "Open to all classes",
        allClassesHint:
          "No restriction: every student in the school can access this path. Select a class below to restrict access.",
        allClassesHintReadonly:
          "No restriction: every student in the school can access this path.",
        unlinkDisabledHint:
          "Classes can only be unlinked while the path is a draft.",
        keepOneClassHint:
          "Add another class before removing the last linked class.",
        linkedTitle: "Classes linked to this path ({{count}})",
        noLinked: "No classes linked yet.",
        addTitle: "Add class",
        restrictTitle: "Restrict to one class",
        statusLinked: "Linked",
        statusUnlinked: "Not linked",
        addOne: "Link {{name}}",
        removeOne: "Unlink {{name}}",
        noResults: "No classes match this filter.",
        loading: "Loading classes…",
        saveSuccess: "Path classes updated.",
        saveError: "Could not update classes.",
      },
      classDetailTitle: "Class",
      phaseDetailTitle: "Phase details",
      phaseDescriptionLabel: "Description",
      activityDetailTitle: "Activity details",
      activityInPhase: "In phase: {{phase}}",
      stepsLabel: "{{count}} steps",
      stepsLabelOne: "1 step",
      orderInPhase: "Order {{order}} in phase",
      completionLabel: "Completion criteria",
      completionAllSteps: "Complete all steps",
      completionMinScore: "Minimum score of {{score}}%",
      deadlineLabel: "Deadline",
      noDescription: "No description provided",
      filterTypeTitle: "{{type}} in this path",
      filterTypeCount: "{{count}} activities of this type",
      openInEditor: "Open in editor",
      rewardsLabel: "Rewards",
      finalRewardTitle: "Final reward",
      finalRewardValue: "+{{coins}} coins",
      finalRewardGames: "Configured for {{count}} linked segment(s)",
      curriculumTagsLabel: "Curriculum references",
      viewPhase: "View phase {{n}}",
      viewActivity: "View activity",
      clearFilter: "Clear filter",
      subjectLabel: "Subject",
      updatedLabel: "Updated on",
      updatedAtValue: "Updated on {{date}}",
      endsAtValue: "Ends on {{date}} at 11:59 PM",
      expiredAtValue: "Expired on {{date}}",
      expiredNotice: "Students can no longer complete new activities in this trail.",
      tabStructure: "Structure",
      tabStudentsProgress: "Student progress",
      studentsProgressSummary: "Class average on this path",
      studentsProgressEligible: "{{count}} eligible",
      studentsProgressStarted: "{{count}} started",
      studentsProgressCompleted: "{{count}} completed",
      studentsProgressActivitiesTotal: "{{count}} activities in path",
      studentsProgressActivitiesDone: "{{done}} of {{total}} activities",
      studentsProgressSearch: "Search student…",
      studentsProgressFilterTurmas: "Classes",
      studentsProgressFilterTurmasSearch: "Search class…",
      studentsProgressFilterTurmasNoResults: "No classes found",
      studentsProgressFilterTurmasClear: "Clear classes",
      studentsProgressEmpty: "No eligible students for this path.",
      studentsProgressNoSearch: "No students match this filter.",
      studentsProgressNoClassFilter: "No students in the selected classes.",
      studentsProgressLoadError: "Could not load student progress.",
      studentsProgressUnknownName: "Student",
      studentsProgressNoClass: "No class",
      studentDetail: {
        pageTitle: "Student progress on path",
        back: "Back",
        backToList: "Back to student list",
        trailLabel: "Path",
        overallProgress: "Overall progress",
        completedAt: "Completed on {{date}}",
        phasesTitle: "Phases and activities",
        phaseProgress: "{{done}} of {{total}} activities",
        activityNotStarted: "Not started yet",
        activityCompleted: "Completed",
        activityScore: "Score {{score}}",
        loadError: "Could not load this student's progress.",
        noPhases: "This path has no phases yet.",
        backToPhases: "Back to phases",
      },
      studentActivity: {
        quizTitle: "Quiz questions",
        writeTitle: "Written answers",
        flashcardsTitle: "Flashcards",
        flashcardTrueFalseTitle: "True or false",
        trueAnswer: "True",
        falseAnswer: "False",
        studentTrueFalseAnswer: "Student answer",
        contentTitle: "Content",
        missionTitle: "Mission",
        correctAnswer: "Correct",
        selectedAnswer: "Student choice",
        answerNotRecorded: "Student answer was not recorded.",
        legacySubmissionHint:
          "This completion was saved before detailed answers were stored. Correct options are shown below; the student's choice may be unavailable.",
        questionN: "Question {{n}}",
        scorePercent: "{{score}}% correct",
      },
    },
    list: {
      title: "Learning paths",
      loadErrorTitle: "Could not load your paths",
      loadErrorDescription:
        "Something went wrong while fetching the list. Check your connection and try again.",
      subtitle: "{{count}} paths · {{published}} published",
      subtitleLoading: "Loading paths...",
      createWithAi: "Create with AI",
      createWithAiShort: "AI",
      createManual: "Create manually",
      createManualShort: "Manual",
      createWithAiDialog: {
        title: "Create path with AI",
        hint: "Describe the topic, grade, and what you want in the path, or add PDFs and images as sources. We will open the editor and send your request to the AI chat.",
        placeholder:
          "E.g. A path about the Industrial Revolution for 9th grade, with a quiz and a research mission…",
        submit: "Create path",
        cancel: "Cancel",
        promptRequired: "Describe what you want to create or add an attachment",
      },
      searchPlaceholder: "Search paths...",
      filters: {
        all: "All",
      },
      status: {
        draft: "Draft",
        generating: "Generating",
        published: "Published",
        archived: "Archived",
      },
      columns: {
        title: "Title",
        status: "Status",
        phases: "Phases",
        classes: "Classes",
        createdAt: "Created",
        actions: "Actions",
      },
      mobileMeta: "{{phases}} phases · {{classes}}",
      empty: {
        title: "Create your first learning path",
        description:
          "Use AI or build manually to create gamified learning journeys for your students.",
      },
      emptyFiltered: {
        title: "No paths found",
        description: "Try another search term or change the status filter.",
      },
      actions: {
        menuLabel: "Actions",
        select: "Select",
        edit: "Edit",
        publish: "Publish",
        unpublish: "Unpublish",
        shareLink: "Access link",
        shareLinkDisabledHint: "Publish to unlock",
        viewReport: "View report",
        delete: "Delete",
      },
      selection: {
        selectedCount: "{{count}} selected",
        selectedShort: "selected",
        toolbarAria: "Bulk selection actions",
        enterMode: "Select multiple",
        enterModeTooltip: "Select paths to delete in bulk",
        selectAll: "Select all",
        deselectAll: "Deselect all",
        cancel: "Cancel selection",
        moreActions: "More actions",
        cancelTooltip: "Exit selection",
        deleteSelected: "Delete selected ({{count}})",
        deleteTooltip: "Delete {{count}} selected",
        cardAria: "Select path {{title}}",
      },
      deleteDialog: {
        title: "Delete path",
        description:
          "Are you sure you want to delete \"{{title}}\"? This action cannot be undone.",
        cancel: "Cancel",
        confirm: "Delete",
        deleting: "Deleting...",
      },
      bulkDeleteDialog: {
        title: "Delete selected paths",
        description:
          "Are you sure you want to delete {{count}} paths? This action cannot be undone.",
        cancel: "Cancel",
        confirm: "Delete",
        deleting: "Deleting...",
      },
      qr: {
        copySuccess: "Link copied!",
        download: "Download QR",
        error: "Failed to generate QR code",
      },
      toast: {
        deleted: "Path deleted",
        deleteError: "Failed to delete path",
        deletedMany: "{{count}} paths deleted",
        deleteManyError: "Could not delete all selected paths",
        published: "Path published",
        unpublished: "Path unpublished",
        unpublishError: "Failed to unpublish path",
      },
      publishing: "Publishing...",
    },
    publish: {
      title: "Publish path",
      description: "Set the deadline and classes to publish this path.",
    },
    create: {
      back: "Paths",
      loadErrorTitle: "Could not load this path",
      loadErrorDescription:
        "Something went wrong while opening the path for editing. Try again or go back to the list.",
      headerEditor: "Editor",
      saveDraft: "Save draft",
      headerMoreActions: "More options",
      openChat: "Chat with AI",
      closeChat: "Close chat",
      resizeChat: "Resize AI chat",
      resizeChatHint: "Drag to adjust the width. Use arrow keys, Home or End. Double-click or press Enter to restore the default size.",
      mobileBackToChat: "Back to chat",
      mobileViewTrail: "View path",
      sectionOverview: "Trail information",
      sectionStructure: "Trail structure",
      metadataPhases: "{{count}} phases",
      metadataActivities: "{{count}} activities",
      titleNew: "Create path",
      titleEdit: "Edit path",
      modeAi: "Create with AI",
      modeManual: "Create manually",
      preview: "Preview",
      panelEdit: "Edit",
      panelPreview: "Preview",
      save: "Save",
      publish: "Publish",
      qrCode: "QR Code",
      devJson: "JSON (dev)",
      devJsonDialog: {
        title: "Full trail JSON",
        hint: "Form, API, job, app visibility (status/classes), and school classes/segments (chat-ia pattern). Localhost only.",
        copy: "Copy JSON",
        copied: "JSON copied!",
        close: "Close",
      },
      generating: "Generating path...",
      generatingProgress: "{{completed}}/{{total}} phases generated",
      resumingProgress: "Resuming generation progress…",
      fields: {
        title: "Title",
        titleRequired: "Title is required to save",
        titlePlaceholder: "Path name",
        description: "Description",
        descriptionPlaceholder: "Short description",
        subjectLabel: "Subject",
        subjectPlaceholder: "Select a subject",
        subjectSearchPlaceholder: "Search subjects…",
        subjectNotFound: "No subjects found",
        theme: "Topic / content",
        themePlaceholder: "E.g. Fractions, French Revolution",
        grade: "Grade",
        gradePlaceholder: "E.g. 8th grade",
        detailsToggle: "Subject, topic, and grade",
      },
      subjects: {
        matematica: "Mathematics",
        portugues: "Portuguese",
        ingles: "English",
        espanhol: "Spanish",
        ciencias: "Science",
        fisica: "Physics",
        quimica: "Chemistry",
        biologia: "Biology",
        historia: "History",
        geografia: "Geography",
        filosofia: "Philosophy",
        sociologia: "Sociology",
        ed_fisica: "Physical Education",
        arte: "Art",
        musica: "Music",
        computacao: "Technology",
        financas: "Finance",
        redacao: "Writing",
        religiao: "Religion",
        outra: "Other",
      },
      moreActions: "More actions",
      publishDialog: {
        optionsTitle: "Path ready! 🎉",
        optionsDescription: "How do you want to use this path now?",
        title: "Send as task",
        classesLabel: "Classes",
        classesHint: "Select classes that will have access to this path",
        noClasses: "No classes found",
        finalRewardLabel: "Final reward",
        finalRewardValue:
          "{{coins}} coins when the path is completed ({{count}} linked segments)",
        finalRewardNone: "No final coins configured",
        cancel: "Cancel",
        confirm: "Publish",
      },
      finalReward: {
        title: "Final coin reward",
        description:
          "Set how many coins the student receives after completing every phase in the path. This reward is paid once.",
        coinsLabel: "Completion coins",
        coinsPlaceholder: "E.g. 50",
        toggleLabel: "Enable final reward",
        activeHint:
          "The reward will be linked to {{count}} segments from the selected classes. With no selected classes, it applies to all classes.",
        disabledHint: "Enable this to configure a final coin reward.",
        emptyEnabledHint: "Enter the coin amount to enable the final reward.",
        noGamesHint:
          "No segments were found in the selected classes. The path can be published, but coins will not be generated until segments are linked.",
        lockedTitle: "Available on plans with rewards.",
        lockedDescription:
          "This setting is locked on the current plan, but existing paths keep their reward contract.",
      },
      previewIframeTitle: "Trail preview in student app",
      previewIframePreparing: "Preparing app preview…",
      previewDialog: {
        title: "App preview",
        emptyPhases: "Add phases to preview",
        start: "START",
      },
      unsavedChangesConfirm:
        "You have unsaved changes. Are you sure you want to leave?",
      toast: {
        saved: "Path saved",
        saveError: "Failed to save",
        generateError: "Failed to generate path",
        published: "Path published!",
        publishError: "Failed to publish path. Please try again.",
        contentMissingTitle: "Some activities have no content",
        contentMissingHelp: "Add text, an image, a video or an attachment to the activities below, then try again.",
        contentMissingPhase: "Phase {{number}}",
        contentMissingPhaseUnknown: "Unidentified phase",
        contentMissingUntitled: "Untitled activity",
        turmasWithoutSegment: "Could not publish: class(es) {{turmas}} have no segment defined or a deleted segment. Set a valid segment for these classes (under Classes) before publishing — otherwise students receive no reward.",
        linkCopied: "Link copied!",
      },
      qr: {
        title: "QR Code",
        download: "Download QR",
      },
    },
    addMenu: {
      manual: "Add manually",
      withAi: "Add with AI",
      aiDialogTitle: "Describe what to add",
      aiDialogHint:
        "Your message will be sent to the AI chat with context from where you are in the editor.",
      aiPromptPlaceholder: "E.g. a 3-question quiz about healthy eating…",
      sendToChat: "Send to chat",
      cancel: "Cancel",
      sentToChat: "Request sent to the AI chat",
      aiUnavailable: "Use AI mode or edit a saved trail to add with the assistant",
    },
    chat: {
      title: "Professor Gamefik",
      subtitle: "Gamefik copilot",
      welcomeNew:
        "Hi! I'm Professor Gamefik, your copilot for building learning paths. Describe the topic or content you want to turn into a path!",
      placeholderNew: "E.g. Colonial Brazil, 8th grade",
      placeholderEdit: "Ask for a change in this phase...",
      suggestionsLabel: "Quick actions",
      quickChipAddActivity: "+ Add activity",
      quickChipMoreContent: "More content",
      quickChipReorder: "Reorder activities",
      quickChipDeletePhase: "Delete phase",
      quickChipMorePhases: "Add more phases",
      quickChipDifficulty: "Change difficulty level",
      quickChipRewards: "Add rewards",
      quickChipReformulate: "Reformulate activities",
      phaseProgress: "Phase {{completed}} of {{total}} generated",
      generationStarted:
        "I'll build your path from what you described. Follow the phase progress below.",
      runQueued: "Request received. It is queued and will continue even if you close this tab.",
      v2: {
        placeholder: "Discuss the trail or ask for a change…",
        pdfStudyTitle: "Use as study material",
        pdfStudyDescription: "Create explanations and activities from the uploaded materials.",
        pdfCopyTitle: "Copy the exercises 1:1",
        pdfCopyDescription: "Keep exercise wording, answer choices and order without rewriting.",
        title: "AI chat v2",
        legacy: "Previous chat",
        versionLabel: "Chat version",
        draftTitle: "New trail",
        running: "AI is preparing the complete trail with the conversation context.",
        subtitle: "Full conversation and trail in the same context",
        historyError: "Could not load the conversation. Try again before sending a message.",
        retry: "Try again",
        source: "Source context {{count}} used by AI",
      },
      runRecovering: "Resuming the run saved on the server…",
      runRunning: "AI is working on this change. You can close the tab and come back later.",
      runRunningProgress: "Run in progress: {{completed}} of {{total}} phases completed.",
      generationDone: "Generation complete! You can now view and edit the phases.",
      generationError: "Generation error: {{error}}. Please try again.",
      sendError: "Failed to send message. Please try again.",
      noCreditsError:
        "You've run out of AI credits. Required: {{needed}}. Available: {{remaining}}. Subscribe to a plan or add credits to continue.",
      actionApplied: "Change applied to the trail. Check the editor panel.",
      sendAria: "Send message",
      addAttachment: "Add PDF or image",
      removeAttachment: "Remove attachment {{name}}",
      attachmentsOnlyPrompt: "Use the attached files as sources to create or update the learning path.",
      uploadProgress: "Uploading attachments",
      attachmentRejected: {
        type: "The file \"{{name}}\" is not supported. Use PDF or image.",
        empty: "The file \"{{name}}\" is empty.",
        size: "The file \"{{name}}\" exceeds the 50 MB limit.",
        count: "The limit is 4 attachments per message.",
        total: "The attachments exceed the 100 MB total limit.",
      },
      userFallback: "You",
      memoryManage: "Memories",
      memoryManageAria: "Manage assistant memories",
      aiSettingsTrigger: "AI",
      aiSettingsManageAria: "Configure AI-generated activity types",
      aiSettingsTitle: "Generation by activity type",
      aiSettingsDescription:
        "Choose which types the assistant may create when generating or editing paths with AI.",
      aiSettingsLocalhostOnly: "Visible on localhost only. Values are stored in the browser.",
      aiSettingsReset: "Reset to defaults",
      memoryDialogTitle: "Saved memories",
      memoryDialogDescription:
        "General facts the assistant remembers about you in this school. Format preferences (e.g. no missions) apply to AI generations; theme and structure follow what you ask for each path.",
      memoryEmpty:
        "No memories saved yet. Chat with the assistant — it may note your audience, preferences, and other stable details.",
      memoryLoadError: "Could not load memories.",
      memoryRetry: "Try again",
      memoryDeleteAria: "Delete memory",
      memoryCategoryIdentity: "Identity",
      memoryCategoryAudience: "Audience",
      memoryCategoryPreferences: "Preferences",
      memoryCategoryTeaching: "Teaching",
      memoryCategoryOther: "Other",
      memoryAddSection: "Add memory",
      memoryAdd: "Add",
      memoryCategoryLabel: "Category",
      memoryCustomCategoryLabel: "Category name",
      memoryCustomCategoryPlaceholder: "E.g. Methodology / Class routine",
      activitySuggestionTitle: "Looks like a standalone activity",
      activitySuggestionDescription:
        "Standalone quizzes, missions and flashcards are created in the AI Chat. Want to continue there with this request?",
      activitySuggestionGo: "Create in AI Chat",
      activitySuggestionStay: "Continue as a trail",
      memoryContentLabel: "Description",
      memoryAddPlaceholder: "E.g. I usually teach 8th grade",
      memoryAddEmpty: "Enter a description to save.",
      memoryAddTooLong: "Maximum {{max}} characters.",
      memoryAddError: "Could not save. Try a different description.",
      memoryMaxReached: "Limit of {{max}} memories reached. Delete one to add another.",
      pdfUsage: {
        legend: "How do you want to use this PDF?",
        required: "Required choice",
        description: "Choose an option to continue.",
        inspirationTitle: "Use as inspiration",
        inspirationDescription: "Uses the material's ideas to create or adapt the trail.",
        faithfulTitle: "Copy faithfully",
        faithfulDescription: "Keeps the document's order and content.",
        faithfulSelectedDescription:
          "Content, quizzes, and flashcards will use only what is presented in the PDF.",
        faithfulMultipleError:
          "For a faithful copy, attach only one PDF at a time, with no images or additional files.",
        selected: "Selected mode: {{mode}}",
      },
      pdfChapters: {
        analysisErrorTitle: "I couldn't analyze the PDF chapters",
        analysisErrorDescription:
          "The file is still attached. Check your connection and try the analysis again.",
        retry: "Try the analysis again",
        multipleTitle: "Send one PDF at a time to organize by chapter",
        multipleDescription:
          "More than one PDF is attached. You can generate from all files without chapter organization, or resend only one PDF to choose chapters.",
        changeFiles: "Change files",
        notFoundTitle: "I couldn't identify chapters reliably",
        notFoundDescription:
          "You can still generate a trail from the entire PDF, but it will not be organized by chapter.",
        faithfulNoHierarchyDescription:
          "The PDF has searchable text but no identifiable chapters. You can copy the entire document while preserving the page order and content.",
        ocrRequiredDescription:
          "This PDF appears to be scanned and needs text recognition. You can still generate a trail from the entire file.",
        generateNormally: "Generate from the entire PDF",
        copyFullPdf: "Copy the entire PDF",
        choiceTitle: "I found {{count}} chapters in the PDF",
        choiceDescription:
          "The file has {{pages}} pages. Choose how you want to turn its content into a trail.",
        completeTitle: "Create a complete trail",
        completeDescription: "One phase will be created for each chapter, for {{count}} phases.",
        completeGroupedDescription:
          "{{count}} phases will be created (the maximum is 10), grouping adjacent chapters in the same phase.",
        generateComplete: "Generate complete trail",
        specificTitle: "Use only one chapter",
        specificDescription: "Choose the chapter that will be used as the trail's source.",
        chapterOption: "Chapter {{order}} — {{title}}",
        generateSpecific: "Generate from this chapter",
        faithfulUnsupportedTitle: "This PDF cannot be copied faithfully",
        faithfulOcrError: "Not enough content could be recognized in this PDF. Try a clearer file or choose to use it as inspiration.",
        faithfulMultipleError: "Faithful copy accepts exactly one PDF at a time. Change the files or choose to use them as inspiration.",
        useInspirationInstead: "Use as inspiration",
        scopeTitle: "Which part of the PDF should be used?",
        scopePlaceholder: "Select the PDF, a macro group, or a chapter",
        fullPdfOption: "Full PDF",
        groupOption: "Macro group — {{title}}",
        childOption: "↳ {{parent}} — {{title}}",
        leafOption: "Chapter — {{title}}",
        scopeHint: "Choose the full PDF, a macro group, or a specific chapter.",
        groupDescription: "This macro group has {{count}} chapters. One phase will be created for each child chapter.",
        groupGroupedDescription: "This macro group has {{count}} chapters. To keep the maximum of {{phases}} phases, adjacent child chapters will be grouped.",
        leafDescription: "The trail will be created only from the content of “{{title}}”.",
        generateSelection: "Generate from this selection",
      },
    },
    editor: {
      phaseLabel: "Phase {{n}}",
      activityCount: "{{count}} activities",
      activityCountOne: "1 activity",
      updating: "Updating...",
      removing: "Removing...",
      generatingContent: "Generating content...",
      generatingPhase: "Generating new phase...",
      addActivity: "Add activity",
      dropInPhase: "Drop in Phase {{n}}: {{title}}",
      dragReorderInPhase: "Reordering «{{title}}» in Phase {{phase}}",
      dragMoveToPhase:
        "Moving «{{title}}» from Phase {{from}} to Phase {{to}}: {{phaseName}}",
      addPhase: "Add phase",
      deletePhase: "Delete phase",
      deleteActivity: "Delete activity",
      renamePhase: "Rename phase",
      moveActivityUp: "Move activity up",
      moveActivityDown: "Move activity down",
      movePhaseUp: "Move phase up",
      movePhaseDown: "Move phase down",
      activityActionsLabel: "More activity actions",
      phaseActionsLabel: "More phase actions",
      expandPhase: "Expand phase",
      collapsePhase: "Collapse phase",
      activityRemovedToast: "Activity removed",
      phaseRemovedToast: "Phase removed",
      undo: "Undo",
      tasksCount: "{{count}} tasks",
      tasksCountOne: "1 task",
      blocksCount: "{{count}} blocks",
      blocksCountOne: "1 block",
      deletePhaseDialog: {
        title: "Delete phase",
        description:
          "Delete \"{{title}}\" and all activities in this phase? This cannot be undone.",
        cancel: "Cancel",
        confirm: "Delete",
      },
      activityModal: {
        written: {
          add: "Add written question",
          title: "Written answer · automatic AI grading",
          hint: "AI evaluates the student’s answer and explains the assessment. The result counts toward the quiz score and follows the selected completion criterion.",
          expectedAnswer: "Expected answer (optional)",
          expectedPlaceholder: "E.g. pharmacy or drugstore. Accept equivalent answers.",
          expectedHint: "Guide AI with the expected answer and acceptance criteria. Without a reference, AI uses the question. Students do not see this guidance.",
          correto: "Correct",
          incorreto: "Incorrect",
          incompleto: "Incomplete",
          review: "Automatic AI grading",
        },
        title: "Edit activity",
        editTypeTitle: "Edit {{type}}",
        save: "Save changes",
        close: "Close",
        titlePlaceholder: "Enter title",
        markCorrectHint: "click the circle to mark correct",
        questionLabel: "Question {{n}}",
        questionOf: "of {{total}}",
        contentHint: "Add text, videos, or attachments for students to study",
        flashcardFrontPlaceholder: "Enter question or term…",
        flashcardBackPlaceholder: "Enter answer or explanation…",
        flashcardFlipHint: "Click the card to flip",
        flashcardOf: "Card {{current}} of {{total}}",
        hintPlaceholder: "Hint for the student",
        missionDescriptionPlaceholder: "Describe what the student should do in this task…",
        addMissionStep: "Add step",
        removeBlock: "Remove block {{n}}",
        fields: {
          title: "Activity title",
          type: "Type",
          completion: "Completion criteria",
          minScore: "Min %",
        },
        types: {
          quiz: "Quiz",
          flashcard: "Flashcard",
          flashcard_true_false: "True or false",
          content: "Content",
          mission: "Mission",
        },
        trueLabel: "True",
        falseLabel: "False",
        trueFalseCorrectLabel: "Correct answer",
        addTrueFalseCard: "Add card",
        completion: {
          allSteps: "All steps",
          minScore: "Minimum score",
        },
        steps: "Steps ({{count}})",
        addQuestion: "Add question",
        addFlashcard: "Add flashcard",
        addBlock: "Add block",
        stepLabels: {
          question: "Question {{n}}",
          flashcard: "Flashcard {{n}}",
          block: "Block {{n}}",
          task: "Task {{n}}",
        },
        statementLabel: "Statement",
        statementPlaceholder: "Question statement",
        alternativesLabel: "Alternatives",
        alternativePlaceholder: "Alternative {{n}}",
        markCorrect: "Mark alternative {{n}} as correct",
        removeAlternative: "Remove alternative {{n}}",
        removeQuestion: "Remove question {{n}}",
        addAlternative: "Add alternative",
        front: "Front",
        back: "Back to trail",
        cardBack: "Back",
        hint: "Hint (optional)",
        contentMd: "Content (Markdown)",
        contentRich: "Content",
        missionDescription: "Task description",
        mediaUrl: "Media URL (optional)",
        media: {
          label: "Media (optional)",
          hint: "Image, video, PDF, audio, spreadsheet, or other files — same pattern as mission create with AI.",
          dropzoneTitle: "Click or drag a file here",
          dropzoneSubtitle: "Video, PDF, images, audio, CSV, Excel, and more",
          remove: "Remove",
          uploading: "Uploading file…",
          uploaded: "Media saved.",
          uploadError: "Failed to upload file.",
          previewTitle: "Preview",
          loadingPreview: "Loading preview…",
          noPreview: "Preview not available for this file type.",
          noTablePreview: "Could not read the spreadsheet.",
          openFile: "Open file",
        },
        verification: "Verification",
        verificationTeacher: "Teacher approval",
        verificationPhoto: "Photo",
        verificationAuto: "Automatic",
      },
      chooseActivityType: {
        title: "Activity type",
        hint: "Choose the format before adding it to the phase.",
      },
      activityTypes: {
        quiz: "Quiz",
        flashcard: "Flashcard",
        flashcardTrueFalse: "True or false",
        content: "Content",
        mission: "Mission",
      },
      stepsCount: "{{count}} steps",
      stepsCountOne: "1 step",
      cardsCount: "{{count}} cards",
      cardsCountOne: "1 card",
    },
  },
  exportButton: {
    exportData: "Export data",
    records: "{count} records",
    exportError: "Error exporting data",
  },

  missionApprove: {
    pageName: "Approve quests",
    updating: "(Updating...)",
    selectMission: "Select a quest",
    pending: "pending",
    exportCsv: "Export CSV",
    loadingProofs: "Loading submissions...",
    selectMissionsToExport: "Select quests to export",
    loadError: "There was an error loading the data.",
    checkConnection: "Check your connection and try again.",
    tryAgain: "Try again",
    loadingData: "Loading data...",
    exportCsvTitle: "Export completions as CSV",
    exportCsvDesc: "Select the quests to be exported.",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    concluded: "completed",
    cancel: "Cancel",
    export: "Export",
    missionNotFound: "Quest not found",
    backToSelection: "Back to selection",
    noMissionsAvailable: "No quests available",
    participation: "Participation",
    studentsParticipatedPercent: "{{percent}}% of students participated",
    completionRate: "Completed Quests Rate",
    pendingToApprove: "{{count}} quests pending approval",
    information: "Information",
    valueLabel: "Value:",
    createdByLabel: "Created by:",
    dateLabel: "Date:",
    continuousLabel: "Continuous:",
    yes: "Yes",
    no: "No",
    unknown: "Unknown",
    unknownDate: "Unknown date",
    preApprovedByAI: "Submissions pre-approved by AI",
    viewAll: "View all",
    approveAll: "Approve all",
    searchByStudentOrClass: "Search by student name or class",
    classFilterLabel: "Class:",
    allClasses: "All",
    gameFilterLabel: "Segment:",
    allGames: "All",
    reject: "Reject",
    approve: "Approve",
    noProofsFound: "No submissions found with the selected filters.",
    preRejectedByAI: "Submissions pre-rejected by AI",
    rejectAll: "Reject all",
    proofApprovedSuccess: "Submission approved successfully!",
    proofRejectedSuccess: "Submission rejected successfully!",
    failedToApprove: "Failed to approve submission",
    failedToReject: "Failed to reject submission",
    noProofsToApprove: "No submissions available to approve",
    allApprovedSuccess: "{{count}} submission(s) approved successfully!",
    failedToApproveAll: "Failed to approve submissions",
    noProofsToReject: "No submissions available to reject",
    allRejectedSuccess: "{{count}} submission(s) rejected successfully!",
    failedToRejectAll: "Failed to reject submissions",
    noClass: "No class",
    noGame: "No segment",
    noDate: "No date",
    textLabel: "Text",
    thumbnail: "Thumbnail",
    expandedProof: "Expanded submission",
    noDescAvailable: "No description available",
    sentOn: "Sent on",
    at: "at",
    missionCompleted: "Quest completed, Congratulations!!",
    notCompleted: "Not completed",
  },
  proofReviewModal: {
    title: "Proof review",
    aiReviewBadge: "AI review",
    missionLabel: "Mission: {{title}}",
    tabs: {
      review: "Review",
      pending: "Pending",
      approved: "Approved",
      retry: "Retry",
      notSent: "Not sent",
      collected: "Collected",
    },
    tabTooltips: {
      review: "Proofs awaiting your decision — the AI suggests approving or rejecting, you confirm",
      pending: "Submitted proofs awaiting your review",
      approved: "Approved by you or automatically by the AI — reward released for the student to collect",
      retry: "Rejected — the student needs to resubmit the proof",
      notSent: "Students in the mission who haven't submitted a proof yet",
      collected: "Proofs whose reward the student has already collected in the app",
    },
    searchPlaceholder: "Search student or class...",
    studentCount: "{{count}} student(s)",
    clearCount: "Clear ({{count}})",
    approveBulk: "Approve",
    rejectBulk: "Reject",
    selectAll: "Select all",
    empty: {
      noStudents: "No students",
      allSent: "All students have already submitted",
      noPendingRetry: "No proof awaiting retry",
      nothingToReview: "Nothing to review",
      noStudentsInFilter: "No students in this filter",
      noCollected: "No rewards collected yet",
    },
    tag: {
      youApproved: "You approved",
      retry: "Retry",
      iaApproved: "AI approved",
      approved: "Approved",
      iaRejected: "AI rejected",
      pending: "Pending",
      newAttempt: "New attempt",
      collected: "Collected",
      iaSuggestApprove: "AI suggested approval",
    },
    proofSentLabel: "Submitted proof",
    expand: "Expand",
    noImage: "No image",
    viewList: "List view",
    viewGrid: "Grid view",
    proofAlt: "Proof from {{name}}",
    expandedAlt: "Expanded proof",
    aiFeedbackTitle: "AI feedback",
    aiSuggestedReject: "AI suggested rejection",
    aiSuggestedApprove: "AI suggested approval",
    waitingForReview: "Awaiting your review",
    reviewAndDecide: "Review and decide manually",
    approve: "Approve",
    reject: "Reject",
    approveAnyway: "Approve anyway",
    confirmApproval: "Confirm approval",
    alreadyReceived: "Already received",
    iaApprovedAuto: "AI automatically approved",
    iaApprovedDesc: "The student has already received positive feedback",
    iaApprovedPending: "AI approved — confirm to complete",
    iaApprovedPendingDesc: "Confirm to complete the mission and release the student's reward",
    undoIaApproval: "Undo AI approval",
    undoApproval: "Undo approval",
    rewardCollected: "Reward already collected by the student",
    proofApproved: "Proof approved",
    approvedByYou: "Approved by you",
    waitingRetry: "Awaiting retry",
    needsResubmit: "The student needs to resubmit the proof",
    notSentDescription: "This student hasn't submitted the mission proof yet",
    validateManually: "Validate manually",
    selectStudent: "Select a student",
    selectStudentDesc: "Choose a student from the list to view and review",
    unknownStudent: "Student no longer in mission",
    dates: {
      today: "Today",
      yesterday: "Yesterday",
    },
    sentOn: "Sent {{date}}, {{time}}",
    toast: {
      updateError: "Error updating proof. Please try again.",
      alreadyApproved: "This student already has an approved proof for this mission.",
      approved: "Proof approved",
      rejected: "Proof rejected, student can try again",
      undoIa: "AI approval undone",
      approvalUndone: "Approval undone, the student can try again",
      manualValidation: "Student manually validated",
      manualValidationError: "Error validating student. Please try again.",
      noEligibleProofs: "No eligible proofs for approval.",
      bulkApproved: "{{count}} proof(s) approved",
      bulkApproveError: "Error approving proofs. Please try again.",
      bulkRejected: "{{count}} proof(s) rejected",
      bulkRejectError: "Error rejecting proofs. Please try again.",
    },
    feedback: {
      missionCompleted: "Mission completed successfully",
      rejected: "Proof does not meet mission requirements",
      undoApproval: "Approval undone, student can try again",
    },
  },
  missionCreate: {
    basicInfo: "Basic information",
    selectGames: "Select segments",
    deadlinesAndSettings: "Deadlines and settings",
    titleLabel: "Title",
    activeLabel: "Active",
    descriptionLabel: "Description",
    continuousMission: "Continuous quest (can be done multiple times)",
    proofLabel: "Submission",
    defineGameAndValue: "Set the segment and quest value",
    willExpireAt: "Expires on ",
    willStartAt: "Starts on",
    classesLabel: "Classes",
    teacherCanValidate: "Teachers can validate this quest",
    titlePlaceholder: "Quest title",
    descriptionPlaceholder: "Write the quest description here, explaining what the student needs to know to complete the quest.",
    proofPlaceholder: "Detail how the student will prove they completed the quest.",
    willExpireAtCalendar: "📅 Expires on",
    willStartAtCalendar: "📅 Starts on",
    problemsFound: "Problems found",
    missionNeedsTitle: "The quest must have a title.",
    missionNeedsDescription: "The quest must have a description.",
    missionNeedsGameAndReward: "The quest must have a segment and a reward",
    missionNeedsRewardCoverage: "Class(es) {{turmas}} have no reward configured for their segment. Add a reward for the right segment — otherwise the quest won't show up for students in these class(es).",
    missionCantExpireNow: "The quest cannot expire now! Give your students more time.",
    missionNeedsClass: "The quest must have at least one class.",
    back: "back",
    next: "Next",
    pageTitle: "Create quest",
    stepOf: "Step {{current}} of {{total}}",
    addCoverOptional: "Add cover (optional)",
    changeCover: "Change cover",
    enableCoins: "Enable coins",
    enableCoinsHint: "For quests without coins, students will still earn chests and gems in the Gamefik app",
    wantProofInApp: "Do you want to create a quest with proof of completion in the app?",
    withProof: "With proof of completion",
    withProofDesc: "In this option, players submit proof and our AI will analyze and help validate the quests.",
    withoutProof: "Without proof of completion",
    withoutProofDesc: "In this option, players prove outside the app, and validation is done manually here in the manager.",
    additionalCost: "Proof included in activity creation",
    selected: "Selected",
    selectBtn: "Select",
    notifyStudents: "Notify students",
    teachersCanValidateToggle: "Teachers can validate",
    creatingMission: "Creating quest...",
    createMission: "Create quest",
    iaCreditsInsufficient: "Insufficient AI credits to create quest with proof. Required: {{needed}}. Available: {{remaining}}. Subscribe to a plan or add credits to continue.",
    errorCreatingMission: "Error creating quest.",
    autoApprovalByAI: "Automatic approval by AI (Staging)",
  },
  missionCreateWithAi: {
    checkingCredits: "Checking AI credits/plan...",
    cannotCheckCredits: "Unable to verify your AI credits now. Please try again later.",
    letsCreateMission: "Let's create your quest,",
    butFirst: "but first...",
    detailMission: "Describe the quest in a few words",
    whatToCreate: "What do you want to create?",
    generateMission: "Generate quest",
    generatingMission: "Generating quest",
    missionPreview: "Quest preview",
    proofPreviewLabel: "Submission: ",
    coinsLimitExceeded: "The coins limit per class has been exceeded.",
    teachersCanSeeMission: "Teachers can see this quest",
  },
  missionBank: {
    goBack: "Back",
    title: "Quest Bank",
    description: "Explore our collection of ready-to-use quests. Add them directly to your quest list.",
    searchPlaceholder: "Search quests",
    popularTags: "Popular tags",
    all: "All",
    favorites: "Favorites",
    removedFromFavorites: "The quest was removed from your favorites.",
    addedToFavorites: "The quest was added to your favorites.",
    filters: "Filters",
    educationLevel: "Education level",
    subject: "Subject",
    difficulty: "Difficulty",
    duration: "Duration",
    filtersApplied: "Filters applied",
    noFiltersApplied: "No filters applied",
    clearFilters: "Clear filters",
    clearAllFilters: "Clear all filters",
    noFavoritesYet: "You don't have any favorite quests yet",
    noMissionsFound: "No quests found",
    clickStarToFavorite: "Click the star on any quest to add it to your favorites.",
    tryAdjustingFilters: "Try adjusting your filters or removing selected tags.",
    add: "Add",
    removeFromFavorites: "Remove from favorites",
    addToFavorites: "Add to favorites",
    seeMore: "See more",
  },
  missionsOld: {
    pageName: "Quests",
    allGames: "All segments",
    allClasses: "All classes",
    allTeachers: "All teachers",
    allDefault: "All",
    deleteMissions: "Delete quests",
    createWithAi: "Create quest with AI",
    checking: "Checking...",
    createFromScratch: "Create from scratch",
    missionsDisabled: "Quests 2.0 disabled",
    searchByName: "Search by name",
    pendingProofs: "Pending submissions",
    perPage50: "50 per page",
    perPage100: "100 per page",
    perPage200: "200 per page",
    previous: "Previous",
    nextPage: "Next",
    noAiCreditsTitle: "No AI credits available",
    noAiCreditsDesc: "Your school account has no AI credits. Create your quest manually or contact the account manager.",
    cancel: "Cancel",
    createManualMission: "Create manual quest",
    editMission: "Edit quest",
    cancelBtn: "Cancel",
    saveBtn: "Save",
    missionUpdatedSuccess: "Quest updated successfully!",
    missionUpdatedError: "There was an error updating the quest, please try again",
    missionDeletedSuccess: "Quest deleted successfully!",
    missionsDeletedSuccess: "Quests deleted successfully!",
    createdBy: "Created by",
    game: "Segment",
    activeClass: "Class",
    activeMissions: "Active quests",
  },
  missionCard: {
    viewRejectedProofs: "View rejected submissions",
    somePlayersAlreadyReceived: "Some players already received this quest!",
    playersSelected: "{{count}} players selected",
    onePlayerSelected: "1 player selected",
    conclusionsLabel: "Completions:",
    descriptionPrefix: "Description: ",
    createdByPrefix: "Created by:",
    allClassesLabel: "all",
    seeMore: "See more",
    missionDeletedSuccess: "Quest deleted successfully!",
    missionUpdatedSuccess: "Quest updated successfully!",
    missionUpdateError: "There was an error updating the quest",
    disableAction: "disable",
    deleteAction: "delete",
    missionThumbnail: "quest thumbnail",
    pendingProofsCount: "{{count}} submission(s) pending approval",
    noPendingProofs: "No submissions pending approval",
    daysRemaining: "{{days}} days remaining",
    lastDay: "Last day!",
    expired: "Expired",
    noExpiration: "No deadline",
    approveProofs: "Approve submissions",
    edit: "Edit",
    disableMission: "Disable quest",
    enableMission: "Enable quest",
    deleteMission: "Delete quest",
    validateManually: "Manual validation",
    aiValidation: "AI validation",
    searchPlayerByName: "Search player by name",
    orderAlphabetically: "Order by name",
    orderByProofs: "Order by submissions",
    selectAllFiltered: "Select all filtered",
    deselectAll: "Deselect all",
    approveMission: "Approve quest",
    approveMissionFor: "Approve quest for",
    player: "player",
    players: "players",
    confirmApproval: "Confirm approval",
    approvalSuccess: "Quest approved successfully! {{count}} player(s)",
    approvalError: "Error approving quest, please try again",
    close: "Close",
    undoCollection: "Revoke",
    undoCollectionTitle: "Revoke quest",
    undoCollectionDesc: "Are you sure you want to revoke this quest for player {{name}}?",
    undoCollectionConfirm: "Revoke",
    undoCollectionSuccess: "Quest revoked successfully",
    undoCollectionError: "Error revoking quest",
    debugTitle: "Debug Info",
    approveProofsTitle: "Review Submissions",
    allProofs: "All",
    approvedByAi: "Approved by AI",
    rejectedByAi: "Rejected by AI",
    pendingReview: "Pending",
    feedbackLabel: "Feedback:",
    aiFeedbackLabel: "AI Feedback:",
    proofDateLabel: "Date:",
    approved: "Approved",
    rejected: "Rejected",
    pendingStatus: "Pending",
    rewarded: "Rewarded",
    approveBtn: "Approve",
    rejectBtn: "Reject",
    approvedSuccessToast: "Submission(s) approved successfully!",
    rejectedSuccessToast: "Submission(s) rejected successfully!",
    errorUpdatingProofs: "Error updating submissions",
    missionCompletedFeedback: "Quest completed, Congratulations!!",
    notCompletedFeedback: "Not completed",
    noProofsAvailable: "No submissions pending approval.",
    selectAllVisible: "Select All Visible",
    approveSelected: "Approve Selected",
    rejectSelected: "Reject Selected",
    debugJson: "Debug JSON",
    debugJsonTitle: "Debug JSON",
    jsonSerializationError: "Error serializing JSON:",
    periodLabel: "Period",
    missionExpiredOn: "Quest expired on",
    willStartOn: "Starts on",
    noGamesAlert: "No segment assigned to this quest",
    teachersCanValidate: "Teachers can validate",
    teachersCantValidate: "Teachers cannot validate",
    selectClassPlaceholder: "Select class",
    clearFilter: "Clear filter",
    sortByLabel: "Sort by",
    selectedLabel: "Selected",
    clearSelection: "Clear selection",
    confirmRejection: "Confirm rejection",
    confirmBatchAction: "Confirm batch action for {{count}} submission(s)",
    processingBatch: "Processing batch...",
    cancelBtn: "Cancel",
    proofTitle: "Submission",
    addedToSelection: "Added to selection",
    selectPlayersTitle: "Select students",
    collectedCount: "Collected",
    receivedCount: "Received",
    rejectedCount: "Rejected",
    collected: "Collected",
    received: "Received",
    alreadyCollected: "Already collected",
    alreadyReceived: "Already received",
    noProofsForStudent: "No submissions found for this student",
    selectProofToUncollect: "Select submission to revoke",
    undoCollectionConfirmMsg: "Are you sure you want to revoke this submission?",
    approvingLabel: "Approving...",
    loading: "Loading...",
    selectAtLeastOnePlayer: "Select at least one student",
  },
  missionAlertBeforeDisable: {
    confirmDisable: "Are you sure you want to {{action}} this quest?",
    playersNotCollected: "All these players <strong>have not collected the quest yet!!</strong>, are you sure you want to {{action}} this quest without distributing the rewards?",
    andMoreStudents: "And {{count}} more students...",
    disablingMessage: "This action will disable the quest for all participants, preventing them from completing it.",
    deletingMessage: "This action is irreversible, all quest information will be completely lost.",
    cancel: "Cancel",
    distributeAndAction: "Distribute and {{action}}",
    disableAction: "disable",
    deleteAction: "delete",
  },
  missionIAFileConfirm: {
    title: "Confirm file",
    fileLabel: "File:",
    sizeLabel: "Size:",
    typeLabel: "Type:",
    preview: "Preview",
    noPreview: "Preview not available for this file type.",
    cancel: "Cancel",
    confirm: "Confirm",
    loading: "Loading...",
    imageAlt: "File preview",
  },
  missionIASelectStudents: {
    title: "Select students with AI",
    description: "Describe which students you want to select or upload a file.",
    promptPlaceholder: "E.g.: Select the top 5 students from 3rd grade",
    orSendFile: "or upload a file",
    selectFile: "Select file",
    processing: "Processing...",
    processingDesc: "AI is analyzing your request...",
    selectedStudents: "Selected students",
    studentsCount: "{{count}} student(s) selected",
    confirmSelection: "Confirm selection",
    cancel: "Cancel",
    send: "Send",
    errorProcessing: "Error processing request",
    noStudentsFound: "No students found",
    sendingData: "Sending data...",
    deterministicCode: "Deterministic Code",
    aiProcessing: "AI processing",
    iaProcessedSelection: "AI processed the selection",
    configuration: "Configuration",
    configDescription: "Describe your rule and optionally upload a spreadsheet.",
    clickOrDragFile: "Click or drag and drop the file here",
    supportedFormats: "(.csv, .xlsx, .pdf, images)",
    removeFile: "Remove",
    aiPromptLabel: "Write here how our AI should select students",
    aiPromptPlaceholder: "E.g.: Select students who completed the task on 05/28",
    processWithAi: "Process with AI",
    aiAnalysis: "AI Analysis",
    preview: "Preview",
    selectedCountLabel: "Selected: {{count}}",
    searchStudent: "Search student",
    liveAiResponse: "Live AI response",
    processingStatus: "Processing...",
    iaProcessingError: "Error processing AI",
    notSentToAi: "Not yet sent to AI",
    iaFoundNoStudents: "AI found no students",
    hideLogs: "Hide logs",
    viewAllLogs: "View all logs",
    viewProcessingLogs: "View all processing logs",
    debugIa: "🔍 Debug AI",
    studentHeader: "Student",
    actionsHeader: "Actions",
    removeStudent: "Remove",
    removeStudentTitle: "Remove student?",
    removeStudentConfirm: "Do you want to remove {{name}} from the selection?",
    thisStudent: "this student",
    cancelBtn: "Cancel",
    closeBtn: "Close",
    applySelection: "Apply selection",
    fileSelectedReady: "File selected. Ready to process with AI.",
    debugHistoryTitle: "🔍 Debug AI — Complete conversation history",
    downloadJson: "⬇ Download JSON",
    attempt: "attempt",
    step: "step",
    promptSent: "📤 Prompt sent",
    codeGenerated: "💻 Code generated",
    responseResult: "📥 Response / result",
    selectionRegistered: "Selection registered in history.",
    selectionMayNotBeSaved: "History record may not have been saved.",
    failedToRegisterSelection: "Failed to register the selection.",
    validationFailed: "Validation failed after 2 attempts: {{reason}}",
    inconsistentResult: "inconsistent result",
    failedToProcessAi: "Failed to process AI selection",
    completed: "Completed!",
  },
  missionCreateWithAiModal: {
    title: "Create quest with AI",
    promptLabel: "What do you want to create?",
    promptPlaceholder: "Describe the quest you want to create...",
    generating: "Generating...",
    generate: "Generate quest",
    generatingPreview: "Quest preview",
    titleLabel: "Title:",
    descriptionLabel: "Description:",
    proofLabel: "Submission:",
    cancel: "Cancel",
    create: "Create quest",
    aiDescription: "AI will generate a quest based on your description. This is an intelligent feature that may require AI credits.",
    errorGenerating: "Error generating quest with AI",
  },
  missionManualValidation: {
    title: "Manual validation",
    description: "Select the students who completed the quest",
    searchPlaceholder: "Search student by name",
    filterByClass: "Filter by class",
    allClasses: "All classes",
    filterByGame: "Filter by segment",
    allGames: "All segments",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    noStudentsFound: "No students found",
    cancel: "Cancel",
    confirm: "Confirm",
    selectedCount: "{{count}} selected",
    collectedCount: "Collected: {{count}}",
    collected: "Collected",
    receivedCount: "Received: {{count}}",
    received: "Received",
    approvalSuccess: "Quest approved successfully!",
    approvalError: "Error approving quest",
    noStudentsSubtitle: "No students have participated in this quest yet",
  },
  missionProofsModal: {
    title: "Quest submissions",
    searchByName: "Search by student name",
    filterByGame: "Filter by segment",
    filterByClass: "Filter by class",
    allGames: "All",
    allClasses: "All",
    allProofs: "All",
    approvedByAi: "Approved by AI",
    rejectedByAi: "Rejected by AI",
    pending: "Pending",
    noProofsFound: "No submissions found",
    proofDate: "Submission date",
    playerName: "Student name",
    className: "Class",
    gameName: "Segment",
    status: "Status",
    actions: "Actions",
    approve: "Approve",
    reject: "Reject",
    close: "Close",
  },
  missionsFilter: {
    filterBtn: "Filter",
    selectFiltersTitle: "Select your filters",
    selectFilterType: "Select filter type",
    clearFilter: "Clear filter",
    selectFilterValue: "Select a value to filter",
    activeNoValue: "Active quests do not have a value assigned",
    cancel: "Cancel",
    applyFilters: "Apply filters",
    createdBy: "Created by",
    game: "Segment",
    activeMissions: "Active quests",
  },
  verComprovantesModal: {
    title: "Submissions",
    searchPlaceholder: "Search by student name",
    filterMission: "Filter by quest",
    allMissions: "All quests",
    filterStatus: "Status",
    allStatuses: "All",
    approved: "Approved",
    rejected: "Rejected",
    pendingStatus: "Pending",
    noProofs: "No submissions found",
    approve: "Approve",
    reject: "Reject",
    approveAll: "Approve all",
    rejectAll: "Reject all",
    close: "Close",
    proofDetails: "Submission details",
    playerLabel: "Student:",
    classLabel: "Class:",
    gameLabel: "Segment:",
    dateLabel: "Date:",
    statusLabel: "Status:",
    feedbackLabel: "Feedback:",
    aiFeedbackLabel: "AI Feedback:",
    historyTitle: "Attempt history",
    attemptNumber: "Attempt {{number}}",
    noFeedback: "No feedback",
    approvedStatus: "Approved",
    rejectedStatus: "Rejected",
    pendingReview: "Pending",
    rewardedStatus: "Rewarded",
    successApproved: "Submission(s) approved successfully!",
    successRejected: "Submission(s) rejected successfully!",
    errorUpdating: "Error updating submission(s)",
    missionCompletedFeedback: "Quest completed, Congratulations!!",
    notCompletedFeedback: "Not completed",
    unknown: "Unknown",
    noClass: "No class",
    noGame: "No segment",
    proofApprovedSuccess: "Submission approved successfully!",
    proofRejectedSuccess: "Submission rejected successfully!",
    failedToApproveProof: "Failed to approve submission",
    failedToRejectProof: "Failed to reject submission",
    noProofsAvailable: "No submissions available",
    batchApprovedSuccess: "{{count}} submission(s) approved successfully!",
    batchRejectedSuccess: "{{count}} submission(s) rejected successfully!",
    failedToApproveAll: "Failed to approve submissions",
    failedToRejectAll: "Failed to reject submissions",
    collectedBadge: "Collected",
    approvedBadge: "Approved",
    rejectedBadge: "Rejected",
    approvedByAiBadge: "Approved by AI",
    pendingBadge: "Pending",
    noContent: "No content",
    videoLabel: "Video",
    proofOfPlayer: "Submission of {{name}}",
    firstSubmission: "This is the student's first submission for this quest.",
    attemptLabel: "Attempt {{number}}",
    atTime: "at",
    mediaSent: "Media sent",
    noDescription: "No description",
    selectMission: "Select a quest",
    proofsCount: "{{count}} submissions",
    backToList: "Back to list",
    aiFeedback: "AI Feedback",
    teacherFeedback: "Teacher Feedback",
    sendFeedbackToStudent: "Send feedback to student",
    feedbackPlaceholder: "Type your feedback for the student...",
    rejectBtn: "Reject",
    approveBtn: "Approve",
    attemptHistory: "Attempt history",
    searchByNameOrClass: "Search by student name or class",
    classFilterAll: "All",
    classFilterPrefix: "Class:",
    gameFilterAll: "All",
    gameFilterPrefix: "Segment:",
    tabAll: "All ({{count}})",
    tabApprovedAi: "Approved by AI ({{count}})",
    tabRejectedAi: "Rejected by AI ({{count}})",
    tabPending: "Pending ({{count}})",
    noProofsWithFilters: "No submissions found with the selected filters.",
    aiApprovedProofs: "Submissions approved by AI",
    rejectAllBtn: "Reject all",
    approveAllBtn: "Approve all",
    noAiApprovedProofs: "No AI-approved submissions found.",
    aiRejectedProofs: "Submissions rejected by AI",
    noAiRejectedProofs: "No AI-rejected submissions found.",
    pendingProofsForReview: "Submissions pending review",
    noPendingProofsFound: "No pending submissions found.",
  },
  relatorioMissoesModal: {
    title: "Results: {{name}}",
    subtitleQuiz: "Detailed activity report",
    subtitleMission: "Detailed quest report",
    eligibleOne: "1 eligible student",
    eligibleMany: "{{count}} eligible students",
    completedOne: "1 completed",
    completedMany: "{{count}} completed",
    pendingOne: "1 pending",
    pendingMany: "{{count}} pending",
    classesOne: "1 class",
    classesMany: "{{count}} classes",
    loadingQuiz: "Loading quiz data...",
    loadingMission: "Loading quest data...",
    noEligibleTitleQuiz: "No eligible students for this quiz",
    noEligibleTitleMission: "No eligible students for this quest",
    noEligibleBodyQuiz:
      "The class filters or segments configured for the quiz do not match any enrolled students. Review the selected classes or the quiz segments to enable participation.",
    noEligibleBodyMission:
      "The class filters or segments configured for the quest do not match any enrolled students. Review the selected classes or the quest segments to enable participation.",
    completionRateTitle: "Completion rate",
    rateHigh: "High",
    rateMedium: "Medium",
    rateLow: "Low",
    noEligibleStudentsRate: "No eligible students",
    completionProgress: "{{completed}} of {{total}} students completed",
    studyTimeTitle: "Study time",
    comingSoon: "Coming soon",
    metricUnavailableQuiz: "This metric is not available for quizzes yet.",
    metricUnavailableMission: "This metric is not available for quests yet.",
    studyTimeDescription: "Total study time for students",
    insightLabel: "Insight:",
    insightBest: "{{name}} leads with {{pct}}% completion",
    worstNeedsAttention: "{{name}} needs attention at {{pct}}%",
    rankingSectionTitle: "Completion by class",
    rankingSectionHintQuiz: "Classes sorted by quiz completion rate",
    rankingSectionHintMission: "Classes sorted by quest completion rate",
    noClassTitle: "No class available",
    noClassBecauseNoEligible: "There are no eligible students yet, so there are no classes to show.",
    noClassOtherQuiz:
      "Participants in this quiz are not linked to classes, or the filtered classes have no eligible students.",
    noClassOtherMission:
      "Participants in this quest are not linked to classes, or the filtered classes have no eligible students.",
    percentCompleted: "{{pct}}% completion",
    studentsCompletedRatio: "{{done}}/{{total}} students completed",
    pendingSuffixOne: "1 pending",
    pendingSuffixMany: "{{count}} pending",
    participantsTitle: "Participants",
    completedRatioBadge: "{{done}}/{{total}} completed",
    completionPerStudent: "Completion record per student",
    noneCompletedYetQuiz: "No student has completed the quiz yet. It may have just been created.",
    noneCompletedYetMission:
      "No student has completed the quest yet. It may have just been created or be awaiting proof approval.",
    allClassesFilter: "All classes",
    classesCountSelected: "{{count}} classes",
    searchClassPlaceholder: "Search class...",
    noClassFound: "No class found.",
    clearSelection: "Clear selection ({{count}})",
    allGames: "All segments",
    gameQuiz: "Quiz",
    gameMission: "Quest",
    gameTrail: "Path",
    gameChallenge: "Challenge",
    statusAll: "All",
    statusCompleted: "Completed",
    statusNotCompleted: "Not completed",
    searchByNamePlaceholder: "Search by name",
    colName: "Name",
    colClass: "Class",
    colStatus: "Status",
    colCompletionDate: "Completion date",
    loadingParticipants: "Loading participants...",
    noEligibleParticipants: "No eligible participants",
    noParticipantsForFilters: "No participants match the applied filters",
    adjustFiltersHintQuiz: "Adjust classes or quiz segments to include students.",
    adjustFiltersHintMission: "Adjust classes or quest segments to include students.",
    tryClearFilters: "Try clearing the search or changing class and status filters.",
    statusBadgeCompleted: "Completed",
    statusBadgeNotCompleted: "Not completed",
    showingParticipants: "Showing {{shown}} of {{total}} participants",
    dash: "\u2014",
  },
  missionBncc: {
    bnccCorrelation: "BNCC Correlation",
    proposedAction: "Proposed action:",
    justification: "Justification:",
    noBnccData: "No BNCC data available",
    title: "BNCC",
    close: "Close",
    bnccCodes: "BNCC Codes",
    noteLabel: "Note:",
    noteText: "For more details about the Brazilian National Common Curricular Base (BNCC), consult the official MEC document.",
  },
  bnccSelectionModal: {
    title: "Select BNCC competencies",
    searchPlaceholder: "Search competency...",
    categories: "Categories",
    competencies: "Competencies",
    selectedCount: "{{count}} selected",
    confirm: "Confirm",
    cancel: "Cancel",
    noResults: "No results found",
    clearSelection: "Clear selection",
    bnccTitle: "BNCC Competency Selection",
    home: "Home",
    searchByNameDescCode: "Search by name, description, or code...",
    back: "Back",
    loadingBncc: "Loading BNCC data...",
    loadError: "Error loading BNCC data.",
    ensureFileAvailable: "Make sure the bncc-competencias.json file is available.",
    competencyCount: "{{count}} competency",
    competencyCountPlural: "{{count}} competencies",
    noSearchResults: "No results found for your search.",
    noCategoriesAvailable: "No categories or competencies available at this level.",
  },
  rewardsShoppingDomain: {
    pageSubtitle: "Manage the rewards catalog and track student orders.",
    redeemError: "An error occurred while processing your request",
    rewardDeletedSuccess: "Reward removed successfully.",
    newRewardTitle: "New Reward",
    confirmDeleteTitle: "Confirm deletion",
    confirmDeleteDescription: "Are you sure you want to delete the following rewards?",
    cancelButton: "Cancel",
    pageTitle: "Rewards | Gamefik Schools at max level.",
    browse: "Browse",
    removeImage: "Remove",
    productNamePlaceholder: "Name that will appear to students",
    description: "Description",
    descriptionPlaceholder: "Brief description of the item",
    selectCategory: "Category",
    quantity: "Available quantity",
    quantityPlaceholder: "Stock quantity",
    limitPerPlayer: "Limit per player",
    allGames: "Which segments is this reward applicable to?",
    scheduledStart: "Schedule",
    noStoreGames: "No segments!",
    outOfStoreStock: "Out of store",
    rewardsGeneratorClose: "Close",
    rewardsDialogDescription: "Choose the rewards you want to redeem",
    redeemSuccess: "Rewards redeemed successfully.",
    editRewardPageTitle: "Edit reward | Gamefik Schools at max level.",
    noButton: "No",
    rarityCommonName: "common",
    rarityUncommonName: "uncommon",
    rarityRareName: "rare",
    rarityEpicName: "epic",
    rarityLegendaryName: "legendary",
    rarityCommonTime: "Time to redeem: 1 to 2 weeks",
    rarityUncommonTime: "Time to redeem: 2 to 4 weeks",
    rarityRareTime: "Time to redeem: 1 to 3 months",
    rarityEpicTime: "Time to redeem: 3 to 6 months",
    rarityLegendaryTime: "Time to redeem: 6 to 10 months",
    uploadImage: "Upload an image",
    rarityImportantInfo: "Important information about the reward rarity",
    useThisValue: "🪙 Use this value 🪙",
    defineValueIn: "Set value in {{point}}",
    savingReward: "Please wait, saving reward...",
    fillRewardName: "Enter a reward name",
    fillRewardDescription: "Enter a reward description",
    fillAvailableQuantity: "Enter the available quantity",
    selectAtLeastOneGame: "Select at least one segment",
    saveButton: "Save",
    insufficientScore: "The student does not have enough score for this purchase.",
    duplicatedTransaction: "Duplicate transaction.",
    insufficientBalance: "Insufficient balance for this reward.",
    rewardNotFound: "Reward not found or unavailable.",
    playerNotFound: "Player not found.",
    gameNotFound: "Segment not found.",
    rewardAlreadyRedeemed: "Reward has already been redeemed.",
    purchaseFinishError: "There was an error finishing this purchase. Check your connection and try again.",
    playerNotLinked: "The selected player is not linked to a segment.",
    cannotAssignMultipleGames: "Cannot assign rewards to students linked to different segments.",
    allOthersRedeemed: "All other rewards were redeemed successfully.",
    errorRedeemingReward: "Error redeeming the reward",
    forPlayer: "for",
    errorType: "Type",
    errorDetails: "Details",
    genericError: "Generic Error",
    duplicatedTransactionType: "Duplicated Transaction",
    insufficientBalanceType: "Insufficient Balance",
    rewardNotFoundType: "Reward Not Found",
    playerNotFoundType: "Player Not Found",
    gameNotFoundType: "Segment Not Found",
    alreadyRedeemedType: "Reward Already Redeemed",
    technicalError: "Technical Error",
    unknownError: "Unknown error.",
    startCreatingRewards: "Start creating your first reward to motivate your students.",
    gameLabel: "Segment",
    classLabel: "Class",
    totalLabel: "Total",
    selectItemAria: "select item",
    internalError: "An internal problem occurred.",
    invalidProductCode: "Invalid product code. Check if the product is still available.",
    insufficientBalancePurchase: "Insufficient balance to complete the purchase.",
    playerNotFoundPurchase: "Player not found. Check if the player is still active.",
    gameNotFoundPurchase: "Segment not found. Check if the segment is still active.",
    purchaseAlreadyProcessed: "This order has already been processed.",
    processingError: "An error occurred while processing the order. Contact support.",
    connectionError: "Connection problem. Check your internet and try again.",
    timeoutError: "The operation took too long to respond. Try again.",
    serverError: "Server communication error.",
    receiptMessageTitle: "Receipt message",
    readAndAcceptTerms: "I have read and accept the terms of use",
    finishWithBalance: "Finish with Balance",
    clearCart: "Clear",
    termsIntroTitle: "1. INTRODUCTION",
    termsIntroText: "By choosing to add balance to your Gamefik account, you agree to the following Terms of Use. These terms address the rules associated with adding balances, purchasing Gift Cards, and other relevant aspects.",
    termsServiceTitle: "2. SERVICE DESCRIPTION",
    termsServiceText: "Gamefik offers users the option to add balance to their account and then use that balance to purchase Gift Cards from various partner companies.",
    termsAddBalanceTitle: "3. ADDING BALANCE",
    termsAddBalanceMinValue: "a) The minimum amount to add balance is R$50.00.",
    termsAddBalanceRefund: "b) If desired, the user may request a full refund of the added balance within 7 days of purchase, as long as no Gift Card has been purchased.",
    termsGiftCardsTitle: "4. GIFT CARD ACQUISITION",
    termsGiftCardsNoReturn: "a) Once purchased, a Gift Card cannot be returned or refunded.",
    termsGiftCardsCodes: "b) Gift Card codes will only be visible to the player at the time of confirmed purchase. These codes are not accessible through the management interface.",
    termsGiftCardsUnique: "c) The code is unique and generated only once, at the time of purchase by the player.",
    termsGiftCardsProblems: "d) If there are problems with the code, the player should check the activation procedure or contact the Gift Card provider directly.",
    termsGiftCardsIntermediary: "e) Gamefik acts only as an intermediary in the sale of Gift Cards, and codes are provided by the respective companies. We are not responsible for any problems with the codes.",
    termsResponsibilitiesTitle: "5. USER RESPONSIBILITIES AND OBLIGATIONS",
    termsResponsibilitiesA: "a) The user is responsible for all transactions made on their account.",
    termsResponsibilitiesB: "b) Gamefik reserves the right to block the balance and store functions if the customer is in default with the platform.",
    termsResponsibilitiesC: "c) Upon canceling the Gamefik subscription, the user will lose access and rights to the balance and purchased Gift Cards.",
    termsIPTitle: "6. INTELLECTUAL PROPERTY",
    termsIPText: "All rights, titles, and interests associated with the Gamefik service, including but not limited to its design, text, graphics, and all associated software and codes, are the property of Gamefik.",
    termsPrivacyTitle: "7. PRIVACY POLICY",
    termsPrivacyText: "By accepting these terms, you agree to our Privacy Policy. We recommend reading our Privacy Policy available on our website.",
    termsChangesTitle: "8. CHANGES TO TERMS",
    termsChangesText: "These Terms of Use may be updated occasionally. By continuing to use the service after any update, you agree to the new terms. We will notify users of any significant change through the usual communication channels.",
    boletoPix: "Boleto/Pix",
    boletoMethod: "Boleto",
    creditCardPayment: "Credit card",
    adminPayment: "Admin",
    pixPayment: "PIX",
    notInformed: "Not informed",
    giftPurchaseType: "Gift Purchase",
    refundType: "Refund",
    userOrigin: "User",
    adminAddBalance: "Admin - Add balance",
    adminRemoveBalance: "Admin - Remove balance",
    balancePayment: "Balance",
    recommendCoinsOnly: "We recommend assigning only coin values to rewards, so the player doesn't lose experience. Do you want to continue?",
    invalidProductType: "Invalid Product",
    orderAlreadyProcessedType: "Order Already Processed",
    connectionProblemType: "Connection Problem",
    timeoutType: "Timeout",
    communicationErrorType: "Communication Error",
    basicInfo: "Basic Information",
    descriptionLabel2: "Description:",
    noDescription: "No description",
    typeLabel: "Type:",
    rewardType: "Reward",
    priceLabel: "Price:",
    giftCardValue: "Gift Card Value:",
    datesLabel: "Dates",
    createdAtLabel: "Created at:",
    lastUpdateLabel: "Last update:",
    statusAndStock: "Status and Stock",
    statusLabel: "Status:",
    inStockLabel: "In stock",
    outOfStockLabel: "Out of stock",
    indicatorsLabel: "Indicators:",
    noGameSelected: "No segment selected",
    priceLabel2: "Price",
    availableStockLabel: "Available stock",
    creationDateLabel: "Creation date:",
    priceLabel3: "Price:",
    confirmDeletion: "Confirm deletion",
    confirmDeletionDescription: "Are you sure you want to delete the following rewards?",
    cancelAction: "Cancel",
    rewardsPageTitle: "Rewards | Gamefik Schools at max level.",
    tipCreateRewards: "Create attractive rewards",
    tipCreateRewardsDesc: "Offer varied rewards that motivate different types of students.",
    tipCreateRewardsPlaceholder: "Video showing how to create effective rewards",
    tipStrategicPrices: "Configure strategic prices",
    tipStrategicPricesDesc: "Balance the coin value to maintain engagement without making rewards too easy.",
    tipStrategicPricesPlaceholder: "Video about reward pricing strategies",
    tipAISuggestions: "Use AI for suggestions",
    tipAISuggestionsDesc: "Take advantage of automatic reward generation to save time.",
    tipAISuggestionsPlaceholder: "Video tutorial on how to use AI to create rewards",
    tipMonitorStock: "Monitor stock",
    tipMonitorStockDesc: "Keep control over available rewards and replenish when necessary.",
    tipMonitorStockPlaceholder: "Video about reward stock management",
    tipAnalyzePopularity: "Analyze popularity",
    tipAnalyzePopularityDesc: "See which rewards are most popular and adjust your strategy.",
    tipAnalyzePopularityPlaceholder: "Video about reward data analysis",
    errorProcessingRequest: "An error occurred while processing your request",
    editButton: "Edit",
    editReward: "Edit reward",
    deleteButton: "Delete",
    newReward: "New Reward",
    editRewardTitle: "Edit Reward",
    myStore: "My Store",
    // redesign page
    redesignPageTitle: "Rewards — Gamefik",
    newRewardShort: "New",
    filterAllRewards: "All",
    filterActiveRewards: "Active",
    filterInactiveRewards: "Inactive",
    filters: "Filters",
    activeFilter: "{{count}} active filter",
    activeFilters: "{{count}} active filters",
    segmentFilter: "Segment",
    allSegments: "All segments",
    rewardFilter: "Reward",
    allRewards: "All rewards",
    classFilter: "Class",
    allClasses: "All classes",
    periodFilter: "Period",
    allDates: "Any date",
    today: "Today",
    last7Days: "Last 7 days",
    last30Days: "Last 30 days",
    clearFilters: "Clear filters",
    viewList: "List view",
    viewGrid: "Grid view",
    statementTab: "Statement",
    // purchased gift card stock (cart-checkout) — section on the Rewards tab
    giftStockTitle: "Purchased gift cards",
    giftStockSubtitle: "Your paid stock. Make it available in the store so students can redeem it with coins.",
    giftStockAvailable: "{{count}} available",
    giftStockAvailablePlural: "{{count}} available",
    giftStockPublishedBadge: "In store",
    giftStockPublishCta: "Add to store",
    giftStockModalTitle: "Add gift card to the store",
    giftStockModalDescription: "Set how many coins students pay to redeem this gift card.",
    giftStockPriceLabel: "Price in coins",
    giftStockQuantityLabel: "Quantity to make available",
    giftStockLimitLabel: "Limit per student",
    giftStockClassesLabel: "Classes",
    giftStockSelectAllClasses: "All classes",
    giftStockSubmit: "Add to store",
    giftStockSubmitting: "Adding...",
    giftStockSuccess: "Gift card is now available in the store!",
    giftStockError: "Could not add the gift card to the store. Please try again.",
    statementLoadError: "Could not load the statement.",
    statementRetry: "Try again",
    statementShowMore: "Show {{count}} more items",
    statementShowLess: "Show less",
    searchRewardPlaceholder: "Search reward...",
    searchOrdersPlaceholder: "Search order or student...",
    tryAnotherSearch: "Try searching by another name",
    noRewardsRegistered: "No rewards registered",
    clickToCreateFirstReward: "Click New Reward to get started",
    noOrdersFound: "No orders found",
    adjustFilters: "Try adjusting the filters",
    ordersWillAppearHere: "Student orders will appear here",
    statusUpdatedSuccess: "Status updated successfully",
    statusUpdatedError: "Error updating status",
    rewardDeletedSuccessMsg: "Reward deleted successfully",
    rewardDeletedErrorMsg: "Error deleting reward",
  },
  schoolDetails: {
    active: "Active",
    inactive: "Inactive",
    email: "Email",
    status: "Status",
    engagement: "Engagement",
    noTags: "No tags",
  },
  exportModal: {
    exportTitle: "Export Data",
    selectColumns: "Select columns",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    export: "Export",
    cancel: "Cancel",
    exporting: "Exporting...",
    recommendedForAnalysis: "Recommended for analysis",
    compatibleWithAny: "Compatible with any program",
    noSorting: "No sorting",
    descending: "Descending",
    ascending: "Ascending",
    exportSummary: "Export summary",
  },
  filterTable: {
    searchPlaceholder: "Search...",
    noResults: "No results found",
    showing: "Showing",
    of: "of",
    results: "results",
    previous: "Previous",
    next: "Next",
  },
  selectFrequency: {
    daily: "Daily",
    weekly: "Weekly",
    biweekly: "Biweekly",
    monthly: "Monthly",
    selectFrequency: "Frequency",
    monToFri: "Mon. to Fri.",
    custom: "Custom",
    daysOfWeek: "Days of the Week",
  },
  multipleSelect: {
    selectAll: "Select all",
    deselectAll: "Deselect all",
    selected: "selected",
    search: "Search...",
    allClassesCanSee: "All classes will be able to see this quest",
    allYourClassesCanSee: "All your classes will be able to see this quest",
    selectGameToSeeClasses: "Select a segment to see classes",
  },
  infoModal: {
    close: "Close",
    gotIt: "Got it",
  },
  carousel: {
    previous: "Previous",
    next: "Next",
  },
  aiMaterialPreview: {
    description: "{{type}} · {{size}}",
    unknownType: "Unknown type",
    imageAlt: "Preview of {{name}}",
    pdfTitle: "PDF {{name}}",
    unavailable: "Preview is unavailable for this format.",
    openNewTab: "Open in new tab",
    openPreview: "Preview {{name}}",
    remove: "Remove material {{name}}",
    materialsUsed: "Materials used",
  },
  chatIa: {
    titlePlaceholder: "Activity title",
    descriptionPlaceholder: "One line explaining what it is about",
    deleteCardTitle: "Delete card {{n}}?",
    deleteCardDescription: "The front and back of this card are gone. This cannot be undone.",
    deleteCardCancel: "Keep the card",
    copilotSeeAnswer: "See what changed",
    copilotSendToApply: "Press send to apply · {{cost}} AI credits",
    leaveGuardGeneratingTitle: "The AI is still working",
    leaveGuardGeneratingDescription: "If you leave now, it stops halfway and the AI credits for this request are not refunded.",
    leaveGuardGeneratingStay: "Wait for it",
    leaveGuardUnsentTitle: "Leave without sending to the class?",
    leaveGuardUnsentDescription: "We keep your draft, but the activity has not reached any student yet.",
    deleteQuestionTitle: "Delete question {{n}}?",
    deleteQuestionDescription: "The question and its alternatives are gone. This cannot be undone.",
    deleteQuestionCancel: "Keep the question",
    deleteQuestionConfirm: "Delete",
    copilotTriggerLabel: "Edit with AI",
    stateEditing: "Editing...",
    stateSavedNow: "Saved",
    stateUnsaved: "Unsaved changes",
    leaveGuardTitle: "Leave without saving?",
    leaveGuardDescription: "You edited this activity and have not saved yet. If you leave now, the changes are lost.",
    leaveGuardStay: "Keep editing",
    leaveGuardLeave: "Leave anyway",
    removeQuestion: "Delete this question",
    discardDraft: "Discard draft",
    attachFile: "Attach file",
    send: "Send",
    // --- GFK-166: copilot rail + on-demand panel ---
    copilotName: "Professor Gamefik",
    copilotSubtitleQuiz: "Adjusts this quiz",
    copilotSubtitleFlashcard: "Adjusts these cards",
    copilotSubtitleMissao: "Adjusts this mission",
    copilotSubtitleTrilha: "Adjusts this path",
    copilotOpenConversation: "Conversation",
    copilotCloseConversation: "Close conversation",
    copilotNewAnswer: "New answer from the copilot",
    copilotToolsLabel: "What do you want to change",
    copilotHistoryLabel: "Conversation",
    copilotCostHint: "Each request uses {{cost}} AI credits",
    copilotBalance: "You have {{balance}}",
    copilotEditPlaceholder: "Ask for a change. E.g.: make question 5 easier",
    copilotEditPlaceholderFlashcard: "Ask for a change. E.g.: add 2 cards on the topic",
    copilotEditPlaceholderMissao: "Ask for a change. E.g.: accept video as well as photo",
    copilotEditPlaceholderTrilha: "Ask for a change. E.g.: merge phases 2 and 3",
    aiChangedBadge: "AI changed",
    aiChangedGoTo: "Go to {{target}}",
    aiChangedTargetQuestion: "question {{n}}",
    aiChangedTargetCard: "card {{n}}",
    aiChangedTargetMission: "the mission",
    aiChangedTargetPhase: "phase {{n}}",
    useWithClass: "Use with the class",
    endOfQuiz: "End of the quiz.",
    endOfFlashcards: "End of the cards.",
    endOfMission: "End of the mission.",
    reviewedCount: "{{count}} items, reviewed.",
    draftSavedAuto: "Saved automatically",
    draftSaving: "Saving...",
    quickChipMoreCards: "+ More cards",
    quickChipSimpler: "Simpler",
    quickChipChangeProof: "Change the proof",
    quickChipChangeReward: "Change the reward",
    manualQuizReady: "Blank quiz ready! Edit it in the editor and publish whenever you want. Ask me for help here if you need it.",
    manualMissionReady: "Blank quest ready! Edit it in the editor and publish whenever you want. Ask me for help here if you need it.",
    manualQuizToast: "Blank quiz created.",
    manualMissionToast: "Blank quest created.",
    manualFlashcardReady: "Blank flashcard deck ready! Edit the cards in the editor and publish whenever you want. Ask me here if you need help.",
    manualFlashcardToast: "Blank flashcards created.",
    heroTitle: "What shall we",
    heroTitleHighlight: "create today?",
    heroSubtitle: "Describe a topic, paste text, or attach materials. The AI generates a quiz or quest ready to edit and save.",
    textareaPlaceholder: "E.g.: Quiz about photosynthesis for 7th grade with 5 multiple choice questions...",
    options: "Options",
    typeAuto: "Type: Auto",
    typeQuiz: "Quiz",
    typeMission: "Quest",
    difficultyAuto: "Difficulty: Auto",
    difficultyChild: "Children (4-6 years)",
    difficultyElementary1: "Elementary I (7-10 years)",
    difficultyElementary2: "Elementary II (11-14 years)",
    difficultyHighSchool: "High School",
    difficultyExam: "Exam Level",
    difficultyCollege: "College Level",
    difficultyPostGrad: "Post-graduate",
    questionsAuto: "Questions: Auto",
    questionsCount: "{{count}} questions",
    typeFlashcard: "Flashcards",
    typeFlashcardVf: "True/False flashcards",
    retryGeneration: "Try again",
    flashcardVfStatement: "Statement",
    flashcardVfExplanation: "Explanation",
    flashcardVfAnswerLabel: "The statement is...",
    flashcardVfTrue: "True",
    flashcardVfFalse: "False",
    flashcardVariantLabel: "Type:",
    flashcardVariantClassic: "Flip cards",
    flashcardVariantVf: "True or False",
    cardsAuto: "Cards: Auto",
    cardsCount: "{{count}} cards",
    maxCardsReached: "The deck can have at most 30 cards.",
    minCards: "The deck must keep at least one card.",
    flashcardCards: "Deck cards",
    flashcardCardsCount: "{{count}} cards",
    flashcardCardNumber: "Card {{current}}",
    flashcardOf: "Card {{current}} of {{total}}",
    flashcardRemoveCard: "Remove card",
    flashcardFront: "Front",
    flashcardBack: "Back",
    flashcardFrontPlaceholder: "Concept, term or question",
    flashcardBackPlaceholder: "Explanation or answer",
    flashcardAddCard: "Add card",
    flashcardTapToFlip: "Tap to flip",
    flashcardPrevCard: "Previous card",
    flashcardNextCard: "Next card",
    flashcardPreviewEmpty: "Add cards to preview the deck.",
    flashcardPublishError: "Could not publish the flashcards: {{message}}",
    flashcardUpdatedSuccess: "Flashcards updated successfully!",
    flashcardNeedsOneCard: "Fill in at least one complete card (front and back).",
    languageAuto: "Language: Auto",
    languagePtBr: "Portuguese (Brazil)",
    languageEnUs: "English",
    languageEsEs: "Spanish",
    clear: "Clear",
    attachPdf: "Attach PDF or image",
    createWithAi: "Create with AI",
    generating: "Generating...",
    processing: "Processing...",
    connecting: "Connecting to AI...",
    processingDescription: "We're processing your request. This may take a few seconds...",
    applyingChanges: "Applying changes...",
    phaseRouter: "Analyzing intent...",
    phasePlanner: "Planning operation...",
    phaseExecutor: "Generating content...",
    phaseReviewer: "Reviewing quality...",
    phasePatch: "Applying changes...",
    phaseClarification: "Preparing question...",
    phaseDefault: "Starting...",
    phaseRouterDesc: "The AI is analyzing your request...",
    phasePlannerDesc: "Defining the strategy to create or modify your activity...",
    phaseReviewerDesc: "Checking if the generated content meets your request...",
    phasePatchDesc: "Applying changes to the activity...",
    phaseClarificationDesc: "Preparing a clarification question...",
    fileNotSupported: "The file \"{{name}}\" is not supported.",
    chatTitle: "AI Chat",
    chatSubtitle: "Gamefik AI",
    describeActivity: "Describe your activity...",
    quickChipMoreQuestions: "+ More questions",
    quickChipHarder: "Make harder",
    quickChipEasier: "Make easier",
    quickChipChangeTheme: "Change theme",
    quickChipAddImages: "Add images",
    welcomeMessage: "Hi! Describe the activity you want to create or send PDF/image materials. I'll generate a complete quiz or quest for you.",
    trailSuggestionTitle: "Looks like a trail",
    trailSuggestionDescription:
      "Full trails (phases with multiple activities) are created in the trail editor. Want to take this request there?",
    trailSuggestionGo: "Create as a trail",
    trailSuggestionStay: "Continue here",
    generatingActivity: "Generating activity with AI...",
    unsavedChangesConfirm: "You have unsaved changes. Leave anyway?",
    thinkingWord1: "Thinking",
    thinkingWord2: "Analyzing",
    thinkingWord3: "Creating",
    thinkingWord4: "Working",
    thinkingWord5: "Organizing",
    activityGenerated: "Activity generated successfully.",
    activityGeneratedFallback: "Activity created successfully. Review the details in the editor beside.",
    currentActivityInvalid: "There was a problem loading the current activity. Creating a new activity.",
    noActivityEmpty: "The AI will generate the activity here. Start by describing what you need in the chat.",
    noActivityTitle: "No activity generated yet",
    save: "Save",
    saving: "Saving...",
    quiz: "Quiz",
    mission: "Quest",
    tabInfo: "Information",
    tabQuestions: "Questions",
    title: "Title",
    description: "Description",

    statement: "Statement",
    points: "Points",
    alternatives: "Alternatives",
    addQuestion: "Add question",
    addAlternative: "Add alternative",
    proofType: "Submission type",
    proofPhoto: "Photo",
    proofVideo: "Video",
    proofText: "Text",
    proofFile: "File",
    validationType: "Validation",
    validationAi: "AI",
    validationManual: "Manual",
    validationAuto: "Automatic",
    validationAiFull: "Automatic AI",
    validationAutoFull: "Auto-validation",
    validationAiDescription: "Student submits proof and AI validates it instantly",
    validationManualDescription: "Student submits proof and the teacher validates it",
    validationAutoDescription: "No proof: student simply confirms completion",
    proofPhotoDescription: "Image as proof",
    proofVideoDescription: "Video recording",
    proofTextDescription: "Written answer",
    proofFileDescription: "PDF or document",
    missionApprovalSection: "Proof and approval",
    missionHasProofLabel: "Mission requires proof",
    missionHasProofDescription: "Student submits a photo as proof",
    missionAiApprovalLabel: "Automatic approval with AI",
    missionTeacherApprovalLabel: "Teachers can approve",
    missionTeacherApprovalDescription: "The teacher can approve the mission manually, with or without proof",
    missionNoProofHint: "Student simply confirms completion and collects the reward",
    missionNoProofTeacherHint: "Student confirms completion and the teacher approves manually",
    missionNoProofBadge: "No proof",
    richTextPhoto: "Photo",
    richTextVideo: "Video",
    richTextPdf: "PDF",
    bold: "Bold",
    italic: "Italic",
    taskSentTitle: "Homework created!",
    missionSentTitle: "Mission created!",
    taskSentDescription: "Your students need to download the app to complete this homework",
    shareWithStudents: "Share the link with your students",
    copyActivityLink: "Copy activity link",
    linkCopied: "Link copied!",
    downloadAppTitle: "Download the Gamefik app:",
    nextStepsTitle: "Next steps:",
    nextStep1: "Add your students to Gamefik on the Classes page",
    nextStep2: "Share the access link",
    nextStep3: "Your students download the app and learn while having fun!",
    finish: "Done",
    attachmentContext: "Attachment context",
    maxQuestionsReached: "A quiz can have at most 30 questions.",
    minQuestions: "A quiz must have at least one question.",
    maxAlternatives: "Each question can have at most 6 alternatives.",
    minAlternatives: "Each question must have at least 2 alternatives.",
    generateOrLoad: "Generate or load an activity before saving.",
    fillRequired: "Enter all required fields before saving.",
    errorTooManyQuestions: "Too many questions",
    errorTooManyQuestionsDesc: "This request exceeded the current question limit the interface can organize at once.",
    errorTooManyQuestionsSuggestion: "Try requesting fewer questions or split into two requests.",
    errorApiKeyMissing: "AI configuration missing",
    errorApiKeyMissingDesc: "The AI key is not properly configured in this environment.",
    errorApiKeyMissingSuggestion: "Check the AI key configuration and try again.",
    errorInvalidJson: "AI response in unexpected format",
    errorInvalidJsonDesc: "The response received could not be safely interpreted.",
    errorInvalidJsonSuggestion: "Try again with a more specific request.",
    errorUnsupportedFile: "Unsupported file format",
    errorUnsupportedFileDesc: "Currently, only images and PDF files are accepted as attachments.",
    errorUnsupportedFileSuggestion: "Send a PDF or image and try again.",
    errorFileTooLarge: "File too large",
    errorFileTooLargeDesc: "One of the attachments exceeded the maximum allowed size.",
    errorFileTooLargeSuggestion: "Reduce the file to under 50 MB and try again.",
    errorNoContext: "Missing context to generate activity",
    errorNoContextDesc: "No text or attachment was sent for the AI to work with.",
    errorNoContextSuggestion: "Describe the desired activity or send supporting material.",
    errorAiFailed: "The AI could not complete this request",
    errorAiFailedDesc: "The system tried to refine the response but could not reach a safe operation to apply.",
    errorAiFailedSuggestion: "Rephrase the request more clearly and try again.",
    errorGeneric: "Could not complete your request",
    errorGenericDesc: "A problem occurred during activity generation or editing.",
    errorGenericSuggestion: "Try again in a moment or rephrase the request.",
    operationCheckingTitle: "We are confirming your generation",
    operationCheckingDesc: "The connection was interrupted, but the operation may still be in progress.",
    operationCheckingSuggestion: "Please wait while we verify the result without generating or charging again.",
    operationAuthTitle: "Your session needs to be renewed",
    operationAuthDesc: "We could not confirm this generation because your session expired or does not have access.",
    operationAuthSuggestion: "Sign in again or reload the page. Do not start another generation in the meantime.",
    operationInvalidTitle: "We could not confirm this operation",
    operationInvalidDesc: "The generation check received an invalid request.",
    operationInvalidSuggestion: "Reload the page before trying to generate again.",
    committedNoResultTitle: "The activity finished, but the result did not arrive",
    committedNoResultDesc: "The credits were confirmed, but this screen did not receive the final result.",
    committedNoResultSuggestion: "Do not generate it again now. Refresh the page or check your activities shortly.",
    noAttachmentContext: "No attachment context was used in this activity.",
    details: "Details",
    clickCircleHint: "click the circle to mark the correct one",
    selectCorrectAnswer: "Select the correct alternative",
    questionNumber: "Question {{current}}",
    ofTotal: "of {{total}}",
    removeAlternative: "Remove alternative",
    streamingFailed: "Could not complete streaming generation.",
    needMoreDetails: "I need more details to continue.",
    generateFromAttachment: "Generate activity from attachment \"{{name}}\".",
    generateFromAttachments: "Generate activity using {{count}} attachments sent.",
    errorGenericFallback: "Could not generate the activity at this time.",
    back: "Back",
    chat: "Chat",
    edit: "Edit",
    openChat: "Chat with AI",
    closeChat: "Close chat",
    editActivity: "Edit activity",
    editMission: "Edit quest",
    newActivity: "New activity",
    draft: "Draft",
    updateDraft: "Save as draft",
    publish: "Publish",
    publishing: "Publishing...",
    preview: "Preview",
    invalidEditContext: "Invalid edit context.",
    editContextNotFound: "Edit context not found.",
    editContextMismatch: "Edit context does not match the opened activity.",
    editLoadFailed: "Could not load the activity for editing.",
    attemptLabel: "---- Attempt {{count}} ----",
    loadedActivityMismatchQuiz: "Loaded activity does not match the original quiz.",
    loadedActivityMismatchMission: "Loaded activity does not match the original quest.",
    loadedActivityMismatchFlashcard: "Loaded activity does not match the original flashcards.",
    quizUpdatedSuccess: "Quiz updated successfully!",
    missionUpdatedSuccess: "Quest updated successfully!",
    quizPublishedSuccess: "Quiz published successfully!",
    missionPublishedSuccess: "Quest published successfully!",
    insufficientCredits: "Insufficient AI credits. You need {{needed}}, but only have {{remaining}}.",
    publishErrorFallback: "Error publishing activity. Please try again.",
    teacherCoinLimitPreviewTitle: "Coin balance by class",
    teacherCoinLimitPreviewDescription: "Review the usage before publishing.",
    teacherCoinLimitPreviewValues: "Requested: {{requested}} · Remaining: {{remaining}}",
    teacherCoinLimitUnlimited: "Unlimited",
    teacherCoinLimitDisabled: "Coin activities are disabled for educators.",
    teacherCoinLimitExceeded: "One or more classes exceed the coin limit. Adjust the value or classes to try again.",
    teacherCoinLimitUnavailable: "We could not check the coin limits right now. Please try again shortly.",
    turmasWithoutSegmentError: "Could not send: class(es) {{turmas}} have no segment defined or a deleted segment. Set a valid segment for these classes (under Classes) before sending — otherwise students receive no reward.",
    draftUpdatedSuccess: "Draft updated successfully!",
    draftSavedSuccess: "Draft saved successfully!",
    draftErrorFallback: "Error saving draft. Please try again.",
    assistantAvatarAlt: "AI assistant",
    attachAction: "Attach",
    enterToSend: "Press Enter to send",
    createAction: "Create",
    footerTagline: "Gamefik AI · Smart educational activity creation",
    suggestionCapitals: "Quiz about the Seven Wonders of the World",
    suggestionReadingMission: "Family reading quest",
    suggestionMultiplicationQuiz: "Fun multiplication quiz",
    suggestionScienceChallenge: "Science challenge",
    startDateAfterEndDate: "Start date cannot be after end date",
    coverImage: "Cover image",
    coverImageAlt: "Cover",
    addCoverImage: "Add cover image",
    chooseFromBank: "Choose from bank",
    startDate: "Start date",
    endDate: "End date",
    selectDate: "Select a date",
    continuousMissionLabel: "Ongoing mission",
    continuousMissionHint: "Can be completed and approved multiple times by students.",
    continuousMissionNoDeadline: "No deadline (ongoing)",
    classes: "Classes",
    selectClasses: "Select classes",
    allClasses: "All classes",
    classesSelectedSingle: "1 class",
    classesSelectedMultiple: "{{count}} classes",
    selectAllClasses: "Select all",
    noClassesFound: "No classes found",
    selectAtLeastOneClass: "Select at least one class to publish.",
    selectEndDate: "Select an end date to publish.",
    coins: "Coins",
    coinOptionEasy: "Easy",
    coinOptionMedium: "Medium",
    coinOptionHard: "Hard",
    customCoinValue: "Custom value",
    coinsLockedTitle: "Coin rewards unavailable",
    coinsLockedDescription: "Your current plan does not include custom currency. Upgrade to unlock coin distribution.",
    coinsLockedCta: "View plans",
    coinsInvalidTitle: "Plan with pending payment",
    coinsInvalidDescription: "Your subscription is past due or has been canceled. Fix your plan to distribute coins to students.",
    coinsInvalidCta: "Fix plan",
    debugIaButton: "Debug AI",
    debugActive: "active",
    previewAspectRatioLabel: "Aspect",
    previewAspectTallPhone: "Tall 9:19.5",
    previewAspectPhone: "Phone 9:16",
    previewAspectTablet: "Tablet 3:4",
    previewAspectSquare: "Square 1:1",
    previewPreparing: "Preparing live preview...",
    previewIframeTitle: "Quiz preview in student app",
    previewEmptyTitle: "Generate an activity to preview",
    previewEmptyDescription: "As soon as AI responds, the student preview will appear here.",
    previewCorrectFeedback: "Nice! That is the correct alternative.",
    previewIncorrectFeedback: "That's not the correct one. You can move on anyway or change your answer.",
    previewResult: "Result: {{correct}} out of {{total}} correct",
    previewRestart: "Restart preview",
    previewNextQuestion: "Next question",
    previewStartHint: "Tap \"Play this Quiz\" to start the student experience.",
    previewRetake: "Retry preview",
    previewPlayQuiz: "Play this Quiz",
    previewStartMission: "Start Quest",
    previewCreatedBy: "Created by",
    previewTeacherName: "Gamefik Teacher",
    generatingAltThinking: "Shiny thinking",
    generatingAltHappy: "Shiny happy",
    generatingStepIdeas: "Sketching ideas...",
    generatingStepCreativity: "Filling with creativity...",
    generatingStepMixing: "Mixing magical ingredients...",
    generatingStepFun: "Sprinkling some fun...",
    generatingStepKnowledge: "Seasoning with knowledge...",
    generatingStepSpecialTouch: "Adding a special touch...",
    generatingStepShapingQuestions: "Shaping the questions...",
    generatingStepShining: "Making everything shine...",
    generatingStepAdjusting: "Adjusting the details...",
    generatingStepAlmostDone: "Almost done...",
    testAsStudent: "Test as student",
    testAsStudentSubtitle: "See the demo of this activity",
    openDemo: "Open demo",
    sendAsTask: "Send as homework",
    sendAsTaskDescription: "Set a deadline. Each student completes it at their own pace.",
    playLive: "Play live",
    playLiveDescription: "Everyone plays now, together, on their phones.",
    comingSoon: "Coming soon",
    present: "Present",
    presentDescription: "You lead the discussion, students follow along.",
    backToEditor: "Back to editor",
    autoSave: "Your changes are saved automatically",
    activityReady: "Activity ready!",
    howToUseNow: "How do you want to use it now?",
    studentPreviewTitle: "Student preview",
    studentPreviewSubtitle: "Interact with the app below to try it out",
    shinyThumbsUpAlt: "Shiny giving thumbs up",
    quizCreatedTitle: "Quiz created successfully!",
    missionCreatedTitle: "Mission created successfully!",
    newQuiz: "New Quiz",
    newMission: "New Mission",
    activityPublishedDescription: "Your activity has been published and is already available to students.",
    viewMyActivities: "View my activities",
    redirectingIn: "Redirecting in {{seconds}}s...",
    selectClassesPlaceholder: "Select classes",
    add: "Add",
    startDateLabel: "Start",
    deadlineLabel: "Deadline",
    selectPlaceholder: "Select",
    classesWillReceive: "Select the classes that will receive this activity",
    sendMission: "Send mission",
    sendTask: "Send homework",
    sendTaskDescription: "Configure the homework options before sending to students",
    startLiveSession: "Start Live Session",
    startLiveSessionDescription: "Choose the classes and coins before starting the session",
  },
  home: {
    greeting: {
      morning: "Good morning, {name} 👋",
      afternoon: "Good afternoon, {name} 👋",
      evening: "Good evening, {name} 👋",
      morningNoName: "Good morning 👋",
      afternoonNoName: "Good afternoon 👋",
      eveningNoName: "Good evening 👋",
      subtitle: "What are we creating today?",
    },
    chatBar: {
      placeholder: "✨ Describe what you want to create — AI does the rest",
      placeholderMobile: "✨ What to create?",
      create: "Create",
      createWithAi: "Create with AI ✨",
      attach: "Attach PDF or image",
      attachHint: "or drag and drop here",
      dropHere: "Drop to attach",
      suggestionsLabel: "Examples:",
      attachLimit: "Maximum of {count} files, {size}MB each",
      typeLabel: "Activity type",
      suggestion1: "Quiz about the solar system · 6th grade",
      suggestion2: "Reading mission with proof photo",
      expandedPlaceholder: {
        quiz: "What's your quiz about? E.g.: fractions for 5th grade, 10 questions",
        missao: "What will the mission be? E.g.: read a chapter and submit a summary photo",
        flashcard: "What will the cards be about? E.g.: English vocabulary",
        flashcard_vf: "What will the statements be about? E.g.: facts about Brazilian history",
        trilha: "Describe the journey. E.g.: basic math path with 5 stages",
      },
    },
    checklist: {
      title: "Your first steps",
      progress: "{completed} of {total}",
      dismiss: "Hide",
      reopen: "First steps",
      completeTitle: "Your class is ready to play! 🎉",
      completeSubtitle: "You've completed all the steps. Now it's just a matter of following up.",
      footer: "Complete the steps and your class will be playing this week 🚀",
      heroes: {
        microcopy: "Complete the {total} steps and free the heroes 🔓",
        bubble: "Psst! We need your help 👀",
        imageAltCaged: "Gamefik heroes locked in a cage",
        imageAltFree: "Gamefik heroes free and celebrating",
        imageButtonLabel: "Free the Gamefik heroes",
        modalTitle: "Free the Gamefik heroes",
        modalSpeech:
          "Hi, teacher! We got stuck in here and only you can set us free: complete your first steps. There's a reward waiting: an exclusive discount on the Shiny plan. 🎁",
        modalSpeechSchool:
          "Hi! We got stuck in here and only you can set us free: complete the first steps and get your school ready to engage students. 💪",
        modalStepsTitle: "Steps left",
        rewardLocked: "Complete everything to reveal your coupon",
        rewardHint: "{percent}% lifetime coupon on the Shiny plan",
        modalCta: "Continue",
        celebrationTitle: "You freed the heroes! 🎉",
        celebrationSubtitle:
          "All steps complete. All of Gamefik unlocked, and they left you a gift:",
        couponNote: "{percent}% off the Shiny plan, for life",
        couponCopy: "Copy",
        couponCopied: "Copied!",
        celebrationCta: "Go Shiny",
        completedSubtitle: "Every step complete. Your reward is waiting for you.",
        completedSubtitleSchool: "Every step complete. Your school is ready to engage students!",
        rewardCta: "Claim reward",
        rewardCountdown: "Your reward expires in {time}",
        rewardClaimed: "Reward claimed",
        rewardPitch:
          "You unlocked all of Gamefik. With the Shiny plan your class goes even further: full potential, no limits.",
      },
      journey: {
        title: "Complete the journey and free the heroes",
        subtitle: "Unlock Gamefik's full potential and earn a gift. 🎁",
        subtitleSchool: "Set up your school and unlock Gamefik's full potential.",
        remainingSingle: "1 step left to free them!",
        remainingPlural: "{count} steps left to free them",
        stepDone: "done",
        stepCurrent: "current step",
        stepLocked: "not started yet",
      },
      topbar: {
        label: "First steps",
        ariaLabel: "First steps: {completed} of {total} completed",
        tooltip: "Track your first steps here",
        currentStep: "Current step",
        continue: "Continue",
        seeJourney: "See full journey",
        rewardCta: "Claim reward",
        rewardClaimed: "Reward claimed",
        celebration: "Journey complete!",
        celebrationTitle: "Your school is ready!",
        celebrationBody: "All first steps completed. Now it's time to engage your students.",
      },
      sidebar: {
        bubble1: "heyyy, you there? 👀",
        bubble2: "Don't forget to set us free! 🔓",
        bubble3: "Help! Help us 🙏",
        bubble4: "Almost there! Keep going 💪",
        bubble5: "Psst! Over here 😄",
        bubble6: "We believe in you! ⭐",
      },
      toast: {
        stepDone: "{title} done!",
        remainingSingle: "1 step left to free the heroes",
        remainingPlural: "{count} steps left to free the heroes",
        nextStep: "Next step",
        allDoneTitle: "You freed the heroes!",
        allDoneBody: "All first steps completed.",
        seeCelebration: "See celebration",
      },
      emptyState: {
        chip: "Step {number} of your journey",
      },
      stepModal: {
        close: "Close",
        watchVideo: "Watch video",
        videoSubtitle: "Quick tutorial on how to do it",
        backToSteps: "Back to steps",
        downloadApp: "Download the Gamefik app",
      },
      steps: {
        conta: { title: "Account created" },
        trilha: {
          title: "Create your 1st trail",
          cta: "Create trail",
          time: "~3 min",
          detail: "Phases, achievements, and progress: build a learning trail and watch your class advance like a segment.",
          tutorial1: "Click Create trail (or describe your idea in the chat)",
          tutorial2: "Tell the AI the topic and it builds the phases for you",
          tutorial3: "Review the phases and activities in the editor",
          tutorial4: "Publish when it's ready",
        },
        // SCHOOL journey: "atividade_ia" (along with turma/recompensa/
        // convidar_professores) is a step in the school admin's checklist.
        // Fresh ids because the backend seeds the legacy ones at school signup.
        atividade_ia: {
          title: "Create an activity with AI",
          cta: "Create with AI",
          time: "~2 min",
          detail: "Describe what you want to teach and AI creates the activity, ready to review and publish to your classes.",
          tutorial1: "Right here on the home screen, create with AI or pick one of the activity types. The more details you give (topic, grade, number of questions), the better the result",
          tutorial2: "Click Create and review what the AI generated. Chat with it to refine questions, difficulty or topic",
          tutorial3: "When it's ready, click Publish",
          tutorial4: "Choose how to apply it: as a task (each student at their own pace), live (everyone together in class) or streamed on screen (you lead it)",
          tutorial5: "Fill in the settings for start and end dates, coin value and classes, then confirm to send it",
        },
        turma: {
          title: "Create classes and share access",
          cta: "Import classes",
          time: "~3 min",
          detail: "Bring your classes in minutes: import the student spreadsheet and download ready-to-share access. This step is done once at least 1 student logs in with their access.",
          tutorial1: "Go to Classes, click Import classes and download the spreadsheet template",
          tutorial2: "Fill in the template with student name and class, then save it as .csv",
          tutorial3: "Back in the app, upload the filled spreadsheet and confirm with Import classes",
          tutorial4: "On the Classes screen, click Select multiple, pick the class and open Student access in the ⋮ menu",
          tutorial5: "Download it as PDF or spreadsheet: it comes with each student's username, password and QR Code to enter the app",
        },
        recompensa: {
          title: "Add a reward",
          cta: "Create reward",
          time: "~2 min",
          detail: "Rewards give real value to the coins students earn. That's what makes engagement take off.",
          tutorial1: "Go to Rewards and click + New Reward",
          tutorial2: "Fill in the fields and add a nice photo: rewards with images get way more redemptions",
          tutorial3: "Set the price in coins. If you need to, use the calculator to convert from currency",
          tutorial4: "Click Create Reward",
        },
        preview_aluno: {
          title: "See how students receive it",
          cta: "See preview",
          detail: "See exactly the screen your students will see in the app, before publishing to the class.",
          tutorial1: "Create or open an activity in the editor",
          tutorial2: "Click Test as a student",
          tutorial3: "See the exact screen your student will see in the app",
          tutorial4: "Adjust anything before publishing for real",
        },
        convidar_professores: {
          title: "Invite your teachers",
          cta: "Invite teachers",
          time: "~1 min",
          detail: "Invite your school's teachers: each one creates AI activities and follows their own classes.",
          tutorial1: "Click your username (top right corner) and open Settings",
          tutorial2: "In the Users tab, click + Add user",
          tutorial3: "Fill in the email, the permission and the classes the teacher will access",
          tutorial4: "Click Send. The teacher gets an email link to set their password and join Gamefik",
        },
        alunos: {
          title: "Import your students",
          cta: "Import students",
          time: "~2 min",
          detail: "It's super simple! Bring your class in minutes and get everything ready to play.",
          tutorial1: "Go to Classes and pick (or create) a class",
          tutorial2: "Click Import students",
          tutorial3: "Paste the list of names or upload the spreadsheet",
          tutorial4: "Done! The class can now receive trails and activities",
        },
        aplicar_turma: {
          title: "Send the activity to your class",
          cta: "Send",
          detail: "Pick the class and the deadline so your students can start playing.",
          tutorial1: "In the activity editor, click Publish",
          tutorial2: "Choose Send as task",
          tutorial3: "Select the class and set the deadline",
          tutorial4: "Students get access automatically",
        },
        app: {
          title: "Share it with your students",
          cta: "Open student app",
          time: "~1 min",
          detail: "Show the student app and share access: that's how the magic reaches the class.",
          tutorial1: "Ask your students to download the Gamefik app (links below)",
          tutorial2: "Open Student app in the menu to see the class access",
          tutorial3: "Copy one student's access, or print access for the whole class",
          tutorial4: "With the app and access in hand, the class is ready to play",
        },
      },
    },
    types: {
      title: "Create an activity",
      quiz: { title: "Quiz", description: "Questions and answer choices" },
      missao: { title: "Mission", description: "Challenges with photo or video" },
      flashcard: { title: "Flashcards", description: "Memorization cards" },
      flashcard_vf: { title: "T or F", description: "Quick true or false" },
    },
    trail: {
      title: "Duolingo-style path",
      chipLabel: "Path",
      subtitle: "Levels, achievements and progress: your class learns by leveling up like a segment",
      cta: "Create path",
    },
    recent: {
      title: "Track your class",
      draft: "Draft",
      continue: "Continue",
      review: "Review",
      pendingProofsSingle: "{{count}} submission to review",
      pendingProofsPlural: "{{count}} submissions to review",
      responsesSingle: "{{count}} response",
      responsesPlural: "{{count}} responses",
      viewAll: "View all activities",
    },
    celebration: {
      title: "🎉 Your students started playing!",
      subtitle: "{count} student(s) have already joined your path.",
      cta: "View results",
    },
  },
  onboarding: {
    professor: {
      step0: {
        title: "Welcome to Gamefik!",
        subtitle: "Your Free account is ready. Create gamified activities and engage your class.",
        description: "Upgrade to Epic or Shiny anytime to unlock everything.",
      },
      stepApp: {
        title: "An incredible experience for your students",
        descriptionBefore: "You create activities and your students have fun learning! When they complete activities, they collect",
        descriptionHighlight: "incredible Legends",
        descriptionAfter: "and earn coins to exchange for rewards.",
      },
      stepAi: {
        title: "Create Quizzes and Missions with AI",
        descriptionBefore: "Describe a topic or choose a quick action and our",
        descriptionHighlight: "Artificial Intelligence",
        descriptionAfter: "generates complete activities in seconds. Quizzes, missions and much more!",
      },
      stepHow: {
        title: "How does it work?",
        item1Title: "Add classes and students",
        item1Desc: "On the Classes page, register your classes and students",
        item2Title: "Share the app",
        item2Desc: "Send the access code so students can join the app",
        item3Title: "Create activities and the magic happens",
        item3Desc: "Use AI to create quizzes and missions in seconds",
      },
      step1: {
        title: "Almost there!",
        subtitle: "Tell us which subject you teach and let's get started!",
      },
      step2: {
        title: "Complete your profile",
        subtitle: "Add a photo and enter your school name",
      },
      step3: {
        title: "All set! 🎉",
        subtitle: "Explore Gamefik and engage your students in a whole new way.",
        trialDays: "You have {{days}} trial days remaining.",
        trialExpired: "Your trial has expired. Consider upgrading to continue.",
      },
      subject: {
        matematica: "Math",
        portugues: "Portuguese",
        ciencias: "Sciences",
        historia: "History",
        geografia: "Geography",
        ingles: "English",
        fisica: "Physics",
        quimica: "Chemistry",
        biologia: "Biology",
        ed_fisica: "P.E.",
        arte: "Art",
        outra: "Other",
      },
      stepFinal: {
        title: "All set! Let's get started?",
        subtitle: "Explore Gamefik and engage your students in a completely new way.",
      },
      btn: {
        start: "Get started",
        skip: "Skip for now",
        next: "Next",
        complete: "Finish",
        close: "Skip",
        back: "Back",
        continue: "Continue",
        continueIn: "Continue in {{countdown}}s",
        explore: "Start exploring",
        exploreSolo: "Explore on my own",
      },
      photoOptional: "Photo optional",
      schoolLabel: "School where you teach",
      schoolPlaceholder: "e.g. Lincoln High School",
      countryLabel: "Country",
      countryPlaceholder: "Select your country",
      countrySearch: "Search country...",
      countryNotFound: "No country found.",
      phoneLabel: "Mobile / Phone",
      phonePlaceholder: "Phone number",
      phoneOptional: "Optional",
      phoneInvalid: "Invalid number for the selected country.",
    },
    escola: {
      step1: {
        title: "Welcome to Gamefik, {{schoolName}}!",
        subtitle: "Your {{days}}-day trial has started. Let's set everything up in a few minutes.",
        subtitleNoTrial: "Let's set everything up in a few minutes.",
      },
      step2: {
        title: "Engage your students with Gamefik",
        subtitle: "AI-powered missions and curriculum-aligned quizzes will boost {{schoolGoal}}.",
        card1: "AI-generated missions and quizzes",
        card2: "Class and student management",
        card3: "Gamification to super-engage your students",
      },
      step3: {
        title: "Ready to activate your school?",
        subtitle: "We've prepared a quick step-by-step guide to get you started",
      },
      btn: {
        next: "Next",
        back: "Back",
        start: "Start setup",
        explore: "Explore on my own",
        close: "Close",
      },
    },
    schoolWelcomeModal: {
      defaultSchoolName: "School",
      shinyGifAlt: "Happy Shiny mascot",
      appExperienceAlt: "Gamefik app experience",
      aiCreateAlt: "Create activities with AI",
      classesAlt: "Gamefik classes",
      teacherIllustrationAlt: "Teacher",
      step1: {
        title: "Welcome to Gamefik, {{schoolName}}!",
        subtitle: "Your {{days}}-day trial has started. Let's set everything up in just a few minutes.",
      },
      step2: {
        title: "An incredible experience for students",
        descriptionBefore:
          "Teachers create activities and students have fun learning! When they complete activities, they collect",
        descriptionHighlight: "incredible Legends",
        descriptionAfter: "and earn coins to exchange for rewards.",
      },
      step3: {
        title: "Data that drives better decisions",
        descriptionBefore: "Track",
        descriptionHighlight1: "student engagement",
        descriptionMiddle: ", and the performance of your",
        descriptionHighlight2: "classes and teachers",
        descriptionAfter: ", all in real time so you can make data-informed decisions.",
        reportAltEngagement: "Overall student engagement",
        reportAltClasses: "Comparison across classes",
        reportAltTeachers: "Teacher activity",
        reportAltActivities: "Activity performance",
        tabEngagement: "Engagement",
        tabClasses: "Classes",
        tabTeachers: "Teachers",
        tabActivities: "Activities",
      },
      step4: {
        title: "Create activities with AI",
        descriptionBefore: "Your teachers can create",
        descriptionHighlight: "Quizzes, Missions, and Flashcards",
        descriptionAfter: "in seconds using our Artificial Intelligence, saving hours of work.",
      },
      step6: {
        title: "Add your teachers",
        subtitle:
          "Give your teachers an AI tool that saves time and produces valuable engagement data for the school.",
        benefit1: "Saves hours of lesson preparation",
        benefit2: "Accurate engagement and performance data",
        benefit3: "Improves learning outcomes",
      },
      step7: {
        title: "Ready to activate your school?",
        subtitle: "We've prepared a quick step-by-step guide to start transforming education at your school.",
      },
      btn: {
        next: "Next",
        back: "Back",
        continue: "Continue",
        startSetup: "Start setup",
        exploreSolo: "Explore on my own",
      },
    },
    primeiros_passos: {
      header: {
        title: "First steps",
        subtitle: "Set up your account in a few minutes",
      },
      video: {
        timeLabel: "Video tutorial - 25 minutes",
        title: "How to use Gamefik",
        playPrompt: "Click to watch the full tutorial",
        playDesc: "Learn everything about the platform in 25 minutes",
        fallbackLabel: "Watch this step's video",
      },
      tutorial: { heading: "Step by step" },
      checklist: {
        title: "Setup checklist",
        auto: "Tasks completed automatically by the platform",
        done: "Congrats! All steps have been completed.",
      },
      celebration: {
        title: "Setup complete!",
        subtitle: "Your account is ready to use Gamefik",
      },
      btn: {
        back: "Back to start",
        view: "See how",
        close: "Close",
      },
      footer: "{{count}} of {{total}} complete",
      steps: {
        alunos: {
          title: "Add your students",
          description: "Create classes and add your first students",
          videoLabel: "See how to create classes and add students",
          tutorial: {
            t1: { title: "Access the classes page", description: "In the side menu, click 'Classes' to access your school's class list." },
            t2: { title: "Create a new class and open it", description: "Click '+ New Class', fill in the details, then click on the created class to open it." },
            t3: { title: "Add your first student", description: "Inside the class, click 'Add Student' and fill in the student's details." },
            t4: { title: "Share the student's code", description: "Each student receives a unique access code. Share it so they can join the platform." },
          },
        },
        atividade: {
          title: "Create your first activity",
          description: "Create a quiz or mission with AI help",
          videoLabel: "Learn how to create amazing activities with AI",
          tutorial: {
            t1: { title: "Access the Chat page", description: "In the side menu, click 'Chat' to open the AI-powered creation assistant." },
            t2: { title: "Describe what you want to create today", description: "Type what you want to create. The more details, the better the result!" },
            t3: { title: "Preview and edit the activity", description: "After creating, you can see how your students will view it and also edit it." },
            t4: { title: "Adjust the details and publish", description: "Adjust the details in the info tab and publish for your students!" },
          },
        },
        professores: {
          title: "Invite your teachers",
          description: "Add other users to your school",
          videoLabel: "Learn how to add users to your school",
          tutorial: {
            t1: { title: "Access settings through your profile photo", description: "Click on your profile photo in the top right corner and select 'Settings'." },
            t2: { title: "Access the users page", description: "In the settings menu, click 'Users' to see the school's user list." },
            t3: { title: "Add a new user", description: "Click 'Add User' to invite a new teacher or coordinator." },
            t4: { title: "Fill in the fields and confirm", description: "Fill in name, email and role. The added user will receive an email to complete registration." },
          },
        },
        app: {
          title: "Access the student app",
          description: "See how your students will use the platform",
          videoLabel: "Learn everything about the student app in this video!",
          tutorial: {
            t1: { title: "You have 2 ways to view your students' experience", description: "Choose the most convenient way to explore the student app." },
            t2: { title: "1st way: Access the Student App page right here", description: "In the side menu, click 'Student App', select a student and wait for the app to load." },
            t3: { title: "2nd way: Download the Gamefik app", description: "Download from Play Store or App Store by searching for 'Gamefik'." },
            t4: { title: "Explore the features", description: "Explore the features and create activities to elevate your students' learning!" },
          },
        },
      },
    },
  },
  limitModal: {
    limitReachedBadge: "Limit reached",
    limitReachedTitle: "{{type}} limit reached",
    classesLimitDesc: "You have reached the limit of {{count}} classes on the Free plan.",
    studentsLimitDesc: "You have reached the limit of {{count}} students on the Free plan.",
    activitiesLimitDesc: "You have reached the limit of {{count}} activities per month on the Free plan.",
    aiCreditsLimitDesc: "You have used all {{count}} AI credits on the Free plan this month.",
    schoolClassesLimitDesc: "Your school has reached the class limit of the Starter plan. Upgrade to Pro for unlimited classes.",
    schoolStudentsLimitDesc: "Your school has reached the limit of {{count}} students on the Starter plan. Upgrade to Pro or add a +50 students pack.",
    schoolTeachersLimitDesc: "Your school has reached the limit of {{count}} teachers on the Starter plan. Upgrade to Pro for unlimited teachers.",
    schoolAICreditsLimitDesc: "Your teachers have used all {{count}} AI credits on the Starter plan this month. Add the Unlimited AI add-on.",
    upgradeToContinue: "Upgrade to continue using without limits",
    unlockWith: "Unlock with {{plan}}",
    keepCurrentPlan: "Keep your current plan",
    addOnlyWhatYouNeed: "Add only what you need",
    cancelAnytime: "Cancel anytime",
    addonBadge: "Add-on",
    addon50StudentsName: "+50 Students",
    addon50StudentsDesc: "Add 50 more students to your plan",
    addonUnlimitedAIName: "Unlimited AI",
    addonUnlimitedAIDesc: "Unlimited credits per teacher/month",
    upgradeToPro: "Upgrade to Pro",
    addAddon: "Add {{name}}",
  },
  trialEndedModal: {
    title: "Oh, {{name}}... your trial is over",
    body: "It was {{days}} amazing days together! Your students will miss the full gamification experience.",
    statsActivities: "activities created",
    statsStudents: "students engaged",
    unlockWith: "Unlock with {{plan}}",
  },
  loginTestimonials: {
    badgeLabel: "Testimonials",
    slides: {
      s1: {
        quote: "Students love completing missions, earning coins, and leveling up. This greatly increased participation in activities.",
        title: "History Teacher",
      },
      s2: {
        quote: "Gamefik helps keep students focused and motivated. They want to participate and track their progress.",
        title: "Science Teacher",
      },
      s3: {
        quote: "Gamification transformed my classroom into a much more engaging environment full of meaningful learning.",
        title: "Math Teacher",
      },
      s4: {
        quote: "Gamefik greatly helped teachers with classroom management. Students became more attentive, which significantly reduced time spent on pedagogical interventions and administrative processes.",
        title: "Pedagogical Coordinator – TFLA Language School",
      },
      s5: {
        quote: "We've been Gamefik partners for over 4 years. When we started, our school had around 80 students and now we've surpassed 400. Gamification has become a major differentiator for new enrollments and has also greatly helped with student retention.",
        title: "Principal of Colégio Alvorecer",
      },
      s6: {
        quote: "My son became much more excited about school after they started using Gamefik. He comes home telling me about the missions.",
        title: "Parent of a student",
      },
    },
  },
  helpChip: {
    label: "Help",
    tourTitle: "Guided tour",
    tourSubtitle: "Learn step by step",
    videoTitle: "Watch video",
    videoSubtitle: "Full tutorial",
    helpCenterTitle: "Help center",
    helpCenterSubtitle: "Articles and FAQs",
    videoTitleDefault: "Video tutorial",
    videoModalSubtitle: "Watch the full tutorial",
    videoComingSoonTitle: "Video coming soon",
    videoComingSoonDescription: "The video tutorial for this page is still being prepared. In the meantime, visit the Help center for answers to your questions.",
    closeAria: "Close",
  },
  interactiveHint: {
    previewBefore: "This is the student app.",
    previewEmphasis: "Try the activity!",
    arrowJogar: "Click Play",
    arrowEdit: "Edit here",
    dismissAria: "Dismiss hint",
  },
  tour: {
    loading: "Loading...",
    skip: "Skip tour",
    next: "Next",
    previous: "Previous",
    finish: "Finish",
    stepCounter: "Step {{current}} of {{total}}",
    mobileNotAvailable: "The guided tour is available only on desktop. Open it on a computer to follow along step by step.",
    welcome: {
      defaultTitle: "Welcome!",
      defaultDescription: "Looks like this is your first time here. Want me to show you around this page?",
      startCta: "Start guided tour",
      exploreCta: "Explore on my own",
    },
    complete: {
      defaultTitle: "Well done!",
      defaultDescription: "You finished the tour of this page. You're all set to start using it!",
      cta: "Start using",
    },
    chatIa: {
      welcomeTitle: "Let's create your first activity!",
      welcomeDescription: "Quick walkthrough of the AI Chat — from generating the activity to publishing it for students.",
      completeTitle: "You're ready to create!",
      completeDescription: "You now know how to generate an activity with AI, preview it like a student, edit, and publish. Have fun!",
      steps: {
        create: {
          title: "Create with AI",
          description: "Type your activity topic here (e.g., 'Quiz about photosynthesis for 7th grade') and click Create. The AI generates everything in seconds! Continue the tour once it finishes generating.",
        },
        editWithAi: {
          title: "Edit with AI",
          description: "Once the activity is generated, this chat stays available for AI-powered edits. Try: 'make it harder', 'add 3 more questions', or 'change the topic to colonial Brazil'.",
        },
        preview: {
          title: "Preview",
          description: "Once the AI generates the activity, this panel shows exactly how the student will see it in the mobile app. Check everything before publishing.",
        },
        editor: {
          title: "Edit the activity",
          description: "Click Edit to tweak the title, description, questions, alternatives, dates, and coins. You have full control before publishing.",
        },
        publish: {
          title: "Publish",
          description: "When ready, click Publish to send the activity to the classes you choose. Students will see it in the app right away!",
        },
      },
    },
    classDetail: {
      welcomeTitle: "Welcome to this class!",
      welcomeDescription: "Want a quick tour on how to manage your students here?",
      completeTitle: "All set!",
      completeDescription: "You now know how to add students, award attitudes, and share access. Have fun!",
      steps: {
        welcome: {
          title: "This is your class",
          description: "Here you manage every student in this class. We'll walk you through the main actions.",
        },
        addStudent: {
          title: "Add a student",
          description: "Click here to add a student. Inside the modal you can also click 'Import many students' and paste a list straight from Word or Excel (Ctrl+C / Ctrl+V) to register several at once.",
        },
        selectStudent: {
          title: "Select a student",
          description: "Click on a student card to select it. A check mark will appear showing it's selected. You can select as many as you want at the same time.",
        },
        launch: {
          title: "Award attitudes and points",
          description: "Select one or more students by clicking their cards and use this button to award attitudes, points, coins, or achievements in bulk.",
        },
        shareAccess: {
          title: "Share access for multiple students",
          description: "Select several students, open this actions menu and pick 'Student access'. You'll generate the access instructions (QR code + link) for all selected students at once — perfect to hand to parents.",
        },
        final: {
          title: "Ready to go!",
          description: "Explore the class freely. To replay this tour later, just click 'Help' at the top of the page.",
        },
      },
    },
    classes: {
      welcomeTitle: "Welcome to Classes!",
      welcomeDescription: "Looks like this is your first time here. Want me to show you how to use this page?",
      completeTitle: "Tour complete!",
      completeDescription: "You now know how to create classes, bulk-import students, and open a class. Have fun!",
      steps: {
        welcome: {
          title: "Welcome to Classes!",
          description: "This is where you manage all of your classes and students. We'll show you how each feature works.",
        },
        newClass: {
          title: "Create a new class",
          description: "Click here to create a new class. Set the name first, then add students.",
        },
        classCard: {
          title: "Open a class",
          description: "Click any class to see its students and manage it. You can launch activities, add students and more.",
        },
        import: {
          title: "Import classes and students",
          description: "Need to register many classes at once? Click Import, download the spreadsheet template, fill in class name and student name, and upload. The system creates everything for you!",
        },
        final: {
          title: "All set!",
          description: "Now you know how to create and import classes. Explore the platform and start gamifying your lessons!",
        },
      },
    },
  },
  reportsDashboard: reportsDashboardEnUS,
  roomTools: roomToolsEnUS,
  tooltips: {
    classes: {
      editClass: "Edit the class name and settings",
      lancarSelected: "Award points, coins or achievements to the selected students",
      lancarEmpty: "Select students to award",
      moreActions: "More actions (access, move, delete)",
      copyLink: "Copy the class access link",
      classAccessLink: "Class access link",
    },
    chatIa: {
      title: "The title is shown to students in the app. Be clear and concise!",
      description: "Describe the activity clearly so the student understands what to do",

      coverImage: "Image shown as the activity cover in the student's app",
      startDate: "From this date on, students will be able to see and start the activity",
      endDate: "After this date, students will no longer be able to respond",
      coins: "Coins the student earns on completion. They can be redeemed for rewards!",
    },
  },
  onboardingB: {
    welcome: { title: "Welcome to Gamefik!", subtitle: "Create lessons that truly engage — where students never want to stop learning.", cta: "Let's go" },
    nome: { eyebrow: "About you", title: "What's your name?", placeholder: "Your name", cta: "Continue" },
    pais: { eyebrow: "About you", title: "Where do you teach?", paisLabel: "Country", phoneLabel: "Phone (optional)", phoneHint: "So we can let you know when your class plays. No spam.", cta: "Continue" },
    motivacao: { eyebrow: "Tell us", title: "What do you want most for your class?", engajar: "Engage my class", engajarSub: "I want students truly taking part", tempo: "Save time", tempoSub: "Prep lessons in minutes, not hours", resultados: "Track results", resultadosSub: "See who learned, in real time", diversao: "More fun in class", diversaoSub: "Turn the content into a game", comportamento: "Improve behavior", comportamentoSub: "A more focused, engaged class", cta: "Continue" },
    loop: { eyebrow: "How it works", title: "From idea to a published activity in seconds.", subtitle: "A personalized, adaptive learning journey in a few taps.", step1: "Describe the topic", step1Sub: "In one line, say what you want to teach.", step2: "AI builds the activity", step2Sub: "Questions, options and answers — ready.", step3: "Publish to your class", step3Sub: "Share it and track the results.", cta: "Continue" },
    alunoApp: { eyebrow: "Your class", title: "They play the learning path in the Gamefik app.", subtitle: "For the best experience, your students download the Gamefik app and move through the learning path like a game — points, phases and ranking.", storeHint: "Free to download", cta: "Let's build yours" },
    materia: { eyebrow: "Your subject", title: "What subject do you teach?", cta: "Continue" },
    tema: { eyebrow: "The learning path topic", title: "What will your learning path teach?", placeholder: "e.g. fractions", hint: "Type a topic or tap an example", cta: "Build my learning path" },
    montando: { eyebrow: "Building your learning path", title: "Your {{tema}} learning path is coming to life.", phasesProgress: "{{done}} of {{total}} stages generated", preparing: "Preparing your learning path…", genErrorHint: "Continue to finish signing up — you can create your learning paths later.", step1: "Learning path", step1Sub: "The content phases", step2: "Rewards", step2Sub: "Points and achievements", step3: "Ranking", step3Sub: "The class competing", task1: "Creating the phases and activities…", task1Done: "Phases and activities created", task2: "Generating rewards and ranking…", task2Done: "Rewards and ranking ready", task3: "Preparing the link to share with your students…", task3Done: "Link ready to share", cta: "Continue" },
    mais: { eyebrow: "There's more", title: "And there's much more to transform your classroom", subtitle: "On Gamefik you can create many kinds of gamified activities for students to play and learn.", atividadesIa: "Create gamified activities with AI in seconds", gestaoTurmas: "Class management", relatorios: "Pedagogical reports", trilhas: "Learning paths", muralTurma: "Class wall", recompensas: "Rewards", more: "and much more", cta: "Continue" },
    resultados: { eyebrow: "Real results", title: "Do you want these results for your students?", statEngajamentoValue: "90%", statEngajamentoLabel: "class engagement", statProfessoresValue: "+10k", statProfessoresLabel: "teachers already use Gamefik", statTempoValue: "+2h", statTempoLabel: "saved every week", statMelhoraValue: "90%", statMelhoraLabel: "of students improve their performance", quote: "Gamification turned my classroom into a far more engaging place.", quoteAuthor: "Juliana Martins", quoteRole: "Math Teacher", cta: "Yes, I want this for my class!" },
    preview: { eyebrow: "Ready", title: "Your {{tema}} learning path is ready!", ready: "Ready to publish", phaseLabel: "Phase {{n}}", studentsHint: "Your students play all of this in the Gamefik app", cta: "Continue" },
    planos: { eyebrow: "Unlock everything", title: "Try the full Gamefik, free.", subtitle: "Card required. Cancel anytime.", priceSuffix: "/mo", yearlyCaption: "billed {{price}}/yr · save {{percent}}%", cycleMonthly: "Monthly", cycleYearly: "Yearly", yearlyBadge: "Best savings yearly", shinyName: "Shiny", shinyBadge: "Most complete", shinyTrial: "7 days free", shinyCta: "Start 7 days free", shinyF1: "Unlimited classes, students, and activities", shinyF2: "Unlimited AI (fair use)", shinyF3: "Unlimited learning paths", shinyF4: "Rewards and custom currency", skip: "Not now, see my learning path", skipQuiz: "Not now, see my quiz" },
    payoff: {
      gamificacao: {
        eyebrow: "Real engagement",
        title: "Your students won't want to stop studying",
        sub: "Every activity earns points: students collect gems, trade them for legends, and unlock achievements.",
        tarefa: "Complete the tasks",
        gema: "Earn gems",
        lenda: "Buy legends",
        badge: "Unlock achievements",
      },
      produtividade: {
        eyebrow: "Less work, more clarity",
        title: "From idea to published activity in seconds",
        sub: "Create activities and minigames in seconds and see, in reports, exactly where your class gets stuck.",
        relatorios: "Reports that show where your class needs help",
      },
      comportamento: {
        eyebrow: "A more focused class",
        title: "Reinforce good behavior",
        sub: "Send personalized feedback and reward students who stand out — the right nudge at the right time.",
        feedback: "Personalized feedback",
        bonificar: "Reward good behavior",
      },
      cta: "I want this in my class",
    },
    criar: {
      eyebrow: "Let's start",
      title: "Shall we create your first gamified activity?",
      cta: "Create my activity",
      trilha: "Duolingo-style learning path",
      trilhaSub: "A journey of stages that hooks them.",
      quiz: "Quiz",
      quizSub: "Quick questions to lock in the content.",
      flashcard: "Flashcards",
      flashcardSub: "Memorize with cards.", emBreveHint: "Flashcards are coming soon — pick Learning path or Quiz to continue.",
      emBreve: "Coming soon",
    },
    temaQuiz: {
      title: "What will your quiz be about?",
      placeholder: "e.g., industrial revolution",
      cta: "Build my quiz",
    },
    montandoQuiz: {
      eyebrow: "Almost there",
      title: "Building your quiz about {{tema}}",
      task1: "Writing the questions",
      task1Done: "Questions written",
      task2: "Building the choices",
      task2Done: "Choices ready",
      task3: "Reviewing the quiz",
      task3Done: "Quiz reviewed",
    },
    previewQuiz: {
      title: "Your quiz about {{tema}} is ready",
      ready: "Ready to publish",
    },
  },
  liveSession: {
    lobby: {
      exit: "Exit",
      typeMission: "Mission",
      typeQuiz: "Quiz",
      typeFlashcard: "Flashcards",
      coins: "coins",
      exitFullscreen: "Exit fullscreen",
      enterFullscreen: "Fullscreen",
      joinAt: "Join at",
      linkCopied: "Link copied!",
      copyLink: "Copy link",
      gamePin: "Game PIN",
      copied: "Copied!",
      copyPin: "Copy PIN",
      scanToJoin: "Scan to join",
      playerCompleted: "{{count}} player completed",
      playersCompleted: "{{count}} players completed",
      waitingMore: "Waiting for more players...",
      waitingPlayers: "Waiting for players to finish...",
      shareHint: "Share the PIN or QR Code with the class",
      finishGame: "Finish game",
      waitAtLeastOne: "Wait for at least 1 player to finish",
    },
    results: {
      back: "Back",
      finalResult: "Final Results",
      podium: "Podium",
      report: "Report",
    },
    report: {
      noAnswers: "No answers recorded yet.",
      title: "Performance by question",
      subtitle: "All answered questions",
      questionFallback: "Question {{number}}",
      correct: "{{count}} correct",
      wrong: "{{count}} wrong",
      outOf: "of {{count}}",
    },
    podium: {
      defaultName: "Player",
    },
  },
} as const;
